var _KRP0008 = (function() {
    var isMobile = window.innerWidth < 768;

    var additionalItemTemplate = '<li data-id="{{id}}" data-quantity="1" data-price="{{price}}">' +
        '<dl class="price-info">' +
        '<dt class="text">{{title}}</dt>' +
        '<dd class="content">' +
        '<div class="quantity-wrap">' +
        '<div class="select-quantity"><div class="inner">' +
        '<button type="button" class="minus" disabled><span class="blind">빼기</span></button>' +
        '<input type="number" class="quantity" title="수량 입력" value="1" readonly>' +
        '<button type="button" class="plus"><span class="blind">더하기</span></button>' +
        '</div></div>' +
        '</div><span class="price"><em class="blind">판매가</em>{{priceString}}</span>' +
        '</dd>' +
        '</dl>' +
        '<button type="button" class="btn-delete"><span class="blind">삭제</span></button>' +
        '</li>';

    var awardPopupItemTemplate = '<li>' +
        '<a href="#" class="award-item">' +
        '<span class="image"><img src="{{storyPdpThumbnailPath}}{{storyPdpThumbnailServerName}}" alt="{{storyPdpThumbnailAltText}}" onError="lgkorUI.addImgErrorEvent(this);"></span>' +
        '<span class="text">{{storyTitle}}</span>' +
        '</a>' +
        '</li>';

    // 20210722 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
    // BTOCSITE-78119
    var trTemplate =  '{{#each (item, idx) in list}}'+
        '<tr>' +
        '{{#if idx == Object.keys(list).length  && idx > 5 && item.categoryName != "정수기" }}'+
        '<td>{{idx}}년차 이후({{(idx-1)*12+1}}회차~)</td>' +
        '{{#else}}'+
        '<td>{{idx}}년차 ({{(idx-1)*12+1}}~{{(idx*12)}}회차)</td>' +
        '{{/if}}'+
        '<td>{{item.price}}</td>' +
        '<td>{{item.free}}</td>' +
        '</tr>'+
        '{{/each}}';

    // var siblingTemplate =
    //     '<div class="{{#if itemList[0].siblingType=="COLOR"}}sibling-color {{#else}}sibling-select{{/if}}">' +
    //         '{{#if itemList[0].siblingType=="COLOR"}}' +
    //             '<div class="sibling-colorHead">' +
    //                 '<div class="text">{{pdpTitle}}</div>' +
    //                 '<div class="color-text"><span>{{colorValue}}</span></div>' +
    //             '</div>' +
    //             '{{#else}}' +
    //             '<div class="text">{{pdpTitle}}</div>' +
    //         '{{/if}}' +
    //         '<div class="select-option radio {{#if itemList[0].siblingType=="COLOR"}}color{{#else}}select{{/if}}">' +
    //             '<div class="option-list" role="radiogroup">' +
    //             '{{#each (item, index) in itemList}}'+
    //                 '{{#if item.siblingType=="COLOR"}}' +
    //                     '<div role="radio" class="chk-wrap-colorchip {{item.siblingCode}}" title="{{item.siblingValue}}">' +
    //                     '{{#else}}' +
    //                     '<div role="radio" class="rdo-wrap btn-type2" title="{{item.siblingValue}}">' +
    //                 '{{/if}}' +

    //                         '{{#if index === currentCheckIndex}}' +
    //                         '<input type="radio" id="rdo-option-{{optionIndex}}-{{index}}" name="rdo-option-{{optionIndex}}" data-sibling-code="{{item.siblingCode}}" data-sibling-group-code="{{item.siblingGroup_code}}" checked>' +
    //                         '{{#else}}' +
    //                         '<input type="radio" id="rdo-option-{{optionIndex}}-{{index}}" name="rdo-option-{{optionIndex}}" data-sibling-code="{{item.siblingCode}}" data-sibling-group-code="{{item.siblingGroup_code}}">' +
    //                         '{{/if}}' +
    //                         '{{#if item.siblingType=="COLOR"}}' +
    //                             '<label for="rdo-option-{{optionIndex}}-{{index}}"><span class="blind">{{item.siblingValue}}</span></label>' +
    //                             '{{#else}}' +
    //                             '<label for="rdo-option-{{optionIndex}}-{{index}}">{{item.siblingValue}}</label>' +
    //                         '{{/if}}' +
    //                     '</div>' +
    //             '{{/each}}'
    //         '</div>' +
    //     '</div>' +
    // '</div>';

    //$(window).ready(function(){
    //if(!document.querySelector('.KRP0008')) return false;

    //$('.KRP0008').buildCommonUI();
    
    // BTOCSITE-26021 옵션팝업
    var optionStartTemplate = 
    	'<div class="{{_itemClass }} {{optItemId}}-div" data-opt-item-nm="{{optItemNm}}" data-opt-item-buy-chk-flag="{{optItemBuyChkFlag}}">'+
	    	'<div class="text">{{optItemNm }}<span class="option-change"></span>{{#if optItemAttrCode==="03"}}<button type="button" class="btn-change-unit is-cm">인치로 보기</button>{{/if}}</div>' +
		        '<div class="select-option radio {{#if optItemAttrCode==="02"}}color{{#else}}select{{/if}}">' +
		        	'<div class="option-list" role="radiogroup">'+
		        		'{{#if optItemAttrCode==="02"}}'+
		        		'<div role="radio" class="chk-wrap-colorchip {{optItemValueExtra}}" title="{{optItemNm }}">'+
			        		'<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-sibling-group-code="OBJ453_color"{{#if _valueChchked==="Y"}}checked="true"{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
		        		'{{#else}}'+
		        		'<div role="radio" class="rdo-wrap" title="{{optItemNm }}">'+
			        		'<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-opt-item-value-extra="{{optItemValueExtra}}" data-sibling-group-code="OLED-B-type" {{#if _valueChchked==="Y"}}checked{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
		        		'{{/if}}'+
						    '<label for="{{optItemValueId}}"><span class="opt-value-nm">{{optItemValueDispNm }}</span>'+
						    '</label>'+
						'</div>';
    var optionValueTemplate = 
				    	'{{#if optItemAttrCode==="02"}}'+
				    	'<div role="radio" class="chk-wrap-colorchip {{optItemValueExtra}}" title="{{optItemNm }}">'+
					    	'<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-sibling-group-code="OBJ453_color" {{#if _valueChchked==="Y"}}checked="true"{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
						'{{#else}}'+
						'<div role="radio" class="rdo-wrap" title="{{optItemNm }}">'+
							'<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-opt-item-value-extra="{{optItemValueExtra}}" data-sibling-group-code="OLED-B-type" {{#if _valueChchked==="Y"}}checked{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
						'{{/if}}'+
							'<label for="{{optItemValueId}}"><span class="opt-value-nm">{{optItemValueDispNm }}</span>'+
						    '</label>'+
						'</div>';
    var optionNextTemplate = 
			    	'</div>'+
			    '</div>'+
			'</div>'+
		'</div>'+
		'<div class="{{_itemClass }} {{optItemId}}-div" data-opt-item-nm="{{optItemNm}}" data-opt-item-buy-chk-flag="{{optItemBuyChkFlag}}">'+
	    	'<div class="text">{{optItemNm }}<span class="option-change"></span>{{#if optItemAttrCode==="03"}}<button type="button" class="btn-change-unit is-cm">인치로 보기</button>{{/if}}</div>' +
		    	'<div class="select-option radio {{#if optItemAttrCode==="02"}}color{{#else}}select{{/if}}">' +
					'<div class="option-list" role="radiogroup">'+
						'{{#if optItemAttrCode==="02"}}'+
						'<div role="radio" class="chk-wrap-colorchip {{optItemValueExtra}}"title="{{optItemNm }}">'+
							'<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-sibling-group-code="OBJ453_color" {{#if _valueChchked==="Y"}}checked="true"{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
		        		'{{#else}}'+
		        		'<div role="radio" class="rdo-wrap" title="{{optItemNm }}">'+
			        		'<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-opt-item-value-extra="{{optItemValueExtra}}" data-sibling-group-code="OLED-B-type" {{#if _valueChchked==="Y"}}checked{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
		        		'{{/if}}'+
							'<label for="{{optItemValueId}}"><span class="opt-value-nm">{{optItemValueDispNm }}</span>'+
						    '</label>'+
						'</div>';
    var optHeaderTemplate = 
    	'<div data-opt-model-id="{{MODEL_ID}}" class="header-prd" style="display:{{#if _display==="N"}}none{{/if}}">' +
		    '<div class="prd-left">' +
		        '<img src="{{IMAGE_ADDR}}" alt="" >' +
		    '</div>' +
		    '<div class="{{_statusClass}}">' +
		        '<p>{{MODEL_DISPLAY_NAME}}</p>' +
		        '<h4>{{modelOptInfoStr}}</h4>' +
		        '{{#if _modelStatusOrder===1 && _mixProductFlag ==="N"}}'+
		        	'<h5>{{#if _rentalPrice != ""}}<span>월{{_rentalPrice}}원</span><b>{{_visitPer}}</b>{{#else}}{{#if _price != ""}}{{_memberPriceTxt}}<span>{{_price}}원</span>{{/if}}{{/if}}</h5>' +
    			'{{/if}}'+
		        '{{#if _modelStatusOrder===2 && _mixProductFlag ==="N"}}'+
		        	'{{#if _rentalPrice != ""}}<h5><span>월{{_rentalPrice}}원</span><b>{{_visitPer}}</b></h5>{{#else}}{{#if _price != ""}}<h5>{{_memberPriceTxt}}<span>{{_price}}원</span></h5>{{/if}}{{/if}}' +
			        '<h6>판매 예정{{#if _modelSalePlannedDate != "" }}({{_modelSalePlannedDate}}){{/if}}</h6>'+
		        '{{/if}}'+
			    '{{#if _modelStatusOrder===3 && _mixProductFlag ==="N"}}'+
			        '<h5>{{#if _rentalPrice != ""}}<span>월{{_rentalPrice}}원</span><b>{{_visitPer}}</b>{{#else}}{{#if _price != ""}}{{_memberPriceTxt}}<span>{{_price}}원</span>{{/if}}{{/if}}</h5>' +
			        '<h6>일시품절</h6>'+
	    		'{{/if}}'+
			    '{{#if _modelStatusOrder===4 && _obsFlag==="Y" && _mixProductFlag ==="N"}}'+
			        '<h6>LGE.COM에서는<br>제품 정보만 제공하고 있습니다.</h6>'+
    			'{{/if}}'+
			    '{{#if _modelStatusOrder===5 && _mixProductFlag ==="N"}}'+
			        '<h6>단종제품입니다.</h6>'+
		        '{{/if}}'+
                '{{#if _mixProductFlag ==="Y"}}'+
                '<h6>LGE.COM에서는<br>제품 정보만 제공하고 있습니다.</h6>'+
                '{{/if}}'+
		    '</div>' +
		 '</div>';
    // 장바구니 담기 다품목 추천 상품 (BTOCSITE-37933)
    var cartRecommendTemplate =
        '<div class="slide-conts swiper-slide">' +
            '<div class="cart-item-wrap" data-ec-product="{{ecProduct}}">' +
                '<a href="javascript:_KRP0008.setTail(\'{{tail}}\');" class="cart-item" data-url="{{modelUrlPath}}" data-url-target="{{_target}}" data-contents="/{{modelDisplayNameConvert}}/{{modelName}}/{{subtitle}}">' +
                    '<div class="item-image" >' +
                        '<div class="image-wrap" >' +
                            '<img src="{{mediumImageAddr}}" alt="">' +
                        '</div>' +
                    '</div>' +
                    '<div class="item-infos">' +
                        '{{#if multipleItemsFlag == "Y"}}<span class="disc-badge new">다품목할인</span>{{/if}}' +
                        '<div class="item-name">{{#raw modelDisplayName}}</div>' +
                        '<div class="item-num">{{modelName}}</div>' +
                        '<div class="item-price-wrap">' +
                            '<em class="blind">회원가격</em>' +
                            '<span class="item-price">{{#if _discountRate != "0"}}<span class="item-disc"><em class="blind">할인율</em>{{_discountRate}}%</span>{{/if}}{{_obsSellingPrice}}<em>원</em></span>' +
                        '</div>' +
                    '</div>' +
                '</a>' +
            '</div>' +
        '</div>';

    // BTOCSITE-36570 [개인맞춤서비스] 일반제품/소모품 제품추천 영역 추가
    let recommendationTemplate =
        '<div class="req-top-main-title" data-label="{{eventLabel}}">'+
            '{{#if scenarioNo === "s2_3" || scenarioNo === "s2_3_1" || scenarioNo === "s2_3_2"}}'+
                '<h4><span class="req-top-item-name">{{categoryName}}</span> 제품과 <br />함께 많이 구매하는 제품</h4>'+
            '{{#elsif scenarioNo === "s2_4" || scenarioNo === "s2_4_1" || scenarioNo === "s2_4_2" ' +
                    '|| scenarioNo === "s2_6" || scenarioNo === "s2_6_1" || scenarioNo === "s2_6_2" || scenarioNo === "s2_7" || scenarioNo === "s2_8" }}'+
                '<h4><span class="req-top-item-name">{{categoryName}}</span> 카테고리에서 <br />가장 많이 관심받은 제품</h4>'+
            '{{#elsif scenarioNo === "s2_1" || scenarioNo === "s2_1_1" || scenarioNo === "s2_1_2"}}'+
                '<h4><span class="req-top-item-name">가지고 계신 <em class="req-product-name">{{categoryName}}</em></span>에 <br />사용할 수 있는 다른 소모품</h4>'+
            '{{/if}}'+
        '</div>'+
        '<ul>'+
            '{{#each (item, idx) in recommendModels}}'+
                '<li>'+
                    '<a href="{{item.modelUrlPath}}" data-contents="{{item.sku}}/{{item.modelName}}/{{scenarioNo}}/{{idx + 1}}/{{recommendLen}}">'+
                        '<span class="req-img-area">'+
                            '<img src="{{item.imageAddr}}" alt="">'+
                        '</span>'+
                        '<span class="req-text-area">'+
                            '<span class="req-title-inner">'+
                                '<span class="req-main-title">{{#raw item.modelDisplayName}}</span>'+
                                '<span class="req-sub-title">{{item.modelName}}</span>'+
                            '</span>'+
                            '<span class="req-product-info">'+
                                '<em class="product-price">{{item.obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>'+
                                '<em class="product-unit">원</em>'+
                            '</span>'+
                        '</span>'+
                    '</a>'+
                '</li>'+
            '{{/each}}'+
        '</ul>'
    ;

    // BTOCSITE-49751 [상품] 딜 플랫폼
    const timeDealInnerTemplate =
        '<span class="icon"><span>타임딜</span></span>'+
        '{{#if isTimeDealSoldOut}}'+
            '<span class="txt">SOLD OUT</span>'+
        '{{#else}}'+
            '<span class="time">{{remainingDay}}</span>'+
            '<span class="remain-count">{{remainingCount}}</span>'+
        '{{/if}}'
    ;

    // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
    var rentalDirectTemplate =
        '<li class="rental-new-item swiper-slide employee">'+
            '<a href="#" data-rt-model-seq="{{rtModelSeq}}" class="rental-item-box">'+
                '<p class="rental-period">{{contractTerm}}년 구독 시</p>'+
                '<div class="rental-info">'+
                    '<div class="rental-pay">'+
                        '<span>월 이용요금</span>'+
                        '<p>{{years1TotAmt}}원</p>'+
                    '</div>'+
                 '{{#if maxBenefitPrice != null && maxBenefitPrice != ""}}'+
                    '<div class="rental-benefit">'+
                        '<span>최대혜택가</span>'+
                        '<p><span>월</span> {{maxBenefitPrice}}원</p>'+
                    '</div>'+
                 '{{/if}}'+
                '</div>'+
            '</a>'+
        '</li>'
    ;

    var timeDealTimer; // BTOCSITE-49751 타임딜 타이머
    var headerMutationObserver; // BTOCSITE-62058 스마트홈 경험 솔루션

    const KR_TIME_DIFF = 9 * 60 * 60 * 1000;
    const _SECOND	= 1000;
    const _MINUTE	= _SECOND * 60;
    const _HOUR	= _MINUTE * 60;
    const _DAY	= _HOUR * 24;

    // 옵션 팝업 관련 변수
    var checkedOpt = [];
    var orgCheckedOpt = []; //리셋시 필요
    var optList = [];
    var optModelList = [];
    var optBizType = "PRODUCT";
    // BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
    var purchaseButtonDisplay ="Y";
    var purchaseButtonMassage ="";
    var emplCk = "N"; //BTOCSITE-96476

    var KRP0008 = {
        isGetRewardExcuted : false,
        isSetTimeDealExcuted : false,

        init: function(up20Flag) {
            var self = this;

            return new Promise(function(resolve){
                // LGECOMVIO-20 PDP내 앱 하단 바 비노출
                lgkorUI.showAppBottomMenu(false);
                lgkorUI.setEnableAppScrollBottomMenu(false);
                lgkorUI.showAppBottomMenuOver(false)

                // AR 체험하기 APP 호출시 실행
                var url = lgkorUI.parseUrl(location.href);
                var params = url.searchParams.getAll();
                if( isApp() && params.openAR) {
                    lgkorUI.openAR(params.openAR);
                    delete params.openAR;
                    window.history.replaceState('', '', url.pathname + (Object.keys(params).length > 0 ? '?'+$.param(params) : ''))
                }

                // 20211014 BTOCSITE-6768 사전예약 버튼클릭 시 로그인 체크
                loginFlag = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";

                // BTOCSITE-90808
                if (location.pathname.indexOf(lgkorUI.B2B_PATH_URL + "/") > -1) {
                    lgkorUI.DEFAULT_URL = lgkorUI.B2B_PATH_URL;
                    lgkorUI.COMPARE_KEY = "prod_compare_b2b";
                }

                // 옵션 선택 이벤트 발생 여부를 추적하는 변수
                self.isEventTriggered = false;

                //처음 로그인 체크를 하는 ajax 호출 여부
                self.processProductBuy = null;
                self.loginCheckEnd = false;

                // BTOCSITE-48463 B2B 복지몰(제휴사) 상품 구축
                self.default_partner_grp = "B2C";  // 일반
                self.emp_partner_grp = "LGE,AFF";   // LG 계열사
                self.memberPartnerGrp = "";
                self.partnerPrice = 0;
                self.bsnsMbrStat = ""; //BTOCSITE-48266
                self.bsnsMbrUpdStat = "";       //BTOCSITE-85521
                self.bsnsPstnCd = "";           //BTOCSITE-85521 사업자 직위/직책
                self.rprsnNm = "";              //BTOCSITE-85521 사업자 대표 명
                self.mbrName = "";              //BTOCSITE-85521 회원 명
                self.bsnsType = "";             //BTOCSITE-85521 사업자 타입
                self.obsOriginalPrice =0;
                self.partnerBoldBadgesArr = "";
                self.partnerRentalDirectInfoArr = "";

                self.checkIntervalTimer;
                self.checkIntervalCount = 0;

                self.isScrollDown = true; // setIsScrollDown() 통해 변경
                self.isDragging = false;
                self.cartRecommendStorageName = "cartRecommend";

                // 키오스크 여부
                var kiosk = lgkorUI.getParameterByName("kiosk");
                self.kiosk = lgkorUI.stringToBool(kiosk);

                self.setting();
                self.popUpDataSetting();
                self.contentLoadingScrollEvent();

                //최근본 제품 쿠키에 넣기
                //BTOCSITE-48266 사업자몰 제품은 최근본 제품 적재 제외. modelPartnerGrp는 mkt프로젝트에 존재
                if(typeof lgePdpSendData !== 'undefined' && lgePdpSendData.modelId && lgkorUI.getHiddenInputData().b2cYN ==='Y') {
                    lgkorUI.addCookieArrayValue(lgkorUI.RECENT_PROD_COOKIE_NAME,lgePdpSendData.modelId,lgkorUI.MAX_SAVE_RECENT_PRODUCT);

                    //최근본 제품 서버에 등록
                    var ajaxUrl = self.$pdpInfo.attr('data-recent-url');
                    if(ajaxUrl) {
                        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(ajaxUrl, {"requestId":lgePdpSendData.modelId}, null);
                    }
                }

                if(lgkorUI.getHiddenInputData().bizType === 'DISPOSABLE'){
                    self.initDisposable();
                }

                if(lgkorUI.getHiddenInputData().b2cYN ==='Y' && lgePdpSendData.bizTypeDetail !== "CARETAB" && lgkorUI.parseUrl(location.href).searchParams.get("kiosk") != 'y') {
                    self.setTimeDeal(); // BTOCSITE-49751 [상품] 딜 플랫폼
                }
                if(self.$component.data('consumables')) {
                    //BTOCSITE-68092 호출 순서에 의하여 가격 먼저 설정하도록 수정
                    if(loginFlag == 'Y' && loginFlag != null){
                        self.getRewardInfo();
                    }
                    vcui.require(['support/consumables-2.0.0.min'], function (consumables) {
                        self.prepare(up20Flag);
                        self.consumables = consumables;
                    });
                } else if(self.$component.data('notification')) { // BTOCSITE-29838 일반 제품 알림 신청
                    vcui.require(['support/notification-2.0.0.min'], function (notification) {
                        self.prepare(up20Flag);
                        self.notification = notification;
                    });
                } else {
                    self.prepare(up20Flag);
                }

                //BTOCSITE-841 페이지 로드시 활성화탭의 model-name으로 브레드크럼 & sku 변경
                //var activeTabIndex = $('.option-tabs .tabs li.on').index()

                //BTOCSITE-2551 PDP > 매장상담 예약 > 코드에 따른 분기처리 스크립트 추가
                $(document).on('click', '[data-app-link]', function(e){
                    if( isApp()) {
                        e.preventDefault();
                        var appUrl = $(this).attr('data-app-link');
                        if(vcui.detect.isIOS){
                            var jsonString = JSON.stringify({'command':'openInAppBrowser', 'url': appUrl, 'titlebar_show': 'Y'});
                            webkit.messageHandlers.callbackHandler.postMessage(jsonString);
                        } else {
                            void android.openLinkOut(appUrl);
                        }
                    }
                })
                //BTOCSITE-2551 PDP > 매장상담 예약 > 코드에 따른 분기처리
                self.bindRentalPopupEvents();

                // BTOCSITE-55284 // KRP0009 init 전 탭 클릭에 대한 대응
                self.disableKRP0009Tab();

                // BTOCSITE-659
                self.addAWSPdpUp();
                // BTOCSITE-8312 프로젝터>시네빔과 프로빔 스펙비교 예외처리 요청
                self.compareBtnStatus();

                // S : BTOCSITE-15587
                if(self.$view360.length) {
                    vcui.require([
                        '/lg5-common/front/360view/js/View360.js'
                    ], function () {
                        self.open360(); // BTOCSITE-19022
                    });
                }
                // E : BTOCSITE-15587

                $(window).off('.KRP0008-2');

                // visual sticky - only pc
                window.addEventListener('load', self.pdpVisualSticky);
                window.addEventListener('resize', self.pdpVisualSticky);
                window.addEventListener('scroll', self.pdpVisualSticky);
                window.addEventListener('pageshow', self.pageshowEvent);

                $(window).on('resizeend.KRP0008-2', self.resizeEnd.bind(self));
                $(window).on('breakpointchange.KRP0008-2', self.breakpointChange.bind(self));

                // BTOCSITE-72217 제품 번들링 과제
                // $(window).on('breakpointchange.KRP0008-2', function (e, data) {
                //     self.initBundledArea();
                // });

                // 비교하기 레이어 열림 시 bottom, z-index 수치 변경
                var $KRP0015 = $('.KRP0015');
                var $compareOpenEl = $KRP0015.find('.more-arrow');

                var  compareLayerBuffer = function(el) {
                    if($(el).hasClass('open')){
                        $KRP0015.removeClass('is-buffer--open');
                    } else {
                        $KRP0015.addClass('is-buffer--open');
                    }
                }

                if(self.$actionSheet.length) {
                    $KRP0015.addClass('is-buffer');
                    $compareOpenEl.on('click', function () {
                        compareLayerBuffer(this);
                    })
                } else {
                    $('body').addClass('is-only-compare');
                    $KRP0015.addClass('is-only-compare');
                }

                $(window).on("changeStorageData", function (e) {
                    if (e.key == lgkorUI.COMPARE_KEY) {
                        compareLayerBuffer($compareOpenEl);
                        setTimeout(function(){
                            compareLayerBuffer($compareOpenEl);
                        }, 2000);
                    }
                });

                $('.wrap, .iw_viewport-wrapper').on('click', function(e){
                    if($(e.target).parents('.KRP0015').length < 1 && $(e.target).parents('.product-compare').length < 1) {
                        $KRP0015.removeClass('is-buffer--open');
                    }
                });

                // 최대 할인가 로그인 전 노출 영역 처리
                //var $beforeLoginArea = $('.price-detail-item .before-login');

                // 보유제품 로그인 관련 노출 처리 및 보유 제품 팝업 목록 API 호출
                var $myProduct = $('.pdp-my-product');
                var $myProductList = $('#popupMyProductList .my-product-list');
                var isMyProduct = false;
                var myProductTemplate =
                    '{{#each (item, idx) in list}}'+
                    '<div class="my-product-list__item">'+
                    '<span class="my-product-list__image">'+
                    '<img src="{{item.smallImageUrl}}" alt="{{item.modelDisplayName}}">'+
                    '</span>'+
                    '<div class="my-product-list__info">'+
                    '<p class="my-product-list__category">{{item.categoryName}}</p>'+
                    '<p class="my-product-list__name">{{item.modelDisplayName}}</p>'+
                    '<p class="my-product-list__model">{{item.modelName}}</p>'+
                    '</div>'+
                    '</div>'+
                    '{{/each}}';

                if(!lgkorUI.stringToBool(loginFlag)){
                    //$beforeLoginArea.closest('li').show();
                    $myProduct.filter('.is-before-login').addClass('is-active');
                } else {
                    var param = {
                        "modelId": lgePdpSendData.modelId,
                        "modelGubun": modelGubun
                    }

                    const myProductUrl = self.$pdpInfo.data('myProductUrl');
                    myProductUrl && lgkorUI.requestAjaxDataPost(myProductUrl, param,function(result){

                        var data = result.data;

                        if(data.length) {
                            isMyProduct = true;
                            /* BTOCSITE-32756 모델명 내 <br> , <sup> 태그 치환 Start */
                            var replaceMyProductTemplate = vcui.template(myProductTemplate, {list : data});
                            replaceMyProductTemplate = vcui.string.replaceAll(replaceMyProductTemplate, "&lt;br&gt;","<br>",false);
                            replaceMyProductTemplate = vcui.string.replaceAll(replaceMyProductTemplate, "&lt;sup&gt;","<sup>",false);
                            replaceMyProductTemplate = vcui.string.replaceAll(replaceMyProductTemplate, "&lt;/sup&gt;","</sup>",false);
                            $myProductList.append(replaceMyProductTemplate);
                            /* BTOCSITE-32756 End */
                        } else {
                            isMyProduct = false;
                        }

                        if(typeof isMyProduct !== 'undefined' && isMyProduct) {
                            $myProduct.filter('.is-after-login').addClass('is-active');
                            if(data.length == 1){
                                $myProduct.filter('.is-after-login').find('.block-arrow').html('<span>'+data[0].modelDisplayName+'</span> ('+ data[0].modelName +')');
                            } else {
                                $myProduct.filter('.is-after-login').find('.block-arrow').html('<span>'+data[0].modelDisplayName+'</span> ('+ data[0].modelName +') 외 '+Number(result.dataCount-1)+'개');
                            }
                        } else {
                            $myProduct.filter('.is-not-my-product').addClass('is-active');
                        }
                    });
                }

                // action sheets 스펙변경 modal 노출
                var $btnActionSheetsSpec = $('.action-sheet .sibling-spec');
                $btnActionSheetsSpec.on('click', function (e){
                    e.preventDefault();
                    $('#specInfoPopup').vcModal({opener: this}); // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                });

                // LGECOMVIO-20 : 핵심스펙 옵션 비노출/비활성 관련 변수 추가
                self.enableOptionList = [];
                self.disableOptionList = [];

                // LGECOMVIO-20 : pc keyvisual 첫 visual animation 영역일 시 정지/재생 컨트롤러 이벤트 실행
                if(self.$pdpVisualAnimation.length && self.$pdpVisualAnimation.hasClass('is-active')) {
                    var $video = self.$pdpVisualAnimation.find('video');
                    var $controller = self.$pdpVisualAnimation.find('.video-controller');
                    var $pause = $controller.find('.btn-pause');
                    var $play = $controller.find('.btn-play');

                    $video.on('click', function () {
                        $controller.addClass('is-active');
                    })

                    $pause.on('click', function () {
                        $video[0].pause();
                        $(this).removeClass('is-active');
                        $play.addClass('is-active');
                    });

                    $play.on('click', function () {
                        $video[0].play();
                        $controller.removeClass('is-active');
                        $(this).removeClass('is-active');
                        $pause.addClass('is-active');
                    });
                }
                if(typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr) {
                    //옵션팝업 BTOCSITE-26021
                    self.optionPopupSet();
                    //옵션팝업 토스트 닫기 이벤트
                    $('.toast-message2').on('click', '.btn-area', function(e) {
                        e.preventDefault();
                        self.optPopToastClose();
                    });
                }

                // BTOCSITE-37933 다품목 활성화
                self.cartSwiper();
                $('.basket-btn').on('click', function() {
                    $('#actionSheetCart').vcModal({opener: this}); // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    $('#actionSheetPopup').removeClass('active');
                    setTimeout(function(){
                        $('#actionSheetCart').addClass('active');
                    }, 300);

                    setTimeout(function(){
                        KRP0008.recommandActionSheet();
                    }, 100);
                });

                $('.cart-action-sheet').find('.ui_modal_close').on('click', function() {
                    $('#actionSheetCart').removeClass('active')
                    $('html, body').css('overflow','initial');
                });

                $(document).on('click', '.ui_modal_dim', function(e) {
                    $('.cart-action-sheet').find('.ui_modal_close').trigger('click');
                    // BTOCSITE-85293 START
                    // requested by BTOCSITE-85293
                    // var isActionSheetConsentModalOpen = $('#actionSheetConsent').hasClass('ui_modal_container')
                    // if (isActionSheetConsentModalOpen) { // check 5 terms popup was actived
                    //     $('#actionSheetConsent .sheet-close').click();
                    // }
                    // BTOCSITE-85293 END
                });

                // BTOCSITE-51366 PDP 렌탈이동 경로 개선
                self.rentalSwiper();

                // BTOCSITE-72217 제품 번들링 과제
                // self.initBundledArea();

                //BTOCSITE-35421 가격 bold 정책 적용
                self.benefitPriceDisplayInit();

                //BTOCSITE-45195 임직원몰 개선(임직원 전용제품 적용) - 초기화
                if(lgkorUI.getHiddenInputData().b2cYN ==='Y'){
                    self.displayEmployeeArea();
                }else{
                    //BTOCSITE-48266 [상품] B2B OBS 구축
                    self.b2bClickEventLoad();

                }

                self.defaultValueInit();

                //BTOCSITE-71987
                if(lgkorUI.getHiddenInputData().b2cYN ==='Y' && $('#b2cLayerOnlineCounsel') !== undefined && $('#b2cLayerOnlineCounsel').length > 0){
                    self.onlineLinkMove();
                }
                //BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
                if(lgkorUI.getHiddenInputData().bizType === 'DISPOSABLE'){
                    self.disposablePaymentButtonInit('disposable_prod_purchase_button_display', 'disposable_prod_purchase_button_massage');

                    // BTOCSITE-83042 PDP 소모품 회원가 노출로직 수정
                    if ($("#employeeDisposableTab").is(':visible') == false) {
                        $('#priceArea').css('display', 'block');
                    }
                }

                /* BTOCSITE-80498 */
                if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
                    KRP0008.csContentViewRecordEvent();
                }

                /* BTOCSITE-60454 START */
                KRP0008.contentViewRecordEvent();
                /* BTOCSITE-60454 END */

                // Event after loading vcui library
                document.addEventListener('vcLoaded', _vcLoaded_1);
                function _vcLoaded_1() {
                    // 구매하기 버튼 영역
                    self.setPaymentBtnArea();
                    self.refresh();
                    document.removeEventListener("vcLoaded", _vcLoaded_1); // 한 번만 실행

                };

                //로그인,찜하기 관련 데이타 가져오기
                if(lgePdpSendData.bizTypeDetail != 'DISPOSABLE'){
                    self.getRewardInfo();
                }

                //$(document).on("click", )
                // <!-- BTOCSITE-85525 다이렉트 청약 서비스 도입 -->
            	$("a.one-time-link.direct").on('click',function(e){
            		e.preventDefault();
            		const categoryId = $(this).data("category-id");
            		let cstmParam = {categoryId:categoryId};
            		var ajaxUrl = '/care-solutions/cstmSubItemSaveCheck.lgajax';

                	lgkorUI.requestAjaxDataPost(ajaxUrl, cstmParam, function(result){
                		if (result.status === "success" && !vcui.isEmpty(result.data)) {
            				var data = result.data;
            				if(data.isSave){
            					$('#cstmSubItemModal').vcModal({opener: document.activeElement}); // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
            					$('#chkSaveHistory').off('click').on('click',function(e){
            						window.location.href = "/care-solutions/cstmSubItem?isSave=Y&categoryId="+categoryId;
                                });
                                $('#newCstmSubItem').off('click').on('click',function(e){
                                	window.location.href = "/care-solutions/cstmSubItemIntro?categoryId="+categoryId;
                                });
            				}else{
            					location.href = "/care-solutions/cstmSubItemIntro?categoryId="+categoryId;
            				}
            			}
                    }, true);
            	});

                // [S] BTOCSITE-83434 [EPIC] 구독 다품목 적용
                self.setBannerSwiper();
                // [E] BTOCSITE-83434 [EPIC] 구독 다품목 적용
				
				//BTOCSITE-94331 구독 다품목 적용 - 띠배너 적용 : start
				let vsUnifyId     = digitalData.userInfo.unifyId;
				let vsPartnerType = digitalData.userInfo.partnerType;
				
				if(!vcui.isEmpty(vsUnifyId)){
				   $('#cashBackBanner').hide();	
				   KRP0008.cashBackBanner(vsPartnerType);
                }else{
				   $('#cashBackBanner').hide();	
				} // end

                resolve();

            });
        },

        prepare: function(up20Flag) {
            var self = this;

            // BTOCSITE-15360 KRP0008 컴포넌트 수정
            if(!Array.prototype.indexOf){
                Array.prototype.indexOf = function(obj){
                    for(var i=0; i<this.length; i++){
                        if(this[i]==obj){
                            return i;
                        }
                    }
                    return -1;
                }
            };

            //핀치줌
            vcui.require(['ui/pinchZoom'], function (PinchZoom) {
                self.pinchZoom = new PinchZoom('#pop-pdp-visual .zoom-area'); // BTOCSITE-54289 PDP 오른쪽 영역 컴포넌트화 작업하며 이곳 선택자 왼쪽영역으로 한정합니다.

                self.$popPdpVisual.find('div.zoom-btn-area a.zoom-plus').on('click', function(e){
                    e.preventDefault();
                    var zoom =self. pinchZoom.getZoomFactor();
                    if(Math.round(zoom) >= 4) zoom = 0;
                    self.pinchZoom.runZoom(zoom+1, true);
                });

                self.$popPdpVisual.find('div.zoom-btn-area a.zoom-minus').on('click', function(e){
                    e.preventDefault();
                    var zoom =self.pinchZoom.getZoomFactor();
                    self.pinchZoom.runZoom(zoom-1, true);
                });

                self.$popPdpVisualImage.mousedown(function() {
                    self.isDragging = false;
                })
                    .mousemove(function() {
                        self.isDragging = true;
                    })
                    .mouseup(function() {
                        var wasDragging = self.isDragging;
                        self.isDragging = false;
                        if (!wasDragging) {
                            self.$popPdpVisual.find('div.zoom-btn-area a.zoom-plus').trigger('click');
                        }
                    });

                //pinchZoom.update(true);

                self.bindProductEvents();
                self.bindPopupEvents();
                if(up20Flag == 'Y') {
                    self.up20OptionBindSideEvents();            
                } else {
                    self.bindSideEvents();
                }
            });



            //비교하기 체크
            self.setCompares();
            self.setNotifications(); // BTOCSITE-29838 알림 신청
            // BTOCSITE-62058
            if (!self.kiosk && digitalData.productInfo.smart_home_flag ==='N') self.setPersonalRecommendation(); // BTOCSITE-36570 개인맞춤서비스

            self.setDirectRentalChange(); // BTOCSITE-51366 PDP 렌탈이동 경로 개선

            // BTOCSITE-62058
            if (typeof smartHome !== 'undefined') {
                const pkgNo = lgkorUI.parseUrl(location.href).searchParams.get("pkgNo");
                if (pkgNo) {
                    const packageLink = document.querySelector('.package-product-link a');
                    if (packageLink) {
                        packageLink.setAttribute('href', `/aihome/extension/bridgePage/${pkgNo}`);
                    }
                }
                if (smartHome) {
                    smartHome.setSmartHomeRentalRecommand();
                }
            }

            //찜하기 체크
            var ajaxUrl = self.$pdpInfo.attr('data-wish-url');
            lgkorUI.checkWishItem(ajaxUrl);

            //전달받은 리뷰카운트를 krp0009 컴퍼넌트에 넘김
            if(typeof reviewsCount !== 'undefined' && reviewsCount != "") {
                if(parseInt(reviewsCount) > 0) {
                    $(window).trigger("changeCategory.KRP0009",{"title":"리뷰(" + reviewsCount + ")","linkName":"review"});
                }
            }
        },

        setting: function() {
            var self = this;
            //pdp데이타
            self.$pdpData = $('#pdp-data');

            //콤포넌트
            self.$component = $('section.component.KRP0008');

            //데스크탑용 갤러리
            self.$pdpVisual = $('#desktop_summary_gallery div.pdp-visual');
            //데스크탑용 갤러리 - '※소비자의 이해를 돕기 위해 연출된 이미지입니다.' - BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다.
            self.$pdpVisualNotice = $('#pdp_visual_click2');
            //데스크탑용 pdp visual 하위 전체
            self.$pdpVisualList = self.$pdpVisual.find('[class*="pdp-visual-"]');
            //데스크탑용 갤러리 이미지
            self.$pdpImage = self.$pdpVisual.find('div.pdp-visual-image');
            //데스크탑용 video
            self.$pdpVisualVideo = self.$pdpVisual.find('div.pdp-visual-video');
            //데스크탑용 animation
            self.$pdpVisualAnimation = self.$pdpVisual.find('div.pdp-visual-animation');
            //데스크탑용 갤러리 썸네일리스트
            self.$pdpThumbnail = self.$pdpVisual.find('div.pdp-thumbnail-nav div.inner div.pdp-thumbnail-list ul.thumbnail-list');
            self.$pdpThumbnail.find('li > a').append('<span class="blind">선택안됨</span>');
            //선택된 데스크탑 썸네일
            self.$selectItemTarget = self.$pdpThumbnail.find('li.active');
            self.$selectItemTarget.find('.blind').text("선택됨");
            //데스크탑용 갤러리 디스클레이머
            self.$pdpVisualNotices = self.$pdpVisual.find('span.pdp-visual-notice');

            //모바일용 갤러리
            self.$pdpMobileVisual = $('#mobile_summary_gallery');
            //self.$pdpMobileVisual.hide();
            //모바일용 갤러리 슬라이더
            self.$pdpMobileSlider = self.$pdpMobileVisual.find('div.ui_carousel_slider');
            //모바일용 갤러리 썸네일 슬라이더
            self.$pdpMobileSliderTrack = self.$pdpMobileSlider.find('div.slide-content ul.slide-track');
            //모바일용 갤러리 인덱스
            self.$slideNumber = self.$pdpMobileVisual.find('div.slide-number .current');

            //PDP 더보기
            self.$pdpMoreInfo = $('div.pdp-more-info');

            //PDP모달
            self.$popPdpVisual = $('#pop-pdp-visual');
            //PDP모달 360
            self.$popPdpVisual360 = self.$popPdpVisual.find('#modal_detail_target div.item.r360');
            //PDP모달 이미지타입
            self.$popPdpVisualImage = self.$popPdpVisual.find('#modal_detail_target div.item.image');
            //PDP모달 비디오타입
            self.$popPdpVisualVideo = self.$popPdpVisual.find('#modal_detail_target div.item.video');
            //PDP모달 애니메이션타입
            self.$popPdpVisualAnimation = self.$popPdpVisual.find('#modal_detail_target div.item.animation');
            //PDP모달 썸네일 리스트
            self.$popPdpThumbnail = self.$popPdpVisual.find('div.pop-pdp-thumbnail-nav ul.pop-thumbnail-list');
            self.$popPdpThumbnail.find("li a").attr("aria-selected","false");
            //선택된 PDP모달 썸네일
            self.$selectModalItemTarget = self.$popPdpThumbnail.find('li.active');
            //PDP모달 확대축소 버튼영역
            self.$popPdpZoomArea = self.$popPdpVisual.find('div.zoom-btn-area');
            //PDP모달 item-number
            self.$itemNumber = self.$popPdpVisual.find('div.item-number .current');
            self.$view360 = $('#view360'); // BTOCSITE-15587
            //PDP모달 갤러리 디스클레이머
            self.$pdpVisualNoticePopup = self.$popPdpVisual.find('span.pdp-visual-notice-popup');

            //PDP 인포
            self.$pdpInfo = $('div.pdp-info-area');
            self.$mobilePdpInfo = $('div.mobile-pdp-info');
            self.$pdpInfoProductDetailInfo = self.$pdpInfo.find('.product-detail-info');
            self.$productBuyOptionTab = self.$pdpInfoProductDetailInfo.find('.ui_tab:eq(0)');
            //self.$pdpInfoSiblingOption = self.$pdpInfo.find('.sibling-option');
            self.$specInfoPopup = $('#specInfoPopup'); //20210607 스펙선택 추가
            self.$pdpInfoSiblingOption = self.$specInfoPopup.find('.sibling-option'); //20210607 스펙선택 추가
            self.$pdpInfoSiblingColorText = $('.chk-wrap-colorchip'); //20210607 스펙선택 추가

            //BTOCSITE-2551 PDP > 매장상담 예약 > 코드에 따른 분기처리
            self.$pdpInfoWrap = $('div.pdp-wrap .pdp-info-area');
            self.$pdpInfoProductDetailInfo = self.$pdpInfoWrap.find('.product-detail-info');
            self.$packageButton = self.$pdpInfoProductDetailInfo.find('.info-bottom .link-area ul rental-counsel a');

            // 20210923 BTOCSITE-3534 [퍼블] [사용자행태분석 개선사항] PDP 제품명/리뷰 링크 개선
            self.$copy =  self.$component.find('.copy');

            //LGECOMVIO-20
            self.$actionSheetCallBtn = $('.action-sheet-call');
            self.$actionSheet = $('.action-sheet');
            self.$actionSheetCart = $('#actionSheetCart');

            self.$serviceOptPopup1 = $('#pop_subs_common'); //BTOCSITE-22701 add :: 선택옵션 팝업

            self.$bannerLink = $('.scrb-option-banners');   // BTOCSITE-22701 add :: 결합할인 배너
            self.$compositionInfoPopup = $('#compositionInfoPopup');// BTOCSITE-22701 add :: 구성상품 팝업
            //가격정보
            self.$pdpInfoPaymentAmount = self.$pdpInfo.find('.payment-amount');
            self.$pdpInfoPaymentAmount.data('quantity',1); //기본수량 1 세팅
            
            // BTOCSITE-30700 이용요금, 셀렉트박스 영역 노출 처리
            self.$pdpInfoProductDetailInfo.find('.info-accordion-wrap.detail-option-box').css('display', 'block');
            
            if(typeof productPrice !== 'undefined' && productPrice != "") {
                self.$pdpInfoPaymentAmount.data('price',productPrice);
            } else {
                self.$pdpInfoPaymentAmount.data('price',0);
            }

            var $paymentInput = self.$pdpInfoPaymentAmount.find('input.quantity');
            $paymentInput.each(function(index, item){
                var $paymentAmount = $(item).parents('.payment-amount');
                $paymentAmount.data('quantity',item.value);
            });

            // BTOCSITE-70412 START
            if ($('div.pdp-info-area .payment-amount input.quantity').length > 0) {
               if ($('div.pdp-info-area .payment-amount input.quantity').val() > 1) {
                  self.$pdpInfoPaymentAmount.data('quantity', parseInt($('div.pdp-info-area .payment-amount input.quantity').val()));
               }
            }
            // BTOCSITE-70412 END
            self.$pdpInfoPaymentAmount.each(function(index,item){
                self.updatePaymentAmountPrice($(item));
            });

            //
            self.$pdpInfoAdditionalPurchase = self.$pdpInfo.find('.additional-purchase');
            //
            //self.$pdpInfoAllCareshipService = self.$pdpInfo.find('.careship-service');
            self.$pdpInfoCareshipService = self.$pdpInfo.find('div.careship-service');

            self.$pdpInfoCareSiblingOption = self.$pdpInfo.find('div.care-sibling-option');


            //LGECOMVIO-20 렌탈 옵션 체크
            self.rentalAllSelect = true;


            // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용 start
            if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                self.rentalSetting();
            }
            // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용 end

            // 재구독 할인가 일반 PDP 페이지 적용 b2c 가전구독만 재구독 할인
            if(lgkorUI.getHiddenInputData().b2cYN ==='Y' && lgePdpSendData.bizTypeDetail === "CARETAB"){
                self.reSubDisCount();
            }

            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성 START
            var careSelectBoxIndex1 = 0;
            var careSelectBoxIndex2 = 0;

            var selectCareRtModelSeq = null;
            var selectCareVisitTerm = null;
            var selectCareSvcTypeDesc = null;

            var oCareShipInfoData = {};

            careShipInfo.forEach(function(item, index) {

                // 1. 방문주기
                var visitPerTxt = (!item.visitPer || parseInt(item.visitPer) === 0) ? '방문없음/자가관리' : '1회 / '+item.visitPer+'개월'; //BTOCSITE-7447
                var visitPerKey  = visitPerTxt;

                // 2. 서비스타입
                var svcTypeDesc = (item.svcTypeUseYn === "Y") ? ("" + item.svcTypeDesc) : ""; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성

                // 데이터 재정렬
                var dataBySvcTypeDesc = oCareShipInfoData[visitPerKey] || [];

                dataBySvcTypeDesc.push(item);

                oCareShipInfoData[visitPerKey] = dataBySvcTypeDesc; // 첫번째값

                if(item.representChargeFlag == "Y") {
                    selectCareRtModelSeq = item.rtModelSeq;
                    selectCareVisitTerm =  visitPerTxt;
                    selectCareSvcTypeDesc = svcTypeDesc; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성
                }
            });
            self.careshipInfoData = oCareShipInfoData;

            //최초 기본값 찾기
            if(selectCareRtModelSeq) {
                // 방문주기 찾기
                var array = Object.keys(self.careshipInfoData);
                for (var i = 0, len = array.length; i < len; i++) {
                    if(array[i] == selectCareVisitTerm) {
                        careSelectBoxIndex1 = i;
                        break;
                    }
                }

                // 서비스타입 찾기
                var dataBySvcTypeDesc = self.careshipInfoData[selectCareVisitTerm];
                for (var i = 0, len = dataBySvcTypeDesc.length; i < len; i++) {
                    if(dataBySvcTypeDesc[i].representChargeFlag == "Y") {
                        careSelectBoxIndex2 = i;
                        break;
                    }
                }
            }
            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성 END


            //케어십 계약기간
            self.$careshipInfoSelectBox = self.$pdpInfoCareshipService.find('.ui_selectbox:eq(0)');
            self.$careshipInfoSelectBox2 = self.$pdpInfoCareshipService.find('.ui_selectbox:eq(1)');
            if(self.careshipInfoData && self.$careshipInfoSelectBox.length > 0) {
                // self.updateCareshipInfoPrice(self.careshipInfoData[careSelectIndex]);
                self.careshipInfoSelectBoxUpdate(self.$careshipInfoSelectBox,self.careshipInfoData,careSelectBoxIndex1,true);

                //서비스타입
                var key = Object.keys(self.careshipInfoData)[careSelectBoxIndex1];
                var svcTypeDescData = self.careshipInfoData[key];

                if(svcTypeDescData) {
                    self.updateCareshipInfoPrice(svcTypeDescData[careSelectBoxIndex2]);
                    self.careshipInfoSelectBoxUpdate(self.$careshipInfoSelectBox2,svcTypeDescData,careSelectBoxIndex2,true);
                } else { // 서비스타입 데이터가 없을때
                    self.updateCareshipInfoPrice(svcTypeDescData[0]);
                    self.careshipInfoSelectBoxUpdate(self.$careshipInfoSelectBox2,svcTypeDescData,0,true);
                }
            }

            // 케어십 서비스타입



            //렌탈 케어솔루션 제휴카드 리스트 정리
            //var isTab = false;

            self.rentalCardList = [];
            if(typeof rentalAssociatedCardList !== 'undefined' && rentalAssociatedCardList.length > 0) {
                self.rentalCardList = self.makeAssociatedCardListData(rentalAssociatedCardList);
            }

            self.$rentalCardList = self.$pdpInfoCareSiblingOption.find('.rental-card-list'); //BTOCSITE-3523 선택자 수정
            if(self.$rentalCardList.length > 0) {
                //isTab = true;
                self.updateAssociatedCardList(self.$rentalCardList, self.rentalCardList);
            }

            //케어십 제휴카드 리스트 정리
            self.careCardList = [];
            if(typeof careshipAssociatedCardList !== 'undefined' && careshipAssociatedCardList.length > 0) {
                self.careCardList = self.makeAssociatedCardListData(careshipAssociatedCardList);
            }

            self.$careshipCardList = self.$pdpInfoCareshipService.find('.select-box:eq(1)');
            if(self.$careshipCardList.length > 0) {
                //isTab = true;
                self.updateAssociatedCardList(self.$careshipCardList, self.careCardList);
            }

            if($("#typeRental").length) {
                var $paymentAmount = self.$pdpInfoProductDetailInfo.find('.payment-amount');
                var $cardList = self.$pdpInfoProductDetailInfo.find('div.care-sibling-option > .select-box');
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    //케어쉽 선택 버튼이 있으므로 케어타입
                    self.updateAssociatedCardList($cardList, self.careCardList);
                } else {
                    //렌탈타입
                    self.updateAssociatedCardList($cardList, self.rentalCardList);
                }
            }

            //최초 케어쉽 체크 여부
            var checkinput = self.$pdpInfoCareshipService.find('input[type=radio]:checked');
            if(checkinput.length > 0) {
                var check = lgkorUI.stringToBool(checkinput.val());
                var $paymentAmount = self.$pdpInfo.find('.payment-amount'); //LGECOMVIO-20
                self.updatePaymentAmountState($paymentAmount, check);
            }

            //리뷰 클릭하기 // BTOCSITE-59618 탭 로드전에 클릭 방지 및 개선된 스크롤 이동 함수인 KRP0009-2.0.0.js > exactScrollMove() 호출로 대체
            self.$pdpInfoProductDetailInfo.on('click', '.star-rating-wrap a', function(e) {
                e.preventDefault();
                var href = $(this).attr('href');

                if (href && href.match(/^\#\w/i)) $('.pdp-tab .tab-menu > a').filter('[href="'+href+'"]').trigger('click');
            });

            // Event after loading vcui library
            document.addEventListener('vcLoaded', _vcLoaded_2);
            function _vcLoaded_2() {
                self.$pdpMobileSlider.vcCarousel({
                    infinite: true,
                    autoplay: false,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    prevArrow:'.btn-arrow.prev',
                    nextArrow:'.btn-arrow.next',
                    focusOnSelect: false,
                    focusOnChange: false,
                    dots: false,
                    buildDots: false,
                    cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    speed: 150,
                    touchThreshold: 100
                });
                document.removeEventListener("vcLoaded", _vcLoaded_2); // 한 번만 실행
            };

            //BTOCSITE-44 시블링레이어
            self.defaultSiblingDataFlag = true;
            self.codesSortArry = [];
            self.pdpUniqTitle = [];
            self.receivedSiblingData = [];
            self.$specInfoPopup = $('#specInfoPopup'); /* 20210607 스펙선택 추가 */
            self.$siblingCont = self.$specInfoPopup.find('.sibling-cont');
            self.$siblingBtnComp = self.$specInfoPopup.find('.btn-sibling-select');
            self.siblingCurrentModel = "";

            //LGECOMVIO-20
            self.actionSheetCallEvent();
            self.settingAppByArPopup();
            self.laptapSelectColor(); // BTOCSITE-47671 노트북 색상 선택
            self.laptabPopupCarousel(); // BTOCSITE-47671 Popup Carousel 
            self.laptabPopupClose(); // BTOCSITE-47671 노트북 옵션 팝업 닫기
            
            //옵션 선택 BTOCSITE-26021
            self.$optHeader = self.$specInfoPopup.find('.pop-header');
            // 옵션 리뉴얼
            self.$laptapOpt = self.$pdpInfo.find('li.laptap-opt');

            // BTOCSITE-62058스마트홈 경험 솔루션
            var smartWrap = $('.component-wrap .smart-home-wrap')
            var smartItems = smartWrap.find('.smart-home-area > div').last().prop('className');
            if( smartItems == 'smart-banner-area' ){
                smartWrap.addClass('lastBanner');
            }
            //BTOCSITE-90632
            $('.product-share .tooltip-wrap.share .ui_tooltip-target').on('click',function(e){
				var $tooltipBox = $('.product-share .tooltip-wrap.share .tooltip-box');
				$tooltipBox.css({'top':34 });
                if(window.innerWidth < 768 && $('.subRenewPdpWrap').length == 1 && $('#paymentButtonArea').length == 1){
                    var yMax = $tooltipBox.outerHeight() + $(this).offset().top + $(this).outerHeight() - 12;
                    if( $('#paymentButtonArea').offset().top < yMax){
                        yMax = $('#paymentButtonArea').offset().top - yMax;
                        $tooltipBox.css({'top':yMax });
                    }
                }
            });
			//BTOCSITE-83472
			var isResizeScroll = false;
			var resizeObserver = new ResizeObserver(function(entries){
				if(isResizeScroll && window.innerWidth < 768){
					var $id = $(window.pdpTabId)
					if($id.length > 0 && $id.offset().top != $(window).scrollTop()){
						console.log('resizeMoveTop')
						$(window).trigger('resizeMoveTop',window.pdpTabId);
					}
				}
			});
			resizeObserver.observe($('body')[0]);
			$(window).on('startResizeObserver',function(e,obj){
				isResizeScroll = true;
			})
			$(window).on('wheel.stopResizeObserver', function(e) {
				isResizeScroll = false;
			});
			$(document).on('touchstart.stopResizeObserver', function(e) {
				isResizeScroll = false;
			});

            let bannerCnt = $('div.banner-slide').find('div.swiper-container').find("div.swiper-wrapper").children('div.swiper-slide').length;
            if(bannerCnt == 1){
                $("div.banner-slide").find('div.banner-slide-box').addClass('one-bn');
            }else{
                $("div.banner-slide").find('div.banner-slide-box').removeClass('one-bn');
            }
        },
        
        refresh: function () {
            var self = this;

            // BTOCSITE-62058스마트홈 경험 솔루션
            self.smartProdSticky();
            self.smartPackageSwiper();
            self.packageScrollLeft();
        },

        resizeEnd: function () {
            var self = this;

            // BTOCSITE-62058스마트홈 경험 솔루션
            self.packageScrollLeft();
        },

        breakpointChange: function (e, data) {
            var self = this;
            
            isMobile = data.isMobile;

            self.refresh();
        },

        disableKRP0009Tab: function () { // BTOCSITE-55284 // KRP0009 init 전 탭 클릭에 대한 대응
            $('.subRenewPdpWrap').on('click', '.KRP0009 .pdp-tab .tab-menu > a', function (e) {
                if (!$(this).closest('.KRP0009').data('inited')) {
                    e.preventDefault();
                    document.querySelector(e.currentTarget.getAttribute('href')).scrollIntoView();

					//BTOCSITE-83472
                    if(window.innerWidth < 768){
						var id = e.currentTarget.getAttribute('href');
						window.pdpTabId = id;
					}
                }
            });
        },

        //BTOCSITE-2551 PDP > 매장상담 예약 > 코드에 따른 분기처리
        bindRentalPopupEvents: function() {
            var self = this;
            self.$packageButton.on('click', function(e){
                var $this = $(this);
                if( $this.hasClass('package')) {
                    e.preventDefault();
                    var popupId = $this.attr('href');
                    $(popupId).vcModal({opener: this});
                }
            })

            $('.popup-package-model').find('.pop-footer .btn').on('click', function(e){
                var _self = this;
                var $targetPopup = $(this).closest('.popup-package-model')
                self.packageSelect(_self, $targetPopup)
            })
        },
        packageSelect: function(alertTarget, $targetPopup){
            var $radio = $targetPopup.find('.model-list input:radio');
            if( !$radio.filter(':checked').length ) {
                var msgTxt = '제품을 선택해주세요';
                lgkorUI.alert("", {title: msgTxt}, alertTarget);
            } else {
                location.href = $radio.filter(':checked').data('model-path');
            }
        },

        popUpDataSetting: function() {
            var self = this;
            self.$awardPopup = $('#awardPopup');
            self.$saleInfoPopup = $('#saleInfoPopup'); // BTOCSITE-5781
            self.$benefitInfoPopup = $('#benefitInfoPopup'); //추후 삭제 buyBenefitInfoPopup로 대체 처리
            self.$buybenefitInfoPopup = $('#buyBenefitInfoPopup'); //LGECOMVIO-20 추가
            self.$buybenefitInfoPopupNew = $('#buyBenefitInfoPopupNew'); // BTOCSITE-66272 구매 혜택 안내 팝업 신규 디자인
            self.benefitCardPopup = $('#benefitCardPopup'); //LGECOMVIO-20 추가
            self.$caresolutionInfoPopup = $('#caresolutionInfoPopup');

            self.$mainInitPopup = $('#main-init-popup'); //BTOCSITE-1025 : add 20210802
            self.$maxBenefitPopup = $('#maxBenefitPopup'); //최대혜택가 popup
            self.$maxBenefitPopup2 = $('#maxBenefitPopup2'); //최대혜택가2 popup
            self.$memberPricePopup = $('#memberPricePopup'); //회원할인가 popup
            self.$couponPricePopup = $('#couponPricePopup'); //쿠폰할인가 popup
            self.$employeeTabCouponPricePopup = $('#employeeTabCouponPricePopup'); //쿠폰할인가(임직원/복지몰) popup
            self.$employeeTabMaxBenefitPopup = $('#employeeTabMaxBenefitPopup'); //최대혜택가(임직원/복지몰) popup
            // self.$staffPricePopup = $('#staffPricePopup');
            // BTOCSITE-85293 START
            self.$actionSheetConsentPopup     = $('#actionSheetConsent');
            self.$sheetConsent1Popup          = $('#sheetConsent01');
            self.$sheetConsent2Popup          = $('#sheetConsent02');
            self.$sheetConsent3Popup          = $('#sheetConsent03');
            self.$sheetConsent4Popup          = $('#sheetConsent04');
            self.$sheetConsent5Popup          = $('#sheetConsent05');
            // BTOCSITE-85293 END
        },

        bindProductEvents: function() {
            var self = this;

            // 20210923 BTOCSITE-3534 [퍼블] [사용자행태분석 개선사항] PDP 제품명/리뷰 링크 개선
            self.$copy.on('click',function() {
                var $this = $(this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 모델명 복사 팝업 close 시 포커스 이동
                var txt = $(this).clone().find('.blind').remove().end().text().trim();// BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 모델명 복사 시 숨김텍스트 제거
                lgkorUI.confirm('모델명을 복사하시겠습니까?', {
                    title: "",
                    cancelBtnName: "취소",
                    okBtnName: "복사",
                    ok:function(){
                        vcui.dom.copyToClipboard(txt, {
                            container:this,
                            onSuccess: function () {
                                // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 모델명 복사 팝업 close 시 포커스 이동
                                $(window).off('toastopen.productNameCopy').on('toastopen.productNameCopy', function() {
                                    setTimeout(function() {
                                        $('.toast-text').focus();
                                    }, 300);
                                    $(window).off('toastopen.productNameCopy');
                                });
                                $(window).trigger("toastshow",{text:"모델명을 복사했습니다.", opener:$this});
                                // [E] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 모델명 복사 팝업 close 시 포커스 이동
                            }
                        });
                    }
                }, $this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 모델명 복사 팝업 close 시 포커스 이동
            });

            //데스크탑용 갤러리 이미지 클릭
            self.$pdpImage.find('a').first().on('click',function(e){
                e.preventDefault();
                var index = $(this).attr("data-idx");
                self.openVisualModal(index, this);
            });
            self.$pdpVisualNotice.on('click',function(e){ // BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다.
                e.preventDefault();
                var index = $(this).attr("data-idx");
                self.openVisualModal(index, this);
            });

            //데스크탑용 썸네일리스트 클릭
            self.$pdpThumbnail.on('click','li a',function(e) {
                e.preventDefault();
                var $li = $(this).parent();
                var index = $(this).parents('li').index();
                if($li.hasClass('more')) {
                    //더보기 버튼은 바로 pdp모달 뛰움
                    self.openVisualModal(index, this);
                } else {
                    //썸네일 클릭
                    self.clickThumbnailSlide(index, this);
                }
            });

            self.$pdpMobileSlider.on('click', 'a', function(e){
                e.preventDefault();
                var index = $(this).parents(".ui_carousel_current").attr("data-ui_carousel_index");
                self.openVisualModal(index, this);
            });

            //모바일용 갤러리 클릭 //BTOCSITE-19922
            self.$pdpMobileVisual.on('click', '.pdp-visual-animation .video-controller button', function(e){
                var $video = $(this).parents('.pdp-visual-animation').find('video');
                var $parent = $video.parent('.pdp-visual-animation');
                var $controller = $parent.find('.video-controller');
                var $pause = $controller.find('.btn-pause');
                var $play = $controller.find('.btn-play');

                $parent.addClass('is-active');
                $controller.addClass('is-active');

                if( $(this).hasClass('btn-pause') ){
                    $video[0].pause();
                    $(this).removeClass('is-active');
                    $play.addClass('is-active');
                } else {
                    $video[0].play();
                    $controller.removeClass('is-active');
                    $(this).removeClass('is-active');
                    $pause.addClass('is-active');
                }
            });

            //pdp모달 썸네일 리스트 클릭
            self.$popPdpThumbnail.on('click','li a',function(e) {
                e.preventDefault();
                var index = $(this).parents('li').index();

                self.$popPdpThumbnail.find('li a').attr("aria-selected","false");
                $(this).attr("aria-selected","true");

                self.clickModalThumbnail(index);
            });

            //모바일 갤러리 슬라이드시 인덱스 넘버 표시
            self.$pdpMobileSlider.on('carouselafterchange', function(e,target,index){
                self.$slideNumber.text(index + 1);
            });

            //팝업 열기
            //PDP 갤러리 더보기(수상내역등)
            self.$pdpMoreInfo.on('click','a.btn-link.popup', function(e) {
                e.preventDefault();
                var arr = [];
                var loaded = self.$awardPopup.data('loaded');
                if(!loaded) {
                    self.$awardPopup.data('loaded', true);
                    if(typeof awards !== 'undefined' && awards.length > 0) {
                        arr = awards instanceof Array ? awards.slice(0,4) : [];
                        var $list_ul = self.$awardPopup.find('ul.awards-list');
                        $list_ul.empty();

                        var $frag = $(document.createDocumentFragment());
                        arr.forEach(function(item) {
                            $frag.append(vcui.template(awardPopupItemTemplate, item));
                        });
                        $list_ul.append($frag);
                    }
                }

                if(arr.length == 1 || this.parentElement.getAttribute("class").indexOf("award-swiper") > 0) { // BTOCSITE-22977 수상내역일 경우에는 팝업창이 아닌 url로 바로 가도록 수정
                    self.$awardPopup.find('.btn-group button[data-link-url]').trigger('click');
                } else {
                    self.$awardPopup.vcModal({opener: this});
                }
            });

            //수상내역 아이템 클릭
            self.$awardPopup.on('click','li a.award-item', function(e) {
                self.$awardPopup.find('.btn-group button[data-link-url]').trigger('click');
            });

            //AR체험하기 클릭
            self.$component.on('click','div.pdp-ar-area a.btn-ar', function (e){
                e.preventDefault();
                var modelId = this.dataset.arModelId;
                if(!lgkorUI.openAR(modelId)) {
                    $('#arPopup').vcModal({opener: this});
                }
            });

            //360 view
            self.$component.on('click','div.pdp-ar-area a.btn-360', function (e){
                e.preventDefault();
                self.clickThumbnailSlide($(this).data('index'));
            });

            // $(window).on('appNotInstall', function(e){
            //     $('#arPlayPop').vcModal({opener: e.currentTarget});
            // });

            // 리뉴얼 옵션 클릭
            $(document).off('click', 'li.laptap-opt .opt-area input').on('click', 'li.laptap-opt .opt-area input', function (e) {
                e.preventDefault();

                var modelUrlPath = $(this).attr("data-model-url-path");
                if (!modelUrlPath) {
                    return false;
                }

                if (modelUrlPath == location.pathname) {
                    return false;
                }

                var changeOptionList = [];
                var tempChangeOptionList = $(this).attr("data-change-option-list").slice(1, -1).replaceAll(" ", "");
                if (tempChangeOptionList) {
                    changeOptionList = tempChangeOptionList.split(',');
                }

                var param = {
                    pickOptionId: $(this).attr("id").replaceAll("opt-", ""),
                    changedOptionIds: changeOptionList,
					top : $(window).scrollTop()
                };

				//location.href = lgkorUI.DEFAULT_URL+modelUrlPath; //BTOCSITE-48266 b2b url 추가
				try {
                    // lgkorUI.showLoading();
                    $('body').promise().then(function () {
                        __PDP_DOM_MNG__.load(lgkorUI.DEFAULT_URL+modelUrlPath, param);
                        KRP0008.isEventTriggered = true;
                    });
                } catch(e) {
                    lgkorUI.hideLoading();
                    KRP0008.isEventTriggered = false;
                }
				
            });

            // [S] BTOCSITE-91373 [QC][AOS] 구독 계약기간별 상품 이동 영역 내 특정 구독 건 선택 시 페이지 이동되지 않음
            // BTOCSITE-51366 PDP 렌탈이동 경로 개선 85521 문제
            $('ul.rental-new-list li.rental-new-item a').on('click', function(e) {
                e.preventDefault();

                if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "PRODUCT"){
                    let callbackVal = KRP0008.b2bLoginCheck(e);
                    if(!callbackVal) return;
                }

                let url  = $(this).closest('div.rental-new').children('a').prop('href');
                if (url) {
                    lgkorUI.setStorage("dispRtModelSeq", $(this).data('rt-model-seq'));
                    location.href = url;
                }
            });
            // [E] BTOCSITE-91373 [QC][AOS] 구독 계약기간별 상품 이동 영역 내 특정 구독 건 선택 시 페이지 이동되지 않음
        },

        contentLoadingScrollEvent: function() {

            $(window).scroll(function(){

                if (KRP0008.isEventTriggered) {
                    try {
                        // 이벤트 대상
                        var $targetElement = $('.lists.member');
                        // 대상 요소의 페이지 상단으로부터의 거리
                        var targetOffset = $targetElement.offset().top;
                        // 현재 스크롤 위치
                        var scrollPosition = $(window).scrollTop();
                        // 윈도우 높이
                        var windowHeight = $(window).height();
                        // 문서 전체 높이
                        var documentHeight = $(document).height();

                        if (scrollPosition > targetOffset || scrollPosition + windowHeight >= documentHeight) {
                            KRP0008.isEventTriggered = false; 	// 이벤트 발생 처리 표시

                            $(window).trigger('contentLoad');	// 컨텐츠 로딩
                        }

                    } catch(error2) {
                        KRP0008.isEventTriggered = true; // 이벤트 발생 처리 표시 (스크롤 이벤트 발생 가능 상태로 변경)

                        console.error('컨텐츠 스크롤 이벤트 실패: ', error2);
                    }
                }

            });

            // 컨텐츠 로딩 이벤트 등록
            $(window).off('contentLoad').on('contentLoad', function(e){

                $('#contentLoading').show();

                var _promise = __PDP_DOM_MNG__.loadContent(window.location.pathname);

                Promise.all([_promise]).then((result) => {
                    __PDP_DOM_MNG__.execComponentsJs('content');
                    $(window).trigger('load');
                }).catch((error) => {
                    console.error('컨텐츠 로드 실패: ', error);
                });

            });

        },

        setGiftPopup: function (e, data) {  //66272 모달 팝업 내에 들어가는 스와이프 함수
            var $popup = $(e.target);
            var $carousels = $popup.find(".gift-swiper");
            var eventNS = '.buy-benefit';

            // 페이징 변경
            var changePagination = function (carousel) {
                var $indicator = carousel.$el.find(".custom-indi-wrap");
                var $slideCurrent = $indicator.find(".current");
                var $totalCount = $indicator.find(".count");

                var idx = carousel.getCurrent();
                var dotlen = carousel.getDotCount(); // slide 1개면 0

                $slideCurrent.text(idx + 1);
                $totalCount.text(dotlen + 1);

                $indicator.toggle(!!dotlen);
            }

            // 캐러셀
            $carousels.each(function (idx, elm) {
                var $carousel = $(elm);
                
                // 중복 방지
                if ($carousel.vcCarousel('instance', false)) return;

                // 초기화
                $carousel
                .on("carouselafterchange", function (e, carousel, index) {
                    changePagination(carousel);
                }).on("carouselinit", function (e, carousel, index) {
                    changePagination(carousel);
                })
                .vcCarousel({
                    infinite: true,
                    autoplay:false,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: '.btn-arrow.ico-prev',
                    nextArrow: '.btn-arrow.ico-next'
                });
            });

            /**
             * 아코디언 확장 함수
             * @param {jQueryElement} target .ui_accordion 대상
             * @param {number} index 활성화 넘버
             */
            var expandAccordion = function (target, index) {
                if (!target.length) return;
                    
                var accordion = target.vcAccordion('instance', false);
                if (accordion && index >= 0) accordion.expand(index , false);
            }

            // 탭 버튼
            var $tab = $popup.find('.ui_tab'); // 팝업 내부 탭 elm
            var tab = $tab.vcTab('instance', false);

            var targetId = $(data.opener).data("active-target"); // 팝업 오픈한 버튼 dataset
            var matchTabIdx = $popup.find('ul.tabs > li[data-active-target^="'+ targetId.slice(0, -1) +'"]').index(); // 열어둘 아코디언 item index

            if (tab && targetId) {
                // 탭 변경
                $tab
                .off(eventNS)
                .on(tab.$statics.ON_CHANGED + eventNS, function (e, data) {
                    var x = data.button.get(0).offsetLeft;

                    // 탭 버튼 활성화 가로 스크롤 이동
                    data.button.closest('.tabs').get(0).scrollTo({ left: x, behavior: "smooth" });

                    if (!!data.content.find('.ui_accordion').length) {
                        // 아코디언 컨텐츠 존재 시 전부 닫기
                        data.content.find('.ui_accordion').vcAccordion('collapseAll');
                    }
                });

                if (matchTabIdx > -1) tab.select(matchTabIdx); // 해당 탭버튼 활성화

                var $currenTabCont = tab.$contents.eq(matchTabIdx); // 해당 탭 컨텐츠
                var $accordion = $currenTabCont.find('.ui_accordion'); // 탭 컨텐츠 내부 아코디언
                var chooseIndex = $currenTabCont.find('li#' + targetId).index(); // 탭 컨텐츠 내부 아코디언 ui와 targetId와 맞는 element index
                
                expandAccordion($accordion, chooseIndex);
            }

            // 아코디언 토글 시
            $popup.find('.ui_accordion').each(function (idx, elm) {
                var $accordion = $(elm);
                var accordion = $accordion.vcAccordion('instance', false);

                if (!accordion) return;

                $accordion
                .off(eventNS)
                .on(accordion.$statics.ON_START_EXPAND + eventNS, function (e, data) {
                    // 아코디언 열리기 직전 내부 carousel setPosition 으로 ui 갱신
                    data.content.find('.ui_carousel_initialized').vcCarousel('setPosition', true); 
                })
                .on(accordion.$statics.ON_EXPAND + eventNS, function (e, data) {
                    // 아코디언 컨텐츠 열린 후
                    var $popCont = $(e.target).closest('.pop-conts');

                    if (!$popCont.length) return;

                    // 팝업 내에 스크롤이 생겼다면
                    if ($popCont.get(0).clientHeight !== $popCont.get(0).scrollHeight) {
                        // 아코디언에 의해 팝업 스크롤이 생겼다면 아코디언 컨텐츠 내부 carousel width 변경되었으니 setPosition 으로 ui 갱신
                        data.content.find('.ui_carousel_initialized').vcCarousel('setPosition');
                    }
                });
            })

            // 팝업 열리면 내부 초기화된 carousel refresh 1회 실행
            $popup.find('.ui_carousel_initialized').vcCarousel('setPosition', true);
        },

        bindSideEvents: function() {
            var self = this;
            var checkCompareClick = false;

            // LGECOMVIO-20 TAB 제외로 수정
            if(self.$pdpInfo.find('.option-contents').length) {
                if ($('#typeOrder').length) {
                    self.$pdpInfo.attr('data-type-cart', 'P');
                } else {
                    self.$pdpInfo.attr('data-type-cart', 'C');
                }
            }

            //모바일 수상내역 버튼
            self.$mobilePdpInfo.on('click','div.inner a.btn-link.popup', function (e) {
                e.preventDefault();
                self.$pdpMoreInfo.find('a.btn-link.popup').trigger('click');
            });

            //비교하기
            self.$pdpInfo.find('.product-compare input[type=checkbox]').off('click').on('click', function(e) {
                e.preventDefault();
                // BTOCSITE-30428 : 빠른 클릭시 레이아웃이 안뜨는 형상 발생
                if(checkCompareClick) {
                    return;
                }
                checkCompareClick = true;

                var checked = !$(this).hasClass('compare-select');
                var pdpDataId = self.$pdpInfo.attr('data-id'); //BTOCSITE-5856 비교하기 버튼 토글기능 오류

                if(checked) {
                    $(this).addClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
                } else {
                    $(this).removeClass('compare-select');
                    // BTOCSITE-30428 : $('.sticy-compare .list-inner li') 이벤트 발생되어 비교하기 삭제시에서도 세션캐시 2번 호출로 인한 에러 발생
                    // $('.item-inner[data-id=' + pdpDataId + ']').siblings('.btn-close').trigger('click'); //BTOCSITE-5856 비교하기 버튼 토글기능 오류
                }
                //$(this).prop('checked',!checked);
                //self.requestCompareItem(lgePdpSendData, checked, $(this));
                var categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
                var categoryNm = lgkorUI.getHiddenInputData().defaultCategoryName;

                var compareId = lgePdpSendData.sku.split(".");
                if(typeof modelName !== 'undefined') {
                    compareId = modelName;
                }

                if(checked){
                    var compareObj = {
                        "id": lgePdpSendData.id,
                        "b2bcatemapping":lgePdpSendData.b2bCateMapping,
                        "productName": lgePdpSendData.productName,
                        "productID": compareId,
                        "productImg": lgePdpSendData.productImg,
                        "productAlt": lgePdpSendData.productAlt,
                        "careType": lgePdpSendData.careType,
                        "path": modelUrlPath,
                        "lgecomOnlyFlag" : lgePdpSendData.lgecomOnlyFlag,
                        "b2cYN": lgkorUI.getHiddenInputData().b2cYN
                    }
                    var isAdd = lgkorUI.addCompareProd(categoryId, compareObj, categoryNm);
                    if(!isAdd) {
                        $(this).prop('checked', false);
                        $(this).removeClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
                    }
                } else{
                    lgkorUI.removeCompareProd(categoryId, lgePdpSendData.id);
                }

                setTimeout(function(){
                    checkCompareClick = false;
                }, 500);
            });

            //비교하기 컴포넌트 변화 체크
            $(window).on("changeStorageData", function(){
                self.setCompares();
            });

            // 장바구니 담기 성공 리턴(BTOCSITE-37933)
            $(window).on("addCartReturn", function(e){
                self.cartRecommend(false);
            });

            //찜하기
            self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').off().on('click', function(e) {
                self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').attr('disabled', true); // BTOCSITE-61135
            	var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                var $this = $(this);
                var _id = lgePdpSendData.modelId;
                var sku = (productInfo.model_sku ? productInfo.model_sku : lgePdpSendData.sku);
                var categoryId = lgePdpSendData.categoryId;
                var wishListId = $this.data("wishListId");
                var wishItemId = $this.data("wishItemId");
                var wish = $this.is(':checked');
                var param = {
                    "id":_id,
                    "sku":sku,
                    "categoryId": categoryId,
                    "wishListId": wishListId,
                    "wishItemId": wishItemId
                }
                if(wish){
                    param.type = "add";
                } else{
                    param.type = "remove";
                }

                var ajaxUrl = self.$pdpInfo.attr('data-wish-url');

                /* s : BTOCSITE-5938-408 : 찜하기 복수인 경우 */
                var $wishItem = self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]');
                var success = function(data) {
                    self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').removeAttr('disabled'); // BTOCSITE-61135
                    // $this.data("wishItemId",data.wishItemId);
                    // $this.prop("checked",wish);
                    $wishItem.each(function(i){
                        $(this).data("wishItemId",data.wishItemId);
                        $(this).prop("checked",wish);
                    });
                    
                    //찜하기, 위시리스트 태그 삽입
                    if(wish) {
                        self.addWishTag();
                    }

                    // BTOCSITE-13562 : 4월 이벤트 개발 요청_찜하기
                    var eventId = lgkorUI.getCookie("eventZzimId");
                    if(eventId) {
                        lgkorUI.requestAjaxData("/mkt/api/eventManagement/addWishlistEvent", {
                            "modelId" : lgePdpSendData.modelId,
                            "categoryId" : lgePdpSendData.categoryId,
                            "wishFlag" : wish ? 'Y' : 'N',
                            "eventId" :  eventId
                        });
                    }
                };
                var fail = function(data) {
                    self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').removeAttr('disabled'); // BTOCSITE-61135
                    // $this.prop("checked",!wish);
                    $wishItem.each(function(){
                        $(this).prop("checked",!wish);
                    });
                };
                /* e : BTOCSITE-5938-408 */

                lgkorUI.requestWish(
                    param,
                    wish,
                    success,
                    fail,
                    ajaxUrl,
                    $this // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 위시리스트 로그인 확인 팝업 close 시 포커스 이동
                );
            });

            //장바구니
            //BTOCSITE-23825 크리테오tag 삽입 함수 추가
            // BTOCSITE-71622 가전구독 PDP 전화 구매 상담 예약 개선
            self.$pdpInfo.find('div.purchase-button a.cart, div.purchase-button a.btn-cart').on('click', function(e) {
                var opener = $(e.currentTarget).length ? e.currentTarget : ''; // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                e.preventDefault();
                if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
                    return;
                }
                //BTOCSITE-48266 b2b일 때 로그인 체크 start
                if (lgkorUI.getHiddenInputData().b2cYN ==='N') {
                    let className = e.currentTarget.className;
                    if(lgePdpSendData.bizTypeDetail === "CARETAB"){
                        let callbackVal = KRP0008.b2bLoginCheck(e);
                        if(!callbackVal) return;
                    }else{
                        if(className.indexOf("btn-open-action-sheet") == -1){
                            let callbackVal = KRP0008.b2bLoginCheck(e);
                            if(!callbackVal) return;
                        }
                    }
                }
                //BTOCSITE-48266 b2b일 때 로그인 체크 end
                if(!self.rentalAllSelect){
                    lgkorUI.alert("", {title: "모든 옵션을 선택해주세요."}, opener); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                    return;
                }

                var rentalSelfCheck = false;
                
                //BTOCSITE-29501 - 케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    checkCareSelect = lgkorUI.stringToBool(checkinput.val()); //true:신청 / false:미신청
                }

                self.$actionSheet.find('.ui_selectbox').each(function(){
                    if($(this).val() == '방문없음/자가관리' && checkCareSelect) {
                        rentalSelfCheck = true;
                    }
                })

                var param = {
                    "id":lgePdpSendData.id,
                    "sku":lgePdpSendData.sku,
                    "rtSeq":lgePdpSendData.rtSeq,
                    "bizType":lgePdpSendData.bizType,
                    "b2cYN":lgkorUI.getHiddenInputData().b2cYN,
                }

                var $paymentAmount = $(this).parents('.payment-amount');

                //렌탈케어 제품인가(일반구매의 케어십과 틀림)
                var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');

                //소모품이 있는가
                var cart = [];
                var $additionalPurchase = $('.additional-purchase');
                if($additionalPurchase.length > 0) {
                    $additionalPurchase.find('ul.additional-list li').each(function(idx, item){
                        cart.push($(item).data('id')+"|"+$(item).data('quantity'));
                    });
                }

                //선택 수량
                var quantity = self.$actionSheet.find('div.select-quantity input.quantity');
                if(quantity.length > 0) {
                    cart.push(lgePdpSendData.sku+"|"+quantity.val());
                } else {
                    cart.push(lgePdpSendData.sku+"|1");
                }

                param.sku = cart.join(',');

                //var $purchaseButton = $(this).parents('.purchase-button');
                //if($purchaseButton.hasClass('rental')) {
                //렌탈타입
                //   param.typeFlag = "C";
                //} else {
                //제품타입
                param.typeFlag = "P";

                //케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    var checkCareSelect = lgkorUI.stringToBool(checkinput.val());
                    if(checkCareSelect) {
                        //케어쉽 선택
                        param.typeFlag = "C";
                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                    }
                } else {
                    var $careSiblingOption = $('.care-sibling-option');
                    //케어쉽필수 제품인지 체크해서 알림창 뛰움
                    if($careSiblingOption.length < 1) {
                        if(careRequire) {
                            param.typeFlag = "C";
                        }
                    } else {
                        param.typeFlag = "C";
                    }
                }
                //}

                if(param.typeFlag == "C") {
                    if(typeof careshipOnlyFlag !== 'undefined') {
                        param.requireCare = lgkorUI.stringToBool(careshipOnlyFlag) ? true : false;
                    }

                    var careData = $paymentAmount.data('careData');
                    if(careData) {
                        param.rtSeq = careData.rtModelSeq;
			             //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start
			             var modelList = [];
			             var modelMap = {
			                    "modelId":lgePdpSendData.id,
			                    "sku":lgePdpSendData.sku,
			                    "rtModelSeq":careData.rtModelSeq,
			                    "bizType":lgePdpSendData.bizType
			             };
			             modelList.push(modelMap);
			             param.modelList = JSON.stringify(modelList);
	             		//BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 end
                    }

                    var cardData = $paymentAmount.data('cardData');
                    if(cardData) {
                        if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
                            //간편신청카드
                            param.easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
                        }
                    }
                    self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                }

                var ajaxUrl = self.$pdpInfo.attr('data-cart-url');
                
                var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;

                /* 구매시 옵션체크 항목일 경우 START */
                var optItemBuyChkFlag = false;
                var optItemDispNmBuyChk = '';
                var optItemDispValueNmBuyChk = '';
                var action = isRentalCareTab ? '가전 구독' : '구매';

                var optItems = self.$specInfoPopup.find('.sibling-cont > div');
                if (optItems.length > 0) {
                    optItems.each(function(i, e) {
                        if ($(this).data('opt-item-buy-chk-flag') == 'Y') {
                            optItemBuyChkFlag = true;
                            optItemDispNmBuyChk = $(this).data('opt-item-nm');
                            optItemDispValueNmBuyChk = $(this).find('div.option-list input:radio:checked').siblings('label').text();

                            return false;
                        }
                    });
                }

                if (optItemBuyChkFlag === false && buryPipeFlag === 'Y') {
                    optItemBuyChkFlag = true;
                    optItemDispNmBuyChk = '설치타입';
                    optItemDispValueNmBuyChk = '매립배관형';
                }
                // BTOCSITE-85293 START
                self.preCheckTermAndCondition(false, function() {
                    if(optItemBuyChkFlag) {
                        lgkorUI.confirm('', {
                            title:"지금 선택된 제품은 <br>" + optItemDispNmBuyChk + " " +  optItemDispValueNmBuyChk + " 제품입니다.<br>" + optItemDispValueNmBuyChk + " 제품을 " + action + " 하시겠어요?",
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                if(rentalSelfCheck){
                                    lgkorUI.confirm('', {
                                        title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 " + action + " 하시겠어요?",
                                        okBtnName: '확인',
                                        cancelBtnName: '취소',
                                        ok: function() {
                                            if(!isRentalCareTab && param.typeFlag == "C") {
                                                //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START
                                                /* lgkorUI.confirm('', {
                                                     title: "케어십 서비스를 신청하시는 경우<br>1개의 제품만 장바구니에 담을 수 있습니다.<br>해당 제품을 장바구니에 담으시겠어요?",
                                                     okBtnName: '네',
                                                     cancelBtnName: '아니오',
                                                     ok:function(){
                                                         lgkorUI.requestCart(ajaxUrl, param, true);
                                                         self.addCartTag(productInfo, quantity, true);
                                                     }
                                                 });*/
                                                 /* lgkorUI.requestCart(ajaxUrl, param, true);
                                                 self.addCartTag(productInfo, quantity, true);
                                                 //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END
                                                self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선*/
                                                //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                                $('#careRequireBuyCartPopup').vcModal({opener: this});
                                               //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                                return;
                                            }
                                            self.addCartAjaxCall(ajaxUrl, param, true);
                                            self.addCartTag(productInfo, quantity, false);
                                        }
                                    }, opener);  // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                                    return;
                                } else {
                                    if(!isRentalCareTab && param.typeFlag == "C") {
                                        /* lgkorUI.confirm('', {
                                        title: "케어십 서비스를 신청하시는 경우<br>1개의 제품만 장바구니에 담을 수 있습니다.<br>해당 제품을 장바구니에 담으시겠어요?",
                                        okBtnName: '네',
                                        cancelBtnName: '아니오',
                                        ok:function(){
                                            lgkorUI.requestCart(ajaxUrl, param, true);
                                            self.addCartTag(productInfo, quantity, true);
                                        }
                                        });*/
                                      /*  lgkorUI.requestCart(ajaxUrl, param, true);
                                        self.addCartTag(productInfo, quantity, true);
                                      //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END
                                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                                           */
                                         //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건 수정
                                        $('#careRequireBuyCartPopup').vcModal({opener: this});
                                       //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
    
                                        return;
                                    }
                                }
                                self.addCartAjaxCall(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, false);
                            }
                        });
    
                        return;
                    }
                    /* 구매시 옵션체크 항목일 경우 END */
                    
                    if(rentalSelfCheck){
                        lgkorUI.confirm('', {
                            title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 구매하시겠어요?",
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                if(!isRentalCareTab && param.typeFlag == "C") {
                                    //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START
                                    /*
                                    lgkorUI.confirm('', {
                                        title: "케어십 서비스를 신청하시는 경우<br>1개의 제품만 장바구니에 담을 수 있습니다.<br>해당 제품을 장바구니에 담으시겠어요?",
                                        okBtnName: '네',
                                        cancelBtnName: '아니오',
                                        ok:function(){
                                            lgkorUI.requestCart(ajaxUrl, param, true);
                                            self.addCartTag(productInfo, quantity, true);
                                        }
                                    });*/
                                    //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END                            	
                                    /*lgkorUI.requestCart(ajaxUrl, param, true);
                                    self.addCartTag(productInfo, quantity, true);
                                    //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END
                                    self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                                    */
                                    //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                    $('#careRequireBuyCartPopup').vcModal({opener: this});
                                   //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                    return;
                                }
                                self.addCartAjaxCall(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, false);
                            }
                        }, opener); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                        return;
                    }
    
                    if(!isRentalCareTab && param.typeFlag == "C") {
                        //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START
                        /*
                        lgkorUI.confirm('', {
                            title: "케어십 서비스를 신청하시는 경우<br>1개의 제품만 장바구니에 담을 수 있습니다.<br>해당 제품을 장바구니에 담으시겠어요?",
                            okBtnName: '네',
                            cancelBtnName: '아니오',
                            ok:function(){
                                lgkorUI.requestCart(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, true);
                            }
                        });*/
                        //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END
                        /*  lgkorUI.requestCart(ajaxUrl, param, true);
                          self.addCartTag(productInfo, quantity, true);
                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선*/
    
                        //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                        $('#careRequireBuyCartPopup').vcModal({opener: this});
                       //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
    
                        return;
                    } else {
                        //BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
                        if(purchaseButtonDisplay === "N"){
                            lgkorUI.alert("", {title: purchaseButtonMassage}, opener); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                        }else{
                            self.addCartAjaxCall(ajaxUrl, param, true);
                            self.addCartTag(productInfo, quantity, false);
                        }
                    }

                });
                // BTOCSITE-85293 END

            });

            // BTOCSITE-74567 [상품구독] LGE.COM 구독 캠페인 광고 스크립트 개발 요청의 건 - 상담예약 (전화구매상담)
            self.$pdpInfo.find('div.rental-reservation-call > a.link-area, div.btn-group > a.btnTelCall').on('click', function(e) {
                e.preventDefault();

                var url = $(this).attr('href').replace("#","");
                if(url) {
                    try {
                        // 네이버
                        if (window.wcs) {
                            if(!wcs_add) var wcs_add = {};
                            wcs_add["wa"] = "s_10f2ff8ac82";
                            wcs.inflow("lge.co.kr");
                            wcs_do();
                            var _conv = {};
                            _conv.type = "inquiry";
                            wcs.trans(_conv);
                        }
                        // 메타
                        fbq('trackCustom', 'consulting');
                        // 당근마켓
                        window.karrotPixel.track('Lead');
                        // RTB하우스
                        (rtbhEvents = window.rtbhEvents || []).push(
                            {
                                eventType: 'custom',
                                name: 'call-add',
                                value: '1'
                            },
                            {
                                eventType: 'uid',
                                id: 'unknown'
                            }
                        );
                        // 크리테오
                        window.criteo_q = window.criteo_q || [];
                        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                        window.criteo_q.push(
                            { event: "setAccount", account: 114760 },
                            { event: "setSiteType", type: deviceType },
                            { event: "viewHome", sub: "4" }
                        );
                        
                        // BTOCSITE-80498 Start
                        if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                            if($(this).hasClass('link-area')) {
                                KRP0008.csReservationClickRecordEvent();	// 상담예약
                            } else if($(this).hasClass('btnTelCall')) {
                                KRP0008.csCallClickRecordEvent();			// 전화구매상담
                            }
                        }
                        // BTOCSITE-80498 End
                        
                        /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 start*/
                        //전화상담예약
                        if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
	                    	var callback = function () {
                                //[BTOCSITE-92520] 전화상담예약 링크 변경
                                //if (typeof(url) != 'undefined') {
	                    	      //window.location = url;
	                    	    //}
                    		};
	                    	gtag('event', 'conversion', {
	                    		'send_to': 'AW-362582935/uIgLCKSSxPgZEJen8qwB',
	                    		'event_callback': callback
	                    	});
                        }
                        /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 end*/
                    } catch (e) {
                        console.log(e);
                    }
                    //[BTOCSITE-92520] 전화상담예약 링크 변경
                    //location.href = url;
                }
                //[BTOCSITE-92520] 전화상담예약 링크 변경
                // 로그인 여부 확인
                if (!lgkorUI.stringToBool(loginFlag)) {
                    lgkorUI.confirm('', {
                        title:'전화상담 예약 안내를 위해 로그인이 필요해요. ',
                        okBtnName: '로그인 하기',
                        cancelBtnName: '회원가입',
                        ok : function (){
                            window.location.href = "/sso/member/login";
                        },
                        cancel: function() {
                            window.location.href = "/sso/member/join";
                        }
                    });
                    return;
                }

                // 파라미터 생성
                var params = {
                    modelId: lgePdpSendData.modelId,
                    sku: lgePdpSendData.sku,
                    categoryId: lgePdpSendData.categoryId,
                    subCategoryId: lgePdpSendData.subCategoryId,
                    productName: lgePdpSendData.productName,
                    productImg: lgePdpSendData.productImg,
                    productAlt: lgePdpSendData.productAlt,
                    gubun: 'C' //구독(PDP)
                };
                var queryString = Object.keys(params)
                    .map(key => key + '=' + encodeURIComponent(params[key]))
                    .join('&');

                // URL에 파라미터 추가
                var url = '/consultReserve/reg-popup?' + queryString;

                var conSultPop = window.open(url, 'conSultPop', 'width=444, height=788, top=50, left=50, scrollbars=yes');

                try {
                    conSultPop.focus();
                } catch(e){
                    alert('팝업이 차단되었습니다. 팝업을 해제해주세요.');
                }
            });

            //전시매장 찾기
            $('div.info-bottom li.find-store a').on('click', function(e) {
                e.preventDefault();
                var url = $(this).attr('href').replace("#","");
                if(url) {
                    if(typeof outletStockFlag !== 'undefined' && lgkorUI.stringToBool(outletStockFlag)){
                        location.href = url;
                    } else {
                        lgkorUI.confirm('', {
                            title: '해당 제품을 전시하는 베스트샵 매장이 없습니다. 가까운 매장을 찾아 최적의 제품을 상담받으시겠어요?',
                            okBtnName: '네',
                            cancelBtnName: '아니오',
                            ok: function() {
                                location.href = url;
                            }
                        }, this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 전시매장 찾기 클릭 후 노출되는 팝업 close 시 포커스 이동
                    }
                }
            });

            //전화상담예약
            self.$pdpInfo.find('div.purchase-button a.btnConsult').on('click', function(e) {
                e.preventDefault(); // 기본 동작 방지

                // 로그인 여부 확인
                if (!lgkorUI.stringToBool(loginFlag)) {
                    lgkorUI.confirm('', {
                        title:'전화상담 예약 안내를 위해 로그인이 필요해요.',
                        okBtnName: '로그인 하기',
                        cancelBtnName: '회원가입',
                        ok : function (){
                            window.location.href = "/sso/member/login";
                        },
                        cancel: function() {
                            window.location.href = "/sso/member/join";
                        }
                    });
                    return;
                }

                // 파라미터 생성
                var params = {
                    modelId: lgePdpSendData.modelId,
                    sku: lgePdpSendData.sku,
                    categoryId: lgePdpSendData.categoryId,
                    subCategoryId: lgePdpSendData.subCategoryId,
                    productName: lgePdpSendData.productName,
                    productImg: lgePdpSendData.productImg,
                    productAlt: lgePdpSendData.productAlt,
                    gubun: 'J' //일반(PDP)
                };
                var queryString = Object.keys(params)
                    .map(key => key + '=' + encodeURIComponent(params[key]))
                    .join('&');

                // URL에 파라미터 추가
                var url = '/consultReserve/reg-popup?' + queryString;

                var conSultPop = window.open(url, 'conSultPop', 'width=444, height=788, top=50, left=50, scrollbars=yes');

                try {
                    conSultPop.focus();
                } catch(e){
                    alert('팝업이 차단되었습니다. 팝업을 해제해주세요.');
                }

            });

            //구매/예약/렌탈
            // BTOCSITE-71622 가전구독 PDP 전화 구매 상담 예약 개선
            self.$pdpInfo.find('div.purchase-button a:not(.cart, .btn-cart, .btnTelCall, .black, .soldOk, .ai )').on('click', function(e) { // BTOCSITE-85293
                var opener = $(e.currentTarget).length ? e.currentTarget : ''; // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                e.preventDefault();

                if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
                    return;
                }

                //BTOCSITE-48266 b2b일 때 로그인 체크 start
                if (lgkorUI.getHiddenInputData().b2cYN ==='N') {
                    let className = e.currentTarget.className;
                    if(lgePdpSendData.bizTypeDetail === "CARETAB"){
                        let callbackVal = KRP0008.b2bLoginCheck(e);
                        if(!callbackVal) return;
                    }else{
                        if(className.indexOf("btn-open-action-sheet") == -1){
                            let callbackVal = KRP0008.b2bLoginCheck(e);
                            if(!callbackVal) return;
                        }
                    }
                }
                //BTOCSITE-48266 b2b일 때 로그인 체크 end

                // BTOCSITE-22701 add :: 구독일때 구독이벤트 발생
                if (lgePdpSendData.bizType == 'SUBSCRIPTION'){
                    self.$pdpInfo.trigger('subscribe', self.$pdpInfo.data('subscriptionUrl'));
                    return;
                }

                //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 클래스로 인한 중복호출 방지..
                if(e.currentTarget.id == 'btn-up20cart')		return;

                // BTOCSITE-82800 캠페인 광고 스크립트 START
                // <카카오>
                kakaoPixel('975360282649280347').pageView();
                kakaoPixel('975360282649280347').participation('subbutton');

                // <메타>
                fbq('trackCustom', 'subscribe-button');

                // <네이버>
                if (window.wcs) {
                    if(!wcs_add) var wcs_add = {};
                    // (2) 각 사이트별 식별자 설정
                    wcs_add["wa"] = "s_10f2ff8ac82";      // 사이트 식별자 (=네이버공통키, na_account_id)

                    // (3) 광고 전환추적을 위한 cookie domain설정
                    wcs.inflow("https://www.lge.co.kr/");

                    // 아래 Script는 개별 이벤트 발생시 로그를 전송하기 위한 구역. 결제 완료 페이지이므로, PV 이벤트 와 결제완료 전환 이벤트를 전송함

                    // (4) PV 이벤트 전송
                    wcs_do(); // PV 이벤트 전송

                    // (5) 결제완료 전환 이벤트 전송
                    var _conv = {}; // 전환이벤트 정보 담을 object 생성
                    _conv.type = "custom001";  // 전환이벤트의 종류 설정
                    wcs.trans(_conv); // 전환 이벤트 정보를 담은 object를 서버에 전송
                }

                // <크리테오>
                window.criteo_q = window.criteo_q || [];
                var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";

                window.criteo_q.push(
                    { event: "setAccount", account: 114760 },
                    { event: "setSiteType", type: deviceType },
                    { event: "viewHome", sub: "3" }
                );
                // BTOCSITE-82800 캠페인 광고 스크립트 END
                
                /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 start*/
                //구독신청
                if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                	//RTB House
                	(rtbhEvents = window.rtbhEvents || []).push(
            			{
	        				eventType: 'basketadd',
	        				offerId: digitalData.productInfo.model_id
        				},
        				{
	        				eventType: 'custom',
	        				name: 'subscribe-button',
	        				value: '1'
        				},
			            {
			                eventType: 'uid',
			                id: 'unknown'
		            });
                	//구글 애즈
                	var callback = function () {
                        console.log("후처리 필요시 작성.");
                	    // if (typeof(url) != 'undefined') {
                	    //   window.location = url;
                	    // }
            		};
                	gtag('event', 'conversion', {
                		'send_to': 'AW-362582935/zhb7CKGSxPgZEJen8qwB',
                		'event_callback': callback
                	});
                }
                /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 end*/

                var $this = $(this);
                var rentalSelfCheck = false;
                var checkCareSelect = false;
                
                //케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    checkCareSelect = lgkorUI.stringToBool(checkinput.val()); //true:신청 / false:미신청
                }

                self.$actionSheet.find('.ui_selectbox').each(function(){
                    if($(this).val() == '방문없음/자가관리' && checkCareSelect) {
                        rentalSelfCheck = true;
                    }
                })

                if(preOrderFlag && $this.hasClass('btn-pre-order')) {
                    //사전예약 일경우
                    if(lgkorUI.stringToBool(loginFlag)) {
                        //사전예약 안내창 뛰우고 구매진행
                        $('#preOrderPopup').find('div.btn-group button').off('click');
                        $('#preOrderPopup').find('div.btn-group button').on('click',function(e){
                            self.productBuy($this, this);
                        });
                        $('#preOrderPopup').vcModal({opener: this});
                    } else {
                        //로그인 체크후 로그인 안내창 뛰움
                        $('#loginPopup').vcModal({opener: this});
                    }
                } else {
                    if(lgePdpSendData.bizTypeDetail === "PRODUCT" || lgePdpSendData.bizTypeDetail === "DISPOSABLE"){
                        if($(this).hasClass('btn-open-action-sheet')) return;
                    }
                    if(self.rentalAllSelect) {
                    	/* 구매시 옵션체크 항목일 경우 START */
                        var $paymentAmount = $(this).parents('.payment-amount');
                        var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');
                        var action = isRentalCareTab ? '가전 구독' : '구매';

                        if (isRentalCareTab && !lgkorUI.stringToBool(loginFlag)) {
                            //
                        } else {
                            var optItemBuyChkFlag = false;
                            var optItemDispNmBuyChk = '';
                            var optItemDispValueNmBuyChk = '';

                            var optItems = self.$specInfoPopup.find('.sibling-cont > div');
                            if (optItems.length > 0) {
                                optItems.each(function(i, e) {
                                    if ($(this).data('opt-item-buy-chk-flag') == 'Y') {
                                        optItemBuyChkFlag = true;
                                        optItemDispNmBuyChk = $(this).data('opt-item-nm');
                                        optItemDispValueNmBuyChk = $(this).find('div.option-list input:radio:checked').siblings('label').text();

                                        return false;
                                    }
                                });
                            }
                            if (optItemBuyChkFlag === false && buryPipeFlag === 'Y') {
                                optItemBuyChkFlag = true;
                                optItemDispNmBuyChk = '설치타입';
                                optItemDispValueNmBuyChk = '매립배관형';
                            }
                            if(optItemBuyChkFlag) {
                                lgkorUI.confirm('', {
                                    title:"지금 선택된 제품은 <br>" + optItemDispNmBuyChk + " " + optItemDispValueNmBuyChk + " 제품입니다.<br>" + optItemDispValueNmBuyChk + " 제품을 " + action + " 하시겠어요?",
                                    okBtnName: '확인',
                                    cancelBtnName: '취소',
                                    ok: function() {

                                        if(rentalSelfCheck){
                                            lgkorUI.confirm('', {
                                                title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 " + action + " 하시겠어요?",
                                                okBtnName: '확인',
                                                cancelBtnName: '취소',
                                                ok: function() {
                                                    self.productBuy($this, this)
                                                }
                                            });
                                            return;
                                        }

                                        self.productBuy($this, this)
                                    }
                                });
                                return;
                            }
                        }
                        /* 구매시 옵션체크 항목일 경우 END */

                        if(rentalSelfCheck){
                            lgkorUI.confirm('', {
                                title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 " + action + " 하시겠어요?",
                                okBtnName: '확인',
                                cancelBtnName: '취소',
                                ok: function() {
                                    self.productBuy($this, this)
                                }
                            });
                            return;
                        }

                        self.productBuy($this, this);
                    } else {
                        lgkorUI.alert("", {title: "모든 옵션을 선택해주세요."});
                    }
                }
            });

            //구독 BTOCSITE-22701 add :: 구독신청클릭시
            self.$pdpInfo.on('subscribe', function(e, data){

                self.$serviceOptPopup1.trigger('popup', data);

            });

            //상단 스티키 구매버튼
            $(window).on('sendExtraAction.KRP0009', function(e){
                // BTOCSITE-22701 :: 구독일때 케이스 추가
                var $buyButton;
                if (lgePdpSendData.bizType == 'SUBSCRIPTION'){
                    $buyButton =  self.$pdpInfo.find('div.purchase-button a:not(.cart)').eq(1);                    
                } else {
                    $buyButton =  self.$pdpInfo.find('div.purchase-button a:not(.cart)').eq(0);
                }                
                $buyButton.trigger('click');
                // if($buyButton.length > 1) {
                //     $buyButton.each(function(idx,item){
                //         var $item = $(item);
                //         var optionParent = $item.parents('div.option-contents');
                //         if(optionParent.css('display') == "block") {
                //             $item.trigger('click');
                //             return false;
                //         }
                //     });
                // } else {
                //     //한개
                //     $buyButton.trigger('click');
                // }
            });

            //링크
            self.$pdpInfo.on('click','a.btn-link:not(.popup)', function(e) {
                e.preventDefault();
                var $this = $(this);
                if(!$this.attr('data-control')) {
                    var url = $this.attr('href').replace("#","");
                    var addS = $this.data('add');
                    if(url) {
                        if(addS) {
                            url += addS;
                        }
                        location.href = url;
                    }
                }
            });

            //팝업 BTOCSITE-1025 : add 20210802
            /* self.$pdpInfo.on('click','.notice-wrap .notice-box a', function(e) {
                 e.preventDefault();
                 self.$mainInitPopup.vcModal({opener: this});
             });*/

            //할인적용가 팝업 BTOCSITE-5781
            //BTOCSITE-7379 PDP > 버튼 UI 변경건
            /*self.$pdpInfo.on('click','li.lists.member .btn-discount-popup', function(e) {
                e.preventDefault();
                self.$saleInfoPopup.vcModal({opener: this});
            });*/

            //구매혜택 팝업 - 추후 삭제 LGECOMVIO-20
            /*self.$pdpInfo.on('click','li.lists.benefit a.btn-link.popup', function(e) {
                e.preventDefault();
                self.$benefitInfoPopup.vcModal({opener: this});
            });*/
            //LGECOMVIO-20 - 구매혜택 팝업
            // S: BTOCSITE-66272 구매 혜택 안내 팝업 신규 디자인
            // self.$pdpInfo.on('click','li.lists .buy-benefit-info a.btn-link.popup', function(e) {
            //     e.preventDefault();
            //     var target = $(this).data("active-target");
            //     self.$buybenefitInfoPopup.vcModal({opener: this});
            //     self.$buybenefitInfoPopup.find('.ui_accordion .lists').each(function(idx,item){
            //         if($(item).attr('id') === target){
            //             self.$buybenefitInfoPopup.find('.ui_accordion').vcAccordion('expand',idx);
            //         }
            //     })
            // });

            // 66272 모달팝업 함수
            self.$pdpInfo.on('click','li.lists .buy-benefit-info a.btn-link.popup', function(e) {
                e.preventDefault();

                var $popup = self.$buybenefitInfoPopupNew;

                $popup.one('modalshow', self.setGiftPopup);
                $popup.vcModal({opener: this}); // 팝업 열기

				//BTOCSITE-75003 팝업 열기시 활성화 탭 보이도록 좌우 이동
                var $this = $(this)
				setTimeout(function(){
					$popup.find('.tabs').eq(0).find('li.on a').trigger('click')
                    setPopupTabArrow($popup);//BTOCSITE-67752 팝업 열기시 활성화 탭 좌우버튼
           
                    var accoId = $this.attr('data-active-target');
                    var accordion = $('#'+accoId).closest('.ui_accordion').vcAccordion('instance');
                    if( accordion ){
                      accordion.expand($('#'+accoId).index(), false);
                    }
				},100);
            });

            //BTOCSITE-67752 팝업 열기시 활성화 탭 좌우버튼
            var hitTest = function(_$obj1, _$obj2){
                var objPos1 = _$obj1.offset().left + _$obj1.width()
                var objPos2 = _$obj2.offset().left + _$obj2.width()
                if( objPos1 < _$obj2.offset().left || objPos2 < _$obj1.offset().left ){
                    return false
                }else{
                    return true
                }
            }
            var setPopupTabArrow = function(_$popup){
                var $popBene = _$popup;
                var $popBeneChild = $popBene.find('.scroll-tab-wrap'); 
                var $popBeneTabWrap = $popBeneChild.find('.tabs-wrap')
                var $popBeneTab = $popBeneTabWrap.find('.tabs')
                var $popBeneTabBtns = $popBeneChild.find('.scroll-controls')
                var $popBeneTabLeft = $popBeneTabBtns.find('.ui_smooth_prev')
                var $popBeneTabRight = $popBeneTabBtns.find('.ui_smooth_next')
                var isTabchange = false;
                
                setTimeout(function(){
                    $popBeneTabWrap.vcSmoothScroll('scrollToActive')
                    $popBeneTabWrap.vcSmoothScroll('instance').options.center=true;
                    var ins = $popBeneTabWrap.vcSmoothScroll('instance')
                    ins.viewWidth = $popBeneTabWrap.width()-($popBeneTabLeft.width*2);
                    $popBeneTabWrap.vcSmoothScroll('scrollToActive')
                    $(window).trigger('resizeend.popuptabarrow')
                },100)
         
                $(window).off('resizeend.popuptabarrow').on('resizeend.popuptabarrow',function(e){
                    $popBeneTabBtns.hide();
                    if(window.innerWidth > 768){
                        if( $popBeneTabWrap.outerWidth() < $popBeneTab.outerWidth()){
                            $popBeneTabBtns.show();
                        }
                    }
                }).trigger('resizeend.popuptabarrow')

                $popBeneTabLeft.off('click').on('click',function(e){
                    if(window.innerWidth < 768){return;}
                    $popBeneTabWrap.vcSmoothScroll('moveFirst');
                })
                $popBeneTabRight.off('click').on('click',function(e){
                    if(window.innerWidth < 768){return;}
                    $popBeneTabWrap.vcSmoothScroll('moveLast');
                })
                $popBeneTabWrap.off('smoothscrollend.popuptabarrow').on('smoothscrollend.popuptabarrow',function(){
                    if(window.innerWidth < 768 || isTabchange == true){return;}
                    var getX = $popBeneTabWrap.vcSmoothScroll('getPosition').x;
                    if(getX == 0){
                        tabArrowVisible('left')
                    }else if(getX + $popBeneTab.width() < $popBeneTabWrap.width()+5 ){
                        tabArrowVisible('right')
                    }else{
                        tabArrowVisible()
                    }
                })
                $popBeneTabWrap.off('tabchange.popuptabarrow').on('tabchange.popuptabarrow',function(){
                    if(window.innerWidth < 768 || isTabchange == true || $popBene.css('display') == 'none'){return;}
                    activeTab_btnArrow_hitTest()
                });
                function activeTab_btnArrow_hitTest(){
                    isTabchange = true;
                    var getX = $popBeneTabWrap.vcSmoothScroll('getPosition').x;
                    var isHitRight = hitTest($popBeneTab.find('.on'), $popBeneTabRight)
                    var isHitLeft = hitTest($popBeneTab.find('.on'), $popBeneTabLeft)
                    if(isHitLeft || isHitRight){
                        var btnW = isHitRight ? -60 : 60; 
                        var ins = $popBeneTabWrap.vcSmoothScroll('instance')
                        ins.scrollTo( getX + btnW ,0,300);
                    }
                    setTimeout(function(){
                        isTabchange=false;
                    },300)
                }
                function tabArrowVisible(direction){
                    if(direction == 'left'){
                        $popBeneTabLeft.hide();
                        $popBeneTabRight.show();
                    }else if(direction == 'right'){
                        $popBeneTabLeft.show();
                        $popBeneTabRight.hide();
                    }else{
                        $popBeneTabLeft.show();
                        $popBeneTabRight.show();
                    }
                }
            }
            ////BTOCSITE-67752 팝업 열기시 활성화 탭 좌우버튼

            // E: BTOCSITE-66272 구매 혜택 안내 팝업 신규 디자인


            //LGECOMVIO-20 - 단순팝업 열기
            function pdpOpenPopup(selector,targetPopup,fn){
                $(selector).on('click',function(e){
                    e.preventDefault();
                    targetPopup.vcModal({opener: this});
                });
            };

            //팝업 BTOCSITE-1025 : add 20210802 - LGECOMVIO-20
            pdpOpenPopup('.notice-wrap .notice-box a', self.$mainInitPopup);
            //할인적용가 팝업 BTOCSITE-5781 - LGECOMVIO-20
            //pdpOpenPopup('li.lists.member .btn-discount-popup', self.$saleInfoPopup);
            //구매혜택 팝업 - 추후 삭제 LGECOMVIO-20
            pdpOpenPopup('li.lists.benefit a.btn-link.popup', self.$benefitInfoPopup);
            //LGECOMVIO-20 - 제휴카드 팝업 - LGECOMVIO-20
            pdpOpenPopup('.promotion-card-info .card-list-more', self.benefitCardPopup) // BTOCSITE-51891 구독 제휴카드 관련 PDP/팝업 수정의 건 

            // pdpOpenPopup('.pdp-tolltip-new .tooltip-icon', self.$staffPricePopup);
            // pdpOpenPopup('.price-info.pdp-price-popup-new', self.$staffPricePopup);

            pdpOpenPopup('a#maxBenefitPopupSelector', self.$maxBenefitPopup);
            // pdpOpenPopup('a#maxBenefitPopupSelector2', self.$maxBenefitPopup2); // 쿠폰팝업에서 분기처리
            if ($('#memberPricePopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#memberPricePopupSelector', self.$memberPricePopup);
            }
            if ($('#couponPricePopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#couponPricePopupSelector', self.$couponPricePopup);
            }
            // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
            pdpOpenPopup('a#tabMaxBenefitPopupSelector', self.$maxBenefitPopup);
            // pdpOpenPopup('a#tabMaxBenefitPopupSelector2', self.$maxBenefitPopup2); // 쿠폰팝업에서 분기처리
            if ($('#tabMemberPricePopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#tabMemberPricePopupSelector', self.$memberPricePopup);
            }
            if ($('#tabCouponPricePopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#tabCouponPricePopupSelector', self.$couponPricePopup);
            }
            pdpOpenPopup('a#employeeTabBenefitPopupSelector', self.$employeeTabMaxBenefitPopup);
            if ($('#employeeTabCouponPopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#employeeTabCouponPopupSelector', self.$employeeTabCouponPricePopup);
            }

            //소모품 추가구매
            self.$pdpInfoAdditionalPurchase.on('click','div.selectbox-list a', function(e){
                e.preventDefault();
                var $this = $(this);
                var _id = $this.attr('href').replace("#","");
                var price = $this.data('price');
                var $itemInfo = $this.find('.item-info');
                var data = {
                    "id": _id,
                    "title":$itemInfo.find('dt').text(),
                    "price":price,
                    "priceString":(vcui.number.addComma(price) + "원")
                }
                $this.parents('.ui_dropdown').vcDropdown("close");
                var $ul = self.$pdpInfoAdditionalPurchase.find('div.additional-payment ul');
                var $find = $ul.find('li[data-id="' + _id + '"]');
                if($find.length < 1) {
                    self.$pdpInfoAdditionalPurchase.find('div.additional-payment ul').append(vcui.template(additionalItemTemplate, data));
                }

                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                self.updatePaymentAmountPrice($paymentAmount);
            });

            //소모품 추가구매 수량선택
            self.$pdpInfoAdditionalPurchase.on('click','button.minus,button.plus', function(e){
                var $this = $(this);
                var $input = $this.siblings('input');
                var $totalCount = $('.payment-amount .final-count .number');
                var quantity = $input.val();
                if($this.hasClass('minus')) {
                    --quantity;
                    if(quantity < 1) {
                        quantity = 1;
                    }

                    if(quantity == 1) {
                        $this.attr('disabled',true);
                    } else {
                        $this.removeAttr('disabled');
                    }
                } else if($this.hasClass('plus')) {
                    ++quantity;

                    if(quantity > 1) {
                        $this.siblings('button.minus').removeAttr('disabled');
                    }
                }
                $input.val(quantity);
                $totalCount.text(quantity);

                var $li = $this.parents('li');
                $li.data('quantity',quantity);
                var $total = $(".action-sheet .total-payment .price").contents()[1];
                var price = $li.data('price');
                price = price || "0";
                if(typeof price === 'string') {
                    price = vcui.string.replaceAll(price,",","");
                }

                $total.textContent = (vcui.number.addComma(price*quantity) + '원');

                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                self.updatePaymentAmountPrice($paymentAmount, true);
            });

            //소모품 추가구매 삭제
            self.$pdpInfoAdditionalPurchase.on('click','button.btn-delete', function(e){
                var $li = $(this).parents('li');
                $li.remove();

                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                self.updatePaymentAmountPrice($paymentAmount);
            });

            //BTOCSITE-50143 PDP 수량 수기 입력 Start
            $("#quantity").change(function() {
                var quantity = $(this).val();
                var $totalCount = $('.payment-amount .final-count .number');
                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                $paymentAmount.find('button.plus').removeAttr('disabled');

                var max = $paymentAmount.find('button.plus').data('max');
                if (max && quantity >= max) {
                    if (lgkorUI.getHiddenInputData().b2cYN ==='Y'){
                        $paymentAmount.find('button.plus').attr('disabled', true);
                    } else { // BTOCSITE-48266 B2B 구매수량 제한
                        if (quantity > max) {
                            $('#businessAlertMaxQty').text(max + 1);
                            $('#businessMembershipMoreAlert1').vcModal();
                        }
                        // B2B에서 25이상 구매시 +버튼 활성화 유지
                        $paymentAmount.find('button.plus').removeAttr('disabled');
                    }
                    quantity = max;
                    $paymentAmount.find('input.quantity').val(max);
                }
                if(quantity <= 0 || quantity == '') {
                    quantity = 1;
                    $paymentAmount.find('button.minus').attr('disabled',true);
                    $paymentAmount.find('input.quantity').val(1);
                    lgkorUI.alert("", {title: "주문 가능한 최소 수량은 1 개 입니다."}, $paymentAmount.find('input.quantity')); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close시 포커스 이동
                } else if(quantity == 1) {
                    quantity = 1;
                    $paymentAmount.find('button.minus').attr('disabled',true);
                } else {
                    $paymentAmount.find('button.minus').removeAttr('disabled');
                }
                $totalCount.text(quantity);
                $paymentAmount.data('quantity',quantity);
                self.updatePaymentAmountPrice($paymentAmount, true);
            });
            //BTOCSITE-50143 End

            //구매 수량 선택
            self.$pdpInfoPaymentAmount.off('click').on('click', 'button.minus,button.plus',function (e) {
                var $input = $(this).siblings('input');
                var quantity = $input.val();
                var $totalCount = $('.payment-amount .final-count .number');
                if($(this).hasClass('minus')) {
                    --quantity;
                    if(quantity < 1) {
                        quantity = 1;
                    }

                    if(quantity == 1) {
                        $(this).attr('disabled',true);
                        self.$pdpInfoPaymentAmount.find('input.quantity').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 개수 미만 시 포커스 이동
                    } else {
                        $(this).removeAttr('disabled');
                    }

                    $(this).siblings('button.plus').removeAttr('disabled');
                } else if($(this).hasClass('plus')) {
                    var max = $(this).data('max');
                    ++quantity;
                    if (max && quantity >= max) {
                        if (lgkorUI.getHiddenInputData().b2cYN ==='Y'){
                            $(this).attr('disabled',true);
                            self.$pdpInfoPaymentAmount.find('input.quantity').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 개수 초과 시 포커스 이동
                        } else if (quantity > max) { // BTOCSITE-48266 B2B 구매수량 제한
                            // B2B에서 25이상 구매시 +버튼 활성화 유지
                            $('#businessAlertMaxQty').text(max + 1);
                            $('#businessMembershipMoreAlert1').vcModal({opener: self.$pdpInfoPaymentAmount.find('input.quantity')}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        }
                        quantity = max;
                    }

                    if(quantity > 1) {
                        $(this).siblings('button.minus').removeAttr('disabled');
                    }
                }
                $input.val(quantity);
                $totalCount.text(quantity);

                var $paymentAmount = $input.parents('.payment-amount');
                $paymentAmount.data('quantity',quantity);
                self.updatePaymentAmountPrice($paymentAmount, true);
            });

            //케어쉽 서비스 선택 관련
            self.$pdpInfoCareshipService.on('change','input[type=radio]', function(e){
                //케어쉽필수 제품인지 체크해서 알림창 뛰움
                var val = $(this).val();
                var $careshipService = $(this).parents('.careship-service');

                //BTOCSITE-73832 제품 번들링 과제
                KRP0008.additionModel.careshipServiceRadioClick(lgkorUI.stringToBool(val));

                if(!lgkorUI.stringToBool(val)) {
                    if(waterCareRequire) {
                        $(this).parents('ul').find('input[type=radio][value="Y"]').trigger('click');
                        $('#waterCareRequirePopup').vcModal({opener: this});
                    } else if(careRequire) {
                        $(this).parents('ul').find('input[type=radio][value="Y"]').trigger('click');
                        $('#careRequirePopup').vcModal({opener: this});
                    } else {
                        //제품 가격 정보에 케어십 관련 숨김
                        if($careshipService.length > 0) {
                            var $paymentAmount = self.$pdpInfo.find('.payment-amount'); //LGECOMVIO-20
                            var $careshipPriceInfo = $paymentAmount.find('li.careship-price-info');
                            if($careshipPriceInfo.length > 0) {
                                $careshipPriceInfo.hide();
                            }
                            self.updatePaymentAmountPrice($paymentAmount);

                            //수량체크버튼 활성
                            self.updatePaymentAmountState($paymentAmount, false);
                        }
                    }
                } else {
                    if($careshipService.length > 0) {
                        var $paymentAmount = self.$pdpInfo.find('.payment-amount'); //LGECOMVIO-20
                        var $careshipPriceInfo = $paymentAmount.find('li.careship-price-info');
                        if($careshipPriceInfo.length > 0) {
                            $careshipPriceInfo.show();
                        }
                        self.updatePaymentAmountPrice($paymentAmount);

                        //케어십 신청됐으므로 수량체크버튼 비활성
                        self.updatePaymentAmountState($paymentAmount, true);
                    }
                }
                self.pdpVisualSticky();
            });

            //케어십 이용요금
            self.$pdpInfoCareshipService.on('click','dl.price-info a.btn-link.popup', function(e) {
                e.preventDefault();
                requestItemTip(this);
            });

            //케어솔루션 이용요금
            $('.btn-care-solution-popup').on("click", function(e) {
                e.preventDefault();
                if(self.rentalAllSelect) {
                    requestItemTip(this);
                } else {
                    lgkorUI.alert("", {title: "모든 옵션을 선택해주세요."});
                }
            });

            function requestItemTip(dm) {
                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                var careData = $paymentAmount.data('careData');
                var ajaxUrl = '/mkt/ajax/commonmodule/monthlyRateBenefit';
                var param = {
                    'visibleArea': 'cart',
                    'rtModelSeq': careData.rtModelSeq
                };

                lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                    openModalFromHtml(result);
                }, null, "html");
            }

            function openModalFromHtml(html) {
                $('#request-tip-modal').html(html).vcModal();
            }


            //케어십 방문주기
            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성으로 변경
            if(self.$careshipInfoSelectBox.length > 0) {
                self.$careshipInfoSelectBox.on('change', function(e,data){
                    var selectOption = $(this).vcSelectbox('selectedOption');
                    var svcTypeDescData = $(selectOption).data('item');
                    var itemData = null;
                    var selectIndex = 0;
                    for (var i = 0, len = svcTypeDescData.length; i < len; i++) {

                        if(svcTypeDescData[i].representChargeFlag == "Y") { // 방문주기 선택시 서비스타입안의 데이터들 중에 대표요금제노출여부가 Y일 경우에 먼저노출
                            selectIndex = i;
                        }
                    }

                    itemData = svcTypeDescData[selectIndex];

                    self.updateCareshipInfoPrice(itemData); // 선택된 가격정보로 업데이트
                    self.careshipInfoSelectBoxUpdate(self.$careshipInfoSelectBox2, svcTypeDescData, 0, true);
                });
            };

            // 케어십 서비스타입
            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성으로 추가
            if(self.$careshipInfoSelectBox2.length > 0) {
                self.$careshipInfoSelectBox2.on('change', function(e,data){
                    var selectOption = $(this).vcSelectbox('selectedOption');
                    var priceData = $(selectOption).data('item');

                    self.updateCareshipInfoPrice(priceData); // 선택된 가격정보로 업데이트
                });
            };
            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성 END
            //BTOCSITE-3523 - 제휴카드 할인 드롭다운 열림/닫힘 액션
            var cardDropExpanded = "false";
            self.$pdpInfo.on('click','.careship-card-list .ui_dropdown_toggle, .rental-card-list .ui_dropdown_toggle',function(e){
                e.preventDefault();
                var $this = $(this);
                $this.closest('.dropdown-box-wrap').toggleClass('open');
                (cardDropExpanded === "false") ? (cardDropExpanded = "true") : (cardDropExpanded = "false");
                $this.attr('aria-expanded',cardDropExpanded);
            });
            $(document).on('click', function(e) {
                var $rentalCareCardDropList = $('.careship-card-list .dropdown-box-wrap, .rental-card-list .dropdown-box-wrap');
                if($(e.target).closest($rentalCareCardDropList).length == 0){
                    $rentalCareCardDropList.removeClass("open");
                }
            });

            //제휴카드 할인 드롭다운 선택
            //div.option-contents
            self.$pdpInfo.on('click','.rental-card-list div.ui_dropdown_list li a, .careship-card-list div.ui_dropdown_list li a', function(e){
                e.preventDefault();
                var $this = $(this);
                var $dropDown = $this.parents('.dropdown-box-wrap'); //BTOCSITE-3523 수정
                //$dropDown.find('a.ui_dropdown_toggle').text($this.attr('data-card-title'));  //BTOCSITE-3523 삭제

                //BTOCSITE-3523 추가
                if($this.closest("li").hasClass("cancel-item")) {
                    $this.closest('.dropdown-box-wrap').removeClass('is-selected'); //BTOCSITE-3523 수정
                    $dropDown.find('.ui_dropdown_toggle').empty();
                }else{
                    $dropDown.find('.ui_dropdown_toggle').text($this.attr('data-card-title'));
                    $this.closest('.dropdown-box-wrap').addClass('is-selected'); //BTOCSITE-3523 수정
                }

                $dropDown.removeClass('open'); //BTOCSITE-3523 수정

                var cardData = {};
                var cardNameCode = $this.attr('href').replace("#","");
                if(cardNameCode) {
                    cardData.cardNameCode = cardNameCode;
                }
                var cardSale = $this.data('cardSale');
                if(cardSale) {
                    cardData.cardSale = cardSale;
                }
                var cardSubName = $this.data('cardSubName');
                if(cardSubName) {
                    cardData.cardSubName = cardSubName;
                }
                var simpleReqFlag = $this.data('simpleReqFlag');
                if(simpleReqFlag) {
                    cardData.simpleReqFlag = simpleReqFlag;
                }

                var isRental = false;
                var $careshipService = $this.parents('.careship-service');
                if($careshipService.length < 1) {
                    $careshipService = $this.parents('.care-sibling-option');
                    if($careshipService.length > 0) {
                        isRental = true;
                    }
                }
                var $paymentAmount = self.$pdpInfo.find('.payment-amount');

                $paymentAmount.data('cardData',cardData);
                if(isRental){
                    self.updateRentalInfoPrice(self.selectRentalInfoData);
                } else {
                    self.updateCareshipInfoPrice(self.selectCareshipInfoData);
                }
            });

            
            // [S] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 제휴카드 아코디언 작업
            $(document).on('accordionexpand','.discount-details-new .ui_accordion', function(e){
                var $this = $(this);
                
                if ($this.find('.ui_accord_content').is(':visible')) {
                    $this.find('.ui_accord_content input[type="radio"]').first().focus();
                }
            });

            $(document).on('keydown','.discount-details-new .ui_accord_toggle', function(e){
                var $this = $(this);
                var $wrap = $this.closest('.ui_accordion');

                if (e.keyCode === 9 && !e.shiftKey && $wrap.find('.ui_accord_content').is(':visible')) {
                    e.preventDefault();
                    $wrap.find('.ui_accord_content input[type="radio"]').first().focus();
                }
            });

            $(document).on('click keydown','.discount-details-new .ui_accordion input[type="radio"]', function(e){
                var $this = $(this);
                var $accordion = $this.closest('.ui_accordion'); //BTOCSITE-3523 수정
                var $title = $accordion.find('.title');


                if (e.type === 'click' && e.clientX === 0 && e.clientY === 0) {
                    e.preventDefault();
                    return;
                }

                if (e.type === 'keydown' && e.keyCode !== 32) {
                    return;
                }

                $this.prop('checked', 'checked');
            });
            // [E] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 제휴카드 아코디언 작업
            
            //div.option-contents
            var cardDropdown = self.$pdpInfo.find('.rental-card-list div.ui_dropdown_list .simple-card-list, .careship-card-list div.ui_dropdown_list .simple-card-list'); //BTOCSITE-3523 수정
            var firstRow = cardDropdown.find('li a:eq(0)');
            if(firstRow.length > 0) {
                firstRow.trigger('click',firstRow);
            }

            // S : BTOCSITE-20780
            self.$pdpInfo.on('click','li.lists.member .banner-box', function(e) {
                var href = $(this).data('url');
                var eventId = href.substring(href.indexOf("-")+1,href.indexOf("?"));
                var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                var mltlp = $(this).data("mltlp");

                // 다품목 상품이 아닌경우 세션저장 하지 않음
                if(mltlp == "Y" && productInfo) {
                    var stroageItems = lgkorUI.getStorage(eventId + "_calcItems");
                    var item = {}, calcItems = (vcui.isEmpty(stroageItems)) ? [] : JSON.parse(stroageItems);
                    var chkStroageItem = calcItems.filter(function(obj){
                        return obj.sku == lgePdpSendData.sku;
                    });
                    item = {
                        id: 'calc-'+lgePdpSendData.sku,
                        sku: lgePdpSendData.sku,
                        modelName: modelName,
                        oprice: parseInt(productInfo.price),
                        tprice: parseInt(productInfo.discounted_price),
                        dprice: parseInt(productInfo.price) - parseInt(productInfo.discounted_price),
                        odprice: parseInt(lgkorUI.getHiddenInputData().obsDiscountPrice),
                        mediumImageAddr: lgePdpSendData.productImg,
                        imageAltText: lgePdpSendData.productName,
                        modelId: lgePdpSendData.modelId,
                        bizType: lgePdpSendData.bizType,
                        modelStatusCode: lgePdpSendData.modelStatusCode,
                        rtModelSeq: representRtModelSeq,
                        modelComponent: lgePdpSendData.modelComponent
                    }
                    lgkorUI.setStorage(eventId + "_currentItems", JSON.stringify(item), false);
                    if(chkStroageItem.length == 0) {
                        calcItems.push(item);
                        lgkorUI.setStorage(eventId + "_calcItems", JSON.stringify(calcItems), false);
                    }
                }

                location.href = href;
            });
            // E : BTOCSITE-20780

            // S : BTOCSITE-48313
            self.$caresolutionMoreBenefitLink = self.$pdpInfoCareSiblingOption.find('a.more-benefit-link');
            self.$caresolutionMoreBenefitLink.on('click', function(){
                var moreBenefitLinkUrl = $(this).attr('href');
                $(this).attr('href', moreBenefitLinkUrl+self.selectRentalInfoData.rtModelSeq);
            });
            // E : BTOCSITE-48313

            //BTOCSITE-85521 GA
            $('div.discount-details-rental').on("click", function(e) {
                e.preventDefault();
                let gaClass = $('div.discount-details-rental').find('div.details-box-rental').attr('class');
                if(gaClass.indexOf("hide") > -1){
                    $('div.discount-details-rental').find('div.details-header').attr('data-contents','접기');
                    $('div.discount-details-rental').find('div.details-header').find('p').attr('data-contents','접기');
                }else{
                    $('div.discount-details-rental').find('div.details-header').attr('data-contents','펼치기');
                    $('div.discount-details-rental').find('div.details-header').find('p').attr('data-contents','펼치기');
                }
            });

            //카드혜택 B2C 페이지 임으로 B2B인경우는 새창으로
            $("#benefitCardPopup").find("section").find("a").on('click', function(e){
                e.preventDefault();
                let appUrl = $(this).attr('data-app-url');

                if(lgkorUI.getHiddenInputData().b2cYN =='Y'){
                    location.href = appUrl;
                }else{
                    if(isApp()) {
                        let className = e.currentTarget.className;
                        if(className.indexOf('card-request-link') != -1){
                            appUrl = 'https://www.lge.co.kr'+appUrl;
                        }
                        if(vcui.detect.isIOS){
                            let jsonString = JSON.stringify({'url': appUrl, 'command':'openLinkOut'});
                            webkit.messageHandlers.callbackHandler.postMessage(jsonString);
                        } else {
                            android.openLinkOut(appUrl);
                        }
                    }else{
                        let openNewWindow = window.open("about:blank");
                        openNewWindow.location.href = appUrl;
                    }
                }
            });
        },

        // BTOCSITE-85293 START
        activeModalTermAndCondition: function(funcCallBack) {
            var self = this;
            let isMobileMode = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;
            if (isMobileMode) {
                self.$actionSheetConsentPopup.addClass('active');
            } else {
                self.$actionSheetConsentPopup.vcModal('show').addClass('active');
            }
            self.resetAllTerm();
            /* because state checked has been effected from other common-lib js, so click function can't access to correctly value of input checked --> will use array boolean instead */
            var consentsStates = [false, false, false, false, false];

            var btnCloseModal = $('#actionSheetConsent .sheet-close.btn-close');
            btnCloseModal.off('click').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                self.resetAllTerm();
                let isModal = $(this).closest('.ui_modal_wrap'); // user could switch from pc-mode to mobile-mode, so ui_modal_wrap may still in active
                if (isModal.length > 0) {
                    self.$actionSheetConsentPopup.vcModal('hide').removeClass('active');
                    setTimeout(() => {
                        self.$actionSheetConsentPopup.attr('style','');
                    }, 400);
                } else {
                    self.$actionSheetConsentPopup.removeClass('active');
                    setTimeout(() => {
                        self.$actionSheetConsentPopup.attr('style','');
                    }, 400);
                }
            });

            var btnNextProgress = $('#actionSheetConsent .btn.pink.btn-open-action-sheet');
            btnNextProgress.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();

                if (!btnNextProgress.prop('disabled') && self.checkIsAllTermAccepted()) {
                    btnCloseModal.click();
                    funcCallBack();
                }
            });

            var btnCloseConsent1 = $('#sheetConsent01 .sheet-close.btn-close');
            var btnCloseConsent2 = $('#sheetConsent02 .sheet-close.btn-close');
            var btnCloseConsent3 = $('#sheetConsent03 .sheet-close.btn-close');
            var btnCloseConsent4 = $('#sheetConsent04 .sheet-close.btn-close');
            var btnCloseConsent5 = $('#sheetConsent05 .sheet-close.btn-close');

            btnCloseConsent1.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent1Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent1Popup.attr('style','');
                }, 400);
            });
            btnCloseConsent2.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent2Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent2Popup.attr('style','');
                }, 400);
            });
            btnCloseConsent3.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent3Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent3Popup.attr('style','');
                }, 400);
            });
            btnCloseConsent4.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent4Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent4Popup.attr('style','');
                }, 400);
            });
            btnCloseConsent5.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent5Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent5Popup.attr('style','');
                }, 400);
            });

            var btnAcceptedConsent1 = $('#sheetConsent01 .btn.pink.ui_modal_close');
            var btnAcceptedConsent2 = $('#sheetConsent02 .btn.pink.ui_modal_close');
            var btnAcceptedConsent3 = $('#sheetConsent03 .btn.pink.ui_modal_close');
            var btnAcceptedConsent4 = $('#sheetConsent04 .btn.pink.ui_modal_close');
            var btnAcceptedConsent5 = $('#sheetConsent05 .btn.pink.ui_modal_close');

            btnAcceptedConsent1.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent01').prop('checked', true).trigger('change');
                consentsStates[0] = true;
                btnCloseConsent1.click();
            });
            btnAcceptedConsent2.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent02').prop('checked', true).trigger('change');
                consentsStates[1] = true;
                btnCloseConsent2.click();
            });
            btnAcceptedConsent3.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent03').prop('checked', true).trigger('change');
                consentsStates[2] = true;
                btnCloseConsent3.click();
            });
            btnAcceptedConsent4.off('click').on('click',function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent04').prop('checked', true).trigger('change');
                consentsStates[3] = true;
                btnCloseConsent4.click();
            });
            btnAcceptedConsent5.off('click').on('click',function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent05').prop('checked', true).trigger('change');
                consentsStates[4] = true;
                btnCloseConsent5.click();
            });

            var checkBoxConsent1 = $('#consent01');
            var checkBoxConsent2 = $('#consent02');
            var checkBoxConsent3 = $('#consent03');
            var checkBoxConsent4 = $('#consent04');
            var checkBoxConsent5 = $('#consent05');

            checkBoxConsent1.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                consentsStates[0] = $('#consent01').prop('checked');
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });

            checkBoxConsent2.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                consentsStates[1] = $('#consent02').prop('checked');
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });

            checkBoxConsent3.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                consentsStates[3] = $('#consent04').prop('checked');
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });

            checkBoxConsent4.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                consentsStates[4] = $('#consent05').prop('checked');
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });

            checkBoxConsent5.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });

            var arrowBtn1        = $('.consent-detail[data-href="#sheetConsent01"]');
            var arrowBtn2        = $('.consent-detail[data-href="#sheetConsent02"]');
            var arrowBtn3        = $('.consent-detail[data-href="#sheetConsent03"]');
            var arrowBtn4        = $('.consent-detail[data-href="#sheetConsent04"]');
            var arrowBtn5        = $('.consent-detail[data-href="#sheetConsent05"]');

            checkBoxConsent1.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[0]) {
                    arrowBtn1.click();
                    e.preventDefault();
                } else {
                    consentsStates[0] = false;
                }
            });

            checkBoxConsent2.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[1]) {
                    arrowBtn2.click();
                    e.preventDefault();
                } else {
                    consentsStates[1] = false;
                }
            });

            checkBoxConsent3.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[2]) {
                    arrowBtn3.click();
                    e.preventDefault();
                } else {
                    consentsStates[2] = false;
                }
            });

            checkBoxConsent4.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[3]) {
                    arrowBtn4.click();
                    e.preventDefault();
                } else {
                    consentsStates[3] = false;
                }
            });

            checkBoxConsent5.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[4]) {
                    arrowBtn5.click();
                    e.preventDefault();
                } else {
                    consentsStates[4] = false;
                }
            });
        },

        checkIsAllTermAccepted: function() {
            var consent1 = $('#consent01').prop('checked');
            var consent2 = $('#consent02').prop('checked');
            var consent3 = $('#consent03').prop('checked');
            var consent4 = $('#consent04').prop('checked');
            var consent5 = $('#consent05').prop('checked');
            return consent1 && consent2 && consent3 && consent4 && consent5;
        },

        resetAllTerm: function() {
            $('#consent01').prop('checked', false);
            $('#consent02').prop('checked', false);
            $('#consent03').prop('checked', false);
            $('#consent04').prop('checked', false);
            $('#consent05').prop('checked', false);
            var btnNextProgress = $('#actionSheetConsent .btn.pink.btn-open-action-sheet');
            btnNextProgress.prop('disabled', true);
        },

        preCheckTermAndCondition: function(isOnlyCheckBoolean, funcCallBack) {
            var self = this;
            var isCheckTermsAndConditions = $('input[name="isCheckTermsAndConditions"]').val();

            if ('Y' == isCheckTermsAndConditions) {
                if (!isOnlyCheckBoolean) {
                    var checkIsRentalProduct = self.checkIsRentalProduct();
                    
                    /* BTOCSITE-96476 start */
                    if(lgePdpSendData.bizTypeDetail === "CARETAB" && emplCk == "Y"){
                    	checkIsRentalProduct = false;
                    }
                    /* BTOCSITE-96476 end */
                    
                    if (!checkIsRentalProduct) { // checking 5 terms policy not apply to rental product
                        var isMobileMode = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;
                        if (isMobileMode) {
                            // actionSheetPopup is popup for select quantity to buy or add to cart, only active at mobile mode and after 5 terms popup was accepted all
                            var isActionSheetPopupOpen = $('#actionSheetPopup').hasClass('active');
                            if (isActionSheetPopupOpen) {
                                funcCallBack();
                            } else {
                                self.activeModalTermAndCondition(funcCallBack);
                            }
                        } else {
                            self.activeModalTermAndCondition(funcCallBack);
                        }
                    } else {
                        funcCallBack();
                    }
                }
                return true;
            }
            if (!isOnlyCheckBoolean) {
                funcCallBack();
            }
            return false;
        },

        checkIsRentalProduct: function() {
            var self = this;
            var $paymentAmount = self.$pdpInfo.find('.payment-amount');
            var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');
            if (isRentalCareTab) {
                return true;
            }
            var $careshipService = $('.careship-service');
            var checkinput = $careshipService.find('input[type=radio]:checked');
            var isRental = false;
            if(checkinput.length > 0) {
                isRental = lgkorUI.stringToBool(checkinput.val());
            } else {
                var $careSiblingOption = $('.care-sibling-option').eq(0);
                //케어쉽필수 제품인지 체크해서 알림창 뛰움
                if($careSiblingOption.length < 1) {
                    if(careRequire) { // careRequire is global variable
                        isRental = true;
                    }
                } else {
                    isRental = true;
                }
            }
            return isRental;
        },
        // BTOCSITE-85293 END

        up20OptionBindSideEvents: function() {
            var self = this;
            var checkCompareClick = false;

            // LGECOMVIO-20 TAB 제외로 수정
            if(self.$pdpInfo.find('.option-contents').length) {
                if ($('#typeOrder').length) {
                    self.$pdpInfo.attr('data-type-cart', 'P');
                } else {
                    self.$pdpInfo.attr('data-type-cart', 'C');
                }
            }

            //모바일 수상내역 버튼
            self.$mobilePdpInfo.on('click','div.inner a.btn-link.popup', function (e) {
                e.preventDefault();
                self.$pdpMoreInfo.find('a.btn-link.popup').trigger('click');
            });

            //비교하기
            self.$pdpInfo.find('.product-compare input[type=checkbox]').off('click').on('click', function(e) {
                e.preventDefault();
                // BTOCSITE-30428 : 빠른 클릭시 레이아웃이 안뜨는 형상 발생
                if(checkCompareClick) {
                    return;
                }
                checkCompareClick = true;

                var checked = !$(this).hasClass('compare-select');
                var pdpDataId = self.$pdpInfo.attr('data-id'); //BTOCSITE-5856 비교하기 버튼 토글기능 오류

                if(checked) {
                    $(this).addClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
                } else {
                    $(this).removeClass('compare-select');
                    // BTOCSITE-30428 : $('.sticy-compare .list-inner li') 이벤트 발생되어 비교하기 삭제시에서도 세션캐시 2번 호출로 인한 에러 발생
                    // $('.item-inner[data-id=' + pdpDataId + ']').siblings('.btn-close').trigger('click'); //BTOCSITE-5856 비교하기 버튼 토글기능 오류
                }
                //$(this).prop('checked',!checked);
                //self.requestCompareItem(lgePdpSendData, checked, $(this));
                var categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
                var categoryNm = lgkorUI.getHiddenInputData().defaultCategoryName;

                var compareId = lgePdpSendData.sku.split(".");
                if(typeof modelName !== 'undefined') {
                    compareId = modelName;
                }

                if(checked){
                    var compareObj = {
                        "id": lgePdpSendData.id,
                        "b2bcatemapping":lgePdpSendData.b2bCateMapping,
                        "productName": lgePdpSendData.productName,
                        "productID": compareId,
                        "productImg": lgePdpSendData.productImg,
                        "productAlt": lgePdpSendData.productAlt,
                        "careType": lgePdpSendData.careType,
                        "path": modelUrlPath,
                        "lgecomOnlyFlag" : lgePdpSendData.lgecomOnlyFlag,
                        "b2cYN": lgkorUI.getHiddenInputData().b2cYN
                    }
                    var isAdd = lgkorUI.addCompareProd(categoryId, compareObj, categoryNm);
                    if(!isAdd) {
                        $(this).prop('checked', false);
                        $(this).removeClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
                    }
                } else{
                    lgkorUI.removeCompareProd(categoryId, lgePdpSendData.id);
                }

                setTimeout(function(){
                    checkCompareClick = false;
                }, 500);
            });

            //비교하기 컴포넌트 변화 체크
            $(window).on("changeStorageData", function(){
                self.setCompares();
            });

            // 장바구니 담기 성공 리턴(BTOCSITE-37933)
            $(window).on("addCartReturn", function(e){
                self.cartRecommend(false);
            });

            //찜하기
            //self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').on('click', function(e) {
            self.$pdpInfo.find('.top-area-wish input[type=checkbox]').on('click', function(e) {
            	var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                var $this = $(this);
                var _id = lgePdpSendData.modelId;
                var sku = (productInfo.model_sku ? productInfo.model_sku : lgePdpSendData.sku);
                var categoryId = lgePdpSendData.categoryId;
                var wishListId = $this.data("wishListId");
                var wishItemId = $this.data("wishItemId");
                var wish = $this.is(':checked');
                var param = {
                    "id":_id,
                    "sku":sku,
                    "categoryId": categoryId,
                    "wishListId": wishListId,
                    "wishItemId": wishItemId
                }
                if(wish){
                    param.type = "add";
                } else{
                    param.type = "remove";
                }

                var ajaxUrl = self.$pdpInfo.attr('data-wish-url');

                var $wishItem = self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]');
                var success = function(data) {
                    // $this.data("wishItemId",data.wishItemId);
                    // $this.prop("checked",wish);
                    $wishItem.each(function(i){
                        $(this).data("wishItemId",data.wishItemId);
                        $(this).prop("checked",wish);
                    });
                    
                    //찜하기, 위시리스트 태그 삽입
                    if(wish) {
                        self.addWishTag();
                    }

                    // BTOCSITE-13562 : 4월 이벤트 개발 요청_찜하기
                    var eventId = lgkorUI.getCookie("eventZzimId");
                    if(eventId) {
                        lgkorUI.requestAjaxData("/mkt/api/eventManagement/addWishlistEvent", {
                            "modelId" : lgePdpSendData.modelId,
                            "categoryId" : lgePdpSendData.categoryId,
                            "wishFlag" : wish ? 'Y' : 'N',
                            "eventId" :  eventId
                        });
                    }
                };
                var fail = function(data) {
                    // $this.prop("checked",!wish);
                    $wishItem.each(function(){
                        $(this).prop("checked",!wish);
                    });
                };

                lgkorUI.requestWish(
                    param,
                    wish,
                    success,
                    fail,
                    ajaxUrl,
                    $this // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 위시리스트 로그인 확인 팝업 close 시 포커스 이동
                );
            });

            //장바구니
            //BTOCSITE-23825 크리테오tag 삽입 함수 추가
            self.$pdpInfo.find('div.purchase-button a.cart').on('click', function(e) {
                e.preventDefault();
                //BTOCSITE-48266 b2b일 때 로그인 체크 start
                if (lgkorUI.getHiddenInputData().b2cYN ==='N') {
                    let callbackVal = KRP0008.b2bLoginCheck(e);

                    if(!callbackVal) return;
                }
                //BTOCSITE-48266 b2b일 때 로그인 체크 end
                if(!self.rentalAllSelect){
                    lgkorUI.alert("", {title: "모든 옵션을 선택해주세요."});
                    return;
                }

                var rentalSelfCheck = false;
                
                //BTOCSITE-29501 - 케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    checkCareSelect = lgkorUI.stringToBool(checkinput.val()); //true:신청 / false:미신청
                }

                self.$actionSheet.find('.ui_selectbox').each(function(){
                    if($(this).val() == '방문없음/자가관리' && checkCareSelect) {
                        rentalSelfCheck = true;
                    }
                })

                var param = {
                    "id":lgePdpSendData.id,
                    "sku":lgePdpSendData.sku,
                    "rtSeq":lgePdpSendData.rtSeq,
                    "bizType":lgePdpSendData.bizType
                }

                var $paymentAmount = $(this).parents('.payment-amount');

                //렌탈케어 제품인가(일반구매의 케어십과 틀림)
                var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');

                //소모품이 있는가
                var cart = [];
                var $additionalPurchase = $('.additional-purchase');
                if($additionalPurchase.length > 0) {
                    $additionalPurchase.find('ul.additional-list li').each(function(idx, item){
                        cart.push($(item).data('id')+"|"+$(item).data('quantity'));
                    });
                }

                //선택 수량
                var quantity = self.$actionSheet.find('div.select-quantity input.quantity');
                if(quantity.length > 0) {
                    cart.push(lgePdpSendData.sku+"|"+quantity.val());
                } else {
                    cart.push(lgePdpSendData.sku+"|1");
                }

                param.sku = cart.join(',');

                param.typeFlag = "P";

                //케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    var checkCareSelect = lgkorUI.stringToBool(checkinput.val());
                    if(checkCareSelect) {
                        //케어쉽 선택
                        param.typeFlag = "C";
                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                    }
                } else {
                    var $careSiblingOption = $('.care-sibling-option');
                    //케어쉽필수 제품인지 체크해서 알림창 뛰움
                    if($careSiblingOption.length < 1) {
                        if(careRequire) {
                            param.typeFlag = "C";
                        }
                    } else {
                        param.typeFlag = "C";
                    }
                }
                //}

                if(param.typeFlag == "C") {
                    if(typeof careshipOnlyFlag !== 'undefined') {
                        param.requireCare = lgkorUI.stringToBool(careshipOnlyFlag) ? true : false;
                    }

                    var careData = $paymentAmount.data('careData');
                    if(careData) {
                        param.rtSeq = careData.rtModelSeq;
                    }

                    var cardData = $paymentAmount.data('cardData');
                    if(cardData) {
                        if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
                            //간편신청카드
                            param.easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
                        }
                    }
                    self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                }

                var ajaxUrl = self.$pdpInfo.attr('data-cart-url');
                
                var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;

                /* 구매시 옵션체크 항목일 경우 START */
                var optItemBuyChkFlag = false;
                var optItemDispNmBuyChk = '';
                var optItemDispValueNmBuyChk = '';
                var action = isRentalCareTab ? '가전 구독' : '구매';

                var optItems = self.$specInfoPopup.find('.sibling-cont > div');
                if (optItems.length > 0) {
                    optItems.each(function(i, e) {
                        if ($(this).data('opt-item-buy-chk-flag') == 'Y') {
                            optItemBuyChkFlag = true;
                            optItemDispNmBuyChk = $(this).data('opt-item-nm');
                            optItemDispValueNmBuyChk = $(this).find('div.option-list input:radio:checked').siblings('label').text();

                            return false;
                        }
                    });
                }

                if (optItemBuyChkFlag === false && buryPipeFlag === 'Y') {
                    optItemBuyChkFlag = true;
                    optItemDispNmBuyChk = '설치타입';
                    optItemDispValueNmBuyChk = '매립배관형';
                }
                // BTOCSITE-85293 START
                self.preCheckTermAndCondition(false, function() {
                    if(optItemBuyChkFlag) {
                        lgkorUI.confirm('', {
                            title:"지금 선택된 제품은 <br>" + optItemDispNmBuyChk + " " +  optItemDispValueNmBuyChk + " 제품입니다.<br>" + optItemDispValueNmBuyChk + " 제품을 " + action + " 하시겠어요?",
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                if(rentalSelfCheck){
                                    lgkorUI.confirm('', {
                                        title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 " + action + " 하시겠어요?",
                                        okBtnName: '확인',
                                        cancelBtnName: '취소',
                                        ok: function() {
                                            if(!isRentalCareTab && param.typeFlag == "C") {
                                                //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START
    
                                                //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                                $('#careRequireBuyCartPopup').vcModal({opener: this});
                                               //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                                return;
                                            }
                                            self.addCartAjaxCall(ajaxUrl, param, true);
                                            self.addCartTag(productInfo, quantity, false);
                                        }
                                    });
                                    return;
                                } else {
                                    if(!isRentalCareTab && param.typeFlag == "C") {
    
                                         //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건 수정
                                        $('#careRequireBuyCartPopup').vcModal({opener: this});
                                       //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
    
                                        return;
                                    }
                                }
                                self.addCartAjaxCall(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, false);
                            }
                        });
    
                        return;
                    }
                    /* 구매시 옵션체크 항목일 경우 END */
                    
                    if(rentalSelfCheck){
                        lgkorUI.confirm('', {
                            title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 구매하시겠어요?",
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                if(!isRentalCareTab && param.typeFlag == "C") {
                                    //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START
    
                                    //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                    $('#careRequireBuyCartPopup').vcModal({opener: this});
                                   //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                    return;
                                }
                                self.addCartAjaxCall(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, false);
                            }
                        });
                        return;
                    }
    
                    if(!isRentalCareTab && param.typeFlag == "C") {
                        //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START
    
                        //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                        $('#careRequireBuyCartPopup').vcModal({opener: this});
                       //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
    
                        return;
                    } else {
                        //BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
                        if(purchaseButtonDisplay === "N"){
                            lgkorUI.alert("", {title: purchaseButtonMassage}, document.activeElement); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        }else{
                            self.addCartAjaxCall(ajaxUrl, param, true);
                            self.addCartTag(productInfo, quantity, false);
                        }
                    }

                });
                // BTOCSITE-85293 END

            });

            //구독 BTOCSITE-22701 add :: 구독신청클릭시
            self.$pdpInfo.on('subscribe', function(e, data){

                self.$serviceOptPopup1.trigger('popup', data);

            });

            //상단 스티키 구매버튼
            $(window).on('sendExtraAction.KRP0009', function(e){
                // BTOCSITE-22701 :: 구독일때 케이스 추가
                var $buyButton;
                if (lgePdpSendData.bizType == 'SUBSCRIPTION'){
                    $buyButton =  self.$pdpInfo.find('div.purchase-button a:not(.cart)').eq(1);                    
                } else {
                    $buyButton =  self.$pdpInfo.find('div.purchase-button a:not(.cart)').eq(0);
                }                
                $buyButton.trigger('click');
            });

            //링크
            self.$pdpInfo.on('click','a.btn-link:not(.popup)', function(e) {
                e.preventDefault();
                var $this = $(this);
                if(!$this.attr('data-control')) {
                    var url = $this.attr('href').replace("#","");
                    var addS = $this.data('add');
                    if(url) {
                        if(addS) {
                            url += addS;
                        }
                        location.href = url;
                    }
                }
            });

            //LGECOMVIO-20 - 구매혜택 팝업
            self.$pdpInfo.on('click','li.lists .buy-benefit-info a.btn-link.popup', function(e) {
                e.preventDefault();
                var target = $(this).data("active-target");
                self.$buybenefitInfoPopup.vcModal({opener: this});
                self.$buybenefitInfoPopup.find('.ui_accordion .lists').each(function(idx,item){
                    if($(item).attr('id') === target){
                        self.$buybenefitInfoPopup.find('.ui_accordion').vcAccordion('expand',idx);
                    }
                })
            });

            //LGECOMVIO-20 - 단순팝업 열기
            function pdpOpenPopup(selector,targetPopup,fn){
                $(selector).on('click',function(e){
                    e.preventDefault();
                    targetPopup.vcModal({opener: this});
                });
            };

            //팝업 BTOCSITE-1025 : add 20210802 - LGECOMVIO-20
            pdpOpenPopup('.notice-wrap .notice-box a', self.$mainInitPopup);
            //할인적용가 팝업 BTOCSITE-5781 - LGECOMVIO-20
            //pdpOpenPopup('li.lists.member .btn-discount-popup', self.$saleInfoPopup);
            //구매혜택 팝업 - 추후 삭제 LGECOMVIO-20
            pdpOpenPopup('li.lists.benefit a.btn-link.popup', self.$benefitInfoPopup);
            //LGECOMVIO-20 - 제휴카드 팝업 - LGECOMVIO-20
            pdpOpenPopup('.promotion-card-info .card-list-more', self.benefitCardPopup) // BTOCSITE-51891 구독 제휴카드 관련 PDP/팝업 수정의 건

            //제휴카드 할인 드롭다운 선택
            //div.option-contents
            self.$pdpInfo.on('click','.rental-card-list div.ui_dropdown_list li a, .careship-card-list div.ui_dropdown_list li a', function(e){
                e.preventDefault();
                var $this = $(this);
                var $dropDown = $this.parents('.dropdown-box-wrap'); //BTOCSITE-3523 수정

                //BTOCSITE-3523 추가
                if($this.closest("li").hasClass("cancel-item")) {
                    $this.closest('.dropdown-box-wrap').removeClass('is-selected'); //BTOCSITE-3523 수정
                    $dropDown.find('.ui_dropdown_toggle').empty();
                }else{
                    $dropDown.find('.ui_dropdown_toggle').text($this.attr('data-card-title'));
                    $this.closest('.dropdown-box-wrap').addClass('is-selected'); //BTOCSITE-3523 수정
                }

                $dropDown.removeClass('open'); //BTOCSITE-3523 수정

                var cardData = {};
                var cardNameCode = $this.attr('href').replace("#","");
                if(cardNameCode) {
                    cardData.cardNameCode = cardNameCode;
                }
                var cardSale = $this.data('cardSale');
                if(cardSale) {
                    cardData.cardSale = cardSale;
                }
                var cardSubName = $this.data('cardSubName');
                if(cardSubName) {
                    cardData.cardSubName = cardSubName;
                }
                var simpleReqFlag = $this.data('simpleReqFlag');
                if(simpleReqFlag) {
                    cardData.simpleReqFlag = simpleReqFlag;
                }

                var isRental = false;
                var $careshipService = $this.parents('.careship-service');
                if($careshipService.length < 1) {
                    $careshipService = $this.parents('.care-sibling-option');
                    if($careshipService.length > 0) {
                        isRental = true;
                    }
                }
                var $paymentAmount = self.$pdpInfo.find('.payment-amount');

                $paymentAmount.data('cardData',cardData);
                if(isRental){
                    self.updateRentalInfoPrice(self.selectRentalInfoData);
                } else {
                    self.updateCareshipInfoPrice(self.selectCareshipInfoData);
                }
            });

            //div.option-contents
            var cardDropdown = self.$pdpInfo.find('.rental-card-list div.ui_dropdown_list .simple-card-list, .careship-card-list div.ui_dropdown_list .simple-card-list'); //BTOCSITE-3523 수정
            var firstRow = cardDropdown.find('li a:eq(0)');
            if(firstRow.length > 0) {
                firstRow.trigger('click',firstRow);
            }

            // S : BTOCSITE-20780
            self.$pdpInfo.on('click','li.lists.member .btn-buy-benefit', function(e) {
                var href = $(this).data('url');
                var eventId = href.substring(href.indexOf("-")+1,href.indexOf("?"));
                var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                var mltlp = $(this).data("mltlp");

                // 다품목 상품이 아닌경우 세션저장 하지 않음
                if(mltlp == "Y" && productInfo) {
                    var stroageItems = lgkorUI.getStorage(eventId + "_calcItems");
                    var item = {}, calcItems = (vcui.isEmpty(stroageItems)) ? [] : JSON.parse(stroageItems);
                    var chkStroageItem = calcItems.filter(function(obj){
                        return obj.sku == lgePdpSendData.sku;
                    });
                    item = {
                        id: 'calc-'+lgePdpSendData.sku,
                        sku: lgePdpSendData.sku,
                        modelName: modelName,
                        oprice: parseInt(productInfo.price),
                        tprice: parseInt(productInfo.discounted_price),
                        dprice: parseInt(productInfo.price) - parseInt(productInfo.discounted_price),
                        odprice: parseInt(lgkorUI.getHiddenInputData().obsDiscountPrice),
                        mediumImageAddr: lgePdpSendData.productImg,
                        imageAltText: lgePdpSendData.productName,
                        modelId: lgePdpSendData.modelId,
                        bizType: lgePdpSendData.bizType,
                        modelStatusCode: lgePdpSendData.modelStatusCode,
                        rtModelSeq: representRtModelSeq,
                        modelComponent: lgePdpSendData.modelComponent
                    }
                    lgkorUI.setStorage(eventId + "_currentItems", JSON.stringify(item), false);
                    if(chkStroageItem.length == 0) {
                        calcItems.push(item);
                        lgkorUI.setStorage(eventId + "_calcItems", JSON.stringify(calcItems), false);
                    }
                }

                location.href = href;
            });
            // E : BTOCSITE-20780
        },

        resize: function(){
            var self = this;
            self.resizePopup($('#specInfoPopup'), true)

            self.setPaymentBtnArea();
        },

        //팝업 버튼 이벤트
        bindPopupEvents: function() {
            var self = this;
            // careRequireBuyPopup 기본적용
            // salesNotificationPopup 판매 알림신청 입력 BTOCSITE-23884
            // salesNotificationLoginPopup 판매 알림신청 - 비회원/로그인 전 BTOCSITE-23884
            // salesNotificationCompletePopup 판매 알림신청 완료 BTOCSITE-23884
            // BTOCSITE-23884 id값을 변경시 팝업창의 내용이 다릅니다.
            // restockNotificationPopup  BTOCSITE-29838 일시품절 재입고 알림신청 입력
            // restockNotificationCompletePopup BTOCSITE-29838 일시품절 재입고 알림신청 완료
            // salesNotificationErrorPopup BTOCSITE-29838 판매 알림신청 - 에러
            $('#careRequireBuyPopup').on('click','.btn-group button',function(e){
            	
            	// BTOCSITE-22810 START
            	e.preventDefault();
            	lgkorUI.showLoading();
            	setTimeout(function(e){
		             //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start - request form 변경에 따라 submit 으로 구조변경.
					 let submitData = {};
		             var modelList = [];
                     ;
		             var modelMap = {
		                    "modelId":null,
		                    "sku":null,
		                    "rtModelSeq":$('#careRequireBuyPopup').data('rtModelSeq'),
		                    "bizType":null,
	                        "itemSeq":'1'
		             };
		             modelList.push(modelMap);
                    // submit
                    var $careSubmitForm = $('<form method="post" action="/order-to-pay/care-pre-check"><input type="text" name="modelList"/><input type="text" name="easyRequestCard"/></form>');
                    if(lgkorUI.getHiddenInputData().b2cYN == 'N'){
                        $careSubmitForm = $('<form method="post" action="/business/order-to-pay/care-pre-check"><input type="text" name="modelList"/><input type="text" name="easyRequestCard"/></form>');
                    }
                    $careSubmitForm.find('[name=modelList]').val(JSON.stringify(modelList));
                    $careSubmitForm.find('[name=easyRequestCard]').val($('#careRequireBuyPopup').data('easyRequestCard'));
                    $('html').append($careSubmitForm);
                    $careSubmitForm.submit();
	            	/*var popUrl = $('#careRequireBuyPopup').data('sendUrl');
	            	
	            	if(vcui.detect.isIOS){
	            		window.location.href = popUrl;
	            	} else {
	            	    location.href = popUrl;
	            	}*/
	             	//BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 end
            	},300);
            	
            	//setTimeout(function(e){
                    //lgkorUI.showLoading();
                    //location.href = $('#careRequireBuyPopup').data('sendUrl');
                //},30);
            	// BTOCSITE-22810 END
            });

            $('article').on('click', 'button[data-link-url]', function(e) {
                var buttonLinkUrl = $(this).attr('data-link-url');
                var isNew = $(this).attr('data-open-new');
                if(buttonLinkUrl) {
                    if(isNew == "Y") {
                        setTimeout(function () {
                            window.open(buttonLinkUrl);
                        },250);
                    } else {
                        setTimeout(function () {
                            location.href = buttonLinkUrl;
                        },250);
                    }
                }
            });

            $('#pop-pdp-visual').on('modalshown',function(e){
                var index = $(this).data('selectIndex');
                self.clickModalThumbnail(index);
            }).on('modalhidden',function(e){ // BTOCSITE-11452
                $(this).find('video').each(function() {
                    this.pause();
                    this.currentTime = 0;
                })
                self.open360Stop(); // BTOCSITE-15587
            });

            self.$popPdpVisualImage.find('div.zoom-area img').on('load',function(e) {
                self.pinchZoom.update(true);
            });

            // BTOCSITE-89585(비활성화 옵션 선택불가처리)
            self.$siblingCont.on('click', '.select-option input:radio', function(){

				if($(this).closest('#specInfoPopup').hasClass('notebook_Op')){

					if($(this).hasClass('disabled')){

						return false;

					}

				}

			});

            //BTOCSITE-44: 시블링레이어 라디오버튼 change
            self.$siblingCont.on('change', '.select-option input:radio', function(){
                var _self = this;
                var $this = $(_self);
                var models;

                if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우
                	self.siblingCurrentModel = "";
                	
                	// LGECOMVIO-20: 선택한 핵심스펙의 하위 스펙 disabled, checked 초기화
                	$this.closest('.sibling-select').nextAll('div').find('input:radio').prop('checked', false).prop('disabled', false);
                	
                	if(self.receivedSiblingData.length > 0 && self.receivedSiblingData[0].siblingModels && self.defaultSiblingDataFlag ) {
                		models= self.receivedSiblingData[0].siblingModels;
                	} else {
                		models= siblingList[0].siblingModels;
                	}
                	
                	self.$siblingCont.find('.option-list').each(function(optionIndex){
                		var $this = $(this);
                		var $radio = $this.find('input:radio');
                		
                		$radio.each(function(i){
                			self.setSiblingOptionCheck(this, optionIndex, models)
                		});
                	});

                	// LGECOMVIO-20: 선택한 핵심스펙의 하위 스펙 비노출/비활성화 처리
                	$this.closest('.sibling-select').nextAll('div').find('.option-list').each(function(idx){
                		var $radio = $(this).find('input:radio');
                		
                		$(this).show();
                		
                		$radio.each(function(){
                			var targetValue = String($(this).data('siblingCode'));
                			
                			// 노출/비노출
                			if(self.enableOptionList.indexOf(targetValue) == -1) {
                				$(this).closest('[role="radio"]').hide();
                			} else {
                				$(this).closest('[role="radio"]').show();
                			}
                			
                			// 활성/비활성화 (스펙은 있으나 현재 판매가 불가할 시)
                			if(self.disableOptionList.indexOf(targetValue) == -1) {
                				$(this).prop('disabled', false);
                			} else {
                				$(this).prop('disabled', true);
                			}
                		});
                		
                		// 선택 가능한 스펙이 없을 시 영역 비노출
                		self.$siblingCont.find('.option-list').each(function(){
                			if($(this).find('[role="radio"]:visible').length) {
                				$(this).show();
                			} else {
                				$(this).hide();
                			}
                		});
                	})
                	
                	var optionSelectModels = [];
                	
                	self.$siblingCont.find('.option-list').each(function(i){
                		var currentSiblingCode = $(this).find('input:radio').filter(':checked').attr('data-sibling-code')
                		if( i == 0 ) {
                			optionSelectModels = models.filter(function(model){
                				return model.siblingCode === currentSiblingCode
                			})
                		} else {
                			var modelIds = optionSelectModels.map(function(model){
                				return model.modelId
                			});
                			optionSelectModels = models.filter(function(model){
                				return modelIds.indexOf(model.modelId) > -1
                			}).filter(function(model){
                				return model.siblingCode == currentSiblingCode
                			})
                		}
                	})

                	if( optionSelectModels[0] ) {
                		self.siblingCurrentModel = optionSelectModels[0].modelId;
                	} else {
                		self.siblingCurrentModel = '';
                	}
                	
                	if( self.siblingCurrentModel ) {
                		self.requestSiblingData(self.siblingCurrentModel)
                	} else {
                		self.$siblingCont.removeAttr('data-model-path')
                		self.$siblingBtnComp.addClass('disabled'); // LGECOMVIO-20 수정
                	}
                } else { //옵션일 경우 BTOCSITE-26021
                	//클릭한 아이템 정보
                	var changeOptItemId = $(this).data("optItemId");
                	var changeOptItemValueId = $(this).attr("id");
                	var changeOptModel = {};
                	var changeOptModelUrlPath = $(this).data("optModelUrlPath");
                	var isSelectableOption = $(this).hasClass("disabled");
                	
                	//선택된 옵션 item명 옆에 옵션변경됨 초기화
                	self.$siblingCont.find(".option-change").text("");
                	
                	//선택된 옵션 객체에서 해당 itemId값 삭제 및 변경된 값 추가
                	checkedOpt = checkedOpt.filter((item) => item.optItemId != changeOptItemId);
                	checkedOpt.push({optItemId: changeOptItemId, optItemValueId: changeOptItemValueId});

                	if (isSelectableOption) { //선택가능옵션일때
                		//해당하는 모델의 옵션 정보로 라디오 셋팅
                		for(var i = 0; i < optModelList.length; i++) {
                			var result = optModelList[i].optItem.filter(function(item) {
                				  return item.optItemId == changeOptItemId && item.optItemValueId == changeOptItemValueId;
                			});
                			
                			if (result && result.length > 0) {
                				checkedOpt = optModelList[i].optItem;
                				changeOptModel = optModelList[i];
                				changeOptModelUrlPath = optModelList[i].MODEL_URL_PATH;
                				break;
                			}
                		}
                		//모델 옵션 정보로 체크해준다
                		checkedOpt.forEach(function(obj) {
    	    				KRP0008.$siblingCont.find('input:radio[id="' + obj.optItemValueId + '"]').prop("checked", true);
    	    			});
                		//클릭한 옵션을 제외한 자동으로 변경된 옵션 옆에 옵션변경됨 출력
                		var optItemDiv = self.$siblingCont.children("div");
                		optItemDiv.each(function() {
                			var $this = $(this);
                			if ($this.is("." + changeOptItemId + "-div") == false) {
                				$this.find(".option-change").text("옵션 자동 변경됨");
                			}
                		});
                	}

                	KRP0008.optItemModelMap(); //변경된 값으로 셋팅
                	
                	//선택된 옵션 모델아이디 정보로 상단의 모델정보 display 여부 체인지
                	var changeOptModelId = $(this).data("optModelId");
                	self.$optHeader.find(".header-prd").css("display","none");
                	self.$optHeader.find("div[data-opt-model-id=" + changeOptModelId + "]").css("display","");
                	
                	//선택가능옵션 클릭한거면 토스트팝업창도 출력해야함. 
                	if (isSelectableOption) { //선택가능옵션일때
                		var optToastMsg = "";
                		// 판매:1, 판매대기:2, 일시품절:3, 미판매: 4, 단종: 5
                		if (changeOptModel.MODEL_STATUS_ORDER == 1 || changeOptModel.MODEL_STATUS_ORDER == 2 || optBizType == "CARESOLUTION") {
                			optToastMsg = $(this).data("optItemNm") + " " + $(this).data("optItemValueNm") + " 기준으로<br>옵션이 자동 변경되었어요.";
                		} else if (changeOptModel.MODEL_STATUS_ORDER == 3) {
                			optToastMsg = "해당 상품은 품절되었습니다.";
                		} else if (changeOptModel.MODEL_STATUS_ORDER == 5) {
                			optToastMsg ="해당 상품은 단종되었습니다.";
                		} else if (changeOptModel.MODEL_STATUS_ORDER == 4) {
                			optToastMsg ="해당 상품은 제품 정보만 제공하고 있습니다.";
                		}
                		
                		$('.toast-message2').css('z-index', 90002);
                		KRP0008.optPopToastShowHtml(optToastMsg);
                	}
                	//렌탈이면 url끝에 dpType을 붙여준다.
                	if (optBizType == "CARESOLUTION" && (changeOptModelUrlPath.indexOf('dpType=careTab') < 0)) {
                		changeOptModelUrlPath += "?dpType=careTab";
                	}
                	//확인버튼에 해당 modelUrlPath 셋팅
                	self.$siblingBtnComp.data("modelUrlPath", changeOptModelUrlPath);
                }
            });

            //BTOCSITE-44 스펙선택(시블링레이어) 팝업열기
            self.$pdpInfo.on('click','li.lists.Spec a.btn-link.popup', function(e) {
                e.preventDefault();

                self.$specInfoPopup.vcModal({opener: this});
                self.$specInfoPopup.on('modalshown', function(){
                    var $this = $(this);
                    var $siblingCont = $this.find('.sibling-cont');

                    if( !$this.data('init-content') ) {
                        $this.data('init-content', $siblingCont.html());
                        $this.data('init-select-disabled', $this.find('.btn-sibling-select').hasClass('disabled')); // LGECOMVIO-20 수정

                    }
                })
            });

            //BTOSCITE-22701 : 구성상품 팝업
            self.$pdpInfo.on('click','.scrb-composition .btn-link', function(e) {
                e.preventDefault();
                if ($(this).hasClass("no-arrow") == false) {//221208 >가 없는 경우 링크가 안되도록
                    self.$compositionInfoPopup.vcModal({opener: this});
                }
            });            
            
            //BTOSCITE-22701 : 선택옵션수정 팝업
            /*
            self.$pdpInfo.on('click','.scrb-select-option a.btn-pop', function(e) {
                e.preventDefault();
                self.$serviceOptPopup1.trigger('modify');
            });
            */

            //BTOSCITE-22701 결합할인 배너이동 :: START
            self.$bannerLink.on('click', '.more-union a', function(e){
                e.preventDefault();
                var id = $(this).attr('href');
                
                var $nav = $('.KRP0009 .tab-menu-belt')
                var $items = $nav.find('li');
                $items.removeClass('active');
                $nav.find('#pdp_combinedProduct').parent('li').addClass('active');
                
                scrollMoved(id);
            });

            function scrollMoved(id){
                if($(id).length){
                    var checkHeight = 55;
                    var compheight = $('.KRP0009').find('.tab-menu-belt li').eq(0).height();
                    if(compheight < checkHeight) {
                        compheight = checkHeight;
                    } else {
                        checkHeight = compheight;
                    }
                    
                    var movtop = $(id).offset().top - compheight+2;
    
                    if( window.innerWidth < 768 && $(window).scrollTop() > movtop) {
                        movtop = movtop - $('.header').height();
                    }
        
                    $('html, body').stop().animate({scrollTop:movtop}, 200);
                }
            }
            //BTOSCITE-22701 결합할인 배너이동 :: END


            // LGECOMVIO-20 화면사이즈 단위변경 버튼
//            if(self.$specInfoPopup.find('.btn-change-unit').length){
                function cmToInch(cm){
                    var inch = cm/2.54;
                    return Math.ceil(inch);
                }

                self.$specInfoPopup.on('click', '.btn-change-unit', function(){
                    var $this = $(this);
                    var currentUnit = 'cm';

                    if($this.hasClass('is-cm')){
                        $this.removeClass('is-cm');
                        $this.addClass('is-inch').text('cm로 보기');
                        currentUnit = 'inch';
                    } else {
                        $this.removeClass('is-inch');
                        $this.addClass('is-cm').text('인치로 보기');
                        currentUnit = 'cm';
                    }

                    $this.closest('.sibling-select').find('.rdo-wrap').each(function(){
                        var $this = $(this);
                        var targetCode = '';
                        if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우
                        	targetCode = $this.find('input').data('siblingCode');
                        	var siblingValue = $this.attr('title'); // BTOCSITE-32361
                        	if (!isNaN(siblingValue)) {
                        	    siblingValue = targetCode + ' cm';
                        	}
                        	var currentUnitText = currentUnit == 'cm' ? siblingValue : targetCode + ' cm' + '<span class="type-inch">('+ cmToInch(targetCode) + ' inch'+ ')</span>';
                        	$this.find('label').html(currentUnitText);
                        } else { //옵션일 경우 BTOCSITE-26021
                        	targetCode = $this.find('input').data('optItemValueExtra');
                        	targetCodeNm = $this.find('input').data('optItemValueNm');
                        	var currentUnitText = currentUnit == 'cm' ? targetCodeNm : targetCodeNm + '<span class="type-inch">('+ cmToInch(targetCode) + ' inch'+ ')</span>';
                        	$this.find('span.opt-value-nm').html(currentUnitText);
                        }
                    });
                })
//            }

            // LGECOMVIO-20 다시 선택 버튼
            self.$specInfoPopup.find('.btn-sibling-reset').on('click', function(e){
                var $this = $(this);
                var $currentPopup = $this.closest('#specInfoPopup');
                if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우
	                $currentPopup.find('.sibling-cont').empty().append($currentPopup.data('init-content')).removeAttr('data-model-path');
	                if($currentPopup.data('init-select-disabled')){ // LGECOMVIO-20 수정
	                    $currentPopup.find('.btn-sibling-select').addClass('disabled');
	                } else {
	                    $currentPopup.find('.btn-sibling-select').removeClass('disabled');
	                }
                } else { //옵션일 경우 BTOCSITE-26021
                	var $changeUnitBtn = self.$specInfoPopup.find('.btn-change-unit');
                	if ($changeUnitBtn.hasClass('is-inch')) { // cm로 초기화           		
                		$changeUnitBtn.trigger('click');
                	}
                	//선택된 옵션 item명 옆에 옵션변경됨 초기화
                	self.$siblingCont.find(".option-change").text("");
                	checkedOpt = orgCheckedOpt;
                	//모델 옵션 정보로 체크해준다
            		checkedOpt.forEach(function(obj) {
	    				KRP0008.$siblingCont.find('input:radio[id="' + obj.optItemValueId + '"]').prop("checked", true);
	    			});
                	KRP0008.optItemModelMap(); //초기화된 값으로 셋팅
                	//확인버튼에  modelUrlPath 초기화
                	self.$siblingBtnComp.data("modelUrlPath", "");
                	//선택된 옵션 모델아이디 정보로 상단의 모델정보 display 여부 체인지
                	self.$optHeader.find(".header-prd").css("display","none");
                	self.$optHeader.find("div[data-opt-model-id=" + lgePdpSendData.modelId + "]").css("display","");
                }
            })

            //BTOCSITE-44 스펙선택(시블링레이어) 팝업닫기
            self.$specInfoPopup.find('.btn-close').on('click', function(e){
                var $this = $(this);
                var $currentPopup = $this.closest('#specInfoPopup');
                if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우                	
                	$currentPopup.find('.sibling-cont').empty().append($currentPopup.data('init-content')).removeAttr('data-model-path');
                	if($currentPopup.data('init-select-disabled')){ // LGECOMVIO-20 수정
                		$currentPopup.find('.btn-sibling-select').addClass('disabled');
                	} else {
                		$currentPopup.find('.btn-sibling-select').removeClass('disabled');
                	}
                } else { //옵션일 경우 BTOCSITE-26021
                	$currentPopup.hide();
                	var $changeUnitBtn = self.$specInfoPopup.find('.btn-change-unit');
                	if ($changeUnitBtn.hasClass('is-inch')) { // cm로 초기화           		
                		$changeUnitBtn.trigger('click');
                	}
                	//선택된 옵션 item명 옆에 옵션변경됨 초기화
                	self.$siblingCont.find(".option-change").text("");
                	checkedOpt = orgCheckedOpt;
                	//모델 옵션 정보로 체크해준다
            		checkedOpt.forEach(function(obj) {
	    				KRP0008.$siblingCont.find('input:radio[id="' + obj.optItemValueId + '"]').prop("checked", true);
	    			});
                	KRP0008.optItemModelMap(); //초기화된 값으로 셋팅
                	//확인버튼에  modelUrlPath 초기화
                	self.$siblingBtnComp.data("modelUrlPath", "");
                	//선택된 옵션 모델아이디 정보로 상단의 모델정보 display 여부 체인지
                	self.$optHeader.find(".header-prd").css("display","none");
                	self.$optHeader.find("div[data-opt-model-id=" + lgePdpSendData.modelId + "]").css("display","");
                }
            })

            //BTOCSITE-44 스펙선택(시블링레이어) 선택완료
            self.$siblingBtnComp.on('click', function(e){
                var $this = $(this);
                var _smartHomePackageId = self.$pdpInfo.attr('data-smart-home-package-id');
                if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우
                	if($this.hasClass('disabled')) { // LGECOMVIO-20 disabled 관련 분기 추가
//                    $('.toast-message').css('z-index', 90002);
//                    $(window).trigger("toastshow", '모든 옵션을 선택해주세요.');
                	} else {
                		
                		var $currentPopup = $this.closest('#specInfoPopup');
                		var $siblingCont = $currentPopup.find('.sibling-cont');
                		var _modelPath = $siblingCont.attr('data-model-path');
                		
                		if (_modelPath != undefined && _modelPath != "") {
                            if(_smartHomePackageId != undefined && _smartHomePackageId != ""){
                                _modelPath = _modelPath + "?pkgNo=" + _smartHomePackageId;
                            }
                			location.href = lgkorUI.DEFAULT_URL+_modelPath; //BTOCSITE-48266 b2b url 추가
                		} else {
                			$currentPopup.vcModal('hide')
                			$currentPopup.find('.sibling-cont').empty().append($currentPopup.data('init-content')).removeAttr('data-model-path');
                		}
                	}
                } else { //옵션일 경우 BTOCSITE-26021
                	var optModelUrlPath = $this.data("modelUrlPath");
                	$('#specInfoPopup').find('.btn-close').trigger('click');
                    if (optModelUrlPath != null && optModelUrlPath != "" && optModelUrlPath !== modelUrlPath) {
                    	// 초기화
                    	checkedOpt = [];
                    	orgCheckedOpt = [];
                    	optList = [];
                    	optModelList = [];
                    	optBizType = "PRODUCT";
                        // 호출
						
						var param = {
							pickOptionId: null,
							changedOptionIds: null,
							top : $(window).scrollTop()
						};
						if(_smartHomePackageId != undefined && _smartHomePackageId != ""){
                            optModelUrlPath = optModelUrlPath + "?pkgNo=" + _smartHomePackageId;
                        }
						location.href = lgkorUI.DEFAULT_URL+optModelUrlPath; //BTOCSITE-48266 b2b url 추가

                    	//__PDP_DOM_MNG__.load(prodModelUrlPath);
                    }
                }
            });

            //BTOCSITE-34628 [OBS] 얼정냉 장바구니 담기 시, 제품 구매 프로세스 안내 팝업 생성 요청의 건 START
            $('#careRequireBuyCartPopup').on('click','.btn-group button',function(e){

            	e.preventDefault();
            	lgkorUI.showLoading();

            	var param = {
                        "id":lgePdpSendData.id,
                        "sku":lgePdpSendData.sku,
                        "rtSeq":lgePdpSendData.rtSeq,
                        "bizType":lgePdpSendData.bizType
                    }

                    var $paymentAmount = self.$pdpInfo.find('.payment-amount');

                    //렌탈케어 제품인가(일반구매의 케어십과 틀림)
                    var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');

                    //소모품이 있는가
                    var cart = [];
                    var $additionalPurchase = $('.additional-purchase');
                    if($additionalPurchase.length > 0) {
                        $additionalPurchase.find('ul.additional-list li').each(function(idx, item){
                            cart.push($(item).data('id')+"|"+$(item).data('quantity'));
                        });
                    }

                    //선택 수량
                    var quantity = self.$actionSheet.find('div.select-quantity input.quantity');
                    if(quantity.length > 0) {
                        cart.push(lgePdpSendData.sku+"|"+quantity.val());
                    } else {
                        cart.push(lgePdpSendData.sku+"|1");
                    }

                    param.sku = cart.join(',');

                    //var $purchaseButton = $(this).parents('.purchase-button');
                    //if($purchaseButton.hasClass('rental')) {
                    //렌탈타입
                    //   param.typeFlag = "C";
                    //} else {
                    //제품타입
                    param.typeFlag = "P";

                    //케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    var checkCareSelect = lgkorUI.stringToBool(checkinput.val());
                    if(checkCareSelect) {
                        //케어쉽 선택
                        param.typeFlag = "C";
                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                    }
                } else {
                    var $careSiblingOption = $('.care-sibling-option');
                    //케어쉽필수 제품인지 체크해서 알림창 뛰움
                    if($careSiblingOption.length < 1) {
                        if(careRequire) {
                            param.typeFlag = "C";
                        }
                    } else {
                        param.typeFlag = "C";
                    }
                }


                if(param.typeFlag == "C") {
                    if(typeof careshipOnlyFlag !== 'undefined') {
                        param.requireCare = lgkorUI.stringToBool(careshipOnlyFlag) ? true : false;
                    }

                    var careData = $paymentAmount.data('careData');
                    if(careData) {
                        param.rtSeq = careData.rtModelSeq;
	                    //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start
			             var modelList = [];
			             var modelMap = {
			                    "modelId":lgePdpSendData.id,
			                    "sku":lgePdpSendData.sku,
			                    "rtModelSeq":careData.rtModelSeq,
			                    "bizType":lgePdpSendData.bizType
	                    };
	                    modelList.push(modelMap);
	                    param.modelList = JSON.stringify(modelList);
	                    //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start
                    }

                    var cardData = $paymentAmount.data('cardData');
                    if(cardData) {
                        if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
                            //간편신청카드
                            param.easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
                        }
                    }
                    self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                }

                 var ajaxUrl = self.$pdpInfo.attr('data-cart-url');
                 var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                 // BTOCSITE-85293 START
                 self.preCheckTermAndCondition(false, function() {
                     self.addCartAjaxCall(ajaxUrl, param, true);
                     self.addCartTag(productInfo, quantity, true);
                     self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                 });
                 // BTOCSITE-85293 END



            });
            //BTOCSITE-34628 [OBS] 얼정냉 장바구니 담기 시, 제품 구매 프로세스 안내 팝업 생성 요청의 건 END


            // 장바구니 바텀시트 팝업내 장바구니 바로가기 클릭(BTOCSITE-37933)
            self.$actionSheetCart.on('click', '.contain-view button', function(e,target,index){
                lgkorUI.setStorage(self.cartRecommendStorageName, lgePdpSendData.modelId);
                location.href = $(e.currentTarget).data("url");
            });

            // 장바구니 바텀시트 팝업내 다품목 기획전 or 상품 클릭
            self.$actionSheetCart.on('click', 'a', function(e,target,index){
                if( !vcui.detect.isMobileDevice && $(e.currentTarget).data("urlTarget") == "_blank"){
                    window.open($(e.currentTarget).data("url"));
                } else {
                    lgkorUI.setStorage(self.cartRecommendStorageName, lgePdpSendData.modelId);
                    location.href = $(e.currentTarget).data("url");
                }
            });

        },

        resizePopup: function($target, footerFlag){
            //BTOCSITE-44 스펙선택(시블링레이어) 팝업 리사이즈 높이값 조정
            var $popup = $target;

            var _minHeight= parseInt($popup.css('min-height'))
            var $head = $popup.find('.pop-header');
            var $cont = $popup.find('.pop-conts')
            var $footer = $popup.find('.pop-footer');

            var _headerHeight = $head.outerHeight();
            var _contHeight = $cont.outerHeight();
            var _footerHeight= $footer.outerHeight()

            var _curPopupHeight = footerFlag ? _headerHeight + _contHeight + _footerHeight:_headerHeight + _contHeight;

            if( $popup.closest('.ui_modal_wrap').length){
                if( _minHeight > _curPopupHeight ) {
                    $popup.css('min-height', _curPopupHeight);
                } else {
                    return
                }
            }
        },

        //PDP SIDE 관련
        //제휴카드 리스트 정리 펑션
        makeAssociatedCardListData: function(cardListData) {
            var arr = [];
            var simpleCardData = [];
            var individualCardData = [];
            var max = 0;
            cardListData.forEach(function(item, index) {
                if(item.maxSalePrice > max) {
                    max = item.maxSalePrice;
                }
                item.title = "[" + item.cardName.replace("카드","")+ "] " + item.cardSubName;
                lgkorUI.stringToBool(item.simpleReqFlag) ? (item.categoryTitle = "[간편 신청]") : (item.categoryTitle = "[개별 신청]"); //BTOCSITE-3523 추가
                lgkorUI.stringToBool(item.simpleReqFlag) ? simpleCardData.push(item) : individualCardData.push(item);
            });


            //최상단 카드취소
            arr.push({
                "groupTitle":null,
                "listItem":[
                    {
                        "cardNameCode":null,
                        "simpleReqFlag":null,
                        "cardSubName":null,
                        "title":"월 최대 " + vcui.number.addComma(max) + "원 할인",
                        "maxSalePrice":0
                    }
                ]
            });

            //간편 신청 카드
            if(simpleCardData.length > 0) {
                arr.push({
                    "groupTitle":"간편 신청 가능 카드",
                    "listItem":simpleCardData
                });
            }

            //개별 신청 카드
            /* 20210513 텍스트 수정 */
            if(individualCardData.length > 0) {
                arr.push({
                    "groupTitle":"개별 신청 가능 카드",
                    "listItem":individualCardData
                });
            }
            /* //20210513 수정 */
            return arr;
        },

        //제휴카드리스트 갱신
        /* 20210513 수정 */
        //BTOCSITE-3523 : 케어솔루션 PDP 상세조건 개선
        updateAssociatedCardList: function ($cardInfo, cardData) {
            if(cardData && cardData.length > 0) {
                //카드데이타
                var selectList = $cardInfo.find('ul.select-list'),
                    simpleCardList = $('ul.select-list.simple-card-list'),
                    individualCardList = $('ul.select-list.individual-card-list');;
                selectList.empty();
                //var groupItemTemplate = '<li class="divide"><span class="inner"><em>{{groupTitle}}</em></span></li>';
                var cardItemTemplate = '<li><a href="#{{cardNameCode}}" data-card-sub-name="{{cardSubName}}" data-simple-req-flag="{{simpleReqFlag}}" data-card-sale="{{maxSalePrice}}" data-card-title="{{title}}"><p class="card-name">{{label}}</p><p class="card-discount">월 최대 -{{maxSalePriceComma}}원</p></a></li>';
                cardData.forEach(function(obj, idx) {
                    /*if(obj.groupTitle) {
                        selectList.append(vcui.template(groupItemTemplate,obj));
                    }*/
                    if(obj.listItem) {
                        obj.listItem.forEach(function(item, index) {
                            item.label = item.title;
                            item.maxSalePriceComma = vcui.number.addComma(item.maxSalePrice);
                            if(!item.cardNameCode) {
                                item.label = "선택취소"
                                cardItemTemplate = '<li class="cancel-item"><a href="#{{cardNameCode}}" data-card-sub-name="{{cardSubName}}" data-simple-req-flag="{{simpleReqFlag}}" data-card-sale="{{maxSalePrice}}" data-card-title="{{title}}"><p class="card-name">{{label}}</p></a></li>';
                            }else{
                                cardItemTemplate = '<li><a href="#{{cardNameCode}}" data-card-sub-name="{{cardSubName}}" data-simple-req-flag="{{simpleReqFlag}}" data-card-sale="{{maxSalePrice}}" data-card-title="{{title}}"><p class="card-name">{{categoryTitle}}{{label}}</p><p class="card-discount">월 최대 -{{maxSalePriceComma}}원</p></a></li>';
                            }
                            //item.maxSaleString = item.maxSalePrice ? vcui.number.addComma(item.maxSalePrice) : null;
                            if(item.simpleReqFlag === "Y"){
                                //간편 신청 가능 카드
                                $cardInfo.find(simpleCardList).append(vcui.template(cardItemTemplate, item));
                            }else if(item.simpleReqFlag === "N"){
                                //개별 신청 가능 카드
                                $cardInfo.find(individualCardList).append(vcui.template(cardItemTemplate, item));
                            }else {
                                //선택취소
                                $cardInfo.find(simpleCardList).append(vcui.template(cardItemTemplate, item));
                            }
                        });
                    }
                });
                $cardInfo.show();
            } else {
                $cardInfo.hide();
            }
        },
        /* //20210513 수정 */

        //케어십 계약기간 셀렉트박스 갱신 펑션
        careshipInfoSelectBoxUpdate: function($selectBox, selectData, selectIndex, changeEvent) {
            var optionTemplate = '<option value="{{value}}" {{#if json}}data-item="{{json}}"{{/if}}>{{title}}</option>';
            if($selectBox.length > 0) {
                $selectBox.empty();
                if(selectData instanceof Array) { // 서비스타입
                    selectData.forEach(function(item, index){
                        //BTOCSITE-7447
//                            if(item.visitPer == 0){
//                                $selectBox.append(vcui.template(optionTemplate,{"value":item.rtModelSeq,"title":"방문없음(자가관리)", "json":JSON.stringify(item)}));
//                            }else{
//                                $selectBox.append(vcui.template(optionTemplate,{"value":item.rtModelSeq,"title":"1회 / "+ item.visitPer + "개월", "json":JSON.stringify(item)}));
//                            }
                        // BTOCSITE-9177 수정 (기존 방문주기에서 서비스타입으로 변경)
                        $selectBox.append(vcui.template(optionTemplate,{"value":item.svcTypeCd,"title":item.svcTypeDesc,"json":JSON.stringify(item)}));
                    });
                } else { // 방문주기
                    for(key in selectData) {
                        $selectBox.append(vcui.template(optionTemplate,{"value":key,"title":key,"json":JSON.stringify(selectData[key])}));
                    }
                }

                try {
                    $selectBox.vcSelectbox('update');
                    $selectBox.vcSelectbox('selectedIndex', selectIndex, changeEvent);
                } catch (error) {
                    // Event after loading vcui library
                    document.addEventListener('vcLoaded', _vcLoaded_3);
                    function _vcLoaded_3() {
                        $selectBox.vcSelectbox('update');
                        $selectBox.vcSelectbox('selectedIndex', selectIndex, changeEvent);
                        document.removeEventListener("vcLoaded", _vcLoaded_3); // 한 번만 실행
                    };
                }
            }
        },

        // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
        // 렌탈 이동 임직원/복지몰 이용요금 노출 추가
        employeeRentalDirectInfoSetting: function(partnerRentalDirectInfo) {
            let rentalDirectInfo = {
                rtModelSeq : '',
                contractTerm : '',
                years1TotAmt : '',
                maxBenefitPrice : ''
            };
            let rentalMaxSalePrice = vcui.number.parse($('#rentalDirectinfoList').data('rental-max_price'));

            var rentalDirectInfoTemplate = partnerRentalDirectInfo.map(function(item, index, array) {
                rentalDirectInfo.rtModelSeq = item.rtModelSeq;
                rentalDirectInfo.contractTerm = item.contractTerm;
                rentalDirectInfo.years1TotAmt = vcui.number.addComma(item.years1TotAmt);

                if (rentalMaxSalePrice > 0) {
                    if (vcui.number.parse(item.years1TotAmt) < rentalMaxSalePrice) {
                        rentalDirectInfo.maxBenefitPrice = '0';
                    } else {
                        rentalDirectInfo.maxBenefitPrice = vcui.number.addComma(vcui.number.parse(item.years1TotAmt) - rentalMaxSalePrice);
                    }
                }
                return vcui.template(rentalDirectTemplate, rentalDirectInfo);
            }).join('');

            $("#rentalDirectinfoListEmployee .rental-new-list").append(rentalDirectInfoTemplate);
            KRP0008.rentalSwiper();
        },

        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용
        // rental 상품 정보 세팅
        rentalSetting : function(){
            var self = this;
            $('#empBanner').hide();//임직원 배너 영역

            let param = {
                "modelId": lgePdpSendData.modelId,
                "rentalCareType": 'R',
                "allianceBizType": 'CARESOLUTION',
                "subCategoryId": lgePdpSendData.subCategoryId,
                "superCategoryId": lgePdpSendData.superCategoryId,
                "categoryId": lgePdpSendData.categoryId,
                "bizType": lgePdpSendData.bizType,
                "smartHomeFlag" : digitalData.productInfo.smart_home_flag
            };

            lgkorUI.requestAjaxData("/mkt/ajax/product/retrieveRentalInfoProduct", param, function (result) {
                if (result.status === "success" && !vcui.isEmpty(result.data)) {
                    var data = result.data[0];
                    //재구독 회원 여부
                    self.rentalReSubFlag = data.reSubFlag;
                    
                    // BTOCSITE-73594
                    self.obsLinkOrderOfferFlag = data.obsLinkOrderOfferFlag;	// 연계할인 여부(다운타임 여부 포함)

                    // 임직원 값 세팅
                    partnerRentalInfo = data.rentalInfo;

                    self.$rentalActionSheetSelectBox = $('.detail-option-box--action-sheet .ui_selectbox');

                    //대표요금 임시 저장 일반 요금제에 임직원 대표 요금제가 없을 경우 비교대상으로 사용
                    self.defaultSelectRentalOption = {
                        selectContractTerm:null,
                        selectRtModelSeq:null,
                        selectRtRgstFeePre:null,
                        selectDutyTerm:null,
                        selectVisitTerm:null,
                        selectSvcTypeDesc:null
                    }

                    self.rentalOpenTab = "";// 링크를 타고 들어왔을 경우 탭이 있을때 일반 요금제 탭을 오픈하기 위한 변수

                    //임지원 세팅
                    if(partnerRentalInfo.length > 0 && !(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "CARETAB")){//임직원 가격이 존재 할 경우
                        self.$tab1CaresolutionRentalInfoTabBox = self.$pdpInfoCareSiblingOption.find("#tab1");
                        self.$tab1CaresolutionRentalInfoButtonBox = self.$pdpInfoCareSiblingOption.find('div.detail-option-box #tab1 .subscribe-detail-select > div');
                        self.partnerRentalInfoData = self.rentalOptionSetting(partnerRentalInfo,self.$tab1CaresolutionRentalInfoButtonBox,self.$tab1CaresolutionRentalInfoTabBox,"tab01");

                        $('#rentalTabs').show();
                        $('#rental-care-sibling-option').addClass("tabs-type");


                        // 임직원 프로모션 뱃지 세팅
                        if(data.boldBadges && data.boldBadges.length > 0){
                            var partnerBoldBadges = data.boldBadges.map(function(item, index, array) {
                                if(index < 3){
                                    var template = '<span class="flag {{boldFlag}} partnerRentalBadges" style="display:none">{{badgeName}}</span>';
                                    return vcui.template(template,{"boldFlag":item.boldFlag === 'Y' ? 'imp':'',"badgeName":item.badgeName})
                                }
                            }).join('');
                            $("#rentalBadges").append(partnerBoldBadges);
                        }

                        self.rentalPartnerPrefix = '';

                        if(data.partnerGrp){
                            if(data.partnerGrp.indexOf('LGE') > -1 ||
                                data.partnerGrp.indexOf('AFF') > -1
                            ){
                                self.rentalPartnerPrefix = '임직원';
                                emplCk = "Y"; //BTOCSITE-96476
                            }else if (data.partnerGrp.indexOf('AFC') > -1 ){
                                self.rentalPartnerPrefix = '복지몰';
                            }
                        }

                        // rentalTabs 가격 넣기 최저가격 넣기 및 tab title 넣기
                        var rentalMaxSalePrice = $('#rentalTabs').data('rentalMaxSalePrice');
                        var empRentalLowestPrice = data.rentalLowestPrice.empRentalLowestPrice - rentalMaxSalePrice;
                        if(empRentalLowestPrice < 0) empRentalLowestPrice = 0;
                        var rentalLowestPrice = data.rentalLowestPrice.rentalLowestPrice - rentalMaxSalePrice;
                        if(rentalLowestPrice < 0) rentalLowestPrice = 0;


                        var tabTitletemplate = '{{tabTitle}} <span class="tabs-price">{{tabsPrice}}</span>';
                        var partnerTabTitle = vcui.template(tabTitletemplate,{"tabTitle":self.rentalPartnerPrefix,"tabsPrice":'월 ' +vcui.number.addComma(empRentalLowestPrice)+'원~'})
                        var tabTitle = vcui.template(tabTitletemplate,{"tabTitle":'일반회원',"tabsPrice":'월 ' +vcui.number.addComma(rentalLowestPrice)+'원~'})

                        $('#rentalTabs .tabs-title').eq(0).html(partnerTabTitle);//임직원 최저가
                        $('#rentalTabs .tabs-title').eq(1).html(tabTitle);//일반 최저가


                        //가전구독표시광고법 임직원 값 설정
                        $('#rentalPartnerPriceInfoDisp .price-tit').eq(0).text(self.rentalPartnerPrefix+' 가전 구독 총 요금');

                        if(data.careDispText){
                            $('#rentalPartnerPriceInfoDisp .price-tit').eq(1).text(self.rentalPartnerPrefix+' 일시불 요금');
                            $('#rentalPartnerPriceInfoDisp .price-cont').eq(1).text(data.careDispText);
                            $('#rentalPartnerPriceInfoDisp .price-wrap').eq(1).show();
                            $("#rentalIsCareDispText").data('isPartnerCareDispText',false)
                            $("#rentalIsCareDispText").hide();
                        }else{
                            $('#rentalPartnerPriceInfoDisp .price-wrap').eq(1).hide();
                            $("#rentalIsCareDispText").data('isPartnerCareDispText',true)
                            $("#rentalIsCareDispText").show();
                        }

                        //ActionSheet 타이틀 추가
                        $('.action-sheet-title .tit').text(self.rentalPartnerPrefix + '할인 구독');
                        
                        //tootip제어
                        $('.partnerY').show();
                        $('.partnerN').hide();

                    }else{//임직원 가격이 존재 하지 않을경우
                        $('#rentalTabs').remove();
                        $('#tab1').remove();
                        $('.partnerY').remove();
                        $('#tab2').show();
                        $(".rental-price-info.info-box.careDispText").show();
                        $("#rentalPriceInfoDisp").show();
                        if($("#rentalIsCareDispText").data('isCareDispText')){
                            $("#rentalIsCareDispText").show();
                        }
                    }


                    //일반 세팅
                    self.$tab2CaresolutionRentalInfoTabBox = self.$pdpInfoCareSiblingOption.find("#tab2");
                    self.$tab2CaresolutionRentalInfoButtonBox = self.$pdpInfoCareSiblingOption.find('div.detail-option-box #tab2 .subscribe-detail-select > div');
                    self.rentalInfoData = self.rentalOptionSetting(rentalInfo,self.$tab2CaresolutionRentalInfoButtonBox,self.$tab2CaresolutionRentalInfoTabBox,"tab02");
                    sessionStorage.removeItem('dispRtModelSeq');//일반상품에서 찍고 들어온값 제거 처리

                    self.rentalBindSideEvents();

                    //가전 구독 기획전 호출
                    if(rentalInfo){

                        var ajaxUrl = "/mkt/api/exhibit/retrievePlanEventCarePromotionInfo.lgajax";

                        lgkorUI.requestAjaxData(ajaxUrl, {'model_ids' :  lgePdpSendData.modelId}, function(result) {
                            if (result.status === "success" && result.data.length > 0) {
                                const eventPromotionData= result.data[0];
                                self.isEventCarePromotionsDiscount = false;



                                const promtionUrl = '/benefits/exhibitions/detail-'+eventPromotionData.planEventId;
                                if(eventPromotionData.badgeFilterViewFlag === 'Y'){
                                    let boldBadges = $("#rentalBadges span.b2cRentalBadges");
                                    let setBoldBadges = eventPromotionData.badgeFilterText;//

                                    if(setBoldBadges && setBoldBadges.length > 0) {
                                        //기획전 뱃지가 있으면 볼드 뱃지는 지운다.
                                        boldBadges.remove();
                                        if(lgkorUI.getHiddenInputData().b2cYN ==='Y'){
                                            $('#rentalBadges').append('<span class="flag con plus-benefit b2cRentalBadges" style="display:none;">' + eventPromotionData.badgeFilterText + '</span>');
                                        }
                                    }
                                }
                                if(eventPromotionData.benefitInfoViewFlag === 'Y'){
                                    $('#rentalExhibitions > a > strong > span').text(eventPromotionData.benefitInfoMainTitle);
                                    $('#rentalExhibitions > a > span').text(eventPromotionData.benefitInfoSubTitle);
                                    $('#rentalExhibitions > a').attr('href',promtionUrl);
                                    if(!partnerRentalInfo || !partnerRentalInfo.length > 0){
                                        $('#rentalExhibitions').show();
                                    }
                                }else{
                                    $('#rentalExhibitions').remove();
                                }
                                if(eventPromotionData.emblmViewFlag === 'Y' && lgkorUI.getHiddenInputData().b2cYN !=='N'){
                                    let emblmExtraText = eventPromotionData.emblmExtraText1 ? eventPromotionData.emblmExtraText1:eventPromotionData.emblmExtraText2;//
                                    if(emblmExtraText.length > 0) {
                                        $('div.rental-badge-wrap > a.rental-benefit-badge').text(emblmExtraText);
                                        $('div.rental-badge-wrap > a').attr('href',promtionUrl);
                                    }

                                    /*01 : 요금 할인
                                    02 : 포인트
                                    03 : 사은품
                                    04 : 상품권*/
                                    //BTOCSITE-72646 START
                                    let subscribeFlagBox = $('div.pdp-visual-area div.subscribe-flag-box, div.pdp-visual-inner div.subscribe-flag-box');
                                    if((eventPromotionData.emblmType1 === '01' || eventPromotionData.emblmType2 === '01')
                                        && !($("div.pdp-visual-wrap.lge-only").length > 0 && subscribeFlagBox.find("span").length > 0)){
                                        KRP0008.appendTemplate('discount-template', subscribeFlagBox);
                                        self.isEventCarePromotionsDiscount = true;
                                        $('#tab2 div.discount-details-rental > div.details-box-rental > dl.price > dt > span').text('할인 이용 요금');
                                        /* BTOCSITE-85182 */                                        
                                        $('div.rental-badge-wrap > div > span.dscntBadgeTit').text(emblmExtraText);
                                        $('div.rental-badge-wrap').find('.dscntBadgeTooltip').html(eventPromotionData.noteContent);
                                        $('div.rental-badge-wrap').find('.dscntBadgeBtn').on('click', function(){
                                        	location.href = promtionUrl;
                                        });
                                    }
                                    if((eventPromotionData.emblmType1 === '02' || eventPromotionData.emblmType2 === '02')
                                        && !($("div.pdp-visual-wrap.lge-only").length > 0 && subscribeFlagBox.find("span").length > 0)){
                                        KRP0008.appendTemplate('point-template', subscribeFlagBox);
                                    }
                                    if((eventPromotionData.emblmType1 === '03' || eventPromotionData.emblmType2 === '03')
                                        && !($("div.pdp-visual-wrap.lge-only").length > 0 && subscribeFlagBox.find("span").length > 0)){
                                        KRP0008.appendTemplate('gift-template', subscribeFlagBox);
                                    }
                                    if((eventPromotionData.emblmType1 === '04' || eventPromotionData.emblmType2 === '04')
                                        && !($("div.pdp-visual-wrap.lge-only").length > 0 && subscribeFlagBox.find("span").length > 0)){
                                        KRP0008.appendTemplate('gift-card-template', subscribeFlagBox);
                                    }
                                    //BTOCSITE-72646 END
                                }

                            }else{
                                $('#rentalExhibitions').remove();
                            }


                            $(document).ready(function() {//화면 로딩후 탭 클립 한번 해 준다.
                                if(self.partnerRentalInfoData) {//임직원 가격이 존재 할 경우 화면 탭 선택 기능
                                    if(self.rentalOpenTab === 'tab2'){
                                        $('.tabs-wrap.ui_tab').vcTab("select", 1);
                                        $('.care-sibling-option .tabs>li').eq(1).trigger('click');
                                    }else{
                                        $('.tabs-wrap.ui_tab').vcTab("select", 0);
                                        $('.care-sibling-option .tabs>li').eq(0).trigger('click');
                                    }
                                }else{//탭이 없는 경우
                                    if(self.isEventCarePromotionsDiscount){
                                        $("#subscribe-benefit-popup").find('.price-info dl').eq(1).find('div').eq(0).show();
                                    }else{
                                        $("#subscribe-benefit-popup").find('.price-info dl').eq(1).find('div').eq(0).hide();
                                    }

                                    if($('div.pdp-visual-area div.subscribe-flag-box span').length > 0){
                                        $('div.pdp-visual-area div.subscribe-flag-box, div.pdp-visual-inner div.subscribe-flag-box').show();//겔러리 가전 구독 뱃지
                                    }
                                    $("#rentalBadges .b2cRentalBadges").show();
                                    //기획전 뱃지 제어
                                    if(vcui.isEmpty($('div.rental-badge-wrap > div.rental-discount-badge >span.dscntBadgeTit').text())){
                                    	$('div.rental-badge-wrap > div.rental-discount-badge').hide();
                                    }else{
                                    	$('div.rental-badge-wrap > div.rental-discount-badge').show();
                                    }
                                    //다품목 캐시백 배너 제어
                                    subMultiItemBenefit("N");
                                }
                                //가전구독 탭, 이용요금, 셀렉트박스 영역 노출 처리
                                $('#rental-care-sibling-option').eq(0).show();
                                
                                //로그인 후 선택 옵션값 유지
								if(!vcui.isEmpty(sessionStorage.getItem("optionValArr"))){
									const optionValArr = JSON.parse(sessionStorage.getItem("optionValArr"));
									optionValArr.forEach(function(item){
										$(".detail-option-box input[value='"+item+"']:visible").trigger("click");
									});
									//선택 옵션값 sessionStorage초기화
									sessionStorage.removeItem("optionValArr");
								}
								
								//제휴카드 할인 선택 이벤트
						        $("input[name='subDscntCard']").on("click", function(){
						        	const dscntPrice = $(this).data("discount-price");
						        	let dscntPricePrefix = "월 최대 -";
						        	$(".subDscntCardTit").text($(this).data("card-name"));
						        	if(dscntPrice == 0){
						        		dscntPricePrefix = "";
						        	}
						        	$(".subCardDscntAmt").text(dscntPricePrefix+vcui.number.addComma($(this).data("discount-price"))+"원");
						        	KRP0008.updateRentalInfoPrice($(".subOpt:visible").find("dd > ul > li > input:checked").last().data("item"));
						        });
								
								//페이지 최초 진입시 최대 할인 금액 제휴카드 선택 처리
						        const maxDscntPrice = Math.max.apply(null, $("input[name='subDscntCard']").map(function (){
						            return $(this).data("discount-price");
						        }).get());
						        $("input[name='subDscntCard'][data-discount-price='"+maxDscntPrice+"']").eq(0).prop("checked",true).trigger("click");
						        
						        //구독 모델 옵션 선택 없을시 영역 hidden처리
						        if(vcui.isEmpty($(".subModelOptWrap ul").text().trim())){
						        	$(".subModelOptWrap").hide();
						        }
                            });
                        });
                    }
                }

            },"POST", null, null, 150000, null,function(error){
                console.log("error:"+error.statusText);
                }
            );
        },

        reSubDisCount: function(){
            var self = this;
            let param = {
                "modelId": lgePdpSendData.modelId,
                "rentalCareType": 'R',
            };
            lgkorUI.requestAjaxDataPost("/mkt/ajax/product/retrieveReSubFlagCheck", param, function (result) {
                var data = result.data[0];
                
                self.reSubFlagCheck = data.reSubFlag; // 재구독
                var obsLinkOrderOfferFlag = !vcui.isEmpty(data.obsLinkOrderOfferFlag)?data.obsLinkOrderOfferFlag:"N";

                // 가전구독연계 할인 고정 문구
                if(lgkorUI.stringToBool(loginFlag)){
                    if($('#employeePriceTabArea').length > 0){
                        $('#obsLinkOrderOfferLink').show();
                    }else{
                        if(data.obsLinkOrderOfferB2cYn === "Y"){
                            $('#obsLinkOrderOfferLink').show();
                        }else{
                            $('#obsLinkOrderOfferLink').hide();
                        }
                    }
                }else{
                    $('#obsLinkOrderOfferLink').show();
                }

                // 재구독 > 가전연계 순으로 할인
                if(self.reSubFlagCheck == "Y"){

                    $('#rental-info-resub').find('li').each(function(index,item){
                        var $reMaxSalePrice = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('reMaxSalePrice')); //기존 최대혜택가
                        var $years1TotAmt = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('years1Price')); //1년치구독료
                        var $reOrderPrice = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('reorderPrice')); //재구독료
                        var $reSubPrice = $years1TotAmt -$reOrderPrice;
                        let $applyReSubPrice = $('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p');
                        if($reSubPrice < 0){
                            $reSubPrice =0;
                        }

                        if($reOrderPrice > 0){ //재구독료가 있으면 적용
                            if($reMaxSalePrice-$reSubPrice > 0){
                                $applyReSubPrice.html('<span>월</span> '+vcui.number.addComma($reMaxSalePrice-$reSubPrice)+'원'); //재구독 할인가를 적용
                            }else{
                                $applyReSubPrice.html('<span>월</span> 0원'); //기존최대혜택가 - 재구독할인가 = 마이너스인경우
                            }
                        }else{
                            $applyReSubPrice.html('<span>월</span> '+vcui.number.addComma($reMaxSalePrice)+'원'); //재구독가가 없으므로 기존 최대혜택가 적용
                        }

                    });
                }else if(self.reSubFlagCheck === "N" && obsLinkOrderOfferFlag ==="Y"){
                    //BTOCSITE-73428 가전연계
                    $('#rental-info-resub').find('li').each(function(index,item){
                        let $years1TotAmt = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('years1Price')); //일반구독 월구독료
                        let $b2cLinkOrderYears1TotAmt = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('b2cLinkOrderPrice')); //가전연계 월구독료
                        let $cardDiscountPrice = vcui.number.parse($('#rentalDirectinfoList').data('rental-max_price'));//카드할인
                        let $reSubDisCountPrice = $years1TotAmt - $b2cLinkOrderYears1TotAmt; //가전연계 할인가
                        let $applyB2cLinkOrderBenefit = $('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p');

                        //최대혜택가
                        if($b2cLinkOrderYears1TotAmt > 0){

                            if($cardDiscountPrice > 0){
                                //최대혜택가 = 월 이용금액 - 가전연계할인 (일반월구독료 - 가전연계월구독료) - 제휴카드할인
                                var maxSalePrice = $years1TotAmt - $reSubDisCountPrice - $cardDiscountPrice;

                                if(maxSalePrice > 0 && $years1TotAmt > maxSalePrice){
                                    $applyB2cLinkOrderBenefit.html('<span>월</span> '+vcui.number.addComma(maxSalePrice)+'원');
                                }else{
                                    //가전연계 월 구독료가 최대혜택가보다 작으면 0원으로 노출
                                    $applyB2cLinkOrderBenefit.html('<span>월</span> 0원');
                                }
                            }else{
                                $applyB2cLinkOrderBenefit.empty();
                            }
                        }
                    });
                }
            });
        },

        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용
        // rental Option 세팅
        rentalOptionSetting: function(rentalInfo, caresolutionRentalInfoButtonBox,caresolutionRentalInfoTabBox,tabId){
            var self = this;

            //렌탈 가격 정보 정리
            var rentalInfoData = null;

            var defaultSelectRentalOption = {
                selectRtModelSeq:null,
                selectContractDutyTerm:null,
                selectVisitTerm:null,
                selectSvcTypeDesc:null
            }

            // BTOCSITE-51366 :: PDP 렌탈이동 경로개선
            var dispRtModelSeq = '';
            var initDispRtModelSeq = sessionStorage.getItem('dispRtModelSeq');
            if (!vcui.isEmpty(initDispRtModelSeq)) {
                dispRtModelSeq = sessionStorage.getItem('dispRtModelSeq');
            }else{
                dispRtModelSeq = '';
            }


            if(typeof rentalInfo !== 'undefined' && rentalInfo.length > 0) {

                var rentalPriceData = {};
                rentalInfo.forEach(function(item, index) {

                    var contractDutyTerm = (item.contractTerm+"년");
                    var visitPerTxt = item.visitText;
                    var visitPerKey  = visitPerTxt;

                    var svcTypeDesc = (item.svcTypeUseYn === "Y") ? ("" + item.svcTypeDesc) : ""; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성

                    var dataByVisit = rentalPriceData[contractDutyTerm] || {};
                    var dataBySvcTypeDesc = dataByVisit[visitPerKey] || []; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성
                    dataBySvcTypeDesc.push(item);

                    dataByVisit[visitPerKey] = dataBySvcTypeDesc; // 세번째 값
                    rentalPriceData[contractDutyTerm] = dataByVisit; // 첫번째 값

                    //BTOCSITE-51366 :: PDP 렌탈이동 경로개선
                    if(item.rtModelSeq == dispRtModelSeq){
                        defaultSelectRentalOption.selectRtModelSeq = item.rtModelSeq;
                        defaultSelectRentalOption.selectContractDutyTerm = contractDutyTerm;
                        defaultSelectRentalOption.selectVisitTerm =  visitPerTxt;
                        defaultSelectRentalOption.selectSvcTypeDesc = svcTypeDesc;

                        if(partnerRentalInfo.length > 0 && caresolutionRentalInfoTabBox.prop("id") === 'tab2'){
                            self.rentalOpenTab = 'tab2';
                        }
                    }

                    if(
                        dispRtModelSeq === '' &&
                        self.defaultSelectRentalOption.selectRtModelSeq != null &&
                        contractDutyTerm === self.defaultSelectRentalOption.selectContractDutyTerm &&
                        visitPerTxt === self.defaultSelectRentalOption.selectVisitTerm &&
                        svcTypeDesc === self.defaultSelectRentalOption.selectSvcTypeDesc
                    ){
                        defaultSelectRentalOption = self.defaultSelectRentalOption;
                        defaultSelectRentalOption.selectRtModelSeq = item.rtModelSeq;
                    }

                    if(defaultSelectRentalOption.selectRtModelSeq == null && item.representChargeFlag == "Y") {
                        defaultSelectRentalOption.selectRtModelSeq = item.rtModelSeq;
                        defaultSelectRentalOption.selectContractDutyTerm = contractDutyTerm;
                        defaultSelectRentalOption.selectVisitTerm =  visitPerTxt;
                        defaultSelectRentalOption.selectSvcTypeDesc = svcTypeDesc; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성
                    }

                    //일반탭 + 재구독 할인가
                    if(caresolutionRentalInfoTabBox.prop("id") === 'tab2' && self.rentalReSubFlag == "Y"){
                        //
                        var reSubDisCountPrice = parseInt(item.years1TotAmt) - parseInt(item.b2cReorderYears1TotAmt);
                        var reSubPrice = parseInt(item.b2cReorderYears1TotAmt);
					}else if(caresolutionRentalInfoTabBox.prop("id") === 'tab2' && self.obsLinkOrderOfferFlag == "Y"){
                        // 일반탭 + 가전연계 할인가
                        var reSubDisCountPrice = parseInt(item.years1TotAmt) - parseInt(item.b2cLinkOrderYears1TotAmt);
                        var reSubPrice = parseInt(item.b2cLinkOrderYears1TotAmt);
					}
                });
                rentalInfoData = rentalPriceData;
            }


            var rentalButtonBoxIndex = {
                rentalButtonBoxIndex1 : 0, //계약의무기간 contractDutyTerm
                rentalButtonBoxIndex2 : 0, //방문주기 visitPer
                rentalButtonBoxIndex3 : 0,
            }


            //최초 기본값 찾기
            if(defaultSelectRentalOption.selectRtModelSeq) {
                // 기본 계약 기간 찾기
                var array = Object.keys(rentalInfoData);
                for (var i = 0, len = array.length; i < len; i++) {
                    if(array[i] == defaultSelectRentalOption.selectContractDutyTerm) {
                        rentalButtonBoxIndex.rentalButtonBoxIndex1 = i;
                        break;
                    }
                }

                // 방문주기 찾기
                var dataByVisit = rentalInfoData[defaultSelectRentalOption.selectContractDutyTerm];
                if(!dataByVisit){//default 값이 없으면
                    dataByVisit = rentalInfoData[Object.keys(rentalInfoData)[0]];
                }
                var array = Object.keys(dataByVisit);
                for (var i = 0, len = array.length; i < len; i++) {
                    if(array[i] == defaultSelectRentalOption.selectVisitTerm) {
                        rentalButtonBoxIndex.rentalButtonBoxIndex2 = i;
                        break;
                    }
                }

                // 서비스타입찾기
                var array = dataByVisit[defaultSelectRentalOption.selectSvcTypeDesc];
                if(!array){//default 값이 없으면
                    array = dataByVisit[Object.keys(dataByVisit)[0]];
                }
                for (var i = 0, len = array.length; i < len; i++) {
                    //BTOCSITE-51366 :: PDP 렌탈이동 경로개선
                    if(array[i].rtModelSeq == dispRtModelSeq){
                        rentalButtonBoxIndex.rentalButtonBoxIndex3 = i;
                        break;
                    }
                    if(rentalButtonBoxIndex.rentalButtonBoxIndex3 == 0 && array[i].representChargeFlag == "Y") {
                        rentalButtonBoxIndex.rentalButtonBoxIndex3 = i;
                        break;
                    }
                }
            }

            self.defaultSelectRentalOption = defaultSelectRentalOption;

            if(rentalInfoData && caresolutionRentalInfoButtonBox.length > 0) {
                //의무사용기간 세팅
                self.rentalInfoButtonBoxUpdate(0,rentalInfoData,rentalButtonBoxIndex.rentalButtonBoxIndex1,'pageLoad', caresolutionRentalInfoButtonBox,tabId);

                //방문주기 세팅
                var key = Object.keys(rentalInfoData)[rentalButtonBoxIndex.rentalButtonBoxIndex1];
                var visitPerData = rentalInfoData[key];

                if(visitPerData) {
                    self.rentalInfoButtonBoxUpdate(1,visitPerData,rentalButtonBoxIndex.rentalButtonBoxIndex2,'pageLoad', caresolutionRentalInfoButtonBox,tabId);

                    // 서비스타입
                    key = Object.keys(visitPerData)[rentalButtonBoxIndex.rentalButtonBoxIndex2];
                    var svcTypeDescData = visitPerData[key]

                    if(svcTypeDescData) {
                        self.updateRentalInfoPrice(svcTypeDescData[rentalButtonBoxIndex.rentalButtonBoxIndex3],caresolutionRentalInfoTabBox);
                        self.rentalInfoButtonBoxUpdate(2,svcTypeDescData,rentalButtonBoxIndex.rentalButtonBoxIndex3,'pageLoad', caresolutionRentalInfoButtonBox,tabId);
                    }
                }
            }

            return rentalInfoData;
        },

        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용
        // rental 값 세팅후 이벤트 연결
        rentalBindSideEvents : function(){
            var self = this;

            const selectBox01EventSet =
                [
                    self.$tab1CaresolutionRentalInfoButtonBox && self.$tab1CaresolutionRentalInfoButtonBox.eq(0),
                    self.$tab2CaresolutionRentalInfoButtonBox && self.$tab2CaresolutionRentalInfoButtonBox.eq(0)
                ];
            selectBox01EventSet.forEach(el =>{
                if(el){

                    el.on('click','dd > ul > li > input',function(e){
                        const {caresolutionRentalInfoButtonBox, tabId} = self.rentalCurrentTabObjects();

                        const itemData = $(this).data('item');
                        self.rentalInfoButtonBoxUpdate(1,itemData,0,'changeEvent', caresolutionRentalInfoButtonBox, tabId);
                    });
                }
            });

            const selectBox02EventSet =
                [
                    self.$tab1CaresolutionRentalInfoButtonBox && self.$tab1CaresolutionRentalInfoButtonBox.eq(1),
                    self.$tab2CaresolutionRentalInfoButtonBox && self.$tab2CaresolutionRentalInfoButtonBox.eq(1)
                ];
            selectBox02EventSet.forEach(el =>{
                if(el){
                    el.on('click','dd > ul > li > input',function(e){
                        const {caresolutionRentalInfoButtonBox,tabId} = self.rentalCurrentTabObjects();


                        const itemData = $(this).data('item');
                        self.rentalInfoButtonBoxUpdate(2,itemData,0,'changeEvent', caresolutionRentalInfoButtonBox,tabId);
                    });
                }
            });

            const selectBox03EventSet =
                [
                    self.$tab1CaresolutionRentalInfoButtonBox && self.$tab1CaresolutionRentalInfoButtonBox.eq(2),
                    self.$tab2CaresolutionRentalInfoButtonBox && self.$tab2CaresolutionRentalInfoButtonBox.eq(2)
                ];
            selectBox03EventSet.forEach(el =>{
                if(el){
                    el.on('click','dd > ul > li > input',function(e){
                        const itemData = $(this).data('item');
                        self.updateRentalInfoPrice(itemData);
                    });
                }
            });

        },

        //렌탈 케어솔루션 계약기간 셀렉트박스 갱신 펑션
        // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
        // 20220208 BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성 수정
        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용 현재 탭 파라미터 추가
        rentalInfoButtonBoxUpdate: function(buttonBoxIndex, selectData, selectIndex, actionType, caresolutionRentalInfoButtonBox, tabId) {
            const self = this;
            const optionButtonTemplate = '<li><input type="radio" name="{{name}}" id="{{id}}" value="{{value}}" {{#if json}}data-item="{{json}}"{{/if}}><label for="{{id}}">{{title}}</label></li>';
            const optionButtonTemplate2 = '<li><input type="radio" name="{{name}}" id="{{id}}" value="{{value}}" {{#if json}}data-item="{{json}}"{{/if}}><label for="{{id}}">{{title}}<span>{{text}}</span></label></li>';

            if(caresolutionRentalInfoButtonBox.eq(buttonBoxIndex)){
                const $buttonBox = caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find("dd > ul");
                $buttonBox.find('li').remove();
                if(selectData instanceof Array) { // 서비스타입
                    let svcTypeTooltipText = []
                    caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).hide();
                    selectData.forEach(function(item, index){
                    	if(lgkorUI.getHiddenInputData().b2cYN ==='Y' && lgePdpSendData.bizTypeDetail === "CARETAB") {
                    		$buttonBox.append(vcui.template(optionButtonTemplate2,{"name":"name_"+tabId+"_"+buttonBoxIndex,"id":"id_"+tabId+"_"+buttonBoxIndex+"_"+index,"value":item.svcTypeCd,"title":item.svcTypeDesc,"text":item.svcServiceText,"json":JSON.stringify(item)}));
                    		$buttonBox.find("li").eq(index).find("label > span").html(item.svcServiceText);
                    	} else {
                    		$buttonBox.append(vcui.template(optionButtonTemplate,{"name":"name_"+tabId+"_"+buttonBoxIndex,"id":"id_"+tabId+"_"+buttonBoxIndex+"_"+index,"value":item.svcTypeCd,"title":item.svcTypeDesc,"json":JSON.stringify(item)}));
                    	}
                        if(item.svcTypeTooltipText && item.svcTypeTooltipText.length > 0){
                            svcTypeTooltipText.push(item.svcTypeTooltipText);
                        }

                        if(item.svcTypeUseYn === 'Y'){
                            caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).show();
                        }
                    });

                    //서비스 툴팁 설정
                    caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap .bullet-list > li').remove();
                    if(svcTypeTooltipText && svcTypeTooltipText.length > 0){
                        svcTypeTooltipText.forEach(function(item){
                            caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap .bullet-list').append("<li>"+item+"</li>");
                        })

                        if('CT50238004' === lgePdpSendData.categoryId){
                            caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap .bullet-list').append("<li>기본(방문없음/자가관리) : 무상A/S</li>");
                        }

                        caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap').show();
                    }else{
                    	if(lgkorUI.getHiddenInputData().b2cYN ==='Y' && lgePdpSendData.bizTypeDetail === "CARETAB") {
                    		caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap').show();
                    	} else {
                    		caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap').hide();
                    	} 
                    }
                }else{
                    Object.keys(selectData).forEach((key, index) => {
                        // 여기서 index 는 현재 반복의 인덱스
                        $buttonBox.append(vcui.template(optionButtonTemplate,{"name":"name_"+tabId+"_"+buttonBoxIndex,"id":"id_"+tabId+"_"+buttonBoxIndex+"_"+index,"value":key,"title": key,"json": JSON.stringify(selectData[key])}));
                    });
                }
            }

            if(actionType === 'pageLoad'){
                $("input[name='name_"+tabId+"_"+buttonBoxIndex+"']").eq(selectIndex).attr("checked",true);
                if(buttonBoxIndex < 2 || selectData[0].svcTypeCd) {
                    caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).show();
                }
            }else if(actionType === 'changeEvent'){
                $("input[name='name_"+tabId+"_"+buttonBoxIndex+"']").eq(selectIndex).trigger('click');
            }
        },

        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용
        //구독 페이지 현재 선택된 tab 의 관련 Object 리턴
        rentalCurrentTabObjects : function(){
            if(this.$pdpInfoCareSiblingOption.find('ul.tabs>li').length > 0
                && this.$pdpInfoCareSiblingOption.find('.detail-option-box').hasClass('first')){
                var selectItemData = null;
                selectItemData = this.$tab1CaresolutionRentalInfoButtonBox.eq(2).find("dd > ul > li > input:checked").data('item');

                return {
                    tabId : "tab01",
                    caresolutionRentalInfoSelectBox: null,
                    caresolutionRentalInfoButtonBox: this.$tab1CaresolutionRentalInfoButtonBox,
                    rentalInfoData: this.partnerRentalInfoData,
                    selectItemData: selectItemData,
                    tabBox: this.$tab1CaresolutionRentalInfoTabBox
                };
            }else{
                var selectItemData = null;
                selectItemData = this.$tab2CaresolutionRentalInfoButtonBox.eq(2).find("dd > ul > li > input:checked").data('item');

                return {
                    tabId : "tab02",
                    caresolutionRentalInfoSelectBox: null,
                    caresolutionRentalInfoButtonBox: this.$tab2CaresolutionRentalInfoButtonBox,
                    rentalInfoData: this.rentalInfoData,
                    selectItemData: selectItemData,
                    tabBox: this.$tab2CaresolutionRentalInfoTabBox
                };
            }
        },

        //렌탈 케어솔루션 계약기간 선택에 따른 가격정보 변경
        // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용 현재 탭 파라미터 추가
        updateRentalInfoPrice: function(selectRentalInfoData, caresolutionRentalInfoTabBox) {
            var self = this;

            if(!caresolutionRentalInfoTabBox){
                var currentCaresolutionRentalInfo = self.rentalCurrentTabObjects();
                caresolutionRentalInfoTabBox = currentCaresolutionRentalInfo.tabBox;
            }


            self.selectRentalInfoData = selectRentalInfoData;
            var carePrice = parseInt(selectRentalInfoData.years1TotAmt);
            var $paymentAmount = self.$pdpInfo.find('.payment-amount');

console.log("rentalReSubFlag : " + self.rentalReSubFlag + " , obsLinkOrderOfferFlag : " + self.obsLinkOrderOfferFlag + " , b2cLinkOrderYears1TotAmt : " + selectRentalInfoData.b2cLinkOrderYears1TotAmt);
			//재구독 할인가
            var reSubPrice = 0;
            if(caresolutionRentalInfoTabBox.attr('id') === 'tab2' && !(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "CARETAB")){    // 사업자몰 재구독 할인 없음.
                if(self.rentalReSubFlag == 'Y' & parseInt(selectRentalInfoData.b2cReorderYears1TotAmt) > 0){
                    if(carePrice - parseInt(selectRentalInfoData.b2cReorderYears1TotAmt) < 0){
                        reSubPrice = 0;
                        $('#reSubScribePrice').css('display', 'none');
                        $('#reSubScribePricePop').css('display', 'none');
                    }else{
                        reSubPrice = carePrice-parseInt(selectRentalInfoData.b2cReorderYears1TotAmt);
                        $('#reSubScribePrice').css('display', 'flex');
                        $('#reSubScribePricePop').css('display', 'flex');
                    }
                }else if(self.obsLinkOrderOfferFlag == 'Y' & parseInt(selectRentalInfoData.b2cLinkOrderYears1TotAmt) > 0){
                    if(carePrice - parseInt(selectRentalInfoData.b2cLinkOrderYears1TotAmt) < 0){
                        reSubPrice = 0;
                        $('#reSubScribePrice').css('display', 'none');
                        $('#reSubScribePricePop').css('display', 'none');
                    }else{
                        reSubPrice = carePrice-parseInt(selectRentalInfoData.b2cLinkOrderYears1TotAmt);
                        $('#reSubScribePrice').css('display', 'flex');
                        $('#reSubScribePricePop').css('display', 'flex');
						// 우선순위 : 재구독할인 > 가전구독할인 은 동시에 적용될 수 없음. 가전연계 할인 대상이면 '재구독 할인' 영역에 텍스트 변경 처리
						$('#reSubScribePrice').find("dt a").html("가전연계 할인");
						$('#reSubScribePricePop').find("dt a").html("가전연계 할인");
						$('#reSubScribePrice').find("dt a").prop("href", "/care-solutions/rentalService-benefits?rental-scrvice=caresub04");
						$('#reSubScribePricePop').find("dt a").prop("href", "/care-solutions/rentalService-benefits?rental-scrvice=caresub04");
                    }
                }else{
                    reSubPrice = 0;
                    $('#reSubScribePrice').css('display', 'none');
                    $('#reSubScribePricePop').css('display', 'none');
                }
            }else{
                reSubPrice = 0;
                $('#reSubScribePrice').css('display', 'none');
                $('#reSubScribePricePop').css('display', 'none');
            }

            //선택된 카드 데이타
            var cardData = $paymentAmount.data('cardData');
            var monthPrice = carePrice;
            if(cardData && cardData.cardSale) {
                monthPrice -= cardData.cardSale;
            }
            if(monthPrice < 0) {
                monthPrice = 0;
            }

            // 구독료 *개월 무료 혜택 표기
            if(selectRentalInfoData.freeMonth){
                var benefitBadge =  '구독료 ' + selectRentalInfoData.freeMonth + '개월 무료';
                caresolutionRentalInfoTabBox.find('div.rental-badge-wrap > div.rental-benefit-badge').html(benefitBadge); // PC
                caresolutionRentalInfoTabBox.find('div.rental-badge-wrap > div.rental-benefit-badge').show(); // PC
                $('.action-sheet').find('div.rental-badge-wrap > div.rental-benefit-badge').html(benefitBadge); // MO
                $('.action-sheet').find('div.rental-badge-wrap > div.rental-benefit-badge').show(); // MO
            }else{
                caresolutionRentalInfoTabBox.find('div.rental-badge-wrap > div.rental-benefit-badge').html(''); // PC
                caresolutionRentalInfoTabBox.find('div.rental-badge-wrap > div.rental-benefit-badge').hide(); // PC
                $('.action-sheet').find('div.rental-badge-wrap > div.rental-benefit-badge').html(''); // MO
                $('.action-sheet').find('div.rental-badge-wrap > div.rental-benefit-badge').hide(); // MO
            }

            let $viewDiscountDetails = caresolutionRentalInfoTabBox.find('.discount-details-rental');//할인 / 혜택 내용보기

            let $viewDiscountDetailsPrice = $viewDiscountDetails.find('dl.price  dd.content');//할인 / 혜택 내용보기  > 할인 이용 요금
            let $viewDiscountDetailsDiscount = $viewDiscountDetails.find('dl.discount  dd.content');//할인 / 혜택 내용보기  > 제휴카드 할인
            let $viewDiscountDetailsPayment = $viewDiscountDetails.find('dl.payment  dd.content span.won');//할인 / 혜택 내용보기  > 최대혜택가
            let $viewReSubDiscountDetailsDiscount = $(".care-sibling-option").find('dl.re-subscribe-discount  dd.content');//할인 / 혜택 내용보기  > 재구독 할인가

            let $subscribeBenefitPopup = $("#subscribe-benefit-popup");//모바일 최대혜택가 팝업
            let $subscribeBenefitPopupPrice = $subscribeBenefitPopup.find('.price-info dl').eq(0).find('dd span');//모바일 최대혜택가 팝업
            let $subscribeBenefitPopupPriceText = $subscribeBenefitPopup.find('.price-info dl').eq(1).find('div').eq(0).find('dt');
            let $subscribeBenefitPopupPrice2 = $subscribeBenefitPopup.find('.price-info dl').eq(1).find('div').eq(0).find('dd span');
            let $subscribeBenefitPopupReorder = $subscribeBenefitPopup.find('.price-info dl').eq(1).find('div').eq(1).find('dd span'); //재구독 할인가
            let $subscribeBenefitPopupDiscount = $subscribeBenefitPopup.find('.price-info dl').eq(1).find('div').eq(2).find('dd span');
            let $subscribeBenefitPopupPayment = $subscribeBenefitPopup.find('.price-info dl').eq(1).find('div.total').find('dd span');

            //월 이용요금
            var $priceInfo = $(".care-sibling-option").find('dl.price-info span.price.is-all-select');
            var $actionSheetPriceInfo = $('.action-sheet .price.is-all-select');

            var innerHtml = '<span class="sub-text">1년차 월 요금 기준</span><span class="sub-text2">월 </span>' +
                '<strong class="price-won mo">' + vcui.number.addComma(monthPrice) + '<span>원</span></strong><strong class="price-won pc">' + vcui.number.addComma(monthPrice) + '<span>원</span></strong>';
            var innerHtmlActionSheet = '<span class="sub-text2">월</span> ' + '<strong>' + vcui.number.addComma(monthPrice) + '</strong>원'; //BTOCSITE-59756 [상품] [구독 Task] Sales - 임직원가 적용

            $priceInfo.html(innerHtml);
            $actionSheetPriceInfo.html(innerHtmlActionSheet);
            $subscribeBenefitPopupPrice.html(vcui.number.addComma(monthPrice));
            if(self.isEventCarePromotionsDiscount && caresolutionRentalInfoTabBox.attr('id') === 'tab2'){
                $("#subscribe-benefit-popup").find('.price-info dl').eq(1).find('div').eq(0).show();
            }else{
                $("#subscribe-benefit-popup").find('.price-info dl').eq(1).find('div').eq(0).hide();
            }

            $subscribeBenefitPopupPrice2.html(vcui.number.addComma(monthPrice));

            $viewDiscountDetailsPrice.html('<span class="sub-text">1년차 월 요금 기준</span><span class="sub-text2">월</span><span class="won">'+vcui.number.addComma(monthPrice)+'원</span>');

            //::BTOCSITE-51891 구독 제휴카드 관련 PDP/팝업 수정의 건
            var $benefitPriceInfo = $(".care-sibling-option").find('div.benefit-info div.benefit-price em');  // 최대혜택가
            var $actionSheetBenefitPriceInfo = $('.action-sheet div.benefit-info div.benefit-price em');//모바일

            let rentalSalePrice = $("input[name='subDscntCard']:checked").data("discount-price"); // 제휴카드할인금액
            if(vcui.isEmpty(rentalSalePrice)){
            	rentalSalePrice = 0;
            }
            var $rentalSalePriceInfo = $('div.promotion-card-info p.card-discount') // 제휴카드할인가

            var finelSalePrice = monthPrice - rentalSalePrice ;

            if(finelSalePrice-reSubPrice < 0 ){
                finelSalePrice = 0;
                $rentalSalePriceInfo.html('월 최대<span>-' + vcui.number.addComma(monthPrice-reSubPrice) + '원</span>');
                $viewDiscountDetailsDiscount.html('<span class="won">월 최대 -'+vcui.number.addComma(monthPrice-reSubPrice)+'원</span>');
                $subscribeBenefitPopupDiscount.html('-'+vcui.number.addComma(monthPrice-reSubPrice));
                $viewReSubDiscountDetailsDiscount.html('<span class="won">월 -'+vcui.number.addComma(reSubPrice)+'원</span>'); //재구독 할인금액
                $subscribeBenefitPopupReorder.html('-'+vcui.number.addComma(reSubPrice)); //재구독 할인금액 팝업(모바일)
            }else{
                $rentalSalePriceInfo.html('월 최대<span>-' + vcui.number.addComma(rentalSalePrice) + '원</span>');
                $viewDiscountDetailsDiscount.html('<span class="won">월 최대 -'+vcui.number.addComma(rentalSalePrice)+'원</span>');
                $subscribeBenefitPopupDiscount.html('-'+vcui.number.addComma(rentalSalePrice));
                $viewReSubDiscountDetailsDiscount.html('<span class="won">월 -'+vcui.number.addComma(reSubPrice)+'원</span>'); //재구독 할인금액
                $subscribeBenefitPopupReorder.html('-'+vcui.number.addComma(reSubPrice)); //재구독 할인금액 팝업(모바일)
            }

            if(caresolutionRentalInfoTabBox.attr('id') === 'tab2'){
                //일반 탭일경우 재구독 할인가가 있을 수 있으니 재구독 할인가를 제외한다.
                if(finelSalePrice-reSubPrice > 0){
                    $benefitPriceInfo.html(vcui.number.addComma(finelSalePrice-reSubPrice)+'<span>원</span>');
                    $actionSheetBenefitPriceInfo.html(vcui.number.addComma(finelSalePrice-reSubPrice));
                    $subscribeBenefitPopupPayment.html(vcui.number.addComma(finelSalePrice-reSubPrice));
                    $viewDiscountDetailsPayment.html('월 '+vcui.number.addComma(finelSalePrice-reSubPrice)+'원');//할인 / 혜택 내용보기  > 최대혜택가
                }else{
                    $benefitPriceInfo.html(vcui.number.addComma(finelSalePrice)+'<span>원</span>');
                    $actionSheetBenefitPriceInfo.html(vcui.number.addComma(finelSalePrice));
                    $subscribeBenefitPopupPayment.html(vcui.number.addComma(finelSalePrice));
                    $viewDiscountDetailsPayment.html('월 '+vcui.number.addComma(finelSalePrice)+'원');//할인 / 혜택 내용보기  > 최대혜택가
                }
            }else{
                $benefitPriceInfo.html(vcui.number.addComma(finelSalePrice)+'<span>원</span>');
                $actionSheetBenefitPriceInfo.html(vcui.number.addComma(finelSalePrice));
                $subscribeBenefitPopupPayment.html(vcui.number.addComma(finelSalePrice));
                $viewDiscountDetailsPayment.html('월 '+vcui.number.addComma(finelSalePrice)+'원');//할인 / 혜택 내용보기  > 최대혜택가
            }

            //가격정보
            var careData = {
                "rtModelSeq":selectRentalInfoData.rtModelSeq,
                "caresolutionSalesCodeSuffix":selectRentalInfoData.caresolutionSalesCodeSuffix,
                "dutyTerm":selectRentalInfoData.dutyTerm,
                "contractTerm":selectRentalInfoData.contractTerm
            }

            //결헙하여 할인받기 링크용 값 추가
            $('#rentalCarePlanerSale').data('add',selectRentalInfoData.rtModelSeq);

            $paymentAmount.data({"careData":careData,"carePrice":carePrice,"price":0});
            $paymentAmount.data('prefix', '월');
            self.updatePaymentAmountPrice($paymentAmount);
            //
            //꼭 확인하세요 부분 케어솔루션 총요금 업데이트
            var selectInfoData = selectRentalInfoData;
            var rtFreePeriod = selectInfoData.rtFreePeriod ? selectInfoData.rtFreePeriod.split(',') : [];
            var infoTotal = 0;
            
            // BTOCSITE-37605 렌탈 PDP 내 총요금 계산 오류 개선 건 START
            // 주문타입에서는 1년차, 2년차, 3년차, 4년차, 5년차, 6년차 이상, 6개로 관리되며 7년차 부터는 6년차 금액을 더하여 총 금액을 산출하는 방식.
            var maxYears = 6; 
            // BTOCSITE-37605 렌탈 PDP 내 총요금 계산 오류 개선 건 END
            
            // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
            var popupData = {
                "rtFreePeriod":selectInfoData.rtFreePeriod,
                "rtFreePeriodCount":rtFreePeriod.length,
            };

            for(var y=1;y<=selectInfoData.contractTerm;y++){
                var key = y+"";
                // 20210923 BTOCSITE-4441 렌탈제품 PDP 내 신규요금제 출시 배너에 대한 문구 수정 요청
                if(selectInfoData.hasOwnProperty('years'+y+'TotAmt') ) {
                    if(!popupData[key]) popupData[key] = {}
                    var price = selectInfoData['years'+y+'TotAmt'] || 0;
                    if(price) {
                        popupData[key].price = price;
                        popupData[key].free = [];
                        infoTotal += (price * 12);
                    }
                }
                
                // BTOCSITE-37605 렌탈 PDP 내 총요금 계산 오류 개선 건 START
                if(y > maxYears) {
                	let price = selectInfoData['years' + maxYears + 'TotAmt'] || 0;
                	infoTotal += (price * 12);
                }
                // BTOCSITE-37605 렌탈 PDP 내 총요금 계산 오류 개선 건 END
            }

            rtFreePeriod.forEach(function(item, index){
                for(var y=1;y<=selectInfoData.contractTerm;y++){
                    // 20210923 BTOCSITE-4441 렌탈제품 PDP 내 신규요금제 출시 배너에 대한 문구 수정 요청
                    if(item <= y*12 && selectInfoData.hasOwnProperty('years'+y+'TotAmt')) {
                        popupData[y+""].free.push(item);
                        break;
                    }
                }
            });
            //BTOCSITE-22218
            var visitPerTxt = "";
            if((selectInfoData.visitPer === '0') || (selectInfoData.careCategoryName = '전기레인지' && parseInt(selectInfoData.visitPer) == 37) ){
                visitPerTxt = '원 ('+selectInfoData.visitText+')';
            }else{
                visitPerTxt = '원 ('+selectInfoData.visitPer+'개월 방문 기준)';
            }

            if(caresolutionRentalInfoTabBox.attr('id') === 'tab1'){
                $infoBox = $("#rentalPartnerPriceInfoDisp");
                $infoBox.find('dl:eq(0) dd.price-cont').text(vcui.number.addComma(infoTotal) + (selectInfoData.visitPer ? visitPerTxt : '원 (대표요금제 기준)')); //::BTOCSITE-51891 //BTOCSITE-21048
            }else{
                $infoBox = $("#rentalPriceInfoDisp");
                if(lgkorUI.getHiddenInputData().b2cYN ==='N'){
                    $infoBox = $("#b2bRentalPriceInfoDisp");
                }
                $infoBox.find('.components-list:eq(0) li').text(vcui.number.addComma(infoTotal) + (selectInfoData.visitPer ? visitPerTxt : '원 (대표요금제 기준)')); //::BTOCSITE-51891 //BTOCSITE-21048
            }
            $paymentAmount.data('popupData',popupData);
        },

        //케어십 계약기간 선택에 따른 가격정보 변경
        // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
        updateCareshipInfoPrice: function(selectCareshipInfoData) {
            var self = this;
            if(!selectCareshipInfoData) return;
            self.selectCareshipInfoData = selectCareshipInfoData;
            var carePrice = parseInt(selectCareshipInfoData.years1TotAmt);
            var $paymentAmount = self.$pdpInfo.find('.payment-amount');

            //선택된 카드 데이타
            var cardData = $paymentAmount.data('cardData');
            var monthPrice = carePrice;
            if(cardData && cardData.cardSale) {
                monthPrice -= cardData.cardSale;
            }
            if(monthPrice < 0) {
                monthPrice = 0;
            }
            //월 이용요금
            //[BTOCSITE-73060] 제품 PDP UI 개선 START
            var $careshipPriceInfo = self.$pdpInfoCareshipService.find('#careshipPriceInfo');
            $careshipPriceInfo.html('월 <strong>' + vcui.number.addComma(monthPrice) + '</strong>원');
            var $priceInfoBenefit = self.$pdpInfoCareshipService.find('#priceBenefitInfo');
            if($priceInfoBenefit){
                if(selectCareshipInfoData.freeMonth){
                    $priceInfoBenefit.show();
                    $priceInfoBenefit.html(selectCareshipInfoData.freeMonth + '개월 무료혜택');
                } else{
                    $priceInfoBenefit.hide();
                    $priceInfoBenefit.html('');
                }
            }
            //[BTOCSITE-73060] 제품 PDP UI 개선 END

            //가격정보
            var careData = {
                "rtModelSeq":selectCareshipInfoData.rtModelSeq,
                "caresolutionSalesCodeSuffix":selectCareshipInfoData.caresolutionSalesCodeSuffix,
                "dutyTerm":selectCareshipInfoData.dutyTerm
            }
            $paymentAmount.data({"careData":careData,"carePrice":carePrice});
            self.updatePaymentAmountPrice($paymentAmount);

            //케어십 할인 혜택 이용요금 팝업용 데이타
            var selectInfoData = selectCareshipInfoData;
            var rtFreePeriod = selectInfoData.rtFreePeriod ? selectInfoData.rtFreePeriod.split(',') : [];
            var infoTotal = 0;

            // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
            var popupData = {
                "rtFreePeriod":selectInfoData.rtFreePeriod,
                "rtFreePeriodCount":rtFreePeriod.length,
            };

            for(var y=1;y<=selectInfoData.contractTerm;y++){
                var key = y+"";
                if(selectInfoData.hasOwnProperty('years'+y+'TotAmt') ) {
                    if(!popupData[key]) popupData[key] = {}
                    var price = selectInfoData['years'+y+'TotAmt'] || 0;
                    if(price) {
                        popupData[key].price = price;
                        popupData[key].free = [];
                        infoTotal += (price * 12);
                    }
                }
            }

            rtFreePeriod.forEach(function(item, index){
                for(var y=1;y<=selectInfoData.contractTerm;y++){
                    if(item <= y*12 && selectInfoData.hasOwnProperty('years'+y+'TotAmt')) {
                        popupData[y+""].free.push(item);
                        break;
                    }
                }
            });

            $paymentAmount.data('popupData',popupData);
        },

        //구매 가격정보 갱신
        updatePaymentAmountPrice: function($paymentAmount, quantityChange) {
            var self = this;

            //렌탈케어 제품인가(일반구매의 케어십과 틀림)
            var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');

            var quantity = $paymentAmount.data('quantity');
            var price = parseInt($paymentAmount.data('price'));
            var carePrice = parseInt($paymentAmount.data('carePrice'));
            var cardData = $paymentAmount.data('cardData');
            //cardData = cardData ? cardData : {};
            var prefix = $paymentAmount.data('prefix');
            prefix = !prefix ? "" : prefix + " ";
            var businessPrice = parseInt($paymentAmount.data('businessPrice'));  //BTOCSITE-48266 b2b일 때 총금액 변경
            //2021-03-17
            //구매의 케어십은 카드세일을 적용하여 표시하지 않는다 (렌탈케어만 적용해서 표시)
            if(cardData && cardData.cardSale) {
                carePrice -= parseInt(cardData.cardSale);
            }

            var totalPrice = price;
            if(isRentalCareTab) {
                totalPrice = (carePrice ? carePrice : 0);
            }
            //var totalPrice = price + (isRentalCareTab ? (carePrice ? carePrice : 0) : 0);
            //BTOCSITE-48266 b2b일 때 총금액 변경
            if (lgkorUI.stringToBool(loginFlag) && lgkorUI.getHiddenInputData().b2cYN ==='N') {
                totalPrice = businessPrice;
            }
            var $careLi = $paymentAmount.find('li.careship-price-info');
            if($careLi.length > 0 && self.$pdpInfoCareshipService && self.$pdpInfoCareshipService.length > 0) {

                //케어쉽 체크 여부
                var checkinput = self.$pdpInfoCareshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    var check = lgkorUI.stringToBool(checkinput.val());
                }

                //if(!carePrice || parseInt(carePrice) <= 0) {
                //케어십 미신청 일경우 케어십 이용요금 숨김
                if(!check) {
                    $careLi.hide();
                    //totalPrice = price;
                } else {
                    if(carePrice < 0) {
                        carePrice = 0;
                    }

                    $careLi.find('span.price').text("월 " + vcui.number.addComma(carePrice) +"원");

                    var $careshipService = $('.careship-service');
                    var checkinput = $careshipService.find('input[type=radio]:checked');
                    if(checkinput.length > 0) {
                        if(lgkorUI.stringToBool(checkinput.val())) {
                            $careLi.show();
                        } else {
                            $careLi.hide();
                            totalPrice = price;
                        }
                    }
                }
            }

            //소모품이 있는가
            var totalAdditional = 0;
            var $additionalPurchase = $('.additional-purchase');
            if($additionalPurchase.length > 0) {
                $additionalPurchase.find('ul.additional-list li').each(function(idx, item){
                    var quantity = $(item).data('quantity');
                    var price = $(item).data('price');
                    price = price || "0";

                    if(typeof price === 'string'){
                        price = vcui.string.replaceAll(price,",","") ;
                    }

                    if(quantity && price) {
                        totalAdditional += (quantity * price);
                    }
                });

                //totalPrice += totalAdditional;
            }

            var additionTotalPrice = KRP0008.additionModel.getAdditionTotalPrice();/* BTOCSITE-73832 제품 번들링 과제 번들링 총 가격*/
            KRP0008.additionModel.setSelectedTotalText();/* BTOCSITE-73832 제품 번들링 과제 총 금액 텍스트 변경 처리*/

            var $total = self.$actionSheet.find('dl.total-payment span.price');
            /* BTOCSITE-73832 제품 번들링 과제 additionTotalPrice 추가 */
            $total.html(prefix + '<em>' + vcui.number.addComma((totalPrice * quantity) + totalAdditional + additionTotalPrice) + '</em>원'); //[BTOCSITE-73060] 제품 PDP UI 개선
            KRP0008.calcTotalPrice(prefix,totalPrice,quantity,totalAdditional);

            //쿠폰 로직 개선
            //BTOCSITE-48266 : b2b 쿠폰가 수정
            if($('.total-coupon-payment').length && quantityChange) {
                var $discountPrice = $('.total-coupon-payment .payment .price');
                var applyCpCnt = vcui.number.parse($('.total-coupon-payment .payment').data('cp-max-qty')); //최대구매최대할인수량

                if(applyCpCnt > 0){
                    if( quantity <= applyCpCnt) {
                        $discountPrice.html(prefix + '<em>' + vcui.number.addComma($discountPrice.data('price') * quantity + additionTotalPrice) + '</em>원'); // 기존로직
                    }else{
                        var $priceChk = $discountPrice.data('price') * applyCpCnt;
                        var $priceChk2More  = (totalPrice * (quantity-applyCpCnt)) + totalAdditional;
                        var $priceTotalChk = vcui.number.parse($priceChk) + vcui.number.parse($priceChk2More);
                        $discountPrice.html(prefix + '<em>' + vcui.number.addComma($priceTotalChk + additionTotalPrice) + '</em>원');
                    }
                }else{
                    $discountPrice.html(prefix + '<em>' + vcui.number.addComma($discountPrice.data('price') * quantity + additionTotalPrice) + '</em>원'); // 기존로직
                }

            }

            /* BTOCSITE-26123 임직원 할인가 */
            if($('.is-price-calc-new').length && quantityChange) {
                var $employeePrice = $('.is-price-calc-new .payment .price');
                /* BTOCSITE-73832 제품 번들링 과제 additionTotalPrice 추가 */
                $employeePrice.html(prefix + '<em>' + vcui.number.addComma((self.partnerPrice * quantity) +  totalAdditional + additionTotalPrice) + '</em>원');

                var $employeeCouponPrice = $('.is-coupon-price-calc-new .payment .price');

                var applyCpCnt = vcui.number.parse($('.is-coupon-price-calc-new .payment').data('cp-max-qty')); //최대구매최대할인수량

                if(applyCpCnt > 0){
                    if( quantity <= applyCpCnt) {
                        $employeeCouponPrice.html(prefix + '<em>' + vcui.number.addComma($employeeCouponPrice.data('price') * quantity + additionTotalPrice) + '</em>원'); // 기존로직
                    }else{
                        var $priceChk = $employeeCouponPrice.data('price') * applyCpCnt;
                        var $priceChk2More  = (self.partnerPrice * (quantity-applyCpCnt)) + totalAdditional;
                        var $priceTotalChk = vcui.number.parse($priceChk) + vcui.number.parse($priceChk2More);
                        $employeeCouponPrice.html(prefix + '<em>' + vcui.number.addComma($priceTotalChk + additionTotalPrice) + '</em>원');
                    }
                }else{
                    $employeeCouponPrice.html(prefix + '<em>' + vcui.number.addComma($employeeCouponPrice.data('price') * quantity + additionTotalPrice) + '</em>원'); // 기존로직
                }

            }

            if($('#employeeDisposableTotalPriceArea').length && quantityChange){
                var $employeeDisposablePrice = $('#employeeDisposableTotalPriceArea .content .price');
                $employeeDisposablePrice.text(prefix + vcui.number.addComma((self.partnerPrice * quantity) +  totalAdditional + additionTotalPrice) + '원');

                // BTOCSITE-68092 임직원 소모품 쿠폰
                var $employeeCouponPrice = $('.is-coupon-price-calc-new .payment .price');

                var applyCpCnt = vcui.number.parse($('.is-coupon-price-calc-new .payment').data('cp-max-qty')); //최대구매최대할인수량
                if(applyCpCnt > 0){
                    if( quantity <= applyCpCnt) {
                        $employeeCouponPrice.html(prefix + '<em>' + vcui.number.addComma($employeeCouponPrice.data('price') * quantity + additionTotalPrice) + '</em>원'); // 기존로직
                    }else{
                        var $priceChk = $employeeCouponPrice.data('price') * applyCpCnt;
                        //var $priceChk2More  = (totalPrice * (quantity-applyCpCnt)) + totalAdditional;
						var $priceChk2More = (self.partnerPrice * (quantity-applyCpCnt)) +  totalAdditional;
                        var $priceTotalChk = vcui.number.parse($priceChk) + vcui.number.parse($priceChk2More);
                        $employeeCouponPrice.html(prefix + '<em>' + vcui.number.addComma($priceTotalChk + additionTotalPrice) + '</em>원');
                    }
                }else{
                    $employeeCouponPrice.html(prefix + '<em>' + vcui.number.addComma($employeeCouponPrice.data('price') * quantity + additionTotalPrice) + '</em>원'); // 기존로직
                }
            }
            /* BTOCSITE-26123 임직원 할인가 */
        },

        //케어솔루션 선택 여부에 따른 구매수량 버튼 활성/비활성
        updatePaymentAmountState: function($paymentAmount, isCare) {
            var self = this;
            var isQtyChange = false; // BTOCSITE-32528
            if(isCare) {
                //케어십 신청됐으므로 수량체크버튼 비활성
                $paymentAmount.find('button.minus').attr('disabled',true);
                $paymentAmount.find('button.plus').attr('disabled',true);
                if ($paymentAmount.data('quantity') != 1) {
                    $paymentAmount.find('input.quantity').val(1);
                    $paymentAmount.data('quantity',1);
                    isQtyChange = true;
                }
                // $paymentAmount.find('>.info-text').show(); // BTOSITE-55778

                //[BTOCSITE-73060] 제품 PDP UI 개선 start
                $paymentAmount.find('#quantity').attr('disabled',true);
                $paymentAmount.find('#orderQtyNotice').hide();
                $paymentAmount.find('#careshipQtyNotice').show();
                //[BTOCSITE-73060] 제품 PDP UI 개선 end
            } else {
                //수량체크버튼 활성
                var $input = $paymentAmount.find('input.quantity');
                if(parseInt($input.val()) == 1) {
                    $paymentAmount.find('button.minus').attr('disabled',true);
                    $paymentAmount.find('button.plus').attr('disabled',false);
                } else {
                    $paymentAmount.find('button.minus').attr('disabled',false);
                    $paymentAmount.find('button.plus').attr('disabled',false);
                    isQtyChange = true;
                }
                // $paymentAmount.find('>.info-text').hide(); // BTOSITE-55778
                //[BTOCSITE-73060] 제품 PDP UI 개선 start
                $paymentAmount.find('#quantity').attr('disabled',false);
                $paymentAmount.find('#orderQtyNotice').show();
                $paymentAmount.find('#careshipQtyNotice').hide();
                //[BTOCSITE-73060] 제품 PDP UI 개선 end
            }

            self.updatePaymentAmountPrice($paymentAmount, isQtyChange);
        },

        //구매진행
        productBuy: function($dm, eventTarget) {
            var self = this;

            // BTOCSITE-85293 START
            self.preCheckTermAndCondition(false, function() {

                //홈브류 제품 로그인 안내 뛰우기
                if (location.href.indexOf("lg-homebrew") > -1 && !lgkorUI.stringToBool(loginFlag)) {
                    if(eventTarget) {
                        $('#memberBuyGuide').vcModal({opener: eventTarget});
                    } else {
                        $('#memberBuyGuide').vcModal();
                    }
                    return;
                };
    
                if (lgePdpSendData.isTimeDeal && !lgkorUI.stringToBool(loginFlag)) { // BTOCSITE-49751 [상품] 딜 플랫폼
                    const timeDealLoginPopup = $('article#alertNew6');
                    timeDealLoginPopup.vcModal({opener: eventTarget}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    return;
                }
    
                self.processProductBuy = null;
    
                var tempSendData = JSON.parse(JSON.stringify(lgePdpSendData));
                var $paymentAmount = $dm.parents('.payment-amount');
    
                //렌탈케어 제품인가(일반구매의 케어십과 틀림)
                var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');
    
                //구매타입
                var isRental = false;
                var param = {};
                if(typeof modelGubun !== 'undefined') {
                    if(modelGubun == "1" || modelGubun == "2") {
                        param.order_type = "NB";
                    } else if(modelGubun == "3") {
                        param.order_type = "SM";
                    }
                }
    
                param.id = lgePdpSendData.id;
    
                //소모품이 있는가
                var cart = [];
                var $additionalPurchase = $('.additional-purchase');
                if($additionalPurchase.length > 0) {
                    $additionalPurchase.find('ul.additional-list li').each(function(idx, item){
                        cart.push({
                            "sku":$(item).data('id'),
                            "quantity":$(item).data('quantity')
                        });
                        if(param.order_type == "NB") {
                            param.order_type = "NS";
                        }
                    });
                }
    
                //케어십 선택
                //오더타입 교체할것
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    isRental = lgkorUI.stringToBool(checkinput.val());
                } else {
                    var $careSiblingOption = $('.care-sibling-option').eq(0);
                    //케어쉽필수 제품인지 체크해서 알림창 뛰움
                    if($careSiblingOption.length < 1) {
                        if(careRequire) {
                            //$('#careRequireBuyPopup').vcModal();
                            isRental = true;
                        }
                    } else {
                        isRental = true;
                    }
                }
    
                //선택 수량
                var quantity = self.$actionSheet.find('div.select-quantity input.quantity');
                if(quantity.length > 0) {
                    cart.push({
                        "sku":tempSendData.sku,
                        "quantity":quantity.val()
                    });
                } else if (preOrderFlag && tempSendData.modelStatusCode === "READY_FOR_SALE") { /* BTOCSITE-34432 사전예약 */
                    cart.push({
                        "sku":tempSendData.sku,
                        "quantity":"1"
                    });
                }
    
                //렌탈타입
                var careData = $paymentAmount.data('careData');
    
                if(careData) {
                    param.rtModelSeq = careData.rtModelSeq;
                     //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start
                     var modelList = [];
                     var modelMap = {
                            "modelId":lgePdpSendData.id,
                            "sku":lgePdpSendData.sku,
                            "rtModelSeq":careData.rtModelSeq,
                            "bizType":lgePdpSendData.bizType,
                            "itemSeq":'1'
                     };
                     modelList.push(modelMap);
                     param.modelList = JSON.stringify(modelList);
                     //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 end
                }
    
                var cardData = $paymentAmount.data('cardData');
                if(cardData) {
                    if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
                        //간편신청카드
                        param.easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
                    }
                }
    
                /*
                //선택된 케어쉽
                var careData = $paymentAmount.data('careData');
                if(careData) {
                    param.rtModelSeq = careData.rtModelSeq;
                    param.caresolutionSalesCodeSuffix = careData.caresolutionSalesCodeSuffix;
                }
                //선택된 카드
                var cardData = $paymentAmount.data('cardData');
                if(cardData && cardData.cardNameCode) {
                    console.log(cardData);
                    param.cardNameCode = cardData.cardNameCode;
                }
                */
                if(cart.length > 0) {
                    var cart_items = [];
                    cart.forEach(function(obj,idx){
                        cart_items.push({"data":obj});
                    });
                    param.cart_items = cart_items;
                    param.order_item_qty = cart_items.length;
                }
    
                //BTOCSITE-45195 임직원몰 개선(임직원 전용제품 적용)
                let inputdata = lgkorUI.getHiddenInputData();
    
                var ajaxUrl;
                //BTOCSITE-6011
                if(isRental) {
                    // BTOCSITE-80498 렌탈 신청
                    if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                        KRP0008.csSubscribeClickRecordEvent();
                    }
    
                    var isDirectBuy = !$paymentAmount.find('.purchase-button').hasClass('rental');
    
                    if( (careshipOnlyFlag == 'Y') && (!careShipInfo.length) && isDirectBuy ){
                        ajaxUrl = self.$pdpInfo.attr('data-buy-url');
                        //ajaxUrl = "https://wwwdev50.lge.co.kr/mkt/product/addCartDirectPurchase.lgajax"
                        if(ajaxUrl) {
                            lgkorUI.showLoading();
                            lgkorUI.requestAjaxDataPost(ajaxUrl, param, function(result){
                                //console.log(result);
                                var data = result.data;
                                var obsDirectPurchaseUrl = data.obsDirectPurchaseUrl;
                                if(obsDirectPurchaseUrl){
                                    location.href = obsDirectPurchaseUrl;
                                }
                            });
                        }
                    }else{
                        if(self.loginCheckEnd) {
    
                            if(lgkorUI.stringToBool(loginFlag)) {
                                ajaxUrl = self.$pdpInfo.attr('data-rental-url');
                                //var url = ajaxUrl + "?rtModelSeq=" + param.rtModelSeq + (param.easyRequestCard ? ("&easyRequestCard=" + param.easyRequestCard) : "");
                                if(ajaxUrl) {
                                    if(isDirectBuy) {
                                        //$('#careRequireBuyPopup').data('sendUrl',url);
                                        $('#careRequireBuyPopup').data('rtModelSeq',param.rtModelSeq);
                                        $('#careRequireBuyPopup').data('easyRequestCard',param.easyRequestCard);
                                        /*
                                        $('#careRequireBuyPopup').find('.btn-group button').removeAttr('data-link-url');
                                        $('#careRequireBuyPopup').off('.goto').on('click.goto','.btn-group button',function(e){
                                            console.log($('#careRequireBuyPopup').data('sendUrl'));
                                            location.href = $('#careRequireBuyPopup').data('sendUrl');
                                        });
                                        */
                                        var isCare = lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab';
    
                                        if(!isCare){
                                            if(eventTarget) {
                                                $('#careRequireBuyPopup').vcModal({opener: eventTarget});
                                            } else {
                                                $('#careRequireBuyPopup').vcModal();
                                            }
                                        }
                                    } else {
                                        if($paymentAmount){
                                            if($paymentAmount.data('careData')){
                                                //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start - request form 변경에 따라 submit 으로 구조변경.
                                                var easyRequestCard = '';
                                                var modelList = [];
                                                var modelMap = {
                                                    "modelId":null,
                                                    "sku":null,
                                                    "rtModelSeq":$paymentAmount.data('careData').rtModelSeq,
                                                    "bizType":null,
                                                    "itemSeq":'1'
                                                };
                                                modelList.push(modelMap);
                                                let careData = $paymentAmount.data('careData');
                                                if(cardData) {
                                                    if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
                                                        //간편신청카드
                                                        easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
                                                    }
                                                }
                                                // submit
                                                ajaxUrl = self.$pdpInfo.attr('data-rental-url');
    
                                                setTimeout(function(e){
    
                                                    let $careSubmitForm = $('<form method="post" action="/order-to-pay/care-pre-check"><input type="text" name="modelList"/><input type="text" name="easyRequestCard"/></form>');
                                                    if(lgkorUI.getHiddenInputData().b2cYN == 'N'){
                                                        $careSubmitForm = $('<form method="post" action="/business/order-to-pay/care-pre-check"><input type="text" name="modelList"/><input type="text" name="easyRequestCard"/></form>');
                                                    }
                                                    $careSubmitForm.find('[name=modelList]').val(JSON.stringify(modelList));
                                                    $careSubmitForm.find('[name=easyRequestCard]').val(easyRequestCard);
    
                                                    $('html').append($careSubmitForm);
                                                    $careSubmitForm.submit();
    
                                                },10);
                                            }else{
                                                eventTarget.stopPropagation();
                                                eventTarget.stopImmediatePropagation();
                                                return false;
                                            }
                                        }else{
                                            eventTarget.stopPropagation();
                                            eventTarget.stopImmediatePropagation();
                                            return false;
                                        }
                                    }
                                }
                            } else {
                                ajaxUrl = self.$pdpInfo.attr('data-rental-url-notlogin');
                                //스테이지 세팅후 제거 코드
                                ajaxUrl = ajaxUrl ? ajaxUrl : "/care-solutions/orderPay.lgajax";
                                var sendParam = {
                                    "rtModelSeq":param.rtModelSeq,
                                    "easyRequestCard": "",
                                    "salesChannelContribution":""
                                };
                                if(sendParam.easyRequestCard) {
                                    sendParam.easyRequestCard = param.easyRequestCard
                                }
    
                                sendParam.modelUrlPath = location.pathname + location.search;
                                /*
                                if(typeof modelUrlPath !== 'undefined') {
                                    var queryString = location.search;
                                    sendParam.modelUrlPath = modelUrlPath + queryString;
                                }
                                */
    
                                if(isDirectBuy) {
                                    lgkorUI.showLoading();
                                    lgkorUI.requestAjaxDataPost(ajaxUrl, sendParam, function(result){
                                        //console.log(result);
                                    });
                                } else {
                                    lgkorUI.showLoading();
                                    lgkorUI.requestAjaxDataPost(ajaxUrl, sendParam, function(result){
                                        //console.log(result);
                                    });
                                }
                            }
                        } else {
                            self.processProductBuy = $dm;
                        }
                    }
                }else {
    
                    // BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
                    if(purchaseButtonDisplay === "N") {
                        lgkorUI.alert("", {title: purchaseButtonMassage}, document.activeElement); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        return;
                    }
    
                    ajaxUrl = self.$pdpInfo.attr('data-buy-url');
                    //ajaxUrl = "https://wwwdev50.lge.co.kr/mkt/product/addCartDirectPurchase.lgajax"
                    if(ajaxUrl) {
                        //BTOCSITE-73832  제품 번들링 과제
                        KRP0008.additionModel.getAdditionSelectModelBuyParam(param);
    
                        lgkorUI.showLoading();
                        lgkorUI.requestAjaxDataPost(ajaxUrl, param, function(result){
                            //console.log(result);
                            var data = result.data;
    
                            if (result.status != "success") {
                                if(data && data.alert && !vcui.isEmpty(data.alert)) {
                                    lgkorUI.alert("", {
                                        title: data.alert.title
                                    }, document.activeElement); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                                } else {
                                    if(result.isAddition && Array.isArray(result.message)){
                                        let  additionErrorTemplate = "{{#each (item, idx) in list}}" +
                                                        "<li>" +
                                                        " <p class=\"name\">{{item.modelDisplayName}}</p>" +
                                                        " <span class=\"sku\">{{item.modelName}}</span>" +
                                                        " <p class=\"txt\">{{item.message}}</p>" +
                                                        "</li>" +
                                                        "{{/each}}";
                                        $("#additionErrorMessageListBoxPopup .guide-list > li").remove();
                                        $("#additionErrorMessageListBoxPopup .guide-list").append(vcui.template(additionErrorTemplate, { 'list' : result.message }))
    
                                        $('#additionErrorMessageListBoxPopup').vcModal({opener: eventTarget}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                                    }else if(result.message) {
                                        lgkorUI.alert("", {
                                            title: result.message,
                                            ok: function() {
                                                if (result.code && result.code == "OUT_OF_STOCK" && lgePdpSendData.bizType && lgePdpSendData.bizType == "DISPOSABLE") {
                                                    var newUrl = window.location.href + '?refresh=true';
                                                    window.location.href = newUrl;
                                                }
                                            }
                                        });
                                    }
                                }
                                return;
                            }
                            var obsDirectPurchaseUrl = data.obsDirectPurchaseUrl;
                            if(obsDirectPurchaseUrl){
                                if(lgkorUI.getHiddenInputData().b2cYN === "N"){ //BTOCSITE-48266 [상품] B2B OBS 구축
                                    let url = obsDirectPurchaseUrl.replace('/shop', '/business/shop');
                                    location.href = url;
                                }else{
                                    // 소모품 PDP - 바로구매 salesType Parameter추가
                                    if(lgkorUI.getHiddenInputData().bizType === "DISPOSABLE"){
                                        var salesType = $("#employeeDisposableTabArea").find("li.on").attr("data-salestype");
                                        if(!$("#employeeDisposableTab").is(":visible")){
                                            salesType = "B";
                                        }
                                        obsDirectPurchaseUrl = obsDirectPurchaseUrl + "&salesType=" + salesType;
    
                                   // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
                                    } else if (lgkorUI.getHiddenInputData().bizType === "PRODUCT") {
                                        if ($("#employeePriceTabArea").is(":visible")) {
                                            if ($('#b2cTab').hasClass('on')) {
                                                obsDirectPurchaseUrl = obsDirectPurchaseUrl + "&salesType=B"; // 일반
                                            } else if ($('#employeeTab').hasClass('on')) {
                                                obsDirectPurchaseUrl = obsDirectPurchaseUrl + "&salesType=E"; // 임직원
                                            }
                                        }
                                    }
                                    location.href = obsDirectPurchaseUrl;
                                }
                            }
                        }, true);
                    }
                }
                //BTOCSITE-6011
            });
            // BTOCSITE-85293 END

        },

        //상품 정보 가져오기(ajax)
        getRewardInfo: function() {
            if(typeof lgePdpSendData !== 'undefined') {
                var self = this;
                var ajaxUrl = self.$pdpInfo.attr('data-reward-url');
                //BTOCSITE-85864
				var pcsYn = (location.search.indexOf("channel_code") > 0 || location.search.indexOf("naver_code") > 0)? "Y" : "N";
                //BTOCSITE-48266
                var modelUrl = ""
                if(lgkorUI.getHiddenInputData().b2cYN ==='N'){
                    modelUrl = location.pathname.replace("/business","");
                }else{
                    modelUrl = location.pathname;
                }

                var param = {
                    modelId: lgePdpSendData.modelId,
                    modelUrlPath: modelUrl,
                    b2cYN : lgkorUI.getHiddenInputData().b2cYN, //BTOCSITE-48266 : 사업자회원가 가져오기위함.
                    pcsYn: pcsYn								//BTOCSITE-85864
                }

                if(ajaxUrl) {
                    $.ajax({
                        url: ajaxUrl,
                        method: "POST",
                        async : false,
                        data: param,
                        success : function(result) {
                            var data = result.data[0];
                            //보유멤버쉽 포인트
                            var myMembershipPoint = data.myMembershipPoint;
                            let inputdata = lgkorUI.getHiddenInputData(); //BTOCSITE-48266 [상품] B2B OBS 구축

                            digitalData.productInfo.obsSellingPrice = data.obsSellingPrice;
                            digitalData.productInfo.obsOriginalPrice = data.obsOriginalPrice;
                            digitalData.productInfo.obsMemberPrice = data.obsMemberPrice;
                            digitalData.productInfo.obsDiscountPrice = data.obsDiscountPrice;
                            digitalData.productInfo.obsControlPrice = data.obsControlPrice;
                            digitalData.productInfo.partnerLastBenefitPrice = data.partnerLastBenefitPrice;

                            //BTOCSITE-45195 임직원몰 개선(임직원 전용제품 적용) : 로그인 여부 지역변수로 수정
                            loginFlag = data.loginFlag;
                            if(lgkorUI.stringToBool(loginFlag)){
                                if(lgePdpSendData.bizTypeDetail === 'DISPOSABLE'){
                                    self.memberPartnerGrp = vcui.isEmpty(data.memberPartnerGrp) ? "" : data.memberPartnerGrp;
                                    self.partnerPrice = vcui.isNumber(data.partnerPrice) ? data.partnerPrice : 0 ;
                                    self.obsOriginalPrice = vcui.isNumber(data.obsOriginalPrice) ? data.obsOriginalPrice : 0;
                                    digitalData.productInfo.partnerPrice = self.partnerPrice;
                                    digitalData.productInfo.memberPartnerGrp = data.memberPartnerGrp;
                                    self.partnerBoldBadgesArr = vcui.isEmpty(data.partnerBoldBadges) ? "" : data.partnerBoldBadges;

                                    self.displayDisposalbeEmployeeArea();

                                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                                    $("#buyBenefitInfoPoint .benefit-text").data('employeePoint',vcui.isEmpty(data.rewardPoint) ? "" : vcui.number.addComma(data.rewardPoint));
                                    self.displayBenefitPointArea(digitalData.userInfo.partnerType);

                                }else{

                                    // 혜택가 관련 정보 갱신
                                    // 로그인 이후 데이터 기준으로 쿠폰 팝업에서 최대 혜택가를 재계산하기 위함
                                    lgkorUI.setHiddenInputData({
                                        apprDateDiscountLimitPrice: vcui.isNumber(data.apprDateDiscountLimitPrice) ? data.apprDateDiscountLimitPrice : 0,
                                        discountApprPrice: vcui.isNumber(data.discountApprPrice) ? data.discountApprPrice : 0,
                                        apprDateDiscountRate: vcui.isNumber(data.apprDateDiscountRate) ? data.apprDateDiscountRate : 0,
                                        apprDateDiscountPrice:vcui.isNumber(data.apprDateDiscountPrice) ? data.apprDateDiscountPrice : 0,
                                        rewardAmt:vcui.isEmpty(data.rewardAmt) ? "0" : data.rewardAmt,
                                        obsLastBenefitPrice:vcui.isNumber(data.obsLastBenefitPrice) ? data.obsLastBenefitPrice : 0,
                                        obsCouponDiscountRate:vcui.isNumber(data.obsCouponDiscountRate) ? data.obsCouponDiscountRate : 0,
                                    });

                                    //BTOCSITE-48266 [상품] B2B OBS 구축
                                    if(inputdata.b2cYN ==='Y'){
                                        //로그인
                                        self.$benefitInfoPopup.find('.price-info.point').hide();
                                        var $pointMember = self.$benefitInfoPopup.find('.price-info.point.member');
                                        $pointMember.find('.point-confirm input').val(vcui.number.addComma(myMembershipPoint));
                                        $pointMember.show();
                                        //구매혜택 가격 갱신
                                        if(typeof obsOriginalPrice !== 'undefined' && obsOriginalPrice != "") {
                                            var memberPoint = parseInt(myMembershipPoint);
                                            var originalPrice = parseInt(obsOriginalPrice);
                                            var totalDiscountPrice = (typeof obsTotalDiscountPrice  !== 'undefined'  && totalDiscountPrice != "") ? parseInt(obsTotalDiscountPrice) : 0;
                                            var addRewardAmt = (typeof rewardAmt !== 'undefined' && rewardAmt != "") ? parseInt(rewardAmt) : 0;

                                            var totalSale = totalDiscountPrice + addRewardAmt + memberPoint;
                                            if(totalSale > originalPrice) totalSale = originalPrice;

                                            var total = originalPrice - totalSale;
                                            if(total < 0) total = 0;

                                            var percent = Math.floor(totalSale/originalPrice*100.0);

                                            var $discountRate = self.$benefitInfoPopup.find('.discount-rate');
                                            $discountRate.text(percent+"%");
                                            $discountRate.siblings('.price').text(vcui.number.addComma(totalSale)+"원");
                                            self.$benefitInfoPopup.find('.price-info.total-payment .price').text(vcui.number.addComma(total)+"원");
                                        }

                                        self.obsOriginalPrice = vcui.isNumber(data.obsOriginalPrice) ? data.obsOriginalPrice : 0;
                                        self.memberPartnerGrp = vcui.isEmpty(data.memberPartnerGrp) ? "" : data.memberPartnerGrp;
                                        self.partnerPrice = vcui.isNumber(data.partnerPrice) ? data.partnerPrice : 0 ;
                                        self.partnerDiscountRate = vcui.isNumber(data.partnerDiscountRate) ? data.partnerDiscountRate : 0 ;
                                        self.partnerLastBenefitPrice = vcui.isNumber(data.partnerLastBenefitPrice) ? data.partnerLastBenefitPrice : 0 ;
                                        self.partnerApprDateDiscountAmt = vcui.isNumber(data.partnerApprDateDiscountAmt) ? data.partnerApprDateDiscountAmt : 0 ;
                                        self.partnerRewardAmt = vcui.isNumber(data.partnerRewardAmt) ? data.partnerRewardAmt : 0 ;
                                        self.partnerApprDateDiscountRate = vcui.isNumber(data.partnerApprDateDiscountRate) ? data.partnerApprDateDiscountRate : 0 ;
                                        self.partnerBoldBadgesArr = vcui.isEmpty(data.partnerBoldBadges) ? "" : data.partnerBoldBadges;
                                        self.partnerRentalDirectInfoArr = vcui.isEmpty(data.partnerRentalInfo) ? "" : data.partnerRentalInfo;

                                        //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                                        $("#buyBenefitInfoPoint .benefit-text").data('employeePoint',vcui.isEmpty(data.rewardPoint) ? "" : vcui.number.addComma(data.rewardPoint));
                                        self.displayBenefitPointArea(digitalData.userInfo.partnerType);

                                        //BTOCSITE-73832  제품 번들링 과제
                                        if(lgkorUI.stringToBool(loginFlag) && !vcui.isEmpty(self.memberPartnerGrp) && self.memberPartnerGrp != self.default_partner_grp) {
                                            $("#employeeAdditionDisposable").data('additionList',data.additionDisposableModelList)
                                            $("#employeeAdditionProduct").data('additionList',data.additionProductModelList)
                                        }

                                        //BTOCSITE-45195 임직원몰 개선(임직원 전용제품 적용)
                                        self.displayEmployeeArea();
                                        //BTOCSITE-46911 : 임직원 전용제품 wcms 영역 구매하기 버튼 적용하기 위한 처리
                                        self.checkIntervalTimer = setInterval(function() {
                                            self.displayEmployeeBuyBtn();
                                        }, 1000);

                                        digitalData.productInfo.partnerPrice = self.partnerPrice;
                                        digitalData.productInfo.memberPartnerGrp = data.memberPartnerGrp;
                                    }else{
                                        self.memberPartnerGrp = vcui.isEmpty(data.memberPartnerGrp) ? "" : data.memberPartnerGrp;
                                        self.bsnsMbrStat = vcui.isEmpty(data.bsnsMbrStat) ? "" :data.bsnsMbrStat;
                                        // BTOCSITE-85521 [구독] B2B 구독 도입
                                        self.bsnsPstnCd = vcui.isEmpty(data.bsnsPstnCd) ? "" :data.bsnsPstnCd;
                                        self.rprsnNm = vcui.isEmpty(data.rprsnNm) ? "" :data.rprsnNm;
                                        self.bsnsType = vcui.isEmpty(data.bsnsType) ? "" :data.bsnsType;
                                        self.mbrName = vcui.isEmpty(data.mbrName) ? "" :data.mbrName;
                                        self.bsnsMbrUpdStat = vcui.isEmpty(data.bsnsMbrUpdStat) ? "" :data.bsnsMbrUpdStat;
                                        // BTOCSITE-85521 [구독] B2B 구독 도입
                                        self.partnerPrice = vcui.isNumber(data.partnerPrice) ? data.partnerPrice : 0 ;
                                        var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                                        $paymentAmount.data('businessPrice',self.partnerPrice);
                                        $('#bsnsMbrStat').val(self.bsnsMbrStat) //KRP0009 컴포넌트 구매버튼의 로그인체크를 위함.
                                        $('#memberPartnerGrp').val(self.memberPartnerGrp) //KRP0009 컴포넌트 구매버튼의 로그인체크를 위함.
                                        self.displayB2bPriceArea();
                                    }
                                }
                            } else {
                                //로그인 아님
                                //BTOCSITE-48266 [상품] B2B OBS 구축
                                if(inputdata.b2cYN ==='Y'){
                                    self.$benefitInfoPopup.find('.price-info.point').show();
                                    self.$benefitInfoPopup.find('.price-info.point.member').hide();
                                }else{
                                    self.memberPartnerGrp = vcui.isEmpty(data.memberPartnerGrp) ? "" : data.memberPartnerGrp;
                                    self.bsnsMbrStat = vcui.isEmpty(data.bsnsMbrStat) ? "" :data.bsnsMbrStat;
                                    // BTOCSITE-85521 [구독] B2B 구독 도입
                                    self.bsnsPstnCd = vcui.isEmpty(data.bsnsPstnCd) ? "" :data.bsnsPstnCd;
                                    self.rprsnNm = vcui.isEmpty(data.rprsnNm) ? "" :data.rprsnNm;
                                    self.bsnsType = vcui.isEmpty(data.bsnsType) ? "" :data.bsnsType;
                                    self.mbrName = vcui.isEmpty(data.mbrName) ? "" :data.mbrName;
                                    self.bsnsMbrUpdStat = vcui.isEmpty(data.bsnsMbrUpdStat) ? "" :data.bsnsMbrUpdStat;
                                    // BTOCSITE-85521 [구독] B2B 구독 도입
                                    self.partnerPrice = vcui.isNumber(data.partnerPrice) ? data.partnerPrice : 0 ;
                                    $('#bsnsMbrStat').val(self.bsnsMbrStat) //KRP0009 컴포넌트 구매버튼의 로그인체크를 위함.
                                    $('#memberPartnerGrp').val(self.memberPartnerGrp) //KRP0009 컴포넌트 구매버튼의 로그인체크를 위함.
                                    self.displayB2bPriceArea();
                                }
                            }

                            self.loginCheckEnd = true;
                            if(self.processProductBuy) {
                                self.productBuy(self.processProductBuy);
                            }

                            KRP0008.isGetRewardExcuted = true;
                        },
                        error : function(error){
                            console.log(error);
                        }
                    });
                }
            }
        },

        initDisposable: function(){
            $('span[id^="b2cBadge"]').show();
        },

        setNotifications: function () { // BTOCSITE-29838 알림 신청
            if(typeof lgePdpSendData !== 'undefined') {
                var self = this;
                var ajaxUrl = self.$pdpInfo.attr('data-notice-url');
                var param = {
                    modelId: lgePdpSendData.modelId,
                    modelUrlPath: location.pathname
                }

                if (ajaxUrl) {
                    lgkorUI.requestAjaxDataPost(ajaxUrl, param, function(result){
                        var data = result.data[0];

                        if(self.$component.data('consumables')) { // 소모품 재입고 알림 신청
                            self.consumables.init(data);
                        } else if (self.$component.data('notification')) { // 일반 제품 알림 신청
                            self.notification.init(data);
                        }
                    }, true);
                }
            }
        },

        //PDP 이미지 관련

        //페이지에 저장된 pdp 데이타 가져오기
        findPdpData: function(index) {
            var self = this;
            var inputs = self.$pdpData.find('div:eq(' + index +') input');
            var item = {};
            inputs.each(function (i, o) {
                item[$(o).attr('name')] = $(o).val();
            });
            return item;
        },

        //썸네일 리스트 클릭
        clickThumbnailSlide: function(index, eventTarget) {
            var self = this;
            var item = self.findPdpData(index);

            //이전에 선택되었던 썸네일 활성화 제거 및 새로운 썸네일 활성화
            if(item.type !== "360") {
                var $thumbItem = self.$pdpThumbnail.find('li:eq(' + index + ')');

                self.$pdpThumbnail.find('li').removeClass('active');
                self.$pdpThumbnail.find('li > a').children('.blind').text("선택안됨"); //BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정

                $thumbItem.addClass('active');
                $thumbItem.find('.blind').text("선택됨");

                self.$pdpVisualAnimation.find('.video-controller').removeClass('is-active');
                self.$pdpVisualAnimation.find('.video-controller').find('button').removeClass('is-active');
                self.$pdpVisualAnimation.find('.video-controller').find('.btn-pause').addClass('is-active');

                self.$pdpVisualNotices.hide();
            }

            switch(item.type) {
                case "360":
                    // S : BTOCSITE-15587
                    self.openVisualModal(index, eventTarget);
                    self.open360Resize();
                    // E : BTOCSITE-15587
                    break;

                case "image":
                    self.$pdpVisualVideo.find('iframe').attr('src', '');
                    self.$pdpVisualAnimation.find('video').attr('src', '');
                    self.$pdpVisualAnimation.find('video source').attr('src', '');

                    self.$pdpImage.find('a').attr({'data-link-name':item.linkName,'data-idx':(""+index)});
                    self.$pdpImage.find('a img').attr({'src':item.imagePdp,'alt':item.alt});

                    self.$pdpVisualList.removeClass('is-active');
                    self.$pdpImage.addClass('is-active');

                    self.$pdpVisualNotice.addClass('is-active'); // BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다.
                    if(self.$pdpVisualNotice.hasClass('first')){ // BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다.
                        self.$pdpVisualNotice.removeClass('first');
                    }
                    break;

                case "interior":
                    self.$pdpVisualVideo.find('iframe').attr('src', '');
                    self.$pdpVisualAnimation.find('video').attr('src', '');
                    self.$pdpVisualAnimation.find('video source').attr('src', '');

                    self.$pdpImage.find('a').attr({'data-link-name':item.linkName,'data-idx':(""+index)});
                    self.$pdpImage.find('a img').attr({'src':item.imagePdp,'alt':item.alt});

                    self.$pdpVisualList.removeClass('is-active');
                    self.$pdpImage.addClass('is-active');

                    self.$pdpVisualNotices.show();

                    break;

                case "video":
                    if(self.$pdpVisualVideo.length) {
                        self.$pdpVisualAnimation.find('video').attr('src', '');
                        self.$pdpVisualAnimation.find('video source').attr('src', '');

                        self.$pdpVisualList.removeClass('is-active');
                        self.$pdpVisualVideo.find('iframe').attr('src', item.videoUrl + '?autoplay=1&mute=1');
                        self.$pdpVisualVideo.find('.image-cover img').attr('src', item.imagePdp);
                        self.$pdpVisualVideo.find('.see-video').attr({
                            'data-src': item.videoUrl,
                            'data-link-name': item.linkName
                        });
                        self.$pdpVisualVideo.addClass('is-active');
                    } else {
                        self.openVisualModal(index, eventTarget);
                    }
                    break;

                case "animation":
                    if(self.$pdpVisualAnimation.length) {
                        var $video = self.$pdpVisualAnimation.find('video');

                        self.$pdpVisualVideo.find('iframe').attr('src', '');

                        self.$pdpVisualList.removeClass('is-active');
                        $video.attr({'src': item.videoUrl, 'poster': item.imagePdp});
                        $video.find('source').attr({'src': item.videoUrl, 'type': 'video/' + item.videoType});
                        self.$pdpVisualAnimation.addClass('is-active');
                        self.$pdpVisualAnimation.find('.image-cover img').attr('src', item.imagePdp);
                        self.$pdpVisualAnimation.find('.video-box span.blind').text(item.blindText);//BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정

                        var $controller = self.$pdpVisualAnimation.find('.video-controller');
                        var $pause = $controller.find('.btn-pause');
                        var $play = $controller.find('.btn-play');

                        $video.on('click', function () {
                            $controller.addClass('is-active');
                        })

                        $pause.on('click', function () {
                            $video[0].pause();
                            $(this).removeClass('is-active');
                            $play.addClass('is-active');
                        });

                        $play.on('click', function () {
                            $video[0].play();
                            $controller.removeClass('is-active');
                            $(this).removeClass('is-active');
                            $pause.addClass('is-active');
                        });
                    } else {
                        self.openVisualModal(index, eventTarget);
                    }

                    break;
                default:
                    break;
            }
        },

        //PDP모달 오픈
        openVisualModal: function(index, eventTarget) {
            var self = this;
            //self.clickModalThumbnail(index);
            var popPdp = $('#pop-pdp-visual');
            popPdp.data('selectIndex',index);
            self.$popPdpVisualImage.hide();
            if(eventTarget) {
                $('#pop-pdp-visual').vcModal({opener: eventTarget});
            } else {
                $('#pop-pdp-visual').vcModal();
            }
        },

        clickModalThumbnail: function(index) {
            var self = this;
            index = parseInt(index);
            var item = self.findPdpData(index);

            self.$itemNumber.text(index + 1);

            //이전에 선택되었던 썸네일 활성화 제거 및 새로운 썸네일 활성화
            var thumbItem = self.$popPdpThumbnail.find('li:eq('+index+')');
            if(self.$selectModalItemTarget) {
                self.$selectModalItemTarget.removeClass('active');
                self.$selectModalItemTarget.find(">a").attr("aria-selected","false");
            }
            self.$selectModalItemTarget = thumbItem;
            self.$selectModalItemTarget.addClass('active');
            self.$selectModalItemTarget.find(">a").attr("aria-selected","true");

            //self.pinchZoom.runZoom(1, false);
            //self.$popPdpVisualVideo.html('');
            self.$popPdpVisualAnimation.find('div.animation-box').vcVideoBox('reset');
            //if(self.$popPdpVisual.width() <= 450) self.$popPdpVisual.find('div.item-number').show(); // BTOCSITE-15587

            self.$pdpVisualNoticePopup.hide();
            let imgAltText = item.alt; //BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정

            switch(item.type) {
                case "360":
                    // S : BTOCSITE-15587
                    self.$popPdpVisualImage.hide();
                    self.$popPdpVisualVideo.hide();
                    self.$popPdpVisualAnimation.hide();
                    self.$popPdpZoomArea.hide();
                    self.$popPdpVisual360.show();
                    self.open360Resize();
                    //if(self.$popPdpVisual.width() <= 450) self.$popPdpVisual.find('div.item-number').hide();
                    // E : BTOCSITE-15587
                    break;
                case "image":
                    self.open360Stop(); // BTOCSITE-15587
                    self.pinchZoom.runZoom(1, false);
                    self.$popPdpVisualImage.find('div.zoom-area img').attr({'data-pc-src':item.imagePC,'data-m-src':item.imageMobile, 'alt' : imgAltText.replace('메인이미지','줌이미지')}); //BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정
                    //self.$popPdpVisualImage.vcImageSwitch('reload');
                    $('body').vcLazyLoaderSwitch('reload',self.$popPdpVisualImage);
                    self.$popPdpVisualImage.show();
                    self.$popPdpVisualVideo.hide();
                    self.$popPdpVisualAnimation.hide();
                    self.$popPdpVisual360.hide();
                    self.$popPdpZoomArea.show();
                    self.pinchZoom.update(true);
                    break;
                case "interior":
                    self.open360Stop(); // BTOCSITE-15587
                    self.pinchZoom.runZoom(1, false);
                    self.$popPdpVisualImage.find('div.zoom-area img').attr({'data-pc-src':item.imagePC,'data-m-src':item.imageMobile, 'alt' : imgAltText.replace('메인이미지','줌이미지')}); //BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정
                    //self.$popPdpVisualImage.vcImageSwitch('reload');
                    $('body').vcLazyLoaderSwitch('reload',self.$popPdpVisualImage);
                    self.$popPdpVisualImage.show();
                    self.$popPdpVisualVideo.hide();
                    self.$popPdpVisualAnimation.hide();
                    self.$popPdpVisual360.hide();
                    self.$popPdpZoomArea.hide();
                    self.pinchZoom.update(true);

                    self.$pdpVisualNoticePopup.show();

                    break;
                case "video":
                    /*
                    self.$popPdpVisualVideo.find('div.thumnail img').attr({
                        'data-pc-src':item.imagePC,
                        'data-m-src':item.imageMobile,
                        'alt':item.alt
                    });
                    */
                    self.open360Stop(); // BTOCSITE-15587
                    self.$popPdpVisualVideo.find('div.thumnail a').attr({
                        'data-src':item.adUrl,
                        'data-link-name':item.linkName,
                        'aria-describedby':item.alt
                    });
                    self.$popPdpVisualVideo.find('iframe').attr('src',item.videoUrl + '?autoplay=0&mute=1');
                    self.$popPdpVisualImage.hide();
                    self.$popPdpVisualVideo.show();
                    self.$popPdpVisualAnimation.hide();
                    self.$popPdpVisual360.hide();
                    self.$popPdpZoomArea.hide();
                    break;
                case "animation":
                    self.open360Stop(); // BTOCSITE-15587

                    var $targetAnimation = self.$popPdpVisualAnimation.find('div.visual-box div.visual-area');

                    $targetAnimation.find('a').attr({'data-src':item.adUrl,'aria-describedby':item.alt});
                    $targetAnimation.find('p.hidden').text(item.alt);
                    $targetAnimation.find('div.animation-area video source').attr({'src':item.videoUrl,'type':('video/'+item.videoType)});
                    $targetAnimation.find('div.animation-area video').attr({'src':item.videoUrl})
                    $targetAnimation.find('div.animation-area span.blind').text(item.blindText);//BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정

                    $targetAnimation.find('.wa-btn button').removeClass('play');
                    $targetAnimation.find('.wa-btn button').addClass('pause');
                    $targetAnimation.find('div.animation-area video')[0].play();

                    $targetAnimation.find('.wa-btn button').off('click').on('click', function(){
                        if($(this).hasClass('play')) {
                            $targetAnimation.find('.wa-btn button').removeClass('play');
                            $targetAnimation.find('.wa-btn button').addClass('pause');
                            $targetAnimation.find('div.animation-area video')[0].play();
                        } else {
                            $targetAnimation.find('.wa-btn button').removeClass('pause');
                            $targetAnimation.find('.wa-btn button').addClass('play');
                            $targetAnimation.find('div.animation-area video')[0].pause();
                        }
                    });

                    /* BTOCSITE-24792 START */
                    $targetAnimation.find('.play-animaion-btn').off('click').on('click', function(){
                        if($(this).hasClass('acc-btn')) {
                            var aniText = $(this).data('ani-text');
                            $(this).attr('aria-label', aniText).addClass('ani-btn').removeClass('acc-btn').text(aniText);
                            $targetAnimation.find('div.animation-area > video').prop('muted', true);
                        } else {
                            var accAniText = $(this).data('acc-ani-text');
                            $(this).attr('aria-label', accAniText).addClass('acc-btn').removeClass('ani-btn').text(accAniText);
                            $targetAnimation.find('div.animation-area > video').prop('muted', false);
                        }
                    });
                    /* BTOCSITE-24792 END */

                    self.$popPdpVisualImage.hide();
                    self.$popPdpVisualVideo.hide();
                    self.$popPdpVisualAnimation.show();
                    self.$popPdpVisual360.hide();
                    self.$popPdpZoomArea.hide();
                    /* s : BTOCSITE-11059 */
                    var caption = self.$popPdpVisualAnimation.find('div.visual-box div.visual-area .caption');
                    if(item.alt == '') {
                        caption.hide();
                    }else {
                        caption.html(item.alt).show();
                    }
                    if(caption.outerWidth() > 0 && caption.outerWidth() + 10 < caption.get(0).scrollWidth) {
                        var marqueeSpeed = (vcui.detect.isIE || vcui.detect.isMobile) ? 4 : 5;
                        if(caption.find('marquee').size() == 0) caption.wrapInner('<marquee scrollamount="'+marqueeSpeed+'" />')
                    }
                    /* e : BTOCSITE-11059 */
                    break;
                default:
                    break;
            }
        },

        //ajax 팝업뷰 뛰우기
        requestModal: function(dm) {
            var self = this;
            var ajaxUrl = $(dm).attr('href');
            lgkorUI.requestAjaxData(ajaxUrl, null, function(result){
                self.openModalFromHtml(result);
            }, null, "html");
        },

        openModalFromHtml: function(html) {
            $('#pdp-modal').html(html).vcModal();
        },
        //선택된 옵션으로 케어쉽 가격 가져오기
        requestSelectCareOption: function($dom) {
            var self = this;
            var ajaxUrl = self.$pdpInfo.attr('data-care-select-url');
            var $checkedinputs = $dom.find('input:checked');
            var $hiddenInputs = $dom.find('input[type=hidden]');
            var param = {};
            $checkedinputs.each(function (i, o) {
                var $o = $(o);
                param[$o.attr('name')] = $o.attr('value');
            });
            $hiddenInputs.each(function (i, o) {
                var $o = $(o);
                param[$o.attr('name')] = $o.attr('value');
            });

            lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                var data = result.data;
                $dom.find('span.price').contents()[0].textContent = data.price;
            });
        },

        //선택된 옵션으로 케어쉽 렌탈 가격 가져오기
        requestSelectCareSiblingOption: function($dom) {
            var self = this;
            var ajaxUrl = self.$pdpInfo.attr('data-care-select-url');
            var $checkedinputs = $dom.find('input:checked');
            var $hiddenInputs = $dom.find('input[type=hidden]');
            var param = {};
            $checkedinputs.each(function (i, o) {
                var $o = $(o);
                param[$o.attr('name')] = $o.attr('value');
            });
            $hiddenInputs.each(function (i, o) {
                var $o = $(o);
                param[$o.attr('name')] = $o.attr('value');
            });

            lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                var data = result.data;
                $dom.find('span.price').contents()[2].textContent = data.price;
            });
        },

        //비교하기 저장 유무 체크...
        setCompares:function(){
            var self = this;
            var chk = false;
            var categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
            var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, categoryId);
            var isCompare = vcui.isEmpty(storageCompare);

            if(!isCompare){
                storageCompare['data'].forEach(function (item) {
                    if(lgePdpSendData['id'] == item['id']) chk = true;
                });
            }

            var $dm = self.$pdpInfo.find('.product-compare input[type=checkbox]');
            $dm.prop('checked', chk)
            if(chk) {
                $dm.addClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
            } else {
                $dm.removeClass('compare-select');
            }
        },
        // 비교하기 버튼 상태 변경
        compareBtnStatus:function(){
            var self = this;
            var categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
            var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, categoryId);
            // BTOCSITE-22701 :: 에러처리
            if (!!storageCompare && !!storageCompare['data'] == false){
                return;
            }

            if(storageCompare && storageCompare['data'].length > 0){
                var data = storageCompare['data'][0];
                if(data.b2bcatemapping != lgePdpSendData.b2bCateMapping) self.$pdpInfo.find('.product-compare').hide();
            }
        },

        setSiblingOptionCheck: function(target, currentIndex, modelsData){
            // LGECOMVIO-20 핵심스펙 기능 일부 변경 및 추가
            var self = this;
            var $target = $(target);
            var $siblingCont = $('.sibling-cont');
            var $optionList = $siblingCont.find('.option-list');
            var currentSiblingCode = $target.attr('data-sibling-code');
            var checkedOptionArray = [];

            $optionList.find('input:radio:checked').each(function(optionIndex){
                if(optionIndex === currentIndex) return;

                var $this = $(this);
                var $checkedRadio = $this;
                var radioSiblingCode = $checkedRadio.attr('data-sibling-code');
                var enableOption = [];
                var enableOptionValue = [];
                var enableOptionUniqueArr = [];
                var disableOption = [];
                var disableOptionValue = [];
                var disableOptionUniqueArr = [];

                if(checkedOptionArray.length == 0) {
                    checkedOptionArray = modelsData.filter(function(v){
                        return v.siblingCode == radioSiblingCode
                    });
                } else {
                    var modelId = checkedOptionArray.map(function(model){
                        return model.modelId
                    });

                    checkedOptionArray = modelsData.filter(function(siblingModel){
                        return modelId.indexOf(siblingModel.modelId) > -1
                    }).filter(function(model){
                        return model.siblingCode == radioSiblingCode;
                    })
                }

                // LGECOMVIO-20 : 스펙 노출/비노출 및 활성/비활성화 처리를 위한 데이터 취합
                checkedOptionArray.forEach(function(item){
                    var arr = item.siblingValueList.split(',');
                    enableOption.push(arr);

                    if(item.enableModelFlag == 'N') {
                        disableOption.push(item.siblingValueList.split(','));
                    }
                })

                enableOption.forEach(function(item){
                    enableOptionValue = enableOptionValue.concat(item);
                })

                disableOption.forEach(function(item){
                    disableOptionValue = disableOptionValue.concat(item);
                })

                disableOptionValue.forEach(function(item){
                    var enableArr = enableOptionValue.filter(function(v){
                        return v == item;
                    });

                    var disableArr = disableOptionValue.filter(function(v){
                        return v == item;
                    });

                    if(enableArr.length == disableArr.length) {
                        disableOptionUniqueArr.push(item);
                    }
                });

                enableOptionUniqueArr = enableOptionValue.filter(function(item, idx, self) {
                    return self.indexOf(item) == idx;
                })

                disableOptionUniqueArr = disableOptionUniqueArr.filter(function(item, idx, self) {
                    return self.indexOf(item) == idx;
                })

                self.enableOptionList = enableOptionUniqueArr;
                self.disableOptionList = disableOptionUniqueArr;
            });

            if(checkedOptionArray.length > 0){
                var currentModelId = checkedOptionArray.map(function(model){
                    return model.modelId
                });

                checkedOptionArray = modelsData.filter(function(siblingModel){
                    return currentModelId.indexOf(siblingModel.modelId) > -1
                }).filter(function(model){
                    return model.siblingCode == currentSiblingCode;
                })
            } else {
                if(currentIndex == 0) {
                    checkedOptionArray = modelsData.filter(function(model){
                        return model.siblingCode == currentSiblingCode;
                    })
                }
            }
        },

        requestSiblingData: function(modelId){
            //BTOCSITE-44 시블링레이어 model request
            var self = this;
            var ajaxUrl = self.$pdpInfo.attr('data-sibling-ajax');

            if( ajaxUrl && ajaxUrl != "" ) {
                // lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(ajaxUrl, {modelId: modelId}, function(resultData) {
                    if( resultData.status == "success" && resultData.data) {
                        self.defaultSiblingDataFlag = false;
                        self.receivedSiblingData = resultData.data;

                        var currentPath = resultData.data[0].siblingModels.filter(function(v){
                            return v.modelId == modelId
                        })[0].modelUrlPath;
                        // lgkorUI.hideLoading();
                        self.$siblingCont.attr('data-model-path', currentPath)
                        self.$siblingBtnComp.removeClass('disabled'); // LGECOMVIO-20 수정
                    } else {
                        self.defaultSiblingDataFlag = true;
                        self.receivedSiblingData = [];
                        self.$siblingCont.removeAttr('data-model-path', currentPath)
                        self.$siblingBtnComp.addClass('disabled'); // LGECOMVIO-20 수정
                    }
                });
            }
        },
        // BTOCSITE-659 [UI개발]마이컬렉션 추천 서비스로 개편 : pdp
        addAWSPdpUp: function() {
            // /mkt/commonModule/addAWSPdpUp.lgajax
            // 파라미터
            // itemId : SKU (OLED65A1MS.AKRG : salesmodelcode + surffixcode)

            // BTOCSITE-41671 server Error 로 인해 주석처리
            // lgkorUI.requestAjaxData("/mkt/commonModule/addAWSPdpUp.lgajax",  { "itemId":lgePdpSendData.sku});
        },
        // S : BTOCSITE-15587
        open360: function() {
            var self = this;
            self.view = new View360();
            var opt = $.extend({pathType: 'A'}, self.$view360.data()); // BTOCSITE-19022
            self.view.setConfig({
                width: self.$view360.scrollWidth,
                height: self.$view360.scrollHeight,
                columns: opt.rotateTotal,
                open_cols: opt.openTotal, 
                pathType: opt.pathType, // BTOCSITE-19022
            });
            self.view.setNavigationConfig({
                showOpen: opt.openTotal > 1 ? true:false,
                showTurnLeft: opt.openTotal > 1 ? true:false,
            });
            self.view.setImagesDirectory( opt.productPath + opt.productCode );
            self.view.start(self.$view360[0]);
            self.$view360.append('<span class="View360-text-info">※ 제품의 대표 색상 및 디자인에 대한 이해를 돕기 위한 예시 이미지입니다.<br>해당 모델 색상은 아래 버튼의 이미지컷을 참고하세요.</span>');
        },
        open360Stop: function() {
            var self = this;

            if(self.$view360.length) {
                self.view.stopAutoRotate();
                self.view.lastCol = 0;
                self.view.latestImageIdx = 0;
                self.view.currentCol = 0;
                self.view.currentRow = 0;
                self.view.displayCurrentImage();
            }
        },
        open360Resize: function() {
            var self = this;

            if(self.$view360.length) {
                var w = self.$popPdpVisual.width();
                var p = Number(self.$popPdpVisual.find('.default').css('padding-left').replace('px','') * 2);
                var ww = (w > 450)? 540 : w - p , hh = (w > 450) ? 540 : w - p;
                self.$view360.css({
                    'width':ww,
                    'height':hh
                })
                if ( !!self.view ) {
                    self.view.setConfig({
                        width:  ww,
                        height: hh
                    });
                };
                self.view.updateCanvasSize();
                self.view.displayCurrentImage();
            }
        },
        // E : BTOCSITE-15587
        //렌탈 케어 솔루션 toast popup - LGECOMVIO-20
        // BTOCSITE-47671 색상 선택
        laptapSelectColor: function() {
            var laptabWrap = $('.laptap-opt-wrap').find('.opt-colorchip-wrap');
            var colorchipSelc = laptabWrap.find('input[type="radio"]:checked').parent().attr('title');
            var colorchip = laptabWrap.find('input[type="radio"]').siblings('label');
            $('.opt-info-list').find('.selc-color').text(colorchipSelc);
            colorchip.on('click', function() {

				// BTOCSITE-89585(색상 클릭시 비활성화 되있는 색상 이름변경불가처리)
				if(!$(this).parent().find('input[type="radio"]').hasClass('disabled')){

	                var selcColor = $(this).parent().attr('title');
	                $('.opt-info-list').find('.selc-color').text(selcColor);

				}

	        });
        },
        // BTOCSITE-47671 Popup Carousel
        laptabPopupCarousel: function() {
            $('.btn-opt-tit').on('click', function() {
                $('.opt-slider-wrap').buildCommonUI();
                var _this = $(this);
                var popId = _this.attr('data-href');

                vcui.require(['ui/carousel'], function () {
                    $(popId).find('.ui_carousel_slider').vcCarousel({
                        infinite: true,
                        swipeToSlide: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        prevArrow:'.btn-arrow.prev',
                        nextArrow:'.btn-arrow.next',
                        adaptiveHeight:false,
                        lazyLoad:'anticipated', //수정 jsw
                        cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                        touchThreshold: 100,
                        speed: 150
                    });
                });
                setTimeout(function() {
                    var optCarouselSlider = $(popId).find('.ui_carousel_slider');
                    var optCarouselSlideLast = parseInt(optCarouselSlider.find('.ui_carousel_slide:last').attr('data-ui_carousel_index'));
                    if(optCarouselSlideLast == 0) {
                        optCarouselSlider.find('.slide-controls').hide();
                    } else {
                        optCarouselSlider.find('.slide-controls').children('.slide-number').children('span').text(optCarouselSlideLast);
                    }
                },200);
    
                $(popId).find('.ui_carousel_slider').on('carouselafterchange', function(e,target,index){
                    $(popId).find('.slide-number').children('.current').text(index + 1);
                });
            });
        },
        // BTOCSITE-47671 Popup Close
        laptabPopupClose: function() {
            $(document).on('click', '.ui_modal_dim', function (e) {
                $('.opt-popup-wrap').find('.ui_modal_close').trigger('click');
            });
        },
        //LGECOMVIO-20 - 액션시트 팝업 실행
        actionSheetCallEvent: function(){
            var self = this;
            self.$actionSheetCallBtn.find('.btn-open-action-sheet').on('click', function(e){
                e.preventDefault();
                // BTOCSITE-85293 START
                self.preCheckTermAndCondition(false, function(e) {
                    $('html, body').css('overflow','hidden');
                    $('#actionSheetPopup').addClass('active');
                    $('#actionSheetPopup').children('.sheet-close').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 액션 시트 노출 시 포커스 이동

                    /* BTOCSITE-73060 제품 PDP UI 개선 */
                    var empTit = self.$actionSheet.find('.emp-title');

                    // 임직원/복지몰 할인가 유/무에 따라 하단 간격 수정
                    if( empTit.text().length == 0 ){
                        empTit.css('padding-bottom', 0);
                    } else{
                        empTit.removeAttr('style');
                    }
                    /* //BTOCSITE-73060 제품 PDP UI 개선 */
                });
                // BTOCSITE-85293 END
            });
            /* BTOCSITE-73060 제품 PDP UI 개선 */
            $(document).on('click',function(e){
                //툴팁팝업 열기 상태일때
                if( self.$actionSheetCallBtn.find('.tooltip-wrap').hasClass('active') ){
                    var $this = $(e.target);
                    if($this.hasClass('tooltip-box') || $this.parents('.tooltip-box').length > 0) {
                        //툴팁팝업 내부클릭일때
                    } else {
                        //툴팁팝업 외부클릭일때
                        $('html, body').css('overflow','');
                    }
                }
            })
            //툴팁팝업 닫기버튼
            self.$actionSheetCallBtn.find('.tooltip-wrap').find('.btn-close').on('click', function(){
                 $('html, body').css('overflow','');
            });
            self.$actionSheetCallBtn.find('.price-info .tooltip-icon').on('click', function(e){
                var priceTooltip = $(this).parent('.tooltip-wrap');
                if( !priceTooltip.hasClass('active') ) {
                    $('html, body').css('overflow','hidden');
                }
            });
            /* //BTOCSITE-73060 제품 PDP UI 개선 */
            self.$actionSheet.find('.sheet-close').on('click', function(){
                $('html, body').css('overflow','');
                $('#actionSheetPopup').removeClass('active');
                // BTOCSITE-37933 다품목 판매 활성화
                $('#actionSheetCart').removeClass('active');
                self.$actionSheetCallBtn.find('.btn-open-action-sheet').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 액션 시트 close 시 포커스 이동
            })

            $(window).on('resize', function(){
                if($(window).width() > 767){
                    $('html, body').css('overflow','');
                    $('#actionSheetPopup').removeClass('active');
                }
            })

            $("#actionSheetPopup .action-sheet-mask").on("click", function(e){
                $('html, body').css('overflow','');
                $('#actionSheetPopup').removeClass('active');
                self.$actionSheetCallBtn.find('.btn-open-action-sheet').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 액션 시트 close 시 포커스 이동
            })

            // BTOCSITE-37933 다품목 판매 활성화
            $("#actionSheetCart .action-sheet-mask").on("click", function(e){
                $('html, body').css('overflow','');
                $('#actionSheetCart').removeClass('active');
                self.$actionSheetCallBtn.find('.btn-open-action-sheet').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 액션 시트 close 시 포커스 이동
            })

            // BTOCSITE-85293 START
            $("#actionSheetConsent .action-sheet-mask").on("click", function(e){
                $('html, body').css('overflow','');
                $('#actionSheetConsent').removeClass('active');
            })
            // BTOCSITE-85293 END
        },
        //LGECOMVIO-20 - AR 체험안내 팝업(모바일)
        settingAppByArPopup: function(){
            $('#arPopup .btn-group .btn').on('click',function(){
                goAppUrl();
            })
        },

        /**
         * isScrollDown 정의 함수
         * @param {number} from 현 y 위치
         * @param {number} to 목적 y 위치
         * @returns {array}
         */
        setIsScrollDown: function (from, to) {
            var self = this;
            var pageDirection = (from !== to) ? vcui.math.getDirection({y: from}, {y: to}, 'vertical') : null;
            var isDown = (pageDirection) ? pageDirection === 'up' : null; // true | false | null
            
            if (isDown !== null) self.isScrollDown = isDown;
        },

        /**
         * 위치값 반환 시 소수점으로 반환되어 일관성을 위해 해당 함수를 거쳐 계산
         * @param {number} value 
         * @returns {number} Math.ceil 로 통일 반환
         */
        cutDecimal: function (value) {
            return Math.ceil(value);
        },

        // 스마트홈 스티키 메뉴 // BTOCSITE-62058 스마트홈 경험 솔루션
        smartProdSticky: function () {
            var self = this;

            var $smartProdArea = $('.package-product-area');

            if (!$smartProdArea.length) return;

            var $menu = $smartProdArea.find('.package-product-item');
            var $header = $('header');

            var lastScrollTop = 0;

            var top = 0;
            var paddingBottom = parseInt($smartProdArea.css('paddingBottom')) || 0;
            var space = $header.height() + $smartProdArea.outerHeight() + paddingBottom; // $smartProdArea fixed 로 인해 빠지는 doc 높이

            // destroy
            $(document).off('.smarthome');
            if (headerMutationObserver) {
                headerMutationObserver.disconnect();
                headerMutationObserver = null;
            }

            // scroll.smarthome 에서 적용시킨 css 복구 함수
            var restoreStyle = function () {
                $smartProdArea.removeClass('is-sticky shadow-none').css('top', '').parent().css('padding-top', '');
            }

            // initialize
            if (isMobile) {
                headerMutationObserver = new MutationObserver(function (mutationList) {
                    mutationList.forEach(function (mutation) {
                        if (mutation.attributeName === 'class') {
                            $(document).triggerHandler('scroll.smarthome');
                        }
                    });
                });
            
                if (!!$header.length) headerMutationObserver.observe($header.get(0), { attributes: true });

                $(document).on('scroll.smarthome', function () {
                    var krp0009 = $('.KRP0009');
                    var scrollTop = self.cutDecimal($(window).scrollTop()); // 화면 스크롤 위치

                    $header.addClass('shadow-none'); // header 그림자 강제 숨김

                    self.setIsScrollDown(lastScrollTop, scrollTop); // 스크롤 방향 계산

                    if (krp0009.is('.fixed') && $header.is('.hide')) { // KRP0009 넘어지는 영역에서 header 숨겨지면
                            top = -$smartProdArea.outerHeight(); // 스마트홈 전체 숨김
                    } else {
                        top = $header.outerHeight() // 스마트홈 전체 노출

                        if (!!$menu.length && self.isScrollDown && scrollTop > $header.height()) { // 스크롤 내릴 때 헤드 넘어서기 시작하면
                            top = -$menu.position().top; // 스마트홈 타이틀 높이만큼 위로 당김
                        }
                    }

                    if ($(window).scrollTop() > 0) {
                        $smartProdArea
                            .toggleClass('shadow-none', krp0009.is('.fixed'))  // 그림자 토글
                            .addClass('is-sticky').css('top', top).parent().css('padding-top', space); // doc 높이 유지
                    } else {
                        restoreStyle();
                    }

                    lastScrollTop = self.cutDecimal(window.scrollY);
                })
            } else {
                restoreStyle();
            }
        },

        // visual sticky - only pc
        pdpVisualSticky: function(){
            var $visual = $('.pdp-visual-wrap');
            var $info = $('.pdp-info-area');

            if(window.innerWidth > 767) {
                var offset = ($info.offset().top + $info.outerHeight(true)) - $visual.height();
                var notStickyTop = (offset - $('.header').outerHeight(true) - $('.breadcrumb').outerHeight(true) - 80);

                if ($(window).scrollTop()-60 > $info.offset().top && $(window).scrollTop() <= offset) {
                    $visual.addClass('is-sticky');
                    $visual.removeClass('is-not-sticky').css('top', '');
                } else {
                    if($(window).scrollTop() >= offset){
                        $visual.removeClass('is-sticky');
                        $visual.addClass('is-not-sticky').css('top', notStickyTop); 
                    } else {
                        $visual.removeClass('is-sticky');
                        $visual.removeClass('is-not-sticky').css('top', '');
                    }
                }
            } else {
                $visual.removeClass('is-sticky');
                $visual.removeClass('is-not-sticky').css('top', '');
            }
        },
        
        //BTOCSITE-23825 크리테오 tag삽입
        addCartTag: function(productInfo, quantity, isCareShip) {
        	var self = this;
        	var modelId = productInfo.model_id;
        	var quantity = quantity.length > 0 ? parseInt(quantity.val()) : 1;
        	var price = 0;
        	       	
        	var checkCareSelect = false;
        	if (isCareShip) { //케어십O -> 케어십 신청 여부 체크
        		var $careshipService = $('.careship-service');
        		var checkinput = $careshipService.find('input[type=radio]:checked');
        		if(checkinput.length > 0) {
        			checkCareSelect = lgkorUI.stringToBool(checkinput.val());
        		}
        	}
        	
        	var $paymentAmount = self.$pdpInfo.find('.payment-amount');
        	if (isCareShip && checkCareSelect) { //케어십 선택시        		
        		price = $paymentAmount.data('carePrice');
    			if ($paymentAmount.data('carePrice')) {
    				price = parseInt($paymentAmount.data('carePrice')); //케어십 서비스 신청 가격
    			}
        	} else { //케어십X or 케어십 미신청
        		var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');
        		if (isRentalCareTab) { //렌탈이면
        			if ($paymentAmount.data('carePrice')) {
        				price = parseInt($paymentAmount.data('carePrice'));
        			} else {
        				price = productInfo.rental_price;
        			}
        		} else { //일반이면
        			price = productInfo.price;
        		}
        	}

        	//BTOCSITE-33840 카카오 픽셀
        	kakaoPixel('975360282649280347').addToCart({
                id: modelId
            });

            //BTOCSITE-42097 [개발] 상품- brid.zzz (브리즈) PDP 페이지 내 디지털 매체 스크립트 삽입
            if (typeof bridzYn !== 'undefined' && bridzYn == "Y") {
                // 카카오
                kakaoPixel('4611006492189376410').addToCart({
                    id: modelId
                });
                // 트위터
                //<!-- Twitter conversion tracking event code -->
                    // Insert Twitter Event ID
                    twq('event', 'tw-ofcqj-ofcsf', {
                    value: null,
                    currency: null,
                    contents: [
                {
                    content_type: productInfo.category,
                    content_id: modelId,
                    content_name: "brid.zzz by LG Labs",
                    content_price: productInfo.price,
                    num_items: quantity,
                    content_group_id: null
                }],
                    conversion_id: null,
                    email_address: null,
                    phone_number: null
                });
                //<!-- End Twitter conversion tracking event code -->
            }

            if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                // BTOCSITE-74567 [상품구독] LGE.COM 구독 캠페인 광고 스크립트 개발 요청의 건
                self.addRentalCartTag(modelId, price, quantity);
            } else {
                // 크리테오, RTB하우스 스크립트의 경우 구독과 나머지 분기하여 처리
                window.criteo_q = window.criteo_q || [];
                var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                window.criteo_q.push(
                    { event: "setAccount", account: 76661},
                    { event: "setEmail", email: "", hash_method: "" },
                    { event: "setZipcode", zipcode: "" },
                    { event: "setSiteType", type: deviceType},
                    { event: "addToCart", item: [
                            {id: modelId, price: price, quantity: quantity }
                        ]}
                );

                //BTOCSITE-51052 [상품파트개발] LGE.COM 구매전환 광고 스크립트 개발 요청의 건(RTB)
                (rtbhEvents = window.rtbhEvents || []).push(
                    {
                        eventType: 'basketadd',
                        offerId: lgePdpSendData.modelId
                    },
                    {
                        eventType: 'uid',
                        id: 'unknown'
                    });
            }
        },

        // BTOCSITE-74567 [상품구독] LGE.COM 구독 캠페인 광고 스크립트 개발 요청의 건
        addRentalCartTag: function(modelId, price, quantity) {
            // <!-- Criteo Add to Cart Tag -->
            window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            window.criteo_q.push(
                { event: "setAccount", account: 114760 },
                { event: "setSiteType", type: deviceType},
                { event: "setZipcode", zipcode: "" },
                { event: "addToCart", item: [
                        {id: modelId, price: price, quantity: quantity }
                    ]}
            );
            // <!-- END Criteo Add to Cart Tag -->

            // RTB하우스
            (rtbhEvents = window.rtbhEvents || []).push(
                {
                    eventType: 'basketadd',
                    offerId: modelId
                },
                {
                    eventType: 'uid',
                    id: 'unknown'
                });

            // 메타
            fbq('trackCustom', 'Addtocart_subscribe',
                {
                    content_type: 'product',
                    contents: [
                        {id: modelId, quantity: quantity}
                    ],
                    currency: 'KRW',
                    value: price
                });
        },
        addWishTag: function() {
            //BTOCSITE-50417 RTB스크립트 삽입
            (rtbhEvents = window.rtbhEvents || []).push(
            {
                eventType: 'wishlist',
                offerId: lgePdpSendData.modelId
            },
            {
                eventType: 'uid',
                id: 'unknown'
            });

            // BTOCSITE-79021 (상품) LGE.COM 네이버 스크립트 설치 요청의 건
            KRP0008.naverTransEvent("add_to_wishlist");
        },
        
        // 옵션 팝업 BTOCSITE-26021
        optionPopupSet: function () {
        	if (modelOptInfoStr == "" || modelOptGrpId == "") { //옵션값이 없다면
        		return;
        	}
        	if (window.location.href.indexOf('dpType=careTab') > -1) {
        		optBizType = "CARESOLUTION";
        	}
            var ajaxUrl = "/mkt/api/product/retrieveModelGrpOptionList";
            var param = {
                    "modelId": lgePdpSendData.modelId,
                    "modelOptGrpId": modelOptGrpId,
                    "categoryId" : lgePdpSendData.categoryId,
                    "bizType" : optBizType,
                    "b2cYN" : lgkorUI.getHiddenInputData().b2cYN,
                }
            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                param,
                function (result) {
                    if (result.status === "success") {
                        //success
                    	optList = result.data.grpOptList;
                    	optModelList = result.data.optGrpModelList;
                    	if (result.data.grpOptListCount > 0) {
                    		this.renderOptionList(result.data);
                    		this.renderOptionModelList(result.data);
                    	} else {
                    		this.$pdpInfo.find("li.Spec").css("display","none"); //옵션영역 disabled..비활성화 처리
                    	}
                    } else {
                    	this.$pdpInfo.find("li.Spec").css("display","none"); //옵션영역 disabled..비활성화 처리
                    }
                }.bind(this),
                true,
                true
            );
        },
        renderOptionList: function (data) {
        	var optionList = data.grpOptList;
        	var optionListCnt = data.grpOptListCount;
        	var curOptItemNm = "";
        	var optionTemplateStr = "";
        	var optionLongValueItem = [];
        	for (var i = 0; i < optionListCnt; i++) {
                var item = optionList[i];
                if (modelOptValInfoStr.indexOf(item.optItemValueId) > -1) { //현재 모델의 옵션값중에 있는 값이면
                	item._valueChchked = "Y";
                	var checkedOptObj = {
                			"optItemId" : item.optItemId,
                			"optItemValueId" : item.optItemValueId
                		};
                	checkedOpt.push(checkedOptObj);
                	orgCheckedOpt.push(checkedOptObj);
                } else {
                	item._valueChchked = "N";                	
                }
                
                // 클래스명
                if (item.optItemAttrCode == "02") { //컬러
                	item._itemClass = "sibling-color";

					// // BTOCSITE-89585(구독 노트북 카테고리인경우 클래스 추가)
					if(lgePdpSendData.categoryId == 'CT50238004'){

						item._itemClass = "sibling-color notebook_Op-color";

					}

                } else { //일반
                	item._itemClass = "sibling-select";
                	if (item.optItemValueDispNm.length > 10) {
                		if (!optionLongValueItem.includes(item.optItemId)) { // 템플릿을 그려줄 때 itemdiv를 안그릴때도 있기 때문에 먼저 배열에 담는다.
                			optionLongValueItem.push(item.optItemId);
                		}
                	}
                }
                // 데이터가 optItem-optItemValue 형식이라서 optItemNm이 같을때 달라질때 템플릿도 달라진다.
                if (i == 0) {
                	curOptItemNm = item.optItemNm;
                	optionTemplateStr += vcui.template(optionStartTemplate, item);
                } else if (item.optItemNm != curOptItemNm) {
                	curOptItemNm = item.optItemNm;
                	optionTemplateStr += vcui.template(optionNextTemplate, item);
                } else {
                	optionTemplateStr += vcui.template(optionValueTemplate, item);
                }
        	}
        	this.$siblingCont.append(optionTemplateStr + '</div></div></div>');
        	
        	for (var i = 0; i < optionLongValueItem.length; i++) { //옵션명이 길 경우 클래스명 추가
        		this.$siblingCont.children('.' + optionLongValueItem[i] + '-div').addClass("sibling-time");
        	}
        	
        	this.optItemModelMap();
        },
        renderOptionModelList: function (data) {
        	var optGrpModelList = data.optGrpModelList;
        	for (var i = 0; i < optGrpModelList.length; i++) {
                var item = optGrpModelList[i];
                if(item.MODEL_ID == lgePdpSendData.modelId) {
                	item._display = "Y";
                } else {
                	item._display = "N";                	
                }
                
                if (optBizType !== "PRODUCT" && item.VISIT_PER != null) {
                	if (item.VISIT_PER == 0) {               		
                		item._visitPer = "(방문없음/자가관리)";
                	} else {                		
                		item._visitPer = "(" + item.VISIT_PER + "개월/1회방문)";
                	}
                } else {
                	item._visitPer = "";
                }
                
                item._statusClass = "";
                item._rentalPrice = "";
                item._price = "";
                item._memberPriceTxt = "";
                if ((item.BIZ_TYPE == "CARESOLUTION" || item.BIZ_TYPE == "CARESHIP") && item.OBS_SELLING_PRICE != null && item.OBS_SELLING_PRICE > 0) {
                    if(lgkorUI.getHiddenInputData().b2cYN ==='Y'){
                        item._rentalPrice = vcui.number.addComma(item.OBS_SELLING_PRICE);
                    }
                } else {
                    if (lgkorUI.getHiddenInputData().b2cYN === "N") { //사업자몰은 사업자 인증 회원일 경우에만 가격 노출
                        if (item.PARTNER_PRICE > 0) {
                            item._price = vcui.number.addComma(item.PARTNER_PRICE);
                        }
                    } else {
                        if (item.OBS_SELLING_PRICE != null && item.OBS_SELLING_PRICE > 0) { //회원할인가가 있다면
                            item._memberPriceTxt = '회원할인가';
                            item._price = vcui.number.addComma(item.OBS_SELLING_PRICE);
                            item._statusClass = "prd-right-membership ";
                        } else {
                            if (item.OBS_ORIGINAL_PRICE > 0){
                                item._price = vcui.number.addComma(item.OBS_ORIGINAL_PRICE);
                            }
                        }
                    }
                }
                
                item._modelSalePlannedDate = "";
                item._modelStatusOrder = item.MODEL_STATUS_ORDER;
                item._mixProductFlag = item.MIX_PRODUCT_FLAG;
                // 판매:1, 판매대기:2, 일시품절:3, 미판매: 4, 단종: 5
                if( item.MIX_PRODUCT_FLAG == "Y"){
                    item._statusClass += " prd-right-unsold";
                }else{
                    if (item.MODEL_STATUS_ORDER == 2 && optBizType !== "CARESOLUTION") {
                        item._statusClass += " prd-right-standSale";
                        //판매대기일 노출 여부에 따라 날짜 노출/미노출
                        if (item.MODEL_SALE_PLANNED_DISP_FLAG == 'Y') {
                            if (!vcui.isEmpty(item.MODEL_SALE_PLANNED_MONTH)) {
                                item._modelSalePlannedDate = item.MODEL_SALE_PLANNED_MONTH;
                            }
                            if (!vcui.isEmpty(item.MODEL_SALE_PLANNED_WEEK) && vcui.isEmpty(item.MODEL_SALE_PLANNED_DATE)) {
                                item._modelSalePlannedDate += "월" + item.MODEL_SALE_PLANNED_WEEK;
                            } else if (!vcui.isEmpty(item.MODEL_SALE_PLANNED_DATE)) {
                                item._modelSalePlannedDate += "/" + item.MODEL_SALE_PLANNED_DATE;
                            }
                        } else {
                            item._modelSalePlannedDate = '';
                        }
                        //판매가격 노출 여부에 따라 가격 노출/미노출
                        if (item.MODEL_SALE_PLANNED_PRICE_DISP_FLAG != 'Y') {
                            item._price = "";
                        }
                    } else if (item.MODEL_STATUS_ORDER == 3 && optBizType !== "CARESOLUTION") {
                        item._statusClass += " prd-right-stock";
                    } else if (item.MODEL_STATUS_ORDER == 4  && optBizType !== "CARESOLUTION") {
                        item._statusClass += " prd-right-unsold";
                    } else if (item.MODEL_STATUS_ORDER == 5) {
                        item._statusClass += " prd-right-discontinuance";
                    } else {
                        item._statusClass += " prd-right-price";
                        item._modelStatusOrder = 1;
                    }
                }

                
                //BTOCSITE-19200 참고. 
                if (optBizType !== "CARESOLUTION" && item.OBS_INVENTORY_FLAG == "Y" && item.OBS_SELL_FLAG == "Y") {                	
                	item._obsFlag = "Y";
                } else {
                	item._obsFlag = "N";                	
                }
                
                //optHeaderTemplate 매립배관형은 <sup>태그가 들어가서 replace해줘야함.
                var replaceTemplate = vcui.template(optHeaderTemplate, item);
                replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;br&gt;","<br>",false); // BTOCSITE-38138
            	replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;sup&gt;","<sup>",false);
            	replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;/sup&gt;","</sup>",false);
            	this.$optHeader.append(replaceTemplate);
        	}

        },
        optItemModelMap: function() {
        	this.$siblingCont.find('.option-list').each(function() {
        		var $radio = $(this).find('input:radio');
        		$radio.each(function(){
	        		var radioOptArr = [];
	    			//현재 라디오 옵션값
	    			var curRadioOptItemId = $(this).data("optItemId"); //itemId
	    			var curRadioOptItemValueId = $(this).attr("id");
	    			radioOptArr.push({"optItemId" : curRadioOptItemId, "optItemValueId" : curRadioOptItemValueId});
	    			
	    			//체크되어있는 옵션들중 현재 라디오(옵션value)의 옵션이 아닌 다른옵션의 옵션값
	    			for (var j = 0; j < checkedOpt.length; j++) {
	    				if (checkedOpt[j].optItemId != curRadioOptItemId) {
	    					radioOptArr.push(checkedOpt[j]);
	    				}
	    			}
	    			//위 두개의 조합으로 옵션-모델맵핑list에서 찾기
	    			radioOptArr = radioOptArr.sort((a, b) => a.optItemId < b.optItemId ? -1 : 1); // itemId로 정렬
	    			var radioOptArrStr = "";
	    			radioOptArr.forEach(function(obj) {
	    				radioOptArrStr += obj.optItemValueId;
	    			});
	    			
	    			var radioOptModelId = "";
	    			for (var k = 0; k < optModelList.length; k++) {
	    				var optModelObjOptArr = optModelList[k].optItem.sort((a, b) => a.optItemId < b.optItemId ? -1 : 1);
	    				var optModelObjOptArrStr = "";
	    				optModelObjOptArr.forEach(function(obj) {
	    					optModelObjOptArrStr += obj.optItemValueId;
		    			});
	    				if (radioOptArrStr == optModelObjOptArrStr) {
	    					radioOptModelId = optModelList[k].MODEL_ID;
	    					$(this).data("optModelId", radioOptModelId); //모델id 셋팅
	    					$(this).data("optModelUrlPath", optModelList[k].MODEL_URL_PATH); //모델urlPath 셋팅
	    					break;
	    				}
	    			}
	    			if (radioOptModelId == ""){ //맵핑되는 모델 없음(선택가능옵션)
	    				$(this).addClass("disabled");
	    				$(this).siblings("label").addClass("check-option");
	    				radioOptModelId = KRP0008.selectableOptionModelId(curRadioOptItemId, curRadioOptItemValueId);
	    				$(this).data("optModelId", radioOptModelId); //모델id 셋팅
	    			} else {
	    				$(this).removeClass("disabled");
	    				$(this).siblings("label").removeClass("check-option");
	    			}
        		});
        	});
        },
        selectableOptionModelId: function(curRadioOptItemId, curRadioOptItemValueId) {
        	var radioModelId = "";
        	//선택가능옵션은 우선순위 계산하여 모델id추출
        	//현재 선택한 옵션 item, value 기준으로 해당 옵션에 해당되는 모델리스트 추출
        	//optModelList 사용
        	var optSortArr = [];
    		for(var i = 0; i < optModelList.length; i++) {
    			var result = optModelList[i].optItem.filter(function(item){
    				  return item.optItemId == curRadioOptItemId && item.optItemValueId == curRadioOptItemValueId;
    			});
    			
    			if (result && result.length > 0) {
    				optSortArr.push(optModelList[i]);
    				break;
    			}
    		}
    		
        	//추출한 리스트에서 우선순위 정렬
    		if(optSortArr.length > 1) {  			
    			//우선순위는 판매상태에 따라 먼저 정렬 MODEL_STATUS_ORDER
    			optSortArr = optSortArr.sort((a, b) => a.MODEL_STATUS_ORDER - b.MODEL_STATUS_ORDER);
    			//숫자가 제일 적은것으로 추출
    			var minStatNum = optSortArr[0].MODEL_STATUS_ORDER;
    			optSortArr = optSortArr.filter(function(item){
    				return item.MODEL_STATUS_ORDER == minStatNum;
    			});
    			//추출한 데이터가 두개 이상이면 opt_item_order 체크해서 숫자로 정렬 및 제일 적은것으로 modelid 추출
    			if (optSortArr.length > 1) {
    				optSortArr = optSortArr.sort((a, b) => a.OPT_ITEM_ORDER - b.OPT_ITEM_ORDER);
    			}
    		}
    		//정렬한 리스트에서 제일 첫번째 modelId반환
    		if (optSortArr.length > 0 && optSortArr[0].MODEL_ID != null) {    			
    			radioModelId = optSortArr[0].MODEL_ID;
    		}
        	
        	return radioModelId;
        },
        optPopToastShowHtml: function(msg){
        	$('.toast-message2').find('.toast-text').html(msg);
        	$('.toast-message2').stop().css({
                display:'block',
                opacity:0
            }).animate({opacity:1}, 150);
        	setTimeout(function() {
        		KRP0008.optPopToastClose();
            }, 3000);
        },
        optPopToastClose: function(){
            $('.toast-message2').stop()
            .animate({opacity:0}, 120, function(){
            	$('.toast-message2').css('display', 'none');
            });
        },

        // BTOCSITE-37933 다품목 판매 활성화
        cartSwiper: function() {
            var swiperCommonOpt = {
                speed: 300,
                observer: true,
                observeParents: true,
                slidesPerGroup: 3,
                slidesPerView: 'auto',
                spaceBetween: 0,
                freeMode: true,
                breakpoints: { // [BTOCSITE-67116] 상품 장바구니 담기 팝업 swiper 수정
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 11,
                        freeMode: false,
                    }
                },
            }

            vcui.require(['libs/swiper-8.2.4.min'],function(){ // [BTOCSITE-66557] 시네빔 큐브 포토리뷰 오류
                var cartSwiper1 = new Swiper('.cart-swiper1', $.extend(swiperCommonOpt , {
                    navigation: {
                        nextEl: '.cart-slider-wrap1 .btn-arrow.next',
                        prevEl: '.cart-slider-wrap1 .btn-arrow.prev',
                    }
                }));

                var cartSwiper2 = new Swiper('.cart-swiper2', $.extend(swiperCommonOpt , {
                    navigation: {
                        nextEl: '.cart-slider-wrap2 .btn-arrow.next',
                        prevEl: '.cart-slider-wrap2 .btn-arrow.prev',
                    }
                }));
            });
        },

        // BTOCSITE-51366 PDP 렌탈이동 경로 개선 
        rentalSwiper: function () {
            // [S] BTOCSITE-91373 [QC][AOS] 구독 계약기간별 상품 이동 영역 내 특정 구독 건 선택 시 페이지 이동되지 않음
            var rentalSwiperOpt = {
                slidesPerView: 'auto',
                spaceBetween: 8,
                breakpoints: {
                    1024: {
                        spaceBetween: 13,
                    },
                },
                a11y: false,
                on: {
                    init: function(swiper, e) {
                        var $swiperEl = $(this.el);
                        var $swiperSlide = $swiperEl.find('.swiper-slide');

                        $swiperSlide.each(function(idx) {
                            var $this = $(this);
                            $this.attr('aria-label', (idx+1) +' / '+ $swiperSlide.length);
                            $this.attr('role', 'group');

                        });
                    }
                }
            }

			$(document).off('keydown.rental').on('keydown.rental', function(e) {
                var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
                var isShiftPressed = e.shiftKey;

                setTimeout(function(){
                    var $focusableEl = $(document.activeElement);

                    if ($focusableEl.closest('.rental-new-wrap').length && $focusableEl.closest('.swiper-slide').length) {
                        var swiper = $focusableEl.closest('.rental-new-wrap')[0].swiper;

                        if (swiper) swiper.slideTo($focusableEl.closest('.swiper-slide').index(), 0);
                    }
                }, 10);
            });
            // [E] BTOCSITE-91373 [QC][AOS] 구독 계약기간별 상품 이동 영역 내 특정 구독 건 선택 시 페이지 이동되지 않음

            $(".rental-new-wrap").each(function () {
                var rentalItemsLength = $(this).find('.rental-new-item').length;

                if ($(window).width() > 1024 && rentalItemsLength > 3) {
                    var rentalSwiper = new Swiper(this, rentalSwiperOpt);

                    $(this).addClass("is-swipe");

                    rentalSwiper.on('slideChangeTransitionEnd', function () {
                        if (rentalSwiper.isEnd) {
                            $(rentalSwiper.$el).removeClass("is-swipe");
                        }
                    });

                    rentalSwiper.on('slideChangeTransitionStart', function () {
                        if (rentalSwiper.isBeginning) {
                            $(rentalSwiper.$el).addClass("is-swipe");
                        }
                    });
                } else if ($(window).width() <= 1024 && rentalItemsLength > 2) {
                    var rentalSwiper = new Swiper(this, rentalSwiperOpt);
                }
            });
        },

        // BTOCSITE-62058 스마트홈 경험 솔루션 
        smartPackageSwiper: function () {
            var smartPackageCarousel = $('.smart-package-wrap');
            var smartSetCarousel = $('.smart-set-wrap');
            var smartPackageList = smartPackageCarousel.find('.slide-conts').length;
            var smartSetList = smartSetCarousel.find('.slide-conts').length;

            if (!isMobile) {
                if(window.innerWidth >= 1200 && smartPackageList >= 5){
                    smartPackageCarousel.vcCarousel('destroy');
                    smartPackageCarousel.removeClass('unslick');
                    smartPackageCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 3,    // BTOCSITE-78355 [ThinQ AI Home] 가전 PDP 및 홈IoT 제품 PDP 내 'AI Home' 상품/솔루션 추천 기능 순서 변경 및 통합
                        slidesToScroll: 3,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else if(window.innerWidth < 1200 && smartPackageList >= 4){
                    smartPackageCarousel.vcCarousel('destroy');
                    smartPackageCarousel.removeClass('unslick');
                    smartPackageCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else{
                    smartPackageCarousel.vcCarousel('destroy');
                    smartPackageCarousel.addClass('unslick');
                }                

                if(window.innerWidth >= 1200 && smartSetList >= 6){
                    smartSetCarousel.vcCarousel('destroy');
                    smartSetCarousel.removeClass('unslick');
                    smartSetCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else if(window.innerWidth < 1200 && window.innerWidth > 1000 && smartSetList >= 5){
                    smartSetCarousel.vcCarousel('destroy');
                    smartSetCarousel.removeClass('unslick');
                    smartSetCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else if(window.innerWidth < 1000 && smartSetList >= 4){
                    smartSetCarousel.vcCarousel('destroy');
                    smartSetCarousel.removeClass('unslick');
                    smartSetCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else{
                    smartSetCarousel.vcCarousel('destroy');
                    smartSetCarousel.addClass('unslick');
                }
            } else {
                smartPackageCarousel.vcCarousel('destroy');
                smartSetCarousel.vcCarousel('destroy');
            }
        }, 

        packageScrollLeft: function () {
            var $smartProdArea = $('.package-product-area');
            if (!$smartProdArea.length) return;

            var pkgListElm = $smartProdArea.get(0).querySelector('ul.package-product-item-list');
            var actBtnElm = pkgListElm.querySelector('a.active');

            if (pkgListElm && actBtnElm) {
                var compLeft = $smartProdArea.offset().left;

                if (isMobile) {
                    var actLeft = actBtnElm.offsetLeft - compLeft;
                    var actRight = actLeft + actBtnElm.clientWidth;
                    var isOver = actRight > pkgListElm.clientWidth;

                    pkgListElm.scrollLeft = isOver ? actLeft : 0;
                } else {
                    actBtnElm.scrollIntoView({ block: 'nearest', inline: 'center' });
                }
                
                var isScroll = pkgListElm.scrollWidth !== pkgListElm.clientWidth && !isMobile;
                $(pkgListElm).css('padding-bottom', isScroll ? 24 : '');
            }
        },

        // BTOCSITE-72217 제품 번들링 과제
        initBundledArea: function () {
            var self = this;
            var isMobile = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;

            $('.bundled-products-wrap').each(function (idx, el) {
                var $wrap = $(el);
                var bundLength = $(this).find('.bundled-products-wrapper .swiper-slide').length;

                if (isMobile && bundLength > 1) {
                    if (el.swiper) {
                        el.swiper.update();
                    } else {
                        new Swiper(el, {
                            initialSlide: 0,
                            slidesPerView: 'auto',
                            pagination: {
                                el: ".swiper-pagination",
                                clickable: true,
                            },
                        });
                    }
                } else {
                    self.destroySwiper($(el));
                }
            });

            $('.bundled-products-dropdown').off('click').on('click', function(){
                var active = $(this).hasClass('on');

                self.clearDropdownBundled();

                if (!active) {
                    $(this).addClass('on');

                    self.watchDropdownBundled();
                }
            });

            $('.bundled-products-wrap').off('change').on('change', '.swiper-slide .chk-wrap input', function(e){
                self.clearDropdownBundled();

                if(lgePdpSendData.modelStatusCode !== "ACTIVE"){
                    lgkorUI.alert("", {title: "일시품절 상태에서는<br/>" +
                            "추가상품 선택이 불가합니다.<br/>" +
                            "상품이미지를 선택하시면<br/>" +
                            "해당 제품 페이지에서 구매가 가능합니다.<br/>"}, $(this).closest('.bundled-products-wrap').prev('.bundled-products-dropdown')); // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    $(this).parents('.swiper-slide').removeClass('checked');
                    KRP0008.additionModel.removeSelectedAdditionModel($(this).closest('.swiper-slide'));
                    $(this).parents('.swiper-slide').find("input[type=number]").prop('readonly',true);
                    return;
                }

                //BTOCSITE-73832  제품 번들링 과제
                $(this).closest('.bundled-products-wrap').prev('.bundled-products-dropdown').removeClass('on');

                var isMobile = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;

                if(isMobile) {
                    if ($(this).is(':checked')) {
                        $(this).parents('.swiper-slide').addClass('checked');
                        KRP0008.additionModel.addSelectedAdditionModel($(this).closest('.swiper-slide'));
                        // $(this).parents('.swiper-slide').find("input[type=number]").prop('readonly',false);
                    } else {
                        $(this).parents('.swiper-slide').removeClass('checked');
                        KRP0008.additionModel.removeSelectedAdditionModel($(this).closest('.swiper-slide'));
                        // $(this).parents('.swiper-slide').find("input[type=number]").prop('readonly',true);
                    }
                }else{
                    $(this).is(':checked',true)
                    $(this).parents('.swiper-slide').addClass('checked');
                    KRP0008.additionModel.addSelectedAdditionModel($(this).closest('.swiper-slide'));
                    $(this).parents('.swiper-slide').find("input[type=number]").prop('readonly',false);
                }
            });

            //self.changeStateBundled('대상', index); // swiper index 변경 함수, 혹은 swiper 생성 때 옵션 initialSlide 직접 지정
        },

        /**
         * 열려있는 번들 드롭다운 감시
         */
        watchDropdownBundled: function () {
            var self = this;

            $(document).on('mousedown.KRP0008-bundled', function (e) {
                if (!$(e.target).closest('.bundled-products-select-wrap').length) {
                    self.clearDropdownBundled();
                }
            });
        },

        /**
         * 열려있는 번들 드롭다운 메뉴 닫기
         */
        clearDropdownBundled: function () {
            $(document).off('mousedown.KRP0008-bundled');

            $('.bundled-products-dropdown.on').removeClass('on');
        },

        /**
         * 스와이프 제거
         * @param {jQueryElement} $swiper
         */
        destroySwiper: function ($swiper) {
            var $target = $swiper.hasClass("swiper-initialized")
            ? $swiper
            : $swiper.find(".swiper-initialized");

            $target.each(function (_, el) {
            var swiper = $(el)[0].swiper;

            if (swiper !== undefined) {
                swiper.destroy(true, true);
                // console.log("!!!!! destroySwiper", swiper);
            }
            });
        },

        /**
         * 함께 구매 가능한.. 상태변경 함수// BTOCSITE-72217
         * @param {jQueryElement} $target 대상 .bundled-products-wrap
         * @param {number} idx 인덱스
         */
        changeStateBundled: function ($target, idx) {
            var isMobile = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;

            if (isMobile) {
                // mo
                if (!!$target.length && $target[0].swiper) {
                    var swiper = $target[0].swiper;
                    if (!isNaN(idx)) swiper.slideTo(idx);
                }
            } else {
                // pc
            }
        },

        // BTOCSITE-35421 [PLP/PDP] 구매혜택/다품목/내일배송 개선
        benefitPriceDisplayInit : function () {
            var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
            var modelGubun = '';
            if (productInfo != null) {
                modelGubun = productInfo.model_gubun;
            }

            if(modelGubun === "일반제품" || modelGubun === "케어솔루션"){

                var inputdata = lgkorUI.getHiddenInputData();

                //할인/혜택 내용보기 영역
                var obsLastBenefitPrice = !vcui.isEmpty(inputdata.obsLastBenefitPrice)  && inputdata.obsLastBenefitPrice !=="0" ? vcui.number.parse(inputdata.obsLastBenefitPrice): 0;
                if(obsLastBenefitPrice > 0){
                    $('.view-discount-details').show(); //할인 / 혜택 내용보기 영역
                }

                //할인/혜택 내용보기 영역 > 할인결제가 영역
                var discountApprPrice = !vcui.isEmpty(inputdata.discountApprPrice)  && inputdata.discountApprPrice !=="0" ? vcui.number.parse(inputdata.discountApprPrice): 0;
                var obsOriginalPrice = !vcui.isEmpty(inputdata.obsOriginalPrice)  && inputdata.obsOriginalPrice !=="0" ? vcui.number.parse(inputdata.obsOriginalPrice): 0;
                if(discountApprPrice > 0 && (obsOriginalPrice > discountApprPrice)){
                    $('.view-discount-details .details-box .discount-payment').show();
                }else{
                    $('.view-discount-details .details-box .discount-payment').hide();
                }

                // 캐시백
                var rewardAmt = !vcui.isEmpty(inputdata.rewardAmt)  && inputdata.rewardAmt !=="0" ? vcui.number.parse(inputdata.rewardAmt): 0;
                //결제일할인금액
                var apprDateDiscountPrice = !vcui.isEmpty(inputdata.apprDateDiscountPrice)  && inputdata.apprDateDiscountPrice !=="0" ? vcui.number.parse(inputdata.apprDateDiscountPrice): 0;
                if((rewardAmt >0  || apprDateDiscountPrice > 0) || productInfo.model_id == 'MD10250832'){
                    $('#benefitPrice, #b2cTabBenefitPrice').show(); //가격정보 영역 > 최대혜택가
                    $('.maximum-benefit-price').show(); // 할인/혜택 내용보기 > 최대혜택가

                    // 최대혜택가 노출 시 쿠폰할인가 팝업 제거 처리
                    var $maxPriceCouponPopupLink = $('#couponPricePopupSelector, #tabCouponPricePopupSelector');
                    $maxPriceCouponPopupLink.removeAttr('href');
                    $maxPriceCouponPopupLink.removeClass('link-text');
                    $maxPriceCouponPopupLink.off('click');

                    // 할인/혜택 내용보기 > 결제일 할인영역
                    if(apprDateDiscountPrice > 0 || productInfo.model_id == 'MD10250832' ){
                        $('.maximum-benefit-price .day').show();
                    }

                    if(rewardAmt > 0 || apprDateDiscountPrice > 0){
                        if(rewardAmt > 0){
                            $('#employeeTabBenefitDesc').show();
                        }else{
                            $('#employeeTabBenefitDescNoCash').show();
                        }
                    }
                }

                //쿠폰 할인율
                var obsCouponDiscountRate = !vcui.isEmpty(inputdata.obsCouponDiscountRate)  && inputdata.obsCouponDiscountRate !=="0" ? vcui.number.parse(inputdata.obsCouponDiscountRate): 0;
                if(obsCouponDiscountRate > 0){
                    $('#couponDiscountRate').text(obsCouponDiscountRate+'%');
                }

                // (취소선 가격 외)
                // 가격 1개 노출 > regular
                // 가격 2개 노출 > 강조표기 금액만 bold
                // 가격 3개 노출 > 판매가/회원할인가, 쿠폰할인가 bold | 최대혜택가 regular
                var originalPrice = $('#originalPrice').find('.content').find('.price').text();
                var memberPrice = $('#memberPrice').find('.content').find('.price').text();
                var couponPrice = $('#couponPrice').find('.content').find('.price').text();
                var benefitPrice = $('#benefitPrice').find('.content').find('.price').text();

                var priceList =0;

                if(!vcui.isEmpty(memberPrice)){
                    priceList ++;
                }
                if(!vcui.isEmpty(originalPrice)){
                    priceList ++;
                }
                if(!vcui.isEmpty(couponPrice)){
                    priceList ++;
                }
                if(!vcui.isEmpty(benefitPrice)){
                    priceList ++;
                }

                if(priceList>1){
                    // 할인혜택이 없는 경우 : 회원할인가, 판매가 bold
                    if(vcui.isEmpty(benefitPrice)){
                        $('#memberPrice').attr('class', 'price-detail-item2');
                        $('#originalPrice').attr('class', 'price-detail-item2');
                    }else{
                        //할인혜택이 있는 경우
                        if(vcui.isEmpty(couponPrice)){
                            $('#memberPrice').attr('class', 'price-detail-item3');
                            $('#originalPrice').attr('class', 'price-detail-item3');
                        }else{
                            $('#memberPrice').attr('class', 'price-detail-item2');
                            $('#originalPrice').attr('class', 'price-detail-item2');
                        }
                    }

                    //판매가 강조
                    if($('#memberPrice').hasClass("price-detail-item3")){
                        $('.view-discount-details .details-box').find('.price2').attr("class","price");
                    }
                }
            }else if(modelGubun === "소모품"){
                var inputdata = lgkorUI.getHiddenInputData();
                console.log(inputdata);
                // 캐시백
                var rewardAmt = !vcui.isEmpty(inputdata.rewardAmt)  && inputdata.rewardAmt !=="0" ? vcui.number.parse(inputdata.rewardAmt): 0;
                //결제일할인금액
                var apprDateDiscountPrice = !vcui.isEmpty(inputdata.apprDateDiscountPrice)  && inputdata.apprDateDiscountPrice !=="0" ? vcui.number.parse(inputdata.apprDateDiscountPrice): 0;
                if(rewardAmt >0  || apprDateDiscountPrice > 0){
                   if(rewardAmt > 0){
                       $('#employeeDisposablePriceAreaDesc').show();
                   }else{
                       $('#employeeDisposablePriceAreaDescNoCash').show();
                   }
                }
            }

            //할인 / 혜택 내용보기 이벤트
            $('.details-header').click(function(){
                $(this).find('img').toggleClass('deg');
                $(this).next('div[class*="details-box"]').toggleClass('hide');// [BTOCSITE-63370] [구독 Task] 구독 탐색 강화 - 구독PDP 개선
            });
        },

        /* BTOCSITE-36570 [개인맞춤서비스] 일반제품/소모품 제품추천 영역 추가 */
        setPersonalRecommendation: function () {
            try {
                var unifyId = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId;

                if (lgePdpSendData.bizType === "PRODUCT" || (lgePdpSendData.bizType === "DISPOSABLE" && loginFlag === "Y")) {
                    window.addEventListener('scroll', KRP0008.onViewport);

                    let param = {
                        unifyId: lgkorUI.stringToBool(loginFlag) ? unifyId : "",
                        modelId: lgePdpSendData.modelId !== null ? lgePdpSendData.modelId : "",
                        sku: lgePdpSendData.sku,
                        smartHomeFlag: digitalData.productInfo.smart_home_flag,
                        clientId: lgkorUI.getCookie('_ga')
                    }
                    let personalRecommendation = "";

                    lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrievePersonalRecommendation", {
                        method: "POST",
                        data: param,
                        success: function (result) {
                            personalRecommendation = result.data;

                            let $recommend = $('div.item-recommend-wrap.recommend-type-a');

                            if (personalRecommendation.recommendModels !== null && personalRecommendation.recommendModels.length > 0) {
                                let wrapDisplayFlag = false;

                                if (lgePdpSendData.bizType === "PRODUCT" && personalRecommendation.recommendModels.length >= 3) {
                                    if (["s2_6", "s2_6_1", "s2_6_2"].includes(personalRecommendation.scenarioNo)) wrapDisplayFlag = true;
                                    else if (param.unifyId !== "" && (["s2_3", "s2_3_1", "s2_3_2"].includes(personalRecommendation.scenarioNo) || ["s2_4", "s2_4_1", "s2_4_2", "s2_7", "s2_8"].includes(personalRecommendation.scenarioNo))) wrapDisplayFlag = true;
                                } else if (lgePdpSendData.bizType === "DISPOSABLE") {
                                    if (param.unifyId !== "" && ["s2_1", "s2_1_1", "s2_1_2"].includes(personalRecommendation.scenarioNo)) wrapDisplayFlag = true;
                                    // 비로그인 s2_5인 경우 KRP0012에서 호출
                                }

                                if (wrapDisplayFlag) {
                                    var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                                    if (productInfo !== undefined && productInfo !== null && ["s2_3", "s2_3_1", "s2_3_2", "s2_4", "s2_4_1", "s2_4_2", "s2_6", "s2_6_1", "s2_6_2", "s2_7", "s2_8"].includes(personalRecommendation.scenarioNo)) {
                                        if ("LG 오브제컬렉션|LG 시그니처|LG 업 가전".includes(productInfo.model_category)) {
                                            personalRecommendation.categoryName = productInfo.model_sub_category;
                                            // CDP API 호출 결과, '워시콤보;워시타워;세탁기'인 경우, '워시콤보, 워시타워, 세탁기'로 표시 - BTOCSITE-63269
                                        } else if (['s2_4', 's2_4_1', 's2_4_2', 's2_6', 's2_6_1', 's2_6_2', 's2_7', 's2_8'].includes(personalRecommendation.scenarioNo) && personalRecommendation.categoryName === '워시콤보, 워시타워, 세탁기') {
                                        } else {
                                            personalRecommendation.categoryName = productInfo.model_category;
                                        }
                                        personalRecommendation.categoryName = personalRecommendation.categoryName.replace(/_/g, "/");
                                        if ("공기청정기|제습/가습기".includes(personalRecommendation.categoryName)) {
                                            personalRecommendation.categoryName = "공기청정기, 제습/가습기";
                                        }
                                    }

                                    personalRecommendation.recommendLen = personalRecommendation.recommendModels.length;

                                    let recommendModelList = '';
                                    for (var i = 0; i < personalRecommendation.recommendLen; ++i) {
                                        recommendModelList += personalRecommendation.recommendModels[i].sku + '/';
                                    }
                                    personalRecommendation.eventLabel = personalRecommendation.scenarioNo + '/' + recommendModelList.slice(0, -1);

                                    $recommend.empty();	// 중복생성 방지
                                    $recommend.css('display', 'block');
                                    $recommend.append(vcui.template(recommendationTemplate, personalRecommendation));

                                    if ((window.innerWidth > 767 && personalRecommendation.recommendLen > 5)
                                        || (window.innerWidth <= 767 && personalRecommendation.recommendLen > 2)) {
                                        $recommend.find('ul').on('scroll', function () {
                                            let recommendEventCategory = "클릭";
                                            let recommendEventAction = "PDP 개인화 추천 영역 - 스크롤 클릭";
                                            let recommendEventLabel = "클릭 컨텐츠 : 스크롤 이동";
                                            KRP0008.pushDataLayer('', recommendEventCategory, recommendEventAction, recommendEventLabel);
                                            $recommend.find('ul').off('scroll');
                                        });
                                    }
                                } else if (!["s2_5", "s2_5_1", "s2_5_2"].includes(personalRecommendation.scenarioNo) && !["e2_5", "e2_5_1", "e2_5_2"].includes(personalRecommendation.scenarioNo)) { // 미노출
                                    handleNoneDisplay(personalRecommendation.scenarioNo);
                                }
                            } else if (personalRecommendation.scenarioNo !== null && !["s2_5", "s2_5_1", "s2_5_2"].includes(personalRecommendation.scenarioNo) && !["e2_5", "e2_5_1", "e2_5_2"].includes(personalRecommendation.scenarioNo)) { // 미노출
                                handleNoneDisplay(personalRecommendation.scenarioNo);
                            }
                        },
                        error: function (e) {
                            console.log(e);
                        }
                    });
                }

                function handleNoneDisplay(scenarioNo) {
                    let recommendEventCategory = "배너노출";
                    let recommendEventAction = "PDP 배너 노출 - 개인화 추천";
                    let recommendEventLabel = scenarioNo.replace("s", "e");
                    KRP0008.pushDataLayer('', recommendEventCategory, recommendEventAction, recommendEventLabel);
                }
            } catch (e) {}
        },

        // BTOCSITE-51366 PDP 렌탈이동 경로 개선
        setDirectRentalChange : function() {
            if (lgePdpSendData.bizTypeDetail === "PRODUCT") {
                window.addEventListener('scroll', KRP0008.onRentalViewport);
            }
        },

        // target 영역이 화면에 완전히 노출되는 경우 true
        isElementInViewport: function(target) {
            try {
                let viewportHeight  = $(window).height();
                let scrollTop  = $(window).scrollTop();
                let targetTop = target.offset().top;
                let targetHeight = target.height();

                return ((targetTop + targetHeight) < (viewportHeight + scrollTop)) && (targetTop > scrollTop);
            } catch (e) {
                console.log(e);
            }
        },

        onViewport: function() {
            try {
                let $recommendWrap = $('div.item-recommend-wrap.recommend-type-a');
                let recommendEventLabel = $recommendWrap.find('div.req-top-main-title').attr('data-label');

                if (KRP0008.isElementInViewport($recommendWrap) && recommendEventLabel !== null) {
                    let recommendEventCategory = "배너노출";
                    let recommendEventAction = "PDP 배너 노출 - 개인화 추천";
                    KRP0008.pushDataLayer('', recommendEventCategory, recommendEventAction, recommendEventLabel);
                    window.removeEventListener('scroll', KRP0008.onViewport);
                }
                if (recommendEventLabel === null || $recommendWrap.css('display') === "none") { // 영역이 존재하지 않는 경우
                    window.removeEventListener('scroll', KRP0008.onViewport);
                }
            } catch (e) {
                console.log(e);
            }
        },

        // BTOCSITE-51366 PDP 렌탈이동 경로 개선, 신규 UI에 따른 영역 변경
        onRentalViewport: function() {
            try {
                let $rentalBannerWrap = $('.lists .rental-new .rental-new-wrap');

                if (KRP0008.isElementInViewport($rentalBannerWrap)) {
                    let recommendEventCategory = "배너노출";
                    let recommendEventAction = "배너노출 - PDP 가전구독";
                    KRP0008.pushDataLayer('', recommendEventCategory, recommendEventAction, '');
                    window.removeEventListener('scroll', KRP0008.onRentalViewport);
                } else if ($rentalBannerWrap.length < 1) {
                    window.removeEventListener('scroll', KRP0008.onRentalViewport);
                }
            } catch (e) {
                console.log(e);
            }
        },

        // 윈도우 이벤트 (BTOCSITE-37933)
        pageshowEvent: function(event){
            if (event.persisted || window.performance && window.performance.navigation.type == 2) {
                // 히스토리백시 장바구니 담기 다품목 추천 상품노출 (BTOCSITE-37933)
                try {
                    var sessionCart = lgkorUI.getStorage(KRP0008.cartRecommendStorageName);
                    if(sessionCart == lgePdpSendData.modelId) {
                        KRP0008.cartRecommend(true);
                    }
                    lgkorUI.removeStorage(KRP0008.cartRecommendStorageName);
                } catch (e) {
                    console.log("pageshowEvent Error" + e);
                }
            }
        },

        // 장바구니 담기 ajax Call (BTOCSITE-37933 )
        addCartAjaxCall: function(ajaxUrl, param, isToast) {

            //BTOCSITE-73832  제품 번들링 과제
            KRP0008.additionModel.getAdditionSelectModelCartParam(param);

            var addCartTrigerReturn = false;

            // BTOCSITE-48266 : B2B OBS 구축 : 다품목 팝업 미노출
            if(lgkorUI.getHiddenInputData().b2cYN === "Y" && lgePdpSendData.bizType == 'PRODUCT' && lgkorUI.parseUrl(location.href).searchParams.get("dpType") != 'careTab' && lgkorUI.parseUrl(location.href).searchParams.get("dpType") != 'upCareTab') {
                addCartTrigerReturn = true;
            }

            lgkorUI.removeStorage(KRP0008.cartRecommendStorageName);
            lgkorUI.requestCart(ajaxUrl, param, isToast, addCartTrigerReturn);

            /* BTOCSITE-61062 START */
            KRP0008.gtag_report_conversion();
            /* BTOCSITE-61062 END */
            /* BTOCSITE-65254 START */
            try {
                KRP0008.metaAddToCartEvent();
            } catch (e) {
                console.log(e);
            }
            
            /* BTOCSITE-80498 */
            if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
				KRP0008.csAddToCartRecordEvent();
			}else{
	            /* BTOCSITE-65254 END */
	            /* BTOCSITE-60453 START */
	            KRP0008.addToCartRecordEvent();
	            /* BTOCSITE-60453 END */
	            /* BTOCSITE-62357 START */
			}
					
            try {
                KRP0008.taboolaAddToCartEvent();
            } catch (e) {
                console.log(e);
            }
            /* BTOCSITE-62357 END */

            // BTOCSITE-79021 (상품) LGE.COM 네이버 스크립트 설치 요청의 건
            try {
                KRP0008.naverTransEvent("add_to_cart");
            } catch (e) {
                console.log(e);
            }
        },

        // 장바구니 담기 다품목 추천 상품 (BTOCSITE-37933)
        cartRecommend: function (isHistoryBack) {
            var ajaxUrl = "/mkt/api/product/retrieveMultipleItemRecommend" ;
            var smallProductrSection = $('#actionSheetCart').find("section:eq(0)");
            var largeProductrSection = $('#actionSheetCart').find("section:eq(1)");
            var cartUrlSection = $('#actionSheetCart').find(".contain-view button");

            // lg.commmon과 동일한 경로
            var typeFlag = self.$('.btn-cart').attr('data-type-flag');
            var pdpInfoFlag = self.$('.pdp-info-area').attr('data-type-cart');
            var wishTypeFlag = self.$('.info-tbl-wrap ul').attr('data-type-cart');
            var compareFlag = self.$('.product-items').attr('data-type-cart');

            var cartLink = "/shop/lgobscart/cart/quote";
            if( typeFlag == "CARESOLUTION" || pdpInfoFlag == "C" || wishTypeFlag == "C" || compareFlag == "C" ){
                cartLink = "/add-to-cart/rental-care-solution";
            // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
            } else if ($('#b2cTab').hasClass('on')) { // 임직원탭노출 > 일반탭 선택된 경우
                /*
                firstYn : 보내는쪽에서 결정한대로 따름
                salesType : B(일반) / E (임직원/복지몰)
                 */
                cartLink = "/shop/cart/index?firstYn=N&salesType=B";
            } else if (lgkorUI.getHiddenInputData().b2cYN ==='N') {
                cartLink = "/business/shop/lgobscart/cart/quote";
            }


			let vsPartnerType = '';
			let vsPartnerCode = '';

			//BTOCSITE-86873 임직원,복지몰 탭활성화에 따른 분기처리
			if($('#employeePriceTabArea').is(':visible')){
			   if($('#employeePriceTabArea .tabs > li').length > 0 && $('#employeeTab').hasClass('on')){
				    vsPartnerType = digitalData.userInfo.partnerType;
					vsPartnerCode = digitalData.userInfo.partnerCode;
				}else{
					vsPartnerType = ' ';
					vsPartnerCode = ' ';
				}
			}else{
				vsPartnerType = ' ';
				vsPartnerCode = ' ';
			}

			var cartParam = {
                "modelId": lgePdpSendData.modelId,
                "categoryId": lgkorUI.getHiddenInputData().defaultCategoryId,
				"partnerGrp": vsPartnerType,
				"partnerCd": vsPartnerCode
            };

            cartUrlSection.attr('data-url', cartLink);

            smallProductrSection.find(".swiper-wrapper").empty();
            largeProductrSection.find(".swiper-wrapper").empty();

            lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrieveMultipleItemRecommend", {
                method: "POST",
                data: cartParam,
                success: function (result) {
                    var smallProductList = result.data.smallProductList;
                    var largeProductList = result.data.largeProductList;
                    var isShow = false;
                    var smallTitle = smallProductrSection.find(".component-header__title").text();
                    var largeTitle = largeProductrSection.find(".component-header__title").text();

                    if (smallProductList.length > 0) {
                        smallProductList.forEach(function (item, index) {
                            item.subtitle = smallTitle;
                            var listItem = KRP0008.recommendMakeListItem(item);

                            smallProductrSection.find(".swiper-wrapper").append(listItem);
                        });
                        smallProductrSection.show();

                        isShow = true;
                    }
                    if (largeProductList.length > 0) {
                        largeProductList.forEach(function (item, index) {
                            item.subtitle = largeTitle;
                            var listItem = KRP0008.recommendMakeListItem(item);
                            largeProductrSection.find(".swiper-wrapper").append(listItem);
                        });
                        largeProductrSection.show();
                        isShow = true;
                    }

                    if (isShow) {
                        KRP0008.pushDataLayer('cart_recommend', '장바구니추천제품', '장바구니바텀시트노출', lgePdpSendData.modelId);
                        $('#actionSheetCart').vcModal({opener: document.activeElement}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        $('#actionSheetPopup').removeClass('active');
                        setTimeout(function () {
                            $('#actionSheetCart').addClass('active');
                        }, 300);

                        setTimeout(function () {
                            KRP0008.recommandActionSheet();
                        }, 100);
                    } else {
                        if (!isHistoryBack) {
                            $(window).trigger("toastshow", "선택하신 제품을 장바구니에 담았습니다.");
                            $('.toast-text').append('<br><a href="' + cartLink + '" class="btn-link white">장바구니 이동하기</a>');
                        }
                    }
                },
                error: function (e) {
                    console.log(e);
                }
            });
        },

        // GA 태그 호출
        pushDataLayer: function(eventName, eventCategory, eventAction, eventLabel) {
            if(dataLayer) {
                dataLayer.push({
                    'event': 'customEvent',
                    'ga4event': eventName,
                    'customEventCategory': eventCategory,
                    'customEventAction': eventAction,
                    'customEventLabel': eventLabel
                });
            }
        },

        /* BTOCSITE-61062 START */
        gtag_report_conversion: function(url) {
            var callback = function () {
                if (typeof(url) != 'undefined') {
                    window.location = url;
                }
            };
            /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 start*/
            //장바구니 등록
            if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
            	gtag('event', 'conversion', {
            		'send_to': 'AW-362582935/27pYCJ6SxPgZEJen8qwB',
            		'event_callback': callback
            	});
            	
            }else{
	            gtag('event', 'conversion', {
	                'send_to': 'AW-1029049388/MtYACK6Lq4UZEKyY2OoD',
	                'event_callback': callback
	            });
            }
            /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 end*/
            return false;
        },
        /* BTOCSITE-61062 END */

        /* BTOCSITE-65254 START */
        metaAddToCartEvent: function() {
            var quantity = $('#quantity').val();
            fbq('track', 'AddToCart',
                // begin parameter object data
                {
                    value: lgkorUI.getHiddenInputData().obsOriginalPrice,
                    currency: 'KRW',
                    contents: [
                        {
                            id: lgePdpSendData.modelId,
                            quantity: quantity
                        }],
                    content_type: 'product'
                }
                // end parameter object data
            )
        },
        /* BTOCSITE-65254 END */

        /* BTOCSITE-60454 START */
        recordEvent: function(eventName,eventValue) {
            var iframe = document.createElement("IFRAME");
            iframe.setAttribute("src", "af-event://inappevent?eventName="+eventName+"&eventValue="+eventValue);
            document.documentElement.appendChild(iframe);
            iframe.parentNode.removeChild(iframe);
            iframe = null;
        },

        contentViewRecordEvent: function() {
            var eventName = "af_content_view";
            var eventValue = {"af_price": lgkorUI.getHiddenInputData().obsOriginalPrice, "af_currency": "KRW", "af_content_type": digitalData.productInfo.category, "af_content_id": lgePdpSendData.modelId, "af_content": lgePdpSendData.productName};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
        },

        /* BTOCSITE-62357 START */
        taboolaAddToCartEvent: function() {
            _tfa.push({notify: 'event', name: 'add_to_cart', id: 1648539});
        },
        /* BTOCSITE-62357 END */

        // BTOCSITE-79021 (상품) LGE.COM 네이버 스크립트 설치 요청의 건
        naverTransEvent: function(eventType) {
            if (window.wcs) {
                if(!wcs_add) var wcs_add = {};
                wcs_add["wa"] = "s_10f2ff8ac82";
                wcs.inflow("lge.co.kr");
                wcs_do();
                var _conv = {};
                _conv.type = eventType;
                _conv.items = [
                    {
                        id: lgePdpSendData.modelId
                    }
                ];
                wcs.trans(_conv);
            }
        },

        addToCartRecordEvent: function() {
            var quantity = $('#quantity').val();
            var eventName = "af_add_to_cart";
            var eventValue = {"af_price": lgkorUI.getHiddenInputData().obsOriginalPrice, "af_currency": "KRW", "af_content_type": digitalData.productInfo.category, "af_content_id": lgePdpSendData.modelId, "af_content": lgePdpSendData.productName, "af_quantity": quantity};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
        /* BTOCSITE-60454 END */

		/* BTOCSITE-80498 Start */
        csContentViewRecordEvent: function() {
            var eventName       = "af_cs_content_view";
			var af_price        = digitalData.productInfo.rental_price;
			var af_currency     = "KRW";
			var af_content_type = digitalData.productInfo.category;
			var af_content_id   = lgePdpSendData.modelId;
			var af_content      = lgePdpSendData.productName;
            var eventValue = {"af_price": af_price, "af_currency": af_currency, "af_content_type": af_content_type, "af_content_id": af_content_id, "af_content": af_content};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
        },
        csAddToCartRecordEvent: function() {
            var eventName       = "af_cs_add_to_cart";
			var af_param_1      = (Number(digitalData.productInfo.contract_term)/12)+"년"+"/"+(Number(digitalData.productInfo.duty_term)/12)+"년";
			var af_price        = digitalData.productInfo.rental_price;
			var af_currency     = "KRW";
			var af_content_type = digitalData.productInfo.category;
			var af_content_id   = lgePdpSendData.modelId;
			var af_content      = lgePdpSendData.productName;
			var af_quantity     = $('#quantity').val();
            var eventValue = {"af_param_1": af_param_1, "af_price": af_price, "af_currency": af_currency, "af_content_type": af_content_type, "af_content_id": af_content_id, "af_content": af_content, "af_quantity": af_quantity};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
        csSubscribeClickRecordEvent: function() {
            var eventName       = "af_cs_subscribe_click";
			var af_content_type = digitalData.productInfo.category;
			var af_content      = lgePdpSendData.productName;
			var af_content_id   = lgePdpSendData.modelId;
			var af_price        = digitalData.productInfo.rental_price;
			var af_param_1      = (Number(digitalData.productInfo.contract_term)/12)+"년"+"/"+(Number(digitalData.productInfo.duty_term)/12)+"년";
			var af_currency     = "KRW";
            var eventValue = {"af_content_type": af_content_type, "af_content": af_content, "af_content_id": af_content_id, "af_price": af_price, "af_param_1": af_param_1, "af_currency": af_currency};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
        csReservationClickRecordEvent: function() {
            var eventName       = "af_cs_reservation_click";
			var af_content_type = digitalData.productInfo.category;
			var af_content      = lgePdpSendData.productName;
			var af_content_id   = lgePdpSendData.modelId;
            var eventValue = {"af_content_type": af_content_type, "af_content": af_content, "af_content_id": af_content_id};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
        csCallClickRecordEvent: function() {
            var eventName       = "af_cs_call_click";
			var af_content_type = digitalData.productInfo.category;
			var af_content      = lgePdpSendData.productName;
			var af_content_id   = lgePdpSendData.modelId;
            var eventValue = {"af_content_type": af_content_type, "af_content": af_content, "af_content_id": af_content_id};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
		/* BTOCSITE-80498 End */

        // 장바구니 담기 다품목 추천 상품 아이템 (BTOCSITE-37933)
        recommendMakeListItem: function (item) {
            var orgPrice = Number(item.obsOriginalPrice);
            var sellPrice = Number(item.obsSellingPrice);
            item._discountRate = Math.floor(((orgPrice - sellPrice) / orgPrice) * 100);
            item._obsSellingPrice = sellPrice > 0 ? vcui.number.addComma(item.obsSellingPrice) : null;

            item._target = ""
            if(!vcui.detect.isMobileDevice){
                item._target = "_blank";
            }

            function getEcCategoryName(item){
                if( item.subCategoryName == "" || item.subCategoryName == undefined) {
                    return item.superCategoryName + "/" + item.categoryName
                } else {
                    return item.superCategoryName + "/" + item.categoryName  + '/' + item.subCategoryName
                }
            }

            item.modelDisplayNameConvert = item.modelDisplayName.replace(/(<([^>]+)>)/ig,"");

            var ecProduct = {
                "model_name": item.modelDisplayNameConvert,
                "model_id": item.modelId,
                "model_sku": item.modelName,
                "model_gubun": item.modelGubunName,
                "price": vcui.number.addComma(item.obsOriginalPrice),
                "discounted_price": vcui.number.addComma(item.obsSellingPrice),
                "brand": "LG",
                "category": getEcCategoryName(item),
                "ct_id": item.subCategoryId
            }

            item.ecProduct = JSON.stringify(ecProduct);
            item.tail = "btm_rec_cart";

            return vcui.template(cartRecommendTemplate, item);
        },
        // 장바구니 담기 다품목 UI (BTOCSITE-37933)
        recommandActionSheet: function() {
            if(document.getElementById('actionSheetCart')) { // BTOCSITE-37933 다품목 판매 활성화_ PDP
                if(window.innerWidth > 767) {
                    var size0 = document.querySelector('#actionSheetCart .component-wrap');
                    var size1 = document.getElementById('actionSheetCart');
                    var size2 = document.querySelector('#actionSheetCart .action-sheet-inner');
                    if(size0.offsetHeight > 318) {
                        size2.style.height = size1.offsetHeight - 70 + 'px';
                    }
                    else {
                        size2.style.removeProperty('height');
                    }
                } else {
                    var scrollBtm = false;
                    $('.cart-wrap').scroll(function() {
                        var _this = $(this);
                        var scrollTop = _this.scrollTop();
                        var innerHeight = _this.innerHeight();
                        var scrollHeight = _this.prop('scrollHeight');

                        if(scrollTop + innerHeight >= scrollHeight) {
                            if(scrollBtm == false) {
                                scrollBtm = true;
                                dataLayer.push({
                                    'event': 'customEvent',
                                    'ga4event': 'cart_recommendScroll',
                                    'customEventCategory': '장바구니추천제품',
                                    'customEventAction': '장바구니바텀시트노출스와이프',
                                    'customEventLabel': lgePdpSendData.modelId
                                });
                            }
                        }
                    });
                }
            }
        },

        //BTOCSITE-45195 임직원몰 개선(임직원 전용제품 적용)
        displayEmployeeArea : function () {
            var self = this;
            let inputdata = lgkorUI.getHiddenInputData();
            let displayPurchaseAreaYn = true;
            let modelPartnerGrp = inputdata.partnerGrp;
            let employeeDisplayYn= false;
            let displaySmartHomeBuybtn = inputdata.displaySmartHomeBuybtn;

            var buyDisplayYN = "N";

            if(modelPartnerGrp.indexOf(self.default_partner_grp) > -1) {
                buyDisplayYN = "Y";
            }

            if(lgkorUI.stringToBool(loginFlag) && !vcui.isEmpty(self.memberPartnerGrp) && self.memberPartnerGrp != self.default_partner_grp) {

                // B2C 회원이 아닌경우 : 모델그룹에 멤버 그룹에 포함된 경우 구매영역 노출, 임직원/복지몰가 노출
                if(modelPartnerGrp.indexOf(self.memberPartnerGrp) > -1){
                    buyDisplayYN = "Y";

                    //var checkEmployeeIntervalTimer = setInterval(function() {
                        try {
                            //if (this.isSetTimeDealExcuted) {
                                // 임직원/복지몰 가격 정보 있으며, 딜 제품이 아닌 경우 노출 (이벤트 처리시 class 로 제어 하므로 동일 요소는 삭제 처리)
                                if(self.partnerPrice > 0 && !lgePdpSendData.isTimeDeal) {
                                    var $priceArea;
                                    var $priceTotalArea;
                                    var partnerEmpYN = "N";
                                    var $percentArea;
                                    var $maxBenefitPrice;
                                    var $partnerPricePopupArea; //파트너 할인가
                                    var $partnerApprDateDiscountAmtPopupArea; //파트너 결제일 할인
                                    var $partnerLastBenefitPricePopupArea; //파트너 최대혜택가
                                    var $partnerRewardAmtPopupArea; //파트너 캐시백
                                    var $partnerApprDateDiscountRatePopupArea; //파트너 결제일 할인율
                                    var $partnerMaxBenefitArea;
                                    var $partnerCouponPopupLink;

                                    // 임직원으로 표시 or 복지몰로 표시 여부 확인
                                    if (self.emp_partner_grp.indexOf(self.memberPartnerGrp) > -1) {
                                        partnerEmpYN = "Y";
                                        $priceTotalArea = $('#employeePriceTotalArea .content .payment .price');
                                    } else {
                                        $priceTotalArea = $('#partnerPriceTotalArea .content .payment .price');
                                    }

                                    // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
                                    $priceArea = $('#employeeTabDiscountPrice .content .price');
                                    $percentArea = $('#employeeTabDiscountPrice .content .percent');
                                    $maxBenefitPrice = $('#employeeTabBenefitPrice .content .maxBenefitPrice');
                                    $partnerPricePopupArea = $("#employeeTabMaxBenefitPopup .Employees-discounts-price, #employeeTabCouponPricePopup .Employees-discounts-price");
                                    $partnerApprDateDiscountAmtPopupArea = $("#employeeTabMaxBenefitPopup .appr-date-discount-rate");
                                    $partnerLastBenefitPricePopupArea = $("#employeeTabMaxBenefitPopup .last-benefit-price");
                                    $partnerRewardAmtPopupArea = $("#employeeTabMaxBenefitPopup li.partner-cash-back");
                                    $partnerApprDateDiscountRatePopupArea = $("#employeeTabMaxBenefitPopup li.partner-appr-date-discount");
                                    $partnerMaxBenefitArea = $("#employeeTabBenefitPrice");
                                    $partnerCouponPopupLink = $("#employeeTabCouponPopupSelector");

                                    $priceArea.html('<em class="blind">가격</em>'+ vcui.number.addComma(self.partnerPrice) + '원'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0  : 가격 em 태그 제거 및 숨김 텍스트 추가
                                    $priceTotalArea.html('<em>' + vcui.number.addComma(self.partnerPrice * parseInt($('div.pdp-info-area .payment-amount input.quantity').val())) +  '</em>원');
                                    $percentArea.html('<em class="blind">'+'할인율'+'</em>'+vcui.number.addComma(self.partnerDiscountRate) + '%');// BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0  : 숨김 텍스트 추가

                                    // 쿠폰할인가 포함 임직원 최대혜택가 적용
                                    if ($maxBenefitPrice.data('coupon-add-price') == 'N') {
                                        $maxBenefitPrice.html('<em>' + vcui.number.addComma(self.partnerLastBenefitPrice) + '</em>원');
                                        $partnerLastBenefitPricePopupArea.text(vcui.number.addComma(self.partnerLastBenefitPrice) + '원');
                                    }
                                    $partnerPricePopupArea.text(vcui.number.addComma(self.partnerPrice) + '원');
                                    $partnerApprDateDiscountAmtPopupArea.text('-'+vcui.number.addComma(self.partnerApprDateDiscountAmt)+'원');
                                    $partnerRewardAmtPopupArea.find('.won').text('-'+vcui.number.addComma(self.partnerRewardAmt)+'원');
                                    $partnerApprDateDiscountRatePopupArea.find('.txt').text('결제일 할인 '+self.partnerApprDateDiscountRate+'% (최대)');

                                    if(self.partnerRewardAmt > 0) {
                                        $partnerRewardAmtPopupArea.show();
                                    } else {
                                        $partnerRewardAmtPopupArea.hide();
                                    }

                                    if(self.partnerApprDateDiscountRate > 0) {
                                        $partnerApprDateDiscountRatePopupArea.show();
                                    } else {
                                        $partnerApprDateDiscountRatePopupArea.hide();
                                    }

                                    if (self.partnerRewardAmt > 0 || self.partnerApprDateDiscountAmt > 0) {
                                        $partnerCouponPopupLink.removeAttr('href');
                                        $partnerCouponPopupLink.removeClass('link-text');
                                        $partnerCouponPopupLink.off("click");
                                        $partnerMaxBenefitArea.show();
                                    } else {
                                        $partnerMaxBenefitArea.hide();
                                    }

                                    // 임직원 전용 상품인 경우 일반회원 탭 노출 제거
                                    if (modelPartnerGrp.indexOf("B2C") < 0) {
                                        // 탭 영역 이동 이벤트 삭제
                                        $('#b2cTab').on('click', function(e) {
                                            $('#employeePriceTabArea').find('div.tabs-wrap.ui_tab').off('click');
                                        });
                                        $('#b2cTab').html('<button type="button" data-href="#emppop01" data-control="modal"><p class="tabs-title">일반회원 할인가</p></button>');
                                        $('#b2cTabArea').remove();
                                    }

                                    // 임직원/복지몰 탭 상단 가격 변경
                                    $('#employeeTab .tabs-price').html('<em>' + vcui.number.addComma(self.partnerPrice) + '</em>원');

                                    // 임직원/복지몰 프로모션 뱃지 세팅
                                    $('span[id^="b2cBadge"]').hide();
                                    if(self.partnerBoldBadgesArr && self.partnerBoldBadgesArr.length > 0 && $('span[id^="employeeBadge"]').length == 0){
                                        let boldBadges = self.partnerBoldBadgesArr.map(function(item, index, array) {
                                            if(index < 2){
                                                let template = '<span class="flag imp" id="employeeBadge_' + index + '">' + item.badgeName + '</span>';
                                                return template;
                                            }
                                        }).join('');

                                        $('#badgeArea').append(boldBadges);
                                    } else {
                                        if ($('#badgeArea').find('span').not('span[id^="b2cBadge"]').length > 0 && $('span[id^="b2cBadge"]').length > 0) {
                                            $('#badgeArea').prepend($('span[id^="b2cBadge"]'));
                                        }
                                    }

                                    // 임직원인 경우 임직원/B2C 각각의 가격에 따라 구매 혜택 안내 > 결제일 할인 노출 여부를 별도 처리
                                    let buyBenefitInfoPurchase = $('#buyBenefitInfoPurchase');
                                    if (buyBenefitInfoPurchase.length > 0) {
                                        let minOrdAmtComp = Number(buyBenefitInfoPurchase.data("min-ord-amt"));

                                        if ((self.partnerPrice >= minOrdAmtComp)
                                            && ( ((self.obsOriginalPrice > 0) && self.obsOriginalPrice - self.partnerPrice > 0 )
                                                || buyBenefitInfoPurchase.data("original_member_equals_models") == 'Y')
                                        ) {
                                            self.displayBenefitPurchaseArea(true);
                                            buyBenefitInfoPurchase.data("employee_purchase_yn","Y");
                                        } else {
                                            self.displayBenefitPurchaseArea(false);
                                            buyBenefitInfoPurchase.data("employee_purchase_yn","N");
                                        }
                                    }

                                    // 임직원/복지몰 렌탈 경로 개선 영역 설정
                                    if (self.partnerRentalDirectInfoArr.length > 0 && $('#rentalDirectinfoListEmployee li').length == 0) {
                                        self.employeeRentalDirectInfoSetting(self.partnerRentalDirectInfoArr);
                                        $('#rentalDirectinfoList').hide();
                                        $('#rentalDirectinfoListEmployee').show();
                                    }

                                    // 임직원 영역 노출
                                    if (partnerEmpYN == "Y") {
                                        $('#partnerTooltipArea').remove();
                                        $('#employeePriceTotalArea').show();
                                        $('.is-popup-cont-welfare').remove();
                                        $('#actionSheetDiscountType').text('임직원 할인');

                                    // 복지몰 영역 노출
                                    } else {
                                        // 임직원 -> 복지몰 탭명 및 툴팁 텍스트 변경
                                        $('#employeePriceTabArea .disp-member-type').each(function() {
                                            let text = $(this).html();
                                            $(this).html(text.replace('임직원', '복지몰'));
                                        });

                                        // 임직원 -> 복지몰 최대혜택가 팝업 텍스트 변경
                                        $('#employeeTabMaxBenefitPopup').html($('#employeeTabMaxBenefitPopup').html().replace('임직원', '복지몰'));

                                        // 임직원 -> 복지몰 전용 상품 팝업 & 쿠폰팝업 텍스트 변경
                                        $('#emppop01').html($('#emppop01').html().replace('임직원', '복지몰'));
                                        $('#employeeCouponPopup span').text('복지몰');
                                        $('#employeeTabCouponPricePopup').html($('#employeeTabCouponPricePopup').html().replace('임직원', '복지몰'));

                                        $('#employeeTooltipArea').remove();
                                        $('.is-popup-cont-member').remove();
                                        $('#partnerPriceTotalArea').show();
                                        $('#actionSheetDiscountType').text('복지몰 할인');
                                    }

                                    // $('#actionSheetDiscountType').css("display","");
                                    $('li.lists.member.pdp-tolltip-new').removeClass('pdp-tolltip-new'); // 임직원가격탭 노출일 경우 별도 CSS 적용을 위함
                                    $('#employeePriceTabArea').show();

                                    // 회원할인가 존재하는 경우 일반회원 탭 노출 가격 변경
                                    if ($('#b2cTabArea .type-small-dept').length > 0 && $('#memberDiscountPrice').text().length > 0) {
                                        let dispArea = $('#b2cTab .tabs-title').html();
                                        $('#b2cTab .tabs-title').html(dispArea.replace('판매가', '할인가'));
                                        $('#b2cTab .tabs-price').html('<em class="blind">가격</em> <em>' + $('#memberDiscountPrice').text() + '</em>원');
                                    }

                                    // 바텀영역 일반 쿠폰할인가 비노출
                                    $('.total-coupon-payment').hide();

                                    $('#b2cPriceArea').remove();
                                    employeeDisplayYn = true;

                                    KRP0008.bottomFoldAreaControl('Y');
                                } else {
                                    $('#employeePriceTabArea').remove();
                                    $('.emp-price-info.is-price-calc-new').remove();
                                    $('.emp-price-info.is-coupon-price-calc-new').remove();
                                }
                           // }
                            //self.interValStop(checkEmployeeIntervalTimer);
                        } catch (e) {
                            //self.interValStop(checkEmployeeIntervalTimer);
                        }
                    //}, 200);
                }
            }

            //일반상품에 대해서만 체크
            if (lgePdpSendData.bizTypeDetail === "PRODUCT" && (buyDisplayYN !== "Y" || displaySmartHomeBuybtn === "N")) {
                displayPurchaseAreaYn = false;
            }

            // 일반일 경우 뱃지 노출
            if (!employeeDisplayYn && lgePdpSendData.bizTypeDetail !== "DISPOSABLE") {
                $('span[id^="b2cBadge"]').show();
            }

            //영역 노출 비노출 여부
            if(displayPurchaseAreaYn){
                //일반상품과 일반회원 or 비회원 or 임직원 상품
                $('#productDetailOptionArea').show(); //구매영역
                $('#abnormalDetailOptionArea').hide(); // 구매영역
                $('#badgeArea').show(); //뱃지
                $('#productCompareArea').show(); //비교하기
                $('#topWishArea').show(); //위시리스트
                $('#paymentButtonArea').show(); //장바구니, 구매하기버튼 영역
                $('#extraBtn').show();      // KRP0009 영역 - 구매하기, 일시품절.. 버튼
            }else {
                //임직원 상품과 일반회원 or 비회원 제외한 경우
                $('#productDetailOptionArea').hide(); //구매영역
                if (displaySmartHomeBuybtn === "N") {
                    $('#abnormalDetailOptionArea').hide(); // 구매영역 숨김
                } else {
                    $('#abnormalDetailOptionArea').show(); // 구매영역
                }
                $('#badgeArea').hide(); //뱃지
                $('#productCompareArea').hide(); //비교하기
                $('#topWishArea').hide(); //위시리스트
                $('#paymentButtonArea').hide(); //장바구니, 구매하기버튼 영역
                $('#extraBtn').hide();      // KRP0009 영역 - 구매하기, 일시품절.. 버튼
            }

            /* BTOCSITE-80676 START */
            if (!self.$pdpInfoWrap.hasClass('isLoaded')) {
                self.$pdpInfoWrap.addClass('isLoaded');
            }
            /* BTOCSITE-80676 END */

            $('#pdp-notice-banner').addClass('active'); // KRP 63182

            //BTOCSITE-73832  제품 번들링 과제
            KRP0008.additionModel.additionInit();
        },

        /* 구매혜택 */
        displayBenefitPurchaseArea : function (chkVal) {
            if (chkVal == true) {
                $('#buyBenefitInfo').show();
                $('#buyBenefitInfoPurchase').show();
                /* BTOCSITE-75630 PLCC START */
                $('#buyBenefitInfoPlcc').length && $('#buyBenefitInfoPlcc').show();
                $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').length && $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').show();
                $('#buyBenefitInfoPopupNew').find('#tab06').length && $('#buyBenefitInfoPopupNew').find('#tab06').show();
                $('#shinhanBannerWrap').length && $('#shinhanBannerWrap').show();
                /* BTOCSITE-75630 PLCC END */
                $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="discount"]').show();
                $('#buyBenefitInfoPopupNew').find('#tab03').show();
            } else {
                if ($('#buyBenefitInfo').data("benefit_display_yn") == 'Y') {
                    // 구매헤택 노출대상이 결제일 할인만 있는경우 전체 비노출 그외인 경우 결제일 할인만 비노출
                    if($("#buyBenefitInfo").find("li").length == 1 && $('#buyBenefitInfoPurchase').length == 1) {
                        $('#buyBenefitInfo').hide();
                        $('#buyBenefitInfoPurchase').hide();
                        /* BTOCSITE-75630 PLCC START */
                        $('#buyBenefitInfoPlcc').length && $('#buyBenefitInfoPlcc').hide();
                        $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').length && $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').hide();
                        $('#buyBenefitInfoPopupNew').find('#tab06').length && $('#buyBenefitInfoPopupNew').find('#tab06').hide();
                        $('#shinhanBannerWrap').length && $('#shinhanBannerWrap').hide();
                        /* BTOCSITE-75630 PLCC END */
                        $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="discount"]').hide();
                        $('#buyBenefitInfoPopupNew').find('#tab03').hide();
                    } else {
                        $('#buyBenefitInfo').show();
                        $('#buyBenefitInfoPurchase').hide();
                        /* BTOCSITE-75630 PLCC START */
                        $('#buyBenefitInfoPlcc').length && $('#buyBenefitInfoPlcc').hide();
                        $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').length && $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').hide();
                        $('#buyBenefitInfoPopupNew').find('#tab06').length && $('#buyBenefitInfoPopupNew').find('#tab06').hide();
                        $('#shinhanBannerWrap').length && $('#shinhanBannerWrap').hide();
                        /* BTOCSITE-75630 PLCC END */
                        $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="discount"]').hide();
                        $('#buyBenefitInfoPopupNew').find('#tab03').hide();
                    }
                } else {
                    $('#buyBenefitInfo').hide();
                }
            }
            
        },
        //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
        displayBenefitPointArea : function(partnerType){
            if(partnerType){
                if(partnerType === 'B2C'){

                    let b2cPoint = $("#buyBenefitInfoPoint .benefit-text").data('b2cPoint');
                    if(b2cPoint && b2cPoint.length > 1){
                        $("#buyBenefitInfoPoint .benefit-text").text("최대 "+b2cPoint+" 멤버십 포인트 적립");
                        $("#buyBenefitInfoPoint").show();

                        $("#buyBenefitInfoPopupNew .pop-body div[data-content-name='point'] p").text("최대 "+b2cPoint+" 멤버십 포인트 적립");
                        $("#buyBenefitInfoPopupNew .tabs li[data-active-target='point']").show();
                    }else{
                        $("#buyBenefitInfoPoint").hide();
                        $("#buyBenefitInfoPopupNew .tabs li[data-active-target='point']").hide();
                    }
                }else{
                    // 포인트
                    let employeePoint = $("#buyBenefitInfoPoint .benefit-text").data('employeePoint');
                    if(employeePoint && employeePoint.length > 1){
                        $("#buyBenefitInfoPoint .benefit-text").text("최대 "+employeePoint+" 멤버십 포인트 적립");
                        $("#buyBenefitInfoPoint").show();

                        $("#buyBenefitInfoPopupNew .pop-body div[data-content-name='point'] p").text("최대 "+employeePoint+" 멤버십 포인트 적립");
                        $("#buyBenefitInfoPopupNew .tabs li[data-active-target='point']").show();

                        $("#employeeTabMaxBenefitPopupPoint").text("+ 구매시, LG전자 멤버십 포인트 "+employeePoint+" 원 적립");
                        $("#employeeTabMaxBenefitPopupPoint").show();
                    }else{
                        $("#buyBenefitInfoPoint").hide();
                        $("#buyBenefitInfoPopupNew .tabs li[data-active-target='point']").hide();
                        $("#employeeTabMaxBenefitPopupPoint").hide();
                    }


                    let benefitsCnt = $("#employeeTabMaxBenefitPopup .additional-benefits li").filter(function() {
                        return $(this).css('display') !== 'none';
                    }).length;
                    if(benefitsCnt > 0){
                        $("#employeeTabMaxBenefitPopup .additional-benefits").show();
                    }else{
                        $("#employeeTabMaxBenefitPopup .additional-benefits").hide();
                    }
                }
            }
        },

        /* 임직원 소모품 할인가 BTOCSITE-60292 */
        displayDisposalbeEmployeeArea : function () {
            var self = this;

            if(lgkorUI.stringToBool(loginFlag) && !vcui.isEmpty(self.memberPartnerGrp) && self.memberPartnerGrp != self.default_partner_grp){
                if(self.partnerPrice > 0 && self.partnerPrice < memberDiscountPrice){
                    var $priceArea;
                    var $priceTotalArea;
                    var $percentArea;
                    var $employeePrice = $('.is-price-calc-new .payment .price');
                    // 임직원으로 표시 or 복지몰로 표시 여부 확인
					var actionSheetDiscountTypeName = (self.emp_partner_grp.indexOf(self.memberPartnerGrp) > -1 ? '임직원' : '복지몰') +' 할인';
					$('#actionSheetDiscountType').text(actionSheetDiscountTypeName);
                    // $('#actionSheetDiscountType').css("display","");

                    $('#employeeDisposableArea').css('display', 'block');
                    $('#employeeDisposableTotalPriceArea').css('display', 'block');
                    $priceArea = $('#employeeDisposablePriceArea .content .price');
                    $percentArea = $('#employeeDisposablePriceArea .content .percent');


                    $priceArea.html('<em class="blind">가격</em><em>' + vcui.number.addComma(self.partnerPrice) + '</em>원');
                    $percentArea.html('<em class="blind">할인율</em>'+Math.floor((Number(self.obsOriginalPrice)-Number(self.partnerPrice))/Number(self.obsOriginalPrice)*100.0) + '%');
                    
                    $employeePrice.html('<em>' + vcui.number.addComma(self.partnerPrice * parseInt($('div.pdp-info-area .payment-amount input.quantity').val())) + '</em>원'); // BTOCSITE-70412

                    //BTOCSITE-68092 소모품 임직원 쿠폰 ( 임직원일시 탭 활성화
                    $('#employeeDisposableTab').css('display', 'block');
                    $('#employeeDisposableArea').css('display', 'none');
                    $('#priceArea').css('display', 'none');
                    $tabArea = $('#employeeDisposableTabArea .tabs-price .employee');
                    $tabArea.text(vcui.number.addComma(self.partnerPrice) + '원');

                    $tabPriceArea = $('#employeeDisposableTabPriceArea .content .price');
                    $tabPercentArea = $('#employeeDisposableTabPriceArea .content .percent');

                    $tabPriceArea.html('<em class="blind">가격</em>'+vcui.number.addComma(self.partnerPrice) + '원');
                    $tabPercentArea.html('<em class="blind">할인율</em>'+Math.floor((Number(self.obsOriginalPrice)-Number(self.partnerPrice))/Number(self.obsOriginalPrice)*100.0) + '%');

                    $priceTotalArea = $('#employeeDisposableTotalPriceArea .content .price');
                    $priceTotalArea.text(vcui.number.addComma(self.partnerPrice) + '원');

                    if(Math.floor((Number(self.obsOriginalPrice)-Number(self.partnerPrice))/Number(self.obsOriginalPrice)*100.0) < 1){
                        $percentArea.remove();
                    }else{
                        $percentArea.show();
                    }

                    $('span[id^="b2cBadge"]').hide();
                    if(self.partnerBoldBadgesArr && self.partnerBoldBadgesArr.length > 0 && $('span[id^="employeeBadge"]').length == 0){
                        let boldBadges = self.partnerBoldBadgesArr.map(function(item, index, array) {
                            if(index < 2){
                                let template = '<span class="flag imp" id="employeeBadge_' + index + '">' + item.badgeName + '</span>';
                                return template;
                            }
                        }).join('');

                        $('#badgeArea').append(boldBadges);
                    }
                    // 바텀영역 일반 쿠폰할인가 비노출
                    $('.total-coupon-payment').hide();

                    KRP0008.bottomFoldAreaControl('Y');
                }
            }
        },

		setCookie: function(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + value + expires + "; path=/";
		},

        //BTOCSITE-46911 : 임직원 전용제품 구매하기 버튼 적용하기 위한 처리
        displayEmployeeBuyBtn : function () {
            var self = this;
            try {
                self.checkIntervalCount++;
                if(self.checkIntervalCount < 20) {
                    if ($("#contentLoading").is(':visible') == false) {
                       self.displayEmployeeArea();
                        self.interValStop(self.checkIntervalTimer);
                    }
                } else {
                    $('#extraBtn').hide();
                    self.interValStop(self.checkIntervalTimer);
                }
            } catch (e) {
                $('#extraBtn').hide();
                self.interValStop(self.checkIntervalTimer);
            }
        },
        interValStop : function(timer){
            clearInterval(timer);
        },

        // (BTOCSITE-44432 | PDP 진입시 모델정보 세션 저장)
        defaultValueInit: function() {
            var data = { 'modelId' : lgePdpSendData.modelId, 'categoryId' : lgkorUI.getHiddenInputData().defaultCategoryId};
            lgkorUI.setStorage("recent_view_pdp_info", data);
        },

        // BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
        disposablePaymentButtonInit:function (code , message) {
            let bizType = lgkorUI.getHiddenInputData().bizType;

            //메세지 코드와 구성 코드 값을 받아서 추후 공통으로 사용 가능
            let param = {
                code:code,
                message : message
            };

            try {
                lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/isDisplayPaymentButtonArea", {
                    method: "POST",
                    data: param,
                    success: function (result) {
                        let displayFlag = result.data.flag
                        // 소모품 외에 적용 할려면 삼항 조건문 삭제
                        purchaseButtonDisplay = (bizType === "DISPOSABLE") ? displayFlag : "Y";
                        if (displayFlag === "N") {
                            purchaseButtonMassage = result.data.message;
                        }
                    },
                    error: function (e) {
                        console.log(e);
                    }
                });
            }catch (e) {
                console.log(e)
            }
        },

        // BTOCSITE-49751 [상품] 딜 플랫폼
        setTimeDeal: function () {
            var self = this; //  BTOCSITE-89574
            try {
                let timeDealProduct = null;
                let endDateTime;

                let param = {
                    "modelId": lgePdpSendData.modelId,
                    "modelStatusCode": lgePdpSendData.modelStatusCode
                };
                //  BTOCSITE-89574 START
                var $timeDealPcTemplate = $('#time-deal-area-pc');
                var $timeDealMoTemplate = $('#time-deal-area-mo');
                var $timeDealAreaPc = $($timeDealPcTemplate.html());
                var $timeDealAreaMo = $($timeDealMoTemplate.html());
                //  BTOCSITE-89574 END

                lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrieveDealProduct", {
                    data: param,
                    method: 'POST',
                    success: function (result) {
                        var timeDealProduct = result.data.dealProductModel; //  BTOCSITE-89574

                        if (timeDealProduct != null && timeDealProduct.modelId !== undefined && timeDealProduct.modelId !== null) {
                            lgePdpSendData.isTimeDeal = true;

                            $('#memberPrice').css('display', 'none');
                            $('#timeDealPrice').css('display', 'block');

                            let timeDealInfo = {
                                isTimeDealSoldOut: false,
                                remainingCount: '',
                                remainingDay: '',
                            };

                            //  BTOCSITE-89574 START
                            var modelStatusCodeValue = self.$pdpInfo.attr('data-model-status-code');
                            if ((timeDealProduct.dealInventoryQty == 0 && 'ACTIVE' == modelStatusCodeValue) || (timeDealProduct.dealInventoryQty > 0 && 'SOLD_OUT' == modelStatusCodeValue)) {
                                /* 만약 이 두 가지 경우 중 하나에 해당된다면 (비정상)
                                1. 구매하기 버튼 상태를 일시품절 버튼으로 변경합니다.
                                2. 아래 이미지와 같이 타임딜 영역의 UI를 비노출하게 처리합니다. */
                                timeDealProduct.timeDealSoldOut = true;

                            }
                            //  BTOCSITE-89574 END 

                            if (timeDealProduct.timeDealSoldOut) { // BTOCSITE-89574
                                $timeDealAreaPc.addClass('soldout');
                                $timeDealAreaMo.addClass('soldout');

                                timeDealInfo.isTimeDealSoldOut = timeDealProduct.timeDealSoldOut; // BTOCSITE-89574

                            
                                // BTOCSITE-89574 START
                                //KRP0008.$pdpInfo.find('div.purchase-button.pre-order button.btn.oneLineBtn').prop('disabled', true).addClass('disabled').find('span').text('일시품절');
                                var btnBuyNow = KRP0008.$pdpInfo.find('div.purchase-button.pre-order button.btn.oneLineBtn');
                                if (btnBuyNow.length == 0) {
                                    btnBuyNow = self.$pdpInfo.find('div.purchase-button a:not(.cart, .btn-cart, .btnTelCall, .black, .soldOk, .ai )');
                                }
                                btnBuyNow.prop('disabled', true).addClass('disabled').find('span').text('일시품절');
                                // BTOCSITE-89574 END

                            } else {
                                timeDealInfo.remainingCount = timeDealProduct.dealInventoryQty + '개 남음';

                                endDateTime = new Date(timeDealProduct.endDate);

                                // BTOCSITE-55771 타임딜
                                const current = new Date();
                                const utc = current.getTime() + (current.getTimezoneOffset() * _MINUTE);
                                const currentKRDateTime = new Date(utc + (KR_TIME_DIFF));

                                let remainingTime = endDateTime - currentKRDateTime;
                                if (remainingTime > _DAY) {
                                    let days = Math.floor(remainingTime / _DAY);
                                    // BTOCSITE-72837 START
                                    timeDealInfo.remainingDay = "D-" + days;
                                    // BTOCSITE-72837 END
                                }

                                clearInterval(timeDealTimer);
                                timeDealTimer = setInterval(function () {
                                    KRP0008.calculateRemainingTime(endDateTime, $('.time-deal-area > span.time'));
                                }, 1000);
                            }
                            // BTOCSITE-61287 START
                            $(".time-deal-area.no-timedeal").hide().promise().then(function () {
                                $timeDealAreaPc.append(vcui.template(timeDealInnerTemplate, timeDealInfo));
                                $timeDealAreaMo.append(vcui.template(timeDealInnerTemplate, timeDealInfo));

                                $timeDealPcTemplate.after($timeDealAreaPc);
                                $timeDealMoTemplate.after($timeDealAreaMo);

                                // BTOCSITE-58033 START
                                let showMoreButtonElement = document.getElementsByClassName('time-deal-area pc')[0].getElementsByTagName('a')[0];
                                showMoreButtonElement.setAttribute('style', 'display: none');
                                let isActiveShowMore = timeDealProduct.isActiveShowMore;
                                if (!isActiveShowMore) {
                                    showMoreButtonElement.setAttribute('style', 'display: none');
                                } else {
                                    showMoreButtonElement.setAttribute('style', 'display: unset');
                                }
                                //e BTOCSITE-58033 END
                            });
                            // BTOCSITE-61287 END

                            // BTOCSITE-54300 딜플랫폼 딜재고차감 및 주문/결제 프로세스 개선 건
                            KRP0008.$pdpInfo.find('div.purchase-button.default div.btn-group a.btn.cart').css('display', 'none'); // 장바구니 버튼 미노출
                            KRP0008.$pdpInfo.find('div.box.payment-amount.count-check > div.info-text > p.time-deal-info').css('display', 'block'); // 타임딜 안내 문구 노출
                        }
                    },
                    error: function (e) {
                        console.log(e);
                    }
                });
            } catch (e) {
                console.log(e);
            }
        },

        // 1초 타이머
        calculateRemainingTime: function(targetDateTime, targetElement) {
            try {
                const current = new Date();
                const utc = current.getTime() + (current.getTimezoneOffset() * _MINUTE);
                const currentKRDateTime = new Date(utc + (KR_TIME_DIFF));

                let remainingTime = targetDateTime - currentKRDateTime;

                if (remainingTime > _DAY) {
                    clearInterval(timeDealTimer);
                } else {
                    if (remainingTime <= 0) {
                        clearInterval(timeDealTimer);
                    } else {
                        let hours = Math.floor((remainingTime % _DAY) / _HOUR);
                        let minutes = Math.floor((remainingTime % _HOUR) / _MINUTE);
                        let seconds = Math.floor((remainingTime % _MINUTE) / _SECOND);

                        hours = hours < 10 ? "0" + hours : hours;
                        minutes = minutes < 10 ? "0" + minutes : minutes;
                        seconds = seconds < 10 ? "0" + seconds : seconds;

                        targetElement.text(hours + ":" + minutes + ":" + seconds);
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },

        // 구매하기 버튼 영역 // BTOCSITE-68538 [모니터링 G][APP] Chatbot 아이콘 위에 Top버튼이 노출
        setPaymentBtnArea: function () {
            var self = this;

            if (self.$actionSheetCallBtn && self.$actionSheetCallBtn.length > 0) {
                var areaH = 0;
                var $rentalSheet = self.$actionSheet.filter('.rental-sheet');

                // 구독 월 요금영역 존재하면 높이 추가
                if ($rentalSheet.length > 0) areaH += $rentalSheet.outerHeight();

                var floatingWrap = document.querySelector(".floating-wrap");
                var btnFloatingWrap = document.querySelector(".btn-floating-wrap");
    
                // [S] BTOCSITE-82293 사업자몰(B2B)구독 도입 // top버튼 위치 수정
                if (window.breakpoint.isMobile) {
                    areaH += self.$actionSheetCallBtn.outerHeight();
                    if (floatingWrap) floatingWrap.style.setProperty('--bottom', areaH + 'px');
                    if (btnFloatingWrap) btnFloatingWrap.style.setProperty('--bottom', areaH + 'px');
                } else {
                    if (floatingWrap) floatingWrap.style.removeProperty('--bottom');
                    if (btnFloatingWrap) btnFloatingWrap.style.removeProperty('--bottom');
                }
                // [E] BTOCSITE-82293 사업자몰(B2B)구독 도입 // top버튼 위치 수정
            }
        },

        b2bCartCheck: function() {     // b2b일 때 장바구니 체크
            var self = this;

            if(lgkorUI.stringToBool(loginFlag)){

                if(self.memberPartnerGrp === "ENT") { //사업자회원(승인 완료)
                    return true;
                } else if(self.memberPartnerGrp === 'B2C' || self.bsnsMbrStat === 'WAIT') { //B2C회원(사업자회원 승인대기)
                    $('#businessMembershipMoreAlert4').vcModal({opener: document.activeElement}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    return false;
                } else { // 일반회원 (b2c 회원 외에 임직원 계정도 b2b에서는 일반회원 취급)
                    $('#businessMembershipMoreAlert3').vcModal({opener: document.activeElement}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    return false;
                }
            }else{
                $('#businessMembershipMoreAlert2').vcModal({opener: document.activeElement}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                return false;
            }
        },

        //BTOCSITE-48266 [상품] B2B OBS 구축 start
        b2bLoginCheck: function(e) {     // b2b일 때 로그인 체크
            var self = this;
            var opener = $(e.currentTarget).length ? e.currentTarget : ''; // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
            
            // BITCSITE-85521
            if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "CARETAB"){
                if (lgkorUI.stringToBool(loginFlag)) {
                    if(self.bsnsMbrStat === 'WAIT') {//B2C회원(사업자회원 승인대기)
                        $('#businessMembershipMoreAlert4').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    } else if(self.memberPartnerGrp === 'B2C'){
                        $('#businessMembershipMoreAlert3').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    } else if (self.bsnsMbrStat === 'USE') {
                        if (self.bsnsMbrUpdStat === 'UPD') {
                            let className = e.currentTarget.className;
                            if(className.indexOf("btn black") != -1){         // 견적문의 엑션시트
                                return true;
                            } else if(className.indexOf("cart") != -1){       // 장바구니 담기는 수정승인 체크 안함
                                return true;
                            } else if(className.indexOf("link-area") != -1){  // 견적문의 배너 버튼
                                return true;
                            } else{
                                $('#businessMembershipMoreAlert6').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                                return false
                            }
                        } else if (self.bsnsType === 'ENT' && !self.rprsnNm.includes(self.mbrName)) {
                            $('#businessMembershipMoreAlert5').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        $('#businessMembershipMoreAlert3').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    }
                } else {
                    $('#businessMembershipMoreAlert2').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                    return false;
                }
            }else{
                if(lgkorUI.stringToBool(loginFlag)){

                    if(self.bsnsMbrStat === 'WAIT') {//B2C회원(사업자회원 승인대기)
                        $('#businessMembershipMoreAlert4').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    } else if(self.memberPartnerGrp === 'B2C'){
                        $('#businessMembershipMoreAlert3').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    } else if (self.bsnsMbrStat === 'USE') {
                        return true;
                    } else { // 일반회원 (b2c 회원 외에 임직원 계정도 b2b에서는 일반회원 취급)
                        $('#businessMembershipMoreAlert3').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    }
                }else{
                    $('#businessMembershipMoreAlert2').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                    return false;
                }
            }
        },

        // 가격영역, 액션시트, 장바구니,구매하기 버튼 영역
        displayB2bPriceArea : function () {
            var self = this;
            let inputdata = lgkorUI.getHiddenInputData();
            let modelPartnerGrp = inputdata.partnerGrp;
            let displaySmartHomeBuybtn = inputdata.displaySmartHomeBuybtn;

            $('#noneBusinessProductDetail').hide(); // LGE.COM에서는 제품정보만 제공하고 있습니다. 문구
            $('#businessBadgeArea').show(); // 뱃지영역
            $('#businessCompareArea').show(); //비교하기버튼
            $('#businessProductDetail').show();//가격영역
            $('#actionSheetCall').show();
            if(displaySmartHomeBuybtn === "N"){
                $('#extraBtn').hide();
            }else{
                $('#extraBtn').show();
            }

            if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "CARETAB"){            // b2b 구독
                if(lgkorUI.stringToBool(loginFlag) && self.bsnsType == 'ENT' && self.bsnsMbrStat == 'USE'){
                    $('#b2bBenefitsPrice').show();
                    $('#b2bBenefitsInfo').show();
                    $('#b2bPriceLogin').show();
                    $('#b2bPriceMbLogin').show();
                    $('#b2bRentalPriceInfoDisp').show();
                    $('#b2bMbBestDiscountPrice').show();
                }else{
                    $('#b2bBenefitsPrice').hide();
                    $('#b2bBenefitsInfo').hide();
                    $('#b2bRentalPriceInfoDisp').hide();
                    $('#b2bMbBestDiscountPrice').hide();
                }

                if(lgkorUI.stringToBool(loginFlag)){
                    $('#b2bPriceInfoNonLogin').hide();
                    $('#b2bPriceInfoMbNonLogin').hide();
                    $('#b2bPriceInfoLogin').show();
                    $('#b2bPriceInfoMbLogin').show();
                    if(self.memberPartnerGrp === 'B2C' || self.bsnsMbrStat === 'WAIT') {//B2C회원(사업자회원 승인대기)
                        $('#b2bPriceInfoNonLogin').show();
                        $('#b2bPriceInfoMbNonLogin').show();
                        $('#b2bPriceInfoLogin').hide();
                        $('#b2bPriceInfoMbLogin').hide();
                    }
                    if(self.bsnsType == 'CORP'){
                        $('#b2bPriceLogin').show();
                        $('#b2bPriceInfoMbLogin').hide();       // 모바일은 가격을 보여주지 않음.
                        $('#b2bPriceMbLogin').hide();       // 모바일은 가격을 보여주지 않음.
                    }
                }else{
                    $('#b2bPriceInfoLogin').hide();
                    $('#b2bPriceInfoMbLogin').hide();
                    $('#b2bPriceInfoNonLogin').show();
                    $('#b2bPriceInfoMbNonLogin').show();
                }

                if(self.memberPartnerGrp === 'B2C'){
                    $('#b2bPriceInfoLogin').hide();
                    $('#b2bPriceInfoMbLogin').hide();
                    $('#b2bPriceInfoNonLogin').show();
                    $('#b2bPriceInfoMbNonLogin').show();
                }
            }else if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "PRODUCT"){      // b2b 일시불
                if(self.memberPartnerGrp === 'ENT'){
                    //로그인
                    if(lgkorUI.stringToBool(loginFlag)){
                        $('#businessPriceAreaNoneLogin').hide();
                        $('#totalPaymentNoneLogin').hide();
                        $('#totalPaymentLogin').show();
                        $('#paymentCount').show();

                        if(Number(self.partnerPrice) > 0){
                            $('#businessPriceAreaLogin').show();
                            $('#actionSheetPopup').show();
                            $("[id^='b2bMonthPriceArea_']").show();
                            $("[id^='b2bMonthPriceAreaNonLogin_']").hide();

                            if(self.bsnsType == 'ENT' && self.bsnsMbrStat == 'USE'){
                                $("[id^='b2bMaxSalePriceArea_']").show();
                                $("[id^='b2bMonthPriceArea_']").show();
                                $("[id^='b2bMonthPriceAreaNonLogin_']").hide();
                            }else{
                                $("[id^='b2bMaxSalePriceArea_']").hide();

                                if(self.bsnsType == 'CORP'){
                                    $("[id^='b2bMonthPriceArea_']").show();
                                }else{
                                    $("[id^='b2bMonthPriceArea_']").hide();
                                    $("[id^='b2bMonthPriceAreaNonLogin_']").show();
                                }
                            }


                            $('#businessPriceText').text(vcui.number.addComma(self.partnerPrice) + '원');
                            $('#totalPayment').text(vcui.number.addComma(self.partnerPrice) + '원');

                            //견적문의
                            if(lgePdpSendData.modelStatusCode === "ACTIVE"){
                                self.displayB2bOnlineCounselArea();
                            }
                        }else{
                            if(lgePdpSendData.modelStatusCode === "READY_FOR_SALE"){
                                $('#readyForSaleNonePrice').show();
                                $('#businessProductDetail').hide();
                            }else if(lgePdpSendData.modelStatusCode === "SOLD_OUT"){
                                $('#businessProductDetail').hide();
                                $('#noneBusinessProductDetail').show();
                            }else if(lgePdpSendData.modelStatusCode === "ACTIVE"){
                                $('#noneBusinessProductDetail').show();
                                $('#businessProductDetail').hide();
                                $('#actionSheetCall').hide();
                            }
                        }

                        if(lgePdpSendData.modelStatusCode === "NOT_FOR_SALE"){
                            self.displayB2bOnlineCounselArea();
                        }
                    }else{
                        $('#totalPaymentLogin').hide();
                        $('#paymentCount').hide();
                        $("[id^='b2bMonthPriceAreaNonLogin_']").show();
                        //비로그인
                        if(lgePdpSendData.modelStatusCode === "READY_FOR_SALE"){
                            $('#noneBusinessProductDetail').hide();// LGE.COM에서는 제품정보만 제공하고 있습니다. 문구
                            $('#actionSheetCall').show();//장바구니, 구매하기 버튼

                            if(Number(self.partnerPrice) > 0){
                                $('#businessProductDetail').show(); //가격전체영역
                                $('#businessPriceAreaLogin').hide(); //가격영역
                                $('#readyForSaleNonePrice').hide();
                                $('#businessPriceAreaNoneLogin').show();
                            }else{

                                $('#readyForSaleNonePrice').show();
                                $('#businessProductDetail').hide();
                            }
                        }else if(lgePdpSendData.modelStatusCode === "SOLD_OUT"){
                            if(Number(self.partnerPrice) > 0){
                                $('#businessProductDetail').show();
                                $('#businessPriceAreaNoneLogin').show();
                            }else{
                                $('#businessProductDetail').hide();
                                $('#noneBusinessProductDetail').show();
                            }
                        }else if(lgePdpSendData.modelStatusCode === "ACTIVE"){
                            console.log(Number(self.partnerPrice))
                            if(Number(self.partnerPrice) > 0){
                                $('#totalPaymentNoneLogin').show();
                                $('#businessProductDetail').show();
                                $('#businessPriceAreaNoneLogin').show();
                                self.displayB2bOnlineCounselArea();
                            }else{
                                $('#totalPaymentNoneLogin').hide();
                                $('#businessProductDetail').hide();
                                $('#actionSheetCall').hide();
                                $('#noneBusinessProductDetail').show();// LGE.COM에서는 제품정보만 제공하고 있습니다. 문구
                            }
                        }else if(lgePdpSendData.modelStatusCode === "NOT_FOR_SALE"){
                            self.displayB2bOnlineCounselArea();
                        }
                    }
                }else{      //B2C 횡원
                    $("[id^='b2bMonthPriceAreaNonLogin_']").show();
                    // 가격이 0일 경우...
                    if(Number(self.partnerPrice) > 0){
                        if(lgePdpSendData.modelStatusCode === "READY_FOR_SALE"){
                            $('#readyForSaleNonePrice').hide();
                        }
                        if(lgePdpSendData.modelStatusCode === "ACTIVE" || lgePdpSendData.modelStatusCode === "NOT_FOR_SALE"){
                            self.displayB2bOnlineCounselArea();
                        }
                        $('#businessProductDetail').show(); //가격영역
                        $('#businessPriceAreaNoneLogin').show();
                        $('#businessPriceAreaLogin').hide();
                        $('#totalPaymentNoneLogin').show();
                        $('#totalPaymentLogin').hide();
                        $('#paymentCount').hide();
                    }else{
                        if(lgePdpSendData.modelStatusCode === "READY_FOR_SALE"){
                            $('#businessProductDetail').hide(); //가격영역
                            $('#readyForSaleNonePrice').show();
                        }else if(lgePdpSendData.modelStatusCode === "ACTIVE" || lgePdpSendData.modelStatusCode === "SOLD_OUT"){
                            $('#actionSheetCall').hide(); //가격영역
                            $('#businessProductDetail').hide(); //가격영역
                            $('#noneBusinessProductDetail').show();// LGE.COM에서는 제품정보만 제공하고 있습니다. 문구
                        }else if(lgePdpSendData.modelStatusCode === "NOT_FOR_SALE"){
                            $('#businessProductDetail').show(); //가격영역
                            self.displayB2bOnlineCounselArea();
                        }
                    }
                } //B2C 횡원
            } // b2b PRODUCT
        },

        //견적문의 하기 영역 노출 조건
        displayB2bOnlineCounselArea : function () {
            let inputdata = lgkorUI.getHiddenInputData();
            let modelPartnerGrp = inputdata.partnerGrp;
            let quoteInquiryFlag = inputdata.quoteInquiryFlag;

            //견적문의플래그 ="Y" and 상품판매대상이 일반+사업자, 사업자 경우 노출
            if(quoteInquiryFlag === "Y" &&  ((modelPartnerGrp.indexOf("B2C") > -1 && modelPartnerGrp.indexOf("ENT") > -1) || modelPartnerGrp === "ENT")){
                $('#onlineCounselArea').show();

            }else{
                $('#onlineCounselArea').hide();
            }
        },

        //클릭 이벤트
        b2bClickEventLoad: function (e) {
            $('#memberPriceLook .blt-arrow').unbind('click').bind('click',function(e){
                e.preventDefault();
                KRP0008.b2bLoginCheck(e);
            });

            $('#totalPaymentNoneLogin .blt-arrow').unbind('click').bind('click',function(e){
                e.preventDefault();
                KRP0008.b2bLoginCheck(e);
            });

            $('#businessMembershipLogin').unbind('click').bind('click',function(e){
                e.preventDefault();
                var loginUrl = "/sso/member/login?state=";
                var moveUrl = location.pathname + location.search;
                location.href = vcui.uri.updateQueryParam(
                    loginUrl,
                    "state",
                    encodeURIComponent(moveUrl)
                );
            });

            //일시불 베너
            $('#businessMembershipLoginMovePurchase').unbind('click').bind('click',function(e){
                e.preventDefault();
                let loginUrl = "/sso/member/login?state=";
                let moveUrl = $('#b2bLumpSumPurchase').data("url");
                location.href = vcui.uri.updateQueryParam(
                    loginUrl,
                    "state",
                    encodeURIComponent(moveUrl)
                );
            });

            //사업자 인증하기 화면
            $('#goCertification').unbind('click').bind('click',function(e){
                e.preventDefault();
                var moveUrl = location.pathname + location.search;
                var loginUrl = "/business/registration";
                location.href = vcui.uri.updateQueryParam(
                    loginUrl,
                    "state",
                    encodeURIComponent(moveUrl)
                );
            });

            // 온라인 견적문의 버튼
            $('#onlineCounsel .counsel-link').unbind('click').bind('click',function(e){
                e.preventDefault();
                //&qty=4 추가
                let url = $('#onlineCounsel').data("url");
                window.location.href = url;
            });

            // b2b 견적문의 버튼
            $('#b2bOnlineCounsel .link-area , #b2bCorpEstimate , #b2bCorpCounsel').unbind('click').bind('click',function(e){
                e.preventDefault();

                //&qty=4 추가
                let url = $('#b2bOnlineCounsel').data("url")+'&qty='+$('#quantity').val();
                console.log("businessCounsel" + url);
                let callBackValue = KRP0008.b2bLoginCheck(e);
                if(callBackValue){
                    if(isApp()) {
                        if(vcui.detect.isIOS){
                            window.location.href = url;
                        }else{
                            let openNewWindow = window.open("about:blank");
                            openNewWindow.location.href = url;
                        }
                    } else {
                        // let openNewWindow = window.open("about:blank");
                        // openNewWindow.location.href = url;
                        window.location.href = url;
                    }
                }
            });

            // 견적문의
            $('#businessCounsel').unbind('click').bind('click',function(e){
                e.preventDefault();
                let url = $('#b2bOnlineCounsel').data("url")+'&qty='+$('#quantity').val();

                if(isApp()) {
                    if(vcui.detect.isIOS){
                        window.location.href = url;
                    }else{
                        let openNewWindow = window.open("about:blank");
                        openNewWindow.location.href = url;
                    }
                } else {
                    window.location.href = url;
                }
            });

            // B2B 구독 일시불 구매
            $('#b2bLumpSumPurchase').unbind('click').bind('click',function(e){
                e.preventDefault();
                let url = $('#b2bLumpSumPurchase').data("url");
                if (lgkorUI.stringToBool(loginFlag)) {
                    window.location.href = url;
                }else{
                    $('#businessMembershipMoreAlertMovePurchase').vcModal({opener: this}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    return false;
                }
            });

        },
        //BTOCSITE-72646 START
        getTemplateContent: function (templateId) {
            const template = $('#promotionBadgeTemplate')[0];
            if (template) {
                const content = $(template.content).find(`#${templateId}`);
                return content.length ? content.html() : '';
            }
            return '';
        },
        appendTemplate: function (templateId, targetElement) {
            const templateContent = KRP0008.getTemplateContent(templateId);
            if (templateContent) {
                $(targetElement).append(templateContent);
            }
        },
        //BTOCSITE-72646 END
        //BTOCSITE-48266 [상품] B2B OBS 구축 end

        //[BTOCSITE-73060] 제품 PDP UI 개선 start
        // fold 영역 가격계산 및 control
        bottomFoldAreaControl : function(empYn){
            /**
             * displayEmployeeArea : 일반 상품정보 로딩시
             * displayDisposalbeEmployeeArea : 소모품 상품정보 로딩시
             * $('#employeePriceTabArea .tabs > li') : 일반 tab 선택시(임직원 /일반)
             * $('#employeeDisposableTab .tabs > li') : 소모품 tab 선택시(임직원 /일반)
             */
            let self = this;
            let foldPriceArea = $('#foldPriceArea');
            let partnerEmpYN = 'N';
            if(self.emp_partner_grp.indexOf(self.memberPartnerGrp) > -1){
                partnerEmpYN = 'Y';
            }
            if(foldPriceArea && foldPriceArea.length > 0){
                let foldAreaPrice = foldPriceArea.data('orgPrice');
                $('#totalFoldPriceEmployeeInfo').hide();
                if($('#totalFoldPriceBusinessInfo') && $('#totalFoldPriceBusinessInfo').length > 0){
                    $('#totalFoldPriceBusinessInfo').hide();
                }
                $('#totalFoldPriceInfo').hide();
                if(empYn == 'Y'){   //임직원/복지몰 tab
                    if (partnerEmpYN == "Y") {
                        $('#totalFoldPriceEmployeeInfo').show();
                        $('#actionSheetDiscountType').text('임직원 할인');
                    }else{
                        $('#actionSheetDiscountType').text('복지몰 할인');
                        if($('#totalFoldPriceBusinessInfo') && $('#totalFoldPriceBusinessInfo').length > 0) {
                            $('#totalFoldPriceBusinessInfo').show();
                        }
                    }
                    foldAreaPrice = self.partnerPrice;
                    $('#totalPaymentArea').hide();
                }else{  //일반 tab
                    if (memberDiscountPrice > 0) {
                        foldAreaPrice = memberDiscountPrice;
                    }
                    $('#totalFoldPriceInfo').show();
                    $('#totalPaymentArea').show();
                    $('#actionSheetDiscountType').text('');
                }
                foldPriceArea.find('#totalFoldPrice').html(vcui.number.addComma(foldAreaPrice + KRP0008.additionModel.getAdditionTotalPrice()));
            }
            KRP0008.calcTotalPriceAreaControl(empYn);
        },

        // fold 영역 금액 control
        calcTotalPriceAreaControl : function(empYn){
            /**
             * bottomFoldAreaControl : fold 영역 control
             *
             */
            let $totalCalcPayment = $('#totalCalcPayment');
            if($totalCalcPayment && $totalCalcPayment.length > 0) {
                let $calcNormal = $totalCalcPayment.find('#calcNormalAmt');
                let $calcEmp = $totalCalcPayment.find('#calcEmpAmt');
                if (empYn == 'Y') {   //임직원/복지몰 tab
                    $calcNormal.hide();
                    $calcEmp.show();
                } else {
                    $calcNormal.show();
                    $calcEmp.hide();
                }
            }
        },

        // 바텀 금액 계산
        calcTotalPrice : function(prefix,totalPrice,quantity,totalAdditional){
            /**
             * updatePaymentAmountPrice : 가격계산
             *
             */
            let self = this;
            let $totalCalcPayment = $('#totalCalcPayment');
            if($totalCalcPayment && $totalCalcPayment.length > 0){
                let $calcNormal = $totalCalcPayment.find('#calcNormalAmt');
                let $calcEmp = $totalCalcPayment.find('#calcEmpAmt');
                $calcNormal.html('<em>' + prefix + vcui.number.addComma((totalPrice * quantity) + totalAdditional) + '</em>원');
                $calcEmp.html('<em>' + prefix + vcui.number.addComma((self.partnerPrice * quantity) + totalAdditional) + '</em>원');
            }
        },
        //[BTOCSITE-73060] 제품 PDP UI 개선 end

        //BTOCSITE-71987 LGE.CO.KR B2B제품 견적 문의 시 팝업 추가 요청 start
        onlineLinkMove : function () {
            $('#b2cLayerOnlineCounsel .counsel-link').off('click').on('click',function(e){
                e.preventDefault();
                let b2bUrl = $(e.target).attr('data-b2b-url');
                let popupYn = $(e.target).attr('data-popup-yn');

                if(popupYn === 'Y'){
                    let b2cUrl = $(e.target).attr('data-b2c-url');
                    $('#b2cOnlineCounselModal').vcModal({opener: this}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    $('#personQuestion').off('click').on('click',function(e){
                        window.location.href = b2cUrl;
                    });
                    $('#businessQuestion').off('click').on('click',function(e){
                        window.location.href = b2bUrl;
                    });
                }else{
                    window.location.href = b2bUrl;
                }

            });
        },
        //BTOCSITE-71987 LGE.CO.KR B2B제품 견적 문의 시 팝업 추가 요청 end

        // BTOCSITE-89574 START
        setValueExtraBtnByTimeDeal: function() {
            /* move 로직은 contentLoad가 로드된 후의 지점으로 btn extraBtn의 값을 변경하여 selector jquery가 #extraBtn을 찾지 못하는 비동기 오류를 방지합니다. */
            if(lgkorUI.getHiddenInputData().b2cYN ==='Y' && lgePdpSendData.bizTypeDetail !== "CARETAB" && lgkorUI.parseUrl(location.href).searchParams.get("kiosk") != 'y') {

                let param = {
                    "modelId": lgePdpSendData.modelId,
                    "modelStatusCode": lgePdpSendData.modelStatusCode
                };

                try {
                    lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrieveDealProduct", {
                        data: param,
                        method: 'POST',
                        success: function (result) {
                            var timeDealProduct = result.data.dealProductModel;
                            var modelStatusCodeValue = $('div.pdp-info-area').attr('data-model-status-code');
                            if ((timeDealProduct.dealInventoryQty == 0 && 'ACTIVE' == modelStatusCodeValue) || (timeDealProduct.dealInventoryQty > 0 && 'SOLD_OUT' == modelStatusCodeValue)) {
                                /* 만약 이 두 가지 경우 중 하나에 해당된다면 (비정상)
                                1. 구매하기 버튼 상태를 일시품절 버튼으로 변경합니다.
                                2. 아래 이미지와 같이 타임딜 영역의 UI를 비노출하게 처리합니다. */
                                timeDealProduct.timeDealSoldOut = true;

                            }
                            if (timeDealProduct.timeDealSoldOut) {
                                $('#extraBtn').prop('disabled', true).addClass('disabled').text('일시품절');
                            }
                        }
                    });
                } catch (e) {
                    console.log(e);
                }
            }
        },
        // BTOCSITE-89574 END

		//BTOCSITE-94331 구독 다품목 적용 - 띠배너 적용 : start
		cashBackBanner : function(vsPartnerType) {
		    let param = {
				"unifyId": digitalData.userInfo.unifyId,
				"partnerType": vsPartnerType,
				"sku":  lgePdpSendData.sku
			};
						
			lgkorUI.requestAjaxDataPost("/mkt/ajax/product/retrieveMltplOrderInfo", param, function (result) {
				if (result.status === "S") {
        				let targetYn = result.targetYn;
						let b2cTargetYn = result.b2cTargetYn;
						if(targetYn == 'Y'){
							$('#cashBackBanner').show();
							let $vsDffAmt = $('#cashBackBanner').find('#diffAmt');
							    $vsDffAmt.html('<p class=\'gift-subject\'>'+'당월 내, 이 다품목 제품을 구매하면'+'<br class=\'mo-only\'/>'+'<em> '+result.diffAmt+'</em>'+'이 추가 적용됩니다.'+'</p>');
						}else if(targetYn == 'N'){
							$('#cashBackBanner').hide();
						}
						
						if(b2cTargetYn == 'Y'){
							$('#cashBackBanner').show();
							let $vsDffAmt = $('#cashBackBanner').find('#diffAmt');
								$vsDffAmt.html('<p class=\'gift-subject\'>'+'당월 내, 이 다품목 제품을 구매하면'+'<br class=\'mo-only\'/>'+'<em> '+result.b2cDiffAmt+'</em>'+'이 추가 적용됩니다.'+'</p>');
	                    }else if(b2cTargetYn == 'N'){
							$('#cashBackBanner').hide();
						}
        			}
                }, true);
		}, //end
		
        //BTOCSITE-73832  제품 번들링 과제
        additionModel : {
            storageHistKey : "additionHistoryBack",
            historyTimeOut : 10,//분단위
            isSEndGA : false,
            swiperSlideHtml : "<div class=\"swiper-slide\">\n" +
                "                                                <span class=\"chk-wrap\">\n" +
                "                                                    <input type=\"checkbox\" id=\"bundled-{{selectDivId}}-{{modelId}}\" name=\"bundled-chk1\">\n" +
                "                                                    <label for=\"bundled-{{selectDivId}}-{{modelId}}\"><span class=\"blind\">선택하기</span></label>\n" +
                "                                                </span>\n" +
                "                                                <div class=\"bundled-products-items\">\n" +
                "                                                    <a href=\"#\" class=\"bundled-thumb\" title=\"{{modelDisplayName}}\">\n" +
                "                                                        <span class=\"thumb\"><img src=\"{{smallImageAddr}}\" alt=\"\"/></span>\n" +
                "                                                    </a>\n" +
                "                                                    <div class=\"bundled-content\">\n" +
                "                                                        <div class=\"bundled-content-info\">\n" +
                "                                                            <p class=\"bundled-content-name\">{{modelDisplayName}}</p>\n" +
                "                                                            <span class=\"bundled-content-sku\">{{modelName}}</span>\n" +
                "                                                        </div>\n" +
                "                                                        <div class=\"bundled-content-quantity\">\n" +
                "                                                            <div class=\"quantity-wrap\">\n" +
                "                                                                <div class=\"select-quantity\">\n" +
                "                                                                    <div class=\"inner\">\n" +
                "                                                                        <button type=\"button\" class=\"minus\" disabled><span class=\"blind\">빼기</span></button>\n" +
                "                                                                        <input type=\"number\" class=\"quantity\" name=\"swiperSlideQuantity\" id=\"swiperSlideQuantity{{modelName}}\"  title=\"수량 입력\" value=\"1\">\n" +
                "                                                                        <button type=\"button\" class=\"plus\"><span class=\"blind\">더하기</span></button>\n" +
                "                                                                    </div>\n" +
                "                                                                </div>\n" +
                "                                                            </div>\n" +
                "                                                            <div class=\"price-wrap\">\n" +
                "                                                                <span class=\"percent\"><em class=\"blind\">할인율</em>{{modelDiscountRate}}</span>\n" +
                "                                                                <span class=\"price pc\"><em class=\"blind\">가격</em><em>{{obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>원</span>\n" +
                "                                                                <span class=\"price mo\"><em class=\"blind\">가격</em><em>{{obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>원</span>\n" +
                "                                                            </div>\n" +
                "                                                        </div>\n" +
                "                                                    </div>\n" +
                "                                                </div>\n" +
                "                                            </div>",
            swiperSlideMainSoldOutHtml : "<div class=\"swiper-slide\">\n" +
                "                                                <span class=\"chk-wrap\">\n" +
                "                                                    <input type=\"checkbox\" id=\"bundled-{{selectDivId}}-{{modelId}}\" name=\"bundled-chk1\">\n" +
                "                                                    <label for=\"bundled-{{selectDivId}}-{{modelId}}\"><span class=\"blind\">선택하기</span></label>\n" +
                "                                                </span>\n" +
                "                                                <div class=\"bundled-products-items\">\n" +
                "                                                    <a href=\"#\" class=\"bundled-thumb\" title=\"{{modelDisplayName}}\">\n" +
                "                                                        <span class=\"thumb\"><img src=\"{{smallImageAddr}}\" alt=\"\"/></span>\n" +
                "                                                    </a>\n" +
                "                                                    <div class=\"bundled-content\">\n" +
                "                                                        <div class=\"bundled-content-info\">\n" +
                "                                                            <p class=\"bundled-content-name\">{{modelDisplayName}}</p>\n" +
                "                                                            <span class=\"bundled-content-sku\">{{modelName}}</span>\n" +
                "                                                        </div>\n" +
                "                                                        <div class=\"bundled-content-quantity\">\n" +
                "                                                            <div class=\"quantity-wrap\">\n" +
                "                                                                <div class=\"select-quantity\">\n" +
                "                                                                    <div class=\"inner\">\n" +
                "                                                                        <button type=\"button\" class=\"minus\" disabled><span class=\"blind\">빼기</span></button>\n" +
                "                                                                        <input type=\"number\" class=\"quantity\" name=\"swiperSlideQuantity\" id=\"swiperSlideQuantity{{modelName}}\"  title=\"수량 입력\" value=\"1\" readonly>\n" +
                "                                                                        <button type=\"button\" class=\"plus\" disabled><span class=\"blind\">더하기</span></button>\n" +
                "                                                                    </div>\n" +
                "                                                                </div>\n" +
                "                                                            </div>\n" +
                "                                                            <div class=\"price-wrap\">\n" +
                "                                                                <span class=\"percent\"><em class=\"blind\">할인율</em>{{modelDiscountRate}}</span>\n" +
                "                                                                <span class=\"price pc\"><em class=\"blind\">가격</em><em>{{obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>원</span>\n" +
                "                                                                <span class=\"price mo\"><em class=\"blind\">가격</em><em>{{obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>원</span>\n" +
                "                                                            </div>\n" +
                "                                                        </div>\n" +
                "                                                    </div>\n" +
                "                                                </div>\n" +
                "                                            </div>",
            swiperSlideSoldOutHtml : "<div class=\"swiper-slide\">\n" +
                "                                                <!-- 일시 품절에는 체크 박스 없음 -->\n" +
                "                                                <div class=\"bundled-products-items\">\n" +
                "                                                    <a href=\"#\" class=\"bundled-thumb\" title=\"{{modelDisplayName}}\">\n" +
                "                                                        <span class=\"thumb\"><img src=\"{{smallImageAddr}}\" alt=\"\"/></span>\n" +
                "                                                    </a>\n" +
                "                                                    <div class=\"bundled-content\">\n" +
                "                                                        <div class=\"bundled-content-info\">\n" +
                "                                                            <p class=\"bundled-content-name\">{{modelDisplayName}}</p>\n" +
                "                                                            <span class=\"bundled-content-sku\">{{modelName}}</span>\n" +
                "                                                        </div>\n" +
                "                                                        <div class=\"bundled-content-quantity\">\n" +
                "                                                            <!-- 일시 품절에는 수량 선택 없음 -->\n" +
                "                                                            <span class=\"soldout\">일시품절</span>\n" +
                "                                                            <div class=\"price-wrap\">\n" +
                "                                                                <span class=\"price\"><em>{{obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>원</span>\n" +
                "                                                            </div>\n" +
                "                                                        </div>\n" +
                "                                                    </div>\n" +
                "                                                </div>\n" +
                "                                            </div>",
            selectedHtml : "<div class=\"bundled-products-items\">\n" +
                "                                        <a href=\"#\" class=\"bundled-thumb\" title=\"{{modelDisplayName}}\">\n" +
                "                                            <span class=\"thumb\"><img src=\"{{smallImageAddr}}\" alt=\"\"/></span>\n" +
                "                                        </a>\n" +
                "                                        <div class=\"bundled-content\">\n" +
                "                                            <div class=\"bundled-content-info\">\n" +
                "                                                <p class=\"bundled-content-name\">{{modelDisplayName}}</p>\n" +
                "                                                <span class=\"bundled-content-sku\">{{modelName}}</span>\n" +
                "                                            </div>\n" +
                "                                            <div class=\"bundled-content-quantity\">\n" +
                "                                                <div class=\"quantity-wrap\">\n" +
                "                                                    <div class=\"select-quantity\">\n" +
                "                                                        <div class=\"inner\">\n" +
                "                                                            <button type=\"button\" class=\"minus\" disabled><span class=\"blind\">빼기</span></button>\n" +
                "                                                            <input type=\"number\" class=\"quantity\" name=\"selectedQuantity\"  id=\"selectedQuantity{{modelName}}\" title=\"수량 입력\" value=\"{{quantity}}\">\n" +
                "                                                            <button type=\"button\" class=\"plus\"><span class=\"blind\">더하기</span></button>\n" +
                "                                                        </div>\n" +
                "                                                    </div>\n" +
                "                                                </div>\n" +
                "                                                <div class=\"price-wrap\">\n" +
                "                                                    <span class=\"percent\"><em class=\"blind\">할인율</em>{{modelDiscountRate}}</span>\n" +
                "                                                    <span class=\"price\"><em class=\"blind\">가격</em><em>{{obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>원</span>\n" +
                "                                                </div>\n" +
                "                                            </div>\n" +
                "                                            <button type=\"button\" class=\"btn-del\"><span class=\"blind\">선택 제품 삭제</span></button>\n" +
                "                                        </div>\n" +
                "                                    </div>",
            selectedMobileHtml : "<li>\n" +
                "                                        <div class=\"product-info\">\n" +
                "                                            <p class=\"name\">{{modelDisplayName}}</p>\n" +
                "                                            <p class=\"sku\">{{modelName}}</p>\n" +
                "                                        </div>\n" +
                "                                        <ul class=\"quantity-payment-wrap\">\n" +
                "                                            <li>\n" +
                "                                                <dl class=\"price-info quantity\">\n" +
                "                                                    <dt class=\"text\">수량선택</dt>\n" +
                "                                                    <dd class=\"content\">\n" +
                "                                                        <div class=\"quantity-wrap\">\n" +
                "                                                            <div class=\"select-quantity\">\n" +
                "                                                                <div class=\"inner\">\n" +
                "                                                                    <button type=\"button\" class=\"minus\" disabled><span class=\"blind\">빼기</span></button>\n" +
                "                                                                    <input type=\"number\" class=\"quantity\" name=\"selectedMobileQuantity\"   id=\"selectedMobileQuantity{{modelName}}\" title=\"수량 입력\" value=\"1\">\n" +
                "                                                                    <button type=\"button\" class=\"plus\"><span class=\"blind\">더하기</span></button>\n" +
                "                                                                </div>\n" +
                "                                                            </div>\n" +
                "                                                        </div>\n" +
                "                                                    </dd>\n" +
                "                                                </dl>\n" +
                "                                                <div class=\"payment\">\n" +
                "                                                    <span class=\"price\"><em>{{obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>원</span>\n" +
                "                                                </div>\n" +
                "                                            </li>\n" +
                "                                        </ul>\n" +
                "                                        <button type=\"button\" class=\"btn-del\"><span class=\"blind\">삭제</span></button>\n" +
                "                                    </li>",
            additionInit : function(){
                const self = this;

                if( lgkorUI.getHiddenInputData().bizType === 'PRODUCT'
                    && lgkorUI.parseUrl(location.href).searchParams.get("dpType") !== 'careTab'
                    && lgkorUI.parseUrl(location.href).searchParams.get("dpType") !== 'upCareTab'
                    && careshipOnlyFlag === 'N'
                    && !lgePdpSendData.isTimeDeal
                ){
                    self.createAdditionSelectBox("additionDisposable");// 일반 소모품 콤보박스 생성
                    self.createAdditionSelectBox("additionProduct");// 일반 상품 콤보박스 생성
                    self.createAdditionSelectBox("employeeAdditionDisposable");// 임직원 소모품 콤보박스 생성
                    self.createAdditionSelectBox("employeeAdditionProduct");// 임직원 상품 콤보박스 생성


                    var additionSelect = $('#additionSelect');
                    var employeeAdditionSelect = $('#employeeAdditionSelect');

                    let observer = new IntersectionObserver((entries, observer) => {
                        entries.forEach(entry => {
                            if(entry.isIntersecting){
                                if(!self.isSEndGA){
                                    dataLayer.push({
                                        'event' : 'customEvent',
                                        'ga4event' : 'banner_impression',
                                        'customEventCategory' : '배너노출',
                                        'customEventAction' : '완독률-제품번들',
                                        'customEventLabel' : 'PDP 번들상품 추가 영역'
                                    });

                                    observer.unobserve(additionSelect[0]);
                                    observer.unobserve(employeeAdditionSelect[0]);

                                    self.isSEndGA = true;
                                }
                            }
                        });
                    });

                    if($("#additionDisposable").length === 0 && $("#additionProduct").length === 0){//일반 상품 값이 없으면 영역 삭제
                        $("#additionSelect").hide();
                    }else{
                        observer.observe(additionSelect[0]);
                    }
                    if($("#employeeAdditionDisposable").length === 0 && $("#employeeAdditionProduct").length === 0){//임직원 상품 값이 없으면 영역 삭제
                        $("#employeeAdditionSelect").hide();
                    }else{
                        observer.observe(employeeAdditionSelect[0]);
                    }

                    KRP0008.initBundledArea();

                    let  historyData = self.getStorageHistModel();
                    if(!historyData){
                        historyData = self.currentHistData;
                    }

                    try {
                        self.createEmployeePriceTab(historyData);
                    } catch (error) {
                        // Event after loading vcui library
                        $(function() {
                            self.createEmployeePriceTab(historyData);
                        });
                    }

                }else if(lgkorUI.getHiddenInputData().bizType === 'DISPOSABLE'){
                }else{
                    localStorage.removeItem(self.storageHistKey);
                }

                if($('#quantity').val() > 1){
                    $('.payment-amount .quantity-payment-wrap .minus').prop('disabled',false);
                }
            },

            // temp
            createEmployeePriceTab: function(historyData) {
                const self = this;

                if(historyData){//히스토리 있으면 세팅 한다.
                    try{

                        if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                            if(historyData.tabId && historyData.tabId === 'employeeTab'){//탭이 있을 경우 클릭 이벤트를 준다.
                                $('.tabs-wrap.ui_tab').vcTab("select", 0);
                                $("#employeeTab > a").trigger("click");
                            }else{
                                $('.tabs-wrap.ui_tab').vcTab("select", 1);
                                $("#b2cTab > a").trigger("click");
                            }
                        }else{
                            self.tabClick('b2cTab');
                        }
                        self.additionHistorySetting(historyData);
                    }catch(e){
                        if (e instanceof TypeError && e.message.includes("$(...).vcTab is not a function")) {
                            throw new Error('TypeError: $(...).vcTab is not a function');
                        } else {
                            console.log(e)
                            localStorage.removeItem(self.storageHistKey);
                        }
                    }
                }else{
                    if($('#employeePriceTabArea').is(':visible')){
                        try{
                            if($('#employeePriceTabArea .tabs > li').length > 0 && $('#employeeTab').hasClass('on')){
                                $('.tabs-wrap.ui_tab').vcTab("select", 0);
                                $("#employeeTab > a").trigger("click");
                            }else{
                                $('.tabs-wrap.ui_tab').vcTab("select", 1);
                                $("#b2cTab > a").trigger("click");
                            }
                        }catch(e){
                            if (e instanceof TypeError && e.message.includes("$(...).vcTab is not a function")) {
                                throw new Error('TypeError: $(...).vcTab is not a function');
                            }
                        }
                    }else{
                        self.tabClick('b2cTab');
                    }
                }
            },

            //콤보박스 생성
            createAdditionSelectBox : function(selectDivId){
                const self = this;
                let divObj = $("#"+selectDivId);
                let list = divObj.data('additionList');

                if(list && list.length > 0) {
                    //yongho 오늘은 여기까지 내일은 리팩토링 하고 콤보박스 만든다.
                    $("#"+selectDivId).find('.swiper-slide').remove();

                    $(list).each(function (index, obj) {
                        if(obj.modelStatusCode && ("ACTIVE" === obj.modelStatusCode || "SOLD_OUT" === obj.modelStatusCode)) {
                            let appendObj;

                            if(obj.obsOriginalPrice && obj.obsSellingPrice && obj.obsOriginalPrice > obj.obsSellingPrice){
                                let tempModelDiscountRate = (obj.obsOriginalPrice - obj.obsSellingPrice) / obj.obsOriginalPrice * 100;
                                tempModelDiscountRate - (tempModelDiscountRate % 1)
                                obj.modelDiscountRate = (tempModelDiscountRate - (tempModelDiscountRate % 1))+"%";
                            }else{
                                obj.modelDiscountRate = '';
                            }

                            obj.selectDivId = selectDivId;

                            if ("ACTIVE" === obj.modelStatusCode && 'Y' === obj.obsInventoryFlag) {//ACTIVE 상품 추가
                                if("ACTIVE" === lgePdpSendData.modelStatusCode){
                                    appendObj = $(vcui.template(self.swiperSlideHtml, obj));
                                }else{
                                    appendObj = $(vcui.template(self.swiperSlideMainSoldOutHtml, obj));
                                }
                            } else {//SOLD_OUT 상품 추가
                                appendObj = $(vcui.template(self.swiperSlideSoldOutHtml, obj));
                            }

                            appendObj.find("input[type=number]").on('change',function(event){
                                event.preventDefault();
                                if($(this).closest('.swiper-slide').find('input[type=checkbox]') && !$(this).closest('.swiper-slide').find('input[type=checkbox]').is(':checked')) {
                                    $(this).closest('.swiper-slide').find('input[type=checkbox]').prop('checked',true);
                                    $(this).closest('.swiper-slide').removeClass('checked');
                                    self.addSelectedAdditionModel($(this).closest('.swiper-slide'));
                                }
                                if($(this).val() > 0 && $(this).val() <= 24) {
                                    self.addSelectedAdditionModelPlus($(this).closest('.swiper-slide'), $(this).val());
                                }else if(24 < $(this).val()){
                                    self.addSelectedAdditionModelPlus($(this).closest('.swiper-slide'),24);
                                }else{
                                    lgkorUI.alert("", {
                                        title: "주문 가능한 최소 수량은 1개 입니다."
                                    }, this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 제품 개수 미만 시 포커스 이동
                                    self.addSelectedAdditionModelPlus($(this).closest('.swiper-slide'),1);
                                }
                                $(this).closest('.swiper-slide').find('input[type=checkbox]').prop('checked',true);
                                $(this).closest('.swiper-slide').removeClass('checked');
                            });

                            // 이미지 클릭 이벤트
                            appendObj.find("a").on('click',function(event){
                                event.preventDefault();
                                let addJsonObj = self.createHistorySettingData();
                                self.addStorageHistModel(addJsonObj);
                                location.href = obj.modelUrlPath; // 페이지 이동 링크
                            });
                            appendObj.find('.plus').off('click').on('click',function(event){
                                event.preventDefault();
                                if($(this).closest('.swiper-slide').find('input[type=checkbox]') && !$(this).closest('.swiper-slide').find('input[type=checkbox]').is(':checked')) {
                                    $(this).closest('.swiper-slide').find('input[type=checkbox]').prop('checked',true);
                                    $(this).closest('.swiper-slide').removeClass('checked');
                                    self.addSelectedAdditionModel($(this).closest('.swiper-slide'));
                                    self.addSelectedAdditionModelPlus($(this).closest('.swiper-slide'),2);
                                }else{
                                    self.addSelectedAdditionModelPlus($(this).closest('.swiper-slide'));
                                }
                            });
                            appendObj.find('.minus').off('click').on('click',function(event){
                                event.preventDefault();
                                self.addSelectedAdditionModelMinus($(this).closest('.swiper-slide'));
                            });


                            appendObj.data('additionItemJson', obj);//json 데이타 추가
                            $("#" + selectDivId + "SelectBox").append(appendObj);
                        }
                    });


                    KRP0008.changeStateBundled(divObj.find('.bundled-products-wrap'), 0);//모바일 스와이핑
                    divObj.show();
                }else{
                    divObj.hide();
                }
            },
            // 가격 임직원 탭 클릭시 노출 부분 처리
            tabClick : function(type){
                const self = this;
                let isCareship = KRP0008.$pdpInfoCareshipService.find('input[type=radio]:checked').val();
                if(!lgkorUI.stringToBool(isCareship)) {
                    if(type === 'employeeTab'){
                        $("#additionSelect").hide();
                        $("#employeeAdditionSelect").find('.swiper-slide').length > 0 ? $("#employeeAdditionSelect").show() : $("#employeeAdditionSelect").hide();
                        this.actionSheetReload('employeeAdditionSelect');
                        self.setSelectedCount('employeeAddition');
                    }else{
                        $("#additionSelect").find('.swiper-slide').length > 0 ? $("#additionSelect").show() : $("#additionSelect").hide();
                        $("#employeeAdditionSelect").hide();
                        this.actionSheetReload('additionSelect');
                        self.setSelectedCount('addition');
                    }
                }
            },
            careshipServiceRadioClick : function(isCareship){
                const self = this;

                let additionListTotalCnt = 0

                if($("#additionDisposable") && $("#additionDisposable").data('additionList')){
                    additionListTotalCnt += $("#additionDisposable").data('additionList').length;
                }
                if($("#additionProduct") && $("#additionProduct").data('additionList')){
                    additionListTotalCnt += $("#additionProduct").data('additionList').length;
                }
                if($("#employeeAdditionDisposable") && $("employeeAdditionDisposable").data('additionList')){
                    additionListTotalCnt += $("#employeeAdditionDisposable").data('additionList').length;
                }
                if($("#employeeAdditionProduct") && $("#employeeAdditionProduct").data('additionList')){
                    additionListTotalCnt += $("#employeeAdditionProduct").data('additionList').length;
                }
                if(additionListTotalCnt > 0) {
                    if (isCareship) {
                        let confirmMessage = "";

                        if ($("#actionSheetAddition .bundled-payment-list > li ").length > 0) {
                            confirmMessage = "케어십 서비스 신청시에는</br>" +
                                "추가상품을 함께 구매하지 못하기에</br>" +
                                "선택하신 추가상품은 삭제됩니다.</br>" +
                                "케어십을 신청하시겠습니까?</br>";
                        } else {
                            confirmMessage = "케어십 서비스 신청시에는</br>" +
                                "추가상품을 함께 구매하지 못합니다.</br>" +
                                "케어십을 신청하시겠습니까?</br>";
                        }

                        var saveQuantity = $('#quantity').val();

                        lgkorUI.confirm('', {
                            title: confirmMessage,
                            okBtnName: '예',
                            cancelBtnName: '아니오',
                            ok: function () {
                                self.removeAllSelectedAdditionModel();
                            },
                            cancel: function () {
                                $('#quantity').val(saveQuantity);
                                var $paymentAmount = KRP0008.$pdpInfo.find('.payment-amount');
                                $paymentAmount.data('quantity',saveQuantity);
                                KRP0008.$pdpInfoCareshipService.find('input[type=radio][value=N]').trigger('click');
                            }
                        }, document.activeElement); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    } else {
                        //임직원 탭이 있는지 확인 하고 있으면 어떤것이 선택돼 있는지 확인한다.
                        if ($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0 && $('#employeeTab').hasClass('on')) {
                            $("#additionSelect").hide();
                            $("#employeeAdditionSelect").find('.swiper-slide').length > 0 ? $("#employeeAdditionSelect").show() : $("#employeeAdditionSelect").hide();
                        } else {
                            $("#additionSelect").find('.swiper-slide').length > 0 ? $("#additionSelect").show() : $("#additionSelect").hide();
                            $("#employeeAdditionSelect").hide();
                        }
                    }
                }
            },
            // 모바일 action sheet 갱신
            actionSheetReload : function(tabId){
                const self = this;

                let selectedList = $('#'+tabId).find('.bundled-products-select-list');

                $("#actionSheetAdditionDisposable .bundled-payment-list > li").remove();
                $("#actionSheetAdditionDisposable").hide();
                $("#actionSheetAdditionProduct .bundled-payment-list > li").remove();
                $("#actionSheetAdditionProduct").hide();

                selectedList.find(".bundled-products-items").each(function(index,obj){
                    let additionItemJson = $(obj).data('additionItemJson');

                    let actionSheetAppendObj = $(vcui.template(self.selectedMobileHtml, additionItemJson));
                    actionSheetAppendObj.find('.btn-del').on('click',function(){
                        self.removeSelectedAdditionModel($(this).closest('li'));
                    });
                    actionSheetAppendObj.find('.plus').on('click',function(){
                        self.addSelectedAdditionModelPlus($(this).closest('.quantity-payment-wrap').closest('li'));
                    });
                    actionSheetAppendObj.find('.minus').on('click',function(){
                        self.addSelectedAdditionModelMinus($(this).closest('.quantity-payment-wrap').closest('li'));
                    });

                    actionSheetAppendObj.data("additionItemJson",additionItemJson);
                    actionSheetAppendObj.find('input[type=number]').val($(obj).find('input[type=number]').val());


                    if('DISPOSABLE' === additionItemJson.bizType){
                        $("#actionSheetAdditionDisposable .bundled-payment-list").append(actionSheetAppendObj);
                        $("#actionSheetAdditionDisposable").show();
                    }else{
                        $("#actionSheetAdditionProduct .bundled-payment-list").append(actionSheetAppendObj);
                        $("#actionSheetAdditionProduct").show();
                    }

                    // $("#actionSheetAddition").show();
                });
                var $paymentAmount = KRP0008.$pdpInfo.find('.payment-amount');
                KRP0008.updatePaymentAmountPrice($paymentAmount,true);

                self.setAdditionFoldPrice();
            },
            // 추가 구성품 선택히 호출
            addSelectedAdditionModel : function(slideObj, quantity){
                const self = this;
                let additionItemJson = slideObj.data('additionItemJson');

                slideObj.find('.chk-wrap input').data('contents',additionItemJson.modelDisplayName+'/'+additionItemJson.modelName+'/'+additionItemJson.obsSellingPrice);

                if(quantity && quantity > 1){
                    additionItemJson.quantity = quantity;
                }else{
                    additionItemJson.quantity = 1;
                }

                let appendObj = $(vcui.template(self.selectedHtml, additionItemJson));

                appendObj.find("a").on('click',function(event){
                    event.preventDefault();
                    let addJsonObj = self.createHistorySettingData();
                    self.addStorageHistModel(addJsonObj);
                    location.href = additionItemJson.modelUrlPath; // 페이지 이동 링크
                });

                appendObj.find("input[type=number]").on('change',function(event){
                    event.preventDefault();
                    if($(this).val() > 0 && $(this).val() <= 24){
                        self.addSelectedAdditionModelPlus($(this).closest('.bundled-products-items'),$(this).val());
                    }else if(24 < $(this).val()){
                        self.addSelectedAdditionModelPlus($(this).closest('.bundled-products-items'),24);
                    }else{
                        lgkorUI.alert("", {
                            title: "주문 가능한 최소 수량은 1개 입니다."
                        }, this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        self.addSelectedAdditionModelPlus($(this).closest('.bundled-products-items'),1);
                    }
                });

                appendObj.find('.btn-del').on('click',function(){
                    self.removeSelectedAdditionModel($(this).closest('.bundled-products-items'));
                });
                appendObj.find('.plus').on('click',function(){
                    self.addSelectedAdditionModelPlus($(this).closest('.bundled-products-items'));
                });
                appendObj.find('.minus').on('click',function(){
                    self.addSelectedAdditionModelMinus($(this).closest('.bundled-products-items'));
                });


                let actionSheetAppendObj = $(vcui.template(self.selectedMobileHtml, additionItemJson));

                actionSheetAppendObj.find("input[type=number]").on('change',function(event){
                    // event.preventDefault();
                    if($(this).val() > 0 && $(this).val() <= 24){
                        self.addSelectedAdditionModelPlus($(this).closest('.quantity-payment-wrap').closest('li'),$(this).val());
                    }else if(24 < $(this).val()){
                        self.addSelectedAdditionModelPlus($(this).closest('.quantity-payment-wrap').closest('li'),24);
                    }else{
                        lgkorUI.alert("", {
                            title: "주문 가능한 최소 수량은 1개 입니다."
                        }, this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        self.addSelectedAdditionModelPlus($(this).closest('.quantity-payment-wrap').closest('li'),1);
                    }
                });

                actionSheetAppendObj.find('.btn-del').on('click',function(){
                    self.removeSelectedAdditionModel($(this).closest('li'));
                });
                actionSheetAppendObj.find('.plus').on('click',function(){
                    self.addSelectedAdditionModelPlus($(this).closest('.quantity-payment-wrap').closest('li'));
                });
                actionSheetAppendObj.find('.minus').on('click',function(){
                    self.addSelectedAdditionModelMinus($(this).closest('.quantity-payment-wrap').closest('li'));
                });


                let selectedList = slideObj.closest('.bundled-products-inner').find('.bundled-products-select-list');

                let objInList = false;

                selectedList.find(".bundled-products-items").each(function(index,obj){
                    if($(obj).data('additionItemJson').modelId === additionItemJson.modelId){
                        objInList = true;
                        // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 제품 선택 시 포커스 이동
                        if ($(obj).find('.plus').prop('disabled')) {
                            $(obj).find('.quantity').focus(); 
                        } else {
                            $(obj).find('.plus').focus(); 
                        }
                        // [E] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 제품 선택 시 포커스 이동
                        if(quantity){
                            self.addSelectedAdditionModelPlus(obj,quantity);
                        }else {
                            self.addSelectedAdditionModelPlus(obj);
                        }
                    }
                });

                if(!objInList){
                    appendObj.data("additionItemJson",additionItemJson);
                    actionSheetAppendObj.data("additionItemJson",additionItemJson);
                    selectedList.append(appendObj);
                    appendObj.find("a").focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 제품 선택 시 포커스 이동

                    if('DISPOSABLE' === additionItemJson.bizType){
                        $("#actionSheetAdditionDisposable .bundled-payment-list").append(actionSheetAppendObj);
                        $("#actionSheetAdditionDisposable").show();
                    }else{
                        $("#actionSheetAdditionProduct .bundled-payment-list").append(actionSheetAppendObj);
                        $("#actionSheetAdditionProduct").show();
                    }

                    if(quantity){
                        self.addSelectedAdditionModelPlus(slideObj,quantity);
                    }

                    self.setAdditionFoldPrice();
                }
                $(slideObj).find('.plus').prop('disabled',false);

                self.setSelectedCount();

                var $paymentAmount = KRP0008.$pdpInfo.find('.payment-amount');
                KRP0008.updatePaymentAmountPrice($paymentAmount,true);
            },
            // 추가 구성품 + 버튼
            addSelectedAdditionModelPlus : function(obj,quantity){
                const self = this;
                let cnt = parseInt($(obj).find('input[type=number]').val())+1;
                if(quantity) {
                    self.setCount($(obj).data('additionItemJson'), quantity);
                }else{
                    if(cnt <= 24) {
                        self.setCount($(obj).data('additionItemJson'), cnt);
                    }
                }

                // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 추가 구성품 개수 초과 시 포커스 이동
                if ($(obj).find('.plus').prop('disabled')) {
                    $(obj).find('.quantity').focus(); 
                }
                // [E] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 추가 구성품 개수 초과 시 포커스 이동

                var $paymentAmount = KRP0008.$pdpInfo.find('.payment-amount');
                KRP0008.updatePaymentAmountPrice($paymentAmount,true);

                self.setAdditionFoldPrice();
            },
            // 추가 구성품 - 버튼
            addSelectedAdditionModelMinus : function(obj){
                const self = this;
                let cnt = parseInt($(obj).find('input[type=number]').val())-1;
                self.setCount($(obj).data('additionItemJson'),cnt);

                // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 추가 구성품 개수 미만 시 포커스 이동
                if ($(obj).find('.minus').prop('disabled')) {
                    $(obj).find('.quantity').focus(); 
                }
                // [E] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 추가 구성품 개수 미만 시 포커스 이동

                var $paymentAmount = KRP0008.$pdpInfo.find('.payment-amount');
                KRP0008.updatePaymentAmountPrice($paymentAmount,true);

                self.setAdditionFoldPrice();
            },
            // 추가 구성품 버튼 제어
            setCount : function(additionItemJson,cnt) {//yongho   cnt 따라서 삭제도 하고 추가도 하고 기능
                const self = this;

                let prefixEmploy = "addition";
                if($('#employeePriceTabArea').is(':visible') && $('#employeeTab').hasClass('on')){// <=== 임직원 택여부 처리
                    prefixEmploy = "employeeAddition"
                    $("employeeAdditionSelect").show();
                }else{
                    prefixEmploy = "addition"
                    $("additionSelect").show();
                }

                let bizType = additionItemJson.bizType === 'DISPOSABLE' ? 'Disposable':'Product';

                let comboBoxList = $('#'+prefixEmploy+bizType+'SelectBox').find('.swiper-slide');
                let selectedList = $('#'+prefixEmploy+bizType+'Selected').find('.bundled-products-items');
                let actionSheetList = $('#actionSheetAddition'+bizType).find('.bundled-payment-list > li');
                let objList = [{'name':'pc','list':comboBoxList},{'name':'mobile','list':selectedList},{'name':'actionSheet','list':actionSheetList}];
                let priceList = [{'name':'mobile','list':selectedList},{'name':'actionSheet','list':actionSheetList}];



                if(cnt > 0) {
                    $(objList).each(function (index, box) {
                        let boxName = box.name;
                        $(box.list).each(function (index, itemObj) {
                            if ($(itemObj).data('additionItemJson').modelId === additionItemJson.modelId) {
                                $(itemObj).find('input[type=number]').val(cnt);
                                if (cnt > 1) {
                                    $(itemObj).find('.minus').prop('disabled', false);
                                } else {
                                    $(itemObj).find('.minus').prop('disabled', true);
                                }
                                if (cnt >= 24){
                                    $(itemObj).find('.plus').prop('disabled', true);
                                } else {
                                    $(itemObj).find('.plus').prop('disabled', false);
                                }
                                return false;
                            }
                        });
                    });
                    $(priceList).each(function (index, box) {
                        let boxName = box.name;
                        $(box.list).each(function (index, itemObj) {
                            if ($(itemObj).data('additionItemJson').modelId === additionItemJson.modelId) {
                                let price = $(itemObj).data('additionItemJson').obsSellingPrice * parseInt($(itemObj).find("input[type=number]").val());
                                $(itemObj).find('.price em').text(price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
                                return false;
                            }
                        });
                    });
                    comboBoxList.each(function (index, itemObj) {
                        if ($(itemObj).data('additionItemJson').modelId === additionItemJson.modelId) {
                            let price = $(itemObj).data('additionItemJson').obsSellingPrice * parseInt($(itemObj).find("input[type=number]").val());
                            $(itemObj).find('.price.mo em').text(price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
                            return false;
                        }
                    });
                    self.setSelectedCount();
                }
            },
            removeAllSelectedAdditionModel : function(){
                const self = this;

                $("#additionDisposableSelectBox .swiper-slide").removeClass('checked');
                $("#additionDisposableSelectBox .swiper-slide").find('input[type=checkbox]').attr('checked',false);
                $("#additionDisposableSelectBox .swiper-slide").find('.minus').prop('disabled',true);
                $("#additionDisposableSelectBox .swiper-slide").find('input[type=number]').val(1);

                $("#additionProductSelectBox .swiper-slide").removeClass('checked');
                $("#additionProductSelectBox .swiper-slide").find('input[type=checkbox]').attr('checked',false);
                $("#additionProductSelectBox .swiper-slide").find('.minus').prop('disabled',true);
                $("#additionProductSelectBox .swiper-slide").find('input[type=number]').val(1);

                $("#employeeAdditionDisposableSelectBox .swiper-slide").removeClass('checked');
                $("#employeeAdditionDisposableSelectBox .swiper-slide").find('input[type=checkbox]').attr('checked',false);
                $("#employeeAdditionDisposableSelectBox .swiper-slide").find('.minus').prop('disabled',true);
                $("#employeeAdditionDisposableSelectBox .swiper-slide").find('input[type=number]').val(1);

                $("#employeeAdditionProductSelectBox .swiper-slide").removeClass('checked');
                $("#employeeAdditionProductSelectBox .swiper-slide").find('input[type=checkbox]').attr('checked',false);
                $("#employeeAdditionProductSelectBox .swiper-slide").find('.minus').prop('disabled',true);
                $("#employeeAdditionProductSelectBox .swiper-slide").find('input[type=number]').val(1);

                $("#additionDisposableSelected .bundled-products-items").remove();
                $("#additionProductSelected .bundled-products-items").remove();
                $("#employeeAdditionDisposableSelected .bundled-products-items").remove();
                $("#employeeAdditionProductSelected .bundled-products-items").remove();

                $("#additionSelect").hide();

                $("#employeeAdditionSelect").hide();


                $("#actionSheetAddition .bundled-payment-list > li").remove()
                $("#actionSheetAdditionDisposable").hide();
                $("#actionSheetAdditionProduct").hide();


                self.setSelectedCount();
                var $paymentAmount = KRP0008.$pdpInfo.find('.payment-amount');
                KRP0008.updatePaymentAmountPrice($paymentAmount,true);

                self.setAdditionFoldPrice();
            },
            //선택한 추가 구성품 제거
            removeSelectedAdditionModel : function(obj){
                const self = this;

                let additionItemJson = $(obj).data('additionItemJson');

                // 임직원 상태 확인해야 한다.
                let prefixEmploy = $('#employeePriceTabArea').is(':visible') && $('#employeeTab').hasClass('on') ? 'employeeAddition':'addition';
                let bizType = additionItemJson.bizType === 'DISPOSABLE' ? 'Disposable':'Product';

                let comboBoxList = $('#'+prefixEmploy+bizType+'SelectBox').find('.swiper-slide');
                let selectedList = $('#'+prefixEmploy+bizType+'Selected').find('.bundled-products-items');


                comboBoxList.each(function(index,itemObj){
                    if($(itemObj).data('additionItemJson').modelId === additionItemJson.modelId){
                        self.addSelectedAdditionModelPlus($(itemObj),1);
                        $(itemObj).removeClass('checked');
                        $(itemObj).find('input[type=checkbox]').attr('checked',false);
                        // $(itemObj).find('.plus').prop('disabled',true);
                        $(itemObj).find('.minus').prop('disabled',true);
                        // $(itemObj).find('input[type=number]').val(1);
                    }
                });

                selectedList.each(function(index,itemObj){
                    if($(itemObj).data('additionItemJson').modelId === additionItemJson.modelId){
                        // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 제품 삭제 시 포커스 이동
                        if ($(itemObj).next('.bundled-products-items').length) {
                            $(itemObj).next('.bundled-products-items').find('.bundled-thumb').focus();
                        } else if($(itemObj).prev('.bundled-products-items').length) {
                            $(itemObj).prev('.bundled-products-items').find('.bundled-thumb').focus();
                        } else {
                            $(itemObj).closest('.bundled-products-select-list').siblings('.bundled-products-select-wrap').find('.bundled-products-dropdown').focus();
                        }
                        // [E] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 제품 삭제 시 포커스 이동

                        itemObj.remove();
                    }
                });

                if('DISPOSABLE' === $(obj).data('additionItemJson').bizType){
                    $("#actionSheetAdditionDisposable .bundled-payment-list > li").each(function(index,itemObj) {
                        if ($(itemObj).data('additionItemJson').modelId === additionItemJson.modelId) {
                            itemObj.remove();
                            return false;
                        }
                    });
                }else{
                    $("#actionSheetAdditionProduct .bundled-payment-list > li").each(function(index,itemObj) {
                        if ($(itemObj).data('additionItemJson').modelId === additionItemJson.modelId) {
                            // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 제품 삭제 시 포커스 이동
                            if ($(itemObj).next('li').length) {
                                $(itemObj).next('li').find('.btn-del').focus();
                            } else if($(itemObj).prev('li').length) {
                                $(itemObj).prev('li').find('.btn-del').focus();
                            } else {
                                $(itemObj).closest('.action-sheet').children('.sheet-close').focus();
                            }
                            // [E] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 추가 제품 삭제 시 포커스 이동
                            itemObj.remove();
                            return false;
                        }
                    });
                }

                let actionSheetAdditionDisposableCnt = $("#actionSheetAdditionDisposable .bundled-payment-list > li").length;
                let actionSheetAdditionProductCnt = $("#actionSheetAdditionProduct .bundled-payment-list > li").length;

                if( actionSheetAdditionDisposableCnt === 0){
                    $('#actionSheetAdditionDisposable').hide();
                }
                if(actionSheetAdditionProductCnt === 0){
                    $('#actionSheetAdditionProduct').hide();
                }
                self.setSelectedCount();

                var $paymentAmount = KRP0008.$pdpInfo.find('.payment-amount');
                KRP0008.updatePaymentAmountPrice($paymentAmount, true);

                self.setAdditionFoldPrice();
            },
            // 추가 구성품 선택 갯수 표기
            setSelectedCount : function(prefixEmploy){
                if(!prefixEmploy) {
                    prefixEmploy = $('#employeePriceTabArea').is(':visible') && $('#employeeTab').hasClass('on') ? 'employeeAddition' : 'addition';
                }

                let actionSheetAdditionDisposableCnt = Array.from($("#actionSheetAdditionDisposable .bundled-payment-list > li input[type=number]"))
                    .reduce((total, input) => total + Number(input.value), 0);
                let actionSheetAdditionProductCnt = Array.from($("#actionSheetAdditionProduct .bundled-payment-list > li input[type=number]"))
                    .reduce((total, input) => total + Number(input.value), 0);

                $("#additionDisposableCnt").hide();
                $("#additionProductCnt").hide();
                $("#employeeAdditionDisposableCnt").hide();
                $("#employeeAdditionProductCnt").hide();

                $('#'+prefixEmploy+"DisposableCnt").html('<em>'+actionSheetAdditionDisposableCnt+'</em>개 선택');
                $('#'+prefixEmploy+"ProductCnt").html('<em>'+actionSheetAdditionProductCnt+'</em>개 선택');

                if(actionSheetAdditionDisposableCnt){
                    $('#'+prefixEmploy+"DisposableCnt").show();
                }
                if(actionSheetAdditionProductCnt){
                    $('#'+prefixEmploy+"ProductCnt").show();
                }
            },
            setSelectedTotalText : function(){
                let actionSheetAdditionDisposableCnt = Array.from($("#actionSheetAdditionDisposable .bundled-payment-list > li input[type=number]"))
                    .reduce((total, input) => total + Number(input.value), 0);
                let actionSheetAdditionProductCnt = Array.from($("#actionSheetAdditionProduct .bundled-payment-list > li input[type=number]"))
                    .reduce((total, input) => total + Number(input.value), 0);

                let productCnt = 0;
                if(KRP0008.$actionSheet.find('div.select-quantity input.quantity')){
                    try{
                    productCnt = parseInt(KRP0008.$actionSheet.find('div.select-quantity input.quantity').val());
                    }catch (e){}
                }

                let additionCnt = actionSheetAdditionDisposableCnt + actionSheetAdditionProductCnt;

                let totalCount = additionCnt + productCnt;

                var totalPriceText = KRP0008.$actionSheet.find('dl.total-payment dt.text');
                var employeetotalPriceText = $('.is-price-calc-new .price-info dt.text strong');
                if(additionCnt > 0 && productCnt > 0){
                    totalPriceText.text('총 '+ totalCount+'개 제품 금액');
                    $("#employeePriceTotalArea dt.text strong").text('총 '+ totalCount+'개 제품 금액');
                    $("#employeePriceTotalArea dt.text em").text('');
                    $("#partnerPriceTotalArea dt.text em").text('');
                    employeetotalPriceText.text('총 '+ totalCount+'개 제품 금액');
                }else{
                    totalPriceText.text("총 금액");
                    $("#employeePriceTotalArea dt.text strong").text('총 금액');
                    $("#employeePriceTotalArea dt.text em").text('(임직원 할인가)');
                    $("#partnerPriceTotalArea dt.text em").text('(복지몰 할인가)');
                    employeetotalPriceText.text("총 금액");
                }

                if(additionCnt > 0){
                    $("#totalFoldPriceInfo > strong").text("총 "+(additionCnt+1)+"개 제품 금액");
                    $("#totalFoldPriceEmployeeInfo > strong").text("총 "+(additionCnt+1)+"개 제품 금액");
                    $("#totalFoldPriceBusinessInfo > strong").text("총 "+(additionCnt+1)+"개 제품 금액");
                    $("#totalFoldPriceInfo .tooltip-wrap").hide();
                    $("#totalFoldPriceEmployeeInfo .tooltip-wrap").hide();
                    $("#totalFoldPriceBusinessInfo .tooltip-wrap").hide();
                    $("#employeePriceTotalArea .tooltip-wrap").hide();
                    $("#partnerPriceTotalArea .tooltip-wrap").hide();
                }else{
                    $("#totalFoldPriceInfo > strong").text($("#totalFoldPriceInfo > strong").data('orgText'));
                    $("#totalFoldPriceEmployeeInfo > strong").text($("#totalFoldPriceEmployeeInfo > strong").data('orgText'));
                    $("#totalFoldPriceBusinessInfo > strong").text($("#totalFoldPriceBusinessInfo > strong").data('orgText'));
                    $("#totalFoldPriceInfo .tooltip-wrap").show();
                    $("#totalFoldPriceEmployeeInfo .tooltip-wrap").show();
                    $("#totalFoldPriceBusinessInfo .tooltip-wrap").show();
                    $("#employeePriceTotalArea .tooltip-wrap").show();
                    $("#partnerPriceTotalArea .tooltip-wrap").show();
                }

            },
            setAdditionFoldPrice : function(){
                const self = this;
                if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                    if($('#employeeTab').hasClass('on')){
                        KRP0008.bottomFoldAreaControl('Y');
                    }else{
                        KRP0008.bottomFoldAreaControl('N');
                    }
                }else{
                    let foldPriceArea = $('#foldPriceArea');
                    let foldAreaPrice = foldPriceArea.data('orgPrice');
                    if (memberDiscountPrice > 0) {
                        foldAreaPrice = memberDiscountPrice;
                    }
                    foldPriceArea.find('#totalFoldPrice').html(vcui.number.addComma(foldAreaPrice + self.getAdditionTotalPrice()));
                }
            },
            // 추가 구성품 가격 리턴
            getAdditionTotalPrice : function(){
                let price = 0;

                let actionSheetAdditionDisposableList = $("#actionSheetAdditionDisposable .bundled-payment-list > li");
                let actionSheetAdditionProductList = $("#actionSheetAdditionProduct .bundled-payment-list > li");

                actionSheetAdditionDisposableList.each(function(index,obj){
                    let obsSellingPrice = $(obj).data('additionItemJson').obsSellingPrice;
                    let cnt = parseInt($(obj).find('input[type=number]').val());
                    price += obsSellingPrice * cnt;
                });

                actionSheetAdditionProductList.each(function(index,obj){
                    let obsSellingPrice = $(obj).data('additionItemJson').obsSellingPrice;
                    let cnt = parseInt($(obj).find('input[type=number]').val());
                    price += obsSellingPrice * cnt;
                });

                return price;
            },
            //장바구니 버튼 클릭시 추가 구성품 제품 목록 리턴
            getAdditionSelectModelCartParam : function(param){
                const self = this;

                let actionSheetAdditionDisposableList = $("#actionSheetAdditionDisposable .bundled-payment-list > li");
                let actionSheetAdditionProductList = $("#actionSheetAdditionProduct .bundled-payment-list > li");

                if(actionSheetAdditionDisposableList.length > 0 || actionSheetAdditionProductList.length > 0){
                    param.modelNameList = [{"sku":sendData.sku,"modelDisplayName":sendData.productName,"modelName":sendData.modelName}]

                    actionSheetAdditionDisposableList.each(function(index,obj){
                        let additionItemJson = $(obj).data('additionItemJson');
                        let cnt = parseInt($(obj).find('input[type=number]').val());

                        //yongho yongho 장바구니 에러 확인및 추가 확인해야 한다.
                        param.sku = param.sku+","+additionItemJson.modelSku+"|"+cnt;
                        param.modelNameList.push({"sku":additionItemJson.modelSku,"modelDisplayName":additionItemJson.modelDisplayName,"modelName":additionItemJson.modelName});
                    });

                    actionSheetAdditionProductList.each(function(index,obj){
                        let additionItemJson = $(obj).data('additionItemJson');
                        let cnt = parseInt($(obj).find('input[type=number]').val());

                        param.sku = param.sku+","+additionItemJson.modelSku+"|"+cnt;
                        param.modelNameList.push({"sku":additionItemJson.modelSku,"modelDisplayName":additionItemJson.modelDisplayName,"modelName":additionItemJson.modelName});
                    });

                    param.isAdditionModel = "Y";
                }

            },
            // 구매 하기 버튼 클릭시 추가 구성품 제품 목록 리턴
            getAdditionSelectModelBuyParam : function(param){
                const self = this;

                let actionSheetAdditionDisposableList = $("#actionSheetAdditionDisposable .bundled-payment-list > li");
                let actionSheetAdditionProductList = $("#actionSheetAdditionProduct .bundled-payment-list > li");

                if(actionSheetAdditionDisposableList.length > 0 || actionSheetAdditionProductList.length > 0){
                    param.isDisposable = 'N';

                    param.modelNameList = [{"sku":sendData.sku,"modelDisplayName":sendData.productName,"modelName":sendData.modelName}]


                    actionSheetAdditionDisposableList.each(function(index,obj){
                        let additionItemJson = $(obj).data('additionItemJson');
                        let cnt = parseInt($(obj).find('input[type=number]').val());

                        param.cart_items.push({"data":{"sku": additionItemJson.modelSku,"quantity": cnt}});
                        param.modelNameList.push({"sku":additionItemJson.modelSku,"modelDisplayName":additionItemJson.modelDisplayName,"modelName":additionItemJson.modelName});

                        param.isDisposable = 'Y';
                    });

                    actionSheetAdditionProductList.each(function(index,obj){
                        let additionItemJson = $(obj).data('additionItemJson');
                        let cnt = parseInt($(obj).find('input[type=number]').val());

                        param.cart_items.push({"data":{"sku": additionItemJson.modelSku,"quantity": cnt}});
                        param.modelNameList.push({"sku":additionItemJson.modelSku,"modelDisplayName":additionItemJson.modelDisplayName,"modelName":additionItemJson.modelName});
                    });

                    param.isAdditionModel = "Y";

                    param.order_item_qty = param.cart_items.length; //<==갯수를 넣는다.
                }
            },
            //저장할 모델 json obj 만들기
            createHistorySettingData : function(){//저장할 데이타 만들기
                const self = this;
                let historyData = {
                    modelId: lgePdpSendData.modelId,
                };

                loginFlag = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
                historyData.loginFlag = loginFlag;


                if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                    historyData.tabId = $('#employeePriceTabArea .tabs > li.on').attr("id");
                }

                let getAdditionJson = function (disposableList,productList){
                    let addition = {};

                    let disposable = {}
                    let disposableArr = [];

                    disposableList.each(function(index,obj){
                        let additionItemJson = $(obj).data('additionItemJson');
                        additionItemJson.quantity = parseInt($(obj).find('input[type=number]').val());

                        disposableArr.push(additionItemJson);
                    });

                    disposable.list = disposableArr;

                    let product = {}
                    let productArr = [];

                    productList.each(function(index,obj){
                        let additionItemJson = $(obj).data('additionItemJson');
                        additionItemJson.quantity = parseInt($(obj).find('input[type=number]').val());

                        productArr.push(additionItemJson);
                    });

                    product.list = productArr;

                    addition.disposable = disposable;
                    addition.product = product;

                    return addition;
                }

                let additionDisposableSelectedList = $("#additionDisposableSelected .bundled-products-items");
                let additionProductSelectedList = $("#additionProductSelected .bundled-products-items");

                let employeeAdditionDisposableSelectedList = $("#employeeAdditionDisposableSelected .bundled-products-items");
                let employeeAdditionProductSelectedList = $("#employeeAdditionProductSelected .bundled-products-items");


                historyData.addition = getAdditionJson(additionDisposableSelectedList,additionProductSelectedList);
                historyData.employeeAddition = getAdditionJson(employeeAdditionDisposableSelectedList,employeeAdditionProductSelectedList);

                return historyData;
            },
            // localStorage 데이타 저장
            addStorageHistModel : function(addJsonObj){//localStorage 에 저장
                const self = this;
                localStorage.setItem(self.storageHistKey,JSON.stringify(addJsonObj));
            },
            // localStorage 저장한 데이타 조회
            getStorageHistModel : function(){
                const self = this;
                let historyJson = null;
                if(localStorage.getItem(self.storageHistKey)){
                    historyJson = JSON.parse(localStorage.getItem(self.storageHistKey));
                }
                return historyJson;
            },
            // 히스토리 백 했을 경우 콤보박스 세팅
            additionHistorySetting : function(historyData){
                const self = this;
                //요기에 콤보박스 세팅을 만든다.

                if(historyData){
                    if(historyData.modelId === lgePdpSendData.modelId){

                        let setAdditionJson = function(data,prefixEmploy){
                            if(data.disposable && data.disposable.list){
                                data.disposable.list.forEach(function(obj){
                                    $('#'+prefixEmploy+'DisposableSelectBox').find('.swiper-slide').each(function (index,itemObj){
                                        if($(itemObj).data('additionItemJson').modelId === obj.modelId){
                                            $(itemObj).find('input[type=checkbox]').prop('checked',true)
                                            self.addSelectedAdditionModel($(itemObj),obj.quantity);
                                        }
                                    });
                                });
                                KRP0008.changeStateBundled($('#'+prefixEmploy+'Disposable').find('.bundled-products-wrap'), 0);//모바일 스와이핑
                            }

                            if(data.product && data.product.list){
                                data.product.list.forEach(function(obj){
                                    $('#'+prefixEmploy+'ProductSelectBox').find('.swiper-slide').each(function (index,itemObj){
                                        if($(itemObj).data('additionItemJson').modelId === obj.modelId){
                                            $(itemObj).find('input[type=checkbox]').prop('checked',true)
                                            self.addSelectedAdditionModel($(itemObj),obj.quantity);
                                        }
                                    });
                                });
                                KRP0008.changeStateBundled($('#'+prefixEmploy+'Product').find('.bundled-products-wrap'), 0);//모바일 스와이핑
                            }
                        }

                        setAdditionJson(historyData.addition,'addition');
                        setAdditionJson(historyData.employeeAddition,'employeeAddition');

                        localStorage.removeItem(self.storageHistKey);
                    }
                }
            },
        },

        // [S] BTOCSITE-83434 [EPIC] 구독 다품목 적용
        setBannerSwiper: function() {
            var $bannerSwiper = $('.banner-slide-box .swiper-container');
            var $autoControlBtn = $bannerSwiper.find('.wrap-autoplay-control button');

            $bannerSwiper.each(function() {
                var $this = $(this);

                if ($this[0].swiper) {
                    $this[0].swiper.destroy();
                }

                if ($this.find('.banner_item').length < 2) {
                    $this.find('.control').hide();
                    return;
                }

                var _swiper = new Swiper($this[0], {
                    loop: true,
                    spaceBetween: 12,
                    autoplay: {
                        enabled: true,
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: '.control .swiper-pagination',
                        type: 'fraction',
                        clickable: true,
                        //[S] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 페이징 접근성 작업
                        renderFraction: function(currentClass, totalClass) {
                            return '<span class="blind">현재 페이지</span>'+
                                    '<span class="' + currentClass + '"></span>' +
                                    '<span class="blind">총 페이지 수</span>'+
                                    '<span class="' + totalClass + '"></span>';
                        }
                        //[E] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 페이징 접근성 작업
                    },
                    //[S] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 스와이프 버튼 작업
                    navigation: {
                        nextEl: '.banner-slide-box .swiper-container .wrap-autoplay-control .swiper-button-next',
                        prevEl: '.banner-slide-box .swiper-container .wrap-autoplay-control .swiper-button-prev',
                    },
                    //[E] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 스와이프 버튼 작업
                    on: {
                        init: function(swiper) {
                            var $swiper = $(swiper.el);

                            setAutoPlay(swiper, true);
                        }
                    }
                });
            });

            $autoControlBtn.each(function() {
                var $this = $(this);

                $this.off('click.cartBannerAuto').on('click.cartBannerAuto', function() {
                    var $this = $(this);
                    var $swiper = $this.closest('.swiper-container');
                    var _swiper = $swiper[0].swiper;
                    var autoStatus = $this.attr('aria-pressed');

                    if (autoStatus === 'true') {
                        setAutoPlay(_swiper, true);
                    } else {
                        setAutoPlay(_swiper, false);
                    }
                });
            });

            function setAutoPlay(swiper, isPlay) {
                var $swiper = $(swiper.el);
                var $autoControlBtn = $swiper.find('.wrap-autoplay-control button');

                if (isPlay) {
                    swiper.autoplay.stop();
                    $autoControlBtn.attr('aria-pressed', 'false');
                    $autoControlBtn.attr('aria-label', '일시정지');
                    swiper.autoplay.start();
                } else {
                    $autoControlBtn.attr('aria-pressed', 'true');
                    $autoControlBtn.attr('aria-label', '자동 재생');
                    swiper.autoplay.stop();
                }
            }

            var oldTabIdx = null;
            $('.product-detail-option .care-sibling-option > .tabs-wrap').on('tabchange', function(e, obj) {
                var selectedIdx = obj.selectedIndex;
                if (oldTabIdx === selectedIdx) return;

                $bannerSwiper.not(':hidden').each(function() {
                    var $this = $(this);
                    var _swiper = $this[0].swiper;

                    if (_swiper) {
                        _swiper.slideToLoop(0, 0);
                        setAutoPlay(_swiper, true);
                    }
                });

                oldTabIdx = selectedIdx;
            });
        }
    };

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'PROD', name: 'KRP0008-2.0.0', isFirstLoad: true, fn: function () {
                if (!document.querySelector('.KRP0008')) return false;
                $('.KRP0008').buildCommonUI();
                // KRP0008.init();
                var vcLoadedEvent = new Event("vcLoaded");
                document.dispatchEvent(vcLoadedEvent);
            }
        });
    }

    // SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if (!document.querySelector('.KRP0008')) return false;
        $('.KRP0008').buildCommonUI();
        //KRP0008.init();

        //BTOCSITE-33023 [구매하기]버튼이 키보드에 밀려 올라오는 현상
        if(vcui.detect.isAndroid){
            var prevH = $(window).height();
            $(window).on('resizestart',function(){
                if(prevH - $(window).height() >= 200){
                    //구매버튼 노출하는 로직에 영향도 없게 (키패드 오픈, 구매버튼 비노출)
                    if($('#paymentButtonArea').css('display') == 'block' ){
                        $('#paymentButtonArea').data('open-keypad',true).hide();
                        console.log('키패드 있음, 구매버튼 비노출');
                    }
                }else if(prevH - $(window).height() <= -200){
                    //구매버튼 노출하는 로직에 영향도 없게 (키패드 클로즈, 구매버튼 노출)
                    if( $('#paymentButtonArea').data('open-keypad') == true){
                        $('#paymentButtonArea').show();
                        console.log('키패드 없음, 구매버튼 노출');
                    }
                }
                prevH = $(window).height();
            })
        }
    });

    $(document).ready(function(){
        $('#rental-care-sibling-option .tabs>li').click(function(){
            var tabIdx = $(this).index();
            if(tabIdx == 0) {//임직원
                $('.detail-option-box').addClass("first").removeClass("last");
                $('.action-sheet-title').show();

                $("#rentalBadges .partnerRentalBadges").show();//뱃지 노출 변경
                $("#rentalBadges .b2cRentalBadges").hide();

                $('#rentalPartnerPriceInfoDisp').show();
                $('#rentalPriceInfoDisp').hide();
                $(".cribe-link").hide();
                $('.action-sheet .select-info a').html('이용 요금('+KRP0008.rentalPartnerPrefix+') <span class="blind">이용 요금 팝업 열림</span>');
                $('#empBanner').show();//임직원 배너 영역
                $('#b2cBanner').hide();//일반 배너 영역
                $('#rentalExhibitions').hide();//기획전 베너
                $('div.pdp-visual-area div.subscribe-flag-box, div.pdp-visual-inner div.subscribe-flag-box').hide();//겔러리 가전 구독 뱃지

                if($("#rentalIsCareDispText").data('isPartnerCareDispText')){
                    $("#rentalIsCareDispText").show();
                }else{
                    $("#rentalIsCareDispText").hide();
                }
                
                //tootip제어
                $('.partnerY').show();
                $('.partnerN').hide();
                //기획전 뱃지 제어
                $('div.rental-badge-wrap > div.rental-discount-badge').hide();
                //다품목 캐시백 배너 제어
                subMultiItemBenefit("Y");

            } else {//일반
                $('.detail-option-box').addClass("last").removeClass("first");
                $('.action-sheet-title').hide();

                $("#rentalBadges .partnerRentalBadges").hide();//뱃지 노출 변경
                $("#rentalBadges .b2cRentalBadges").show();

                $('#rentalPartnerPriceInfoDisp').hide();
                $('#rentalPriceInfoDisp').show();
                $(".cribe-link").show();
                $('.action-sheet .select-info a').html('이용 요금 <span class="blind">이용 요금 팝업 열림</span>')

                $('#empBanner').hide();//임직원 배너 영역
                $('#b2cBanner').show();//일반 배너 영역
                $('#rentalExhibitions').show();//기획전 베너
                $('div.pdp-visual-area div.subscribe-flag-box, div.pdp-visual-inner div.subscribe-flag-box').show();//겔러리 가전 구독 뱃지

                if($("#rentalIsCareDispText").data('isCareDispText')){
                    $("#rentalIsCareDispText").show();
                }else{
                    $("#rentalIsCareDispText").hide();
                }
                
                //tootip제어
                $('.partnerY').hide();
                $('.partnerN').show();
                //기획전 뱃지 제어
                if(vcui.isEmpty($('div.rental-badge-wrap > div.rental-discount-badge >span.dscntBadgeTit').text())){
                	$('div.rental-badge-wrap > div.rental-discount-badge').hide();
                }else{
                	$('div.rental-badge-wrap > div.rental-discount-badge').show();
                }
                //다품목 캐시백 배너 제어
                subMultiItemBenefit("N");
            }

            var {selectItemData, rentalInfoData, caresolutionRentalInfoSelectBox, tabBox} = KRP0008.rentalCurrentTabObjects();
            KRP0008.updateRentalInfoPrice(selectItemData);
        });

        // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
        $('#employeePriceTabArea .tabs > li').each(function(){
            var $this = $(this);
            $(this).find('a').click(function(){
                var selectedTab = $this.attr('id');
                var tabIdx = $this.index();
                let $buyBenefitInfoPurchase = $('#buyBenefitInfoPurchase');
				let vsPartnerType = digitalData.userInfo.partnerType;

                // 임직원 or 복지몰 가격탭
                if(tabIdx == 0) {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("first").removeClass("last");
                    $('span[id^="b2cBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="b2cBadge"]'));
                    $('#badgeArea').append($('span[id^="employeeBadge"]'));
                    $('span[id^="employeeBadge"]').show();
                    // $('#actionSheetDiscountType').css("display","");
                    $('.emp-price-info.is-price-calc-new').show();

                    $('.total-coupon-payment').hide();
                    if ($('.emp-price-info.is-coupon-price-calc-new').data('set-coupon-discount-price') == 'Y') $('.emp-price-info.is-coupon-price-calc-new').show();

                    // 렌탈 이동 영역
                    if ($('#rentalDirectinfoListEmployee li').length > 0) {
                        $('#rentalDirectinfoList').hide();
                        $('#rentalDirectinfoListEmployee').show();
                    }

                    // 구매혜택안내 > 결제일 할인 (임직원가격탭)
                    if ($buyBenefitInfoPurchase.data("employee_purchase_yn") == 'Y') {
                        KRP0008.displayBenefitPurchaseArea(true);
                    } else {
                        KRP0008.displayBenefitPurchaseArea(false);
                    }
                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                    KRP0008.displayBenefitPointArea(digitalData.userInfo.partnerType);

                    //BTOCSITE-73832  제품 번들링 과제
                    KRP0008.additionModel.tabClick('employeeTab');

                    KRP0008.bottomFoldAreaControl('Y');
					
					//BTOCSITE-94331 구독 다품목 적용 - 띠배너 적용
					KRP0008.cashBackBanner(vsPartnerType);
                // 일반 가격탭
                } else {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("last").removeClass("first");
                    $('span[id^="employeeBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="employeeBadge"]'));
                    $('#badgeArea').append($('span[id^="b2cBadge"]'));
                    $('span[id^="b2cBadge"]').show();
                    // $('#actionSheetDiscountType').hide();
                    $('.emp-price-info.is-price-calc-new').hide();

                    if ($('.total-coupon-payment .payment .price').data('set-coupon-discount-price') == 'Y') $('.total-coupon-payment').show();
                    $('.emp-price-info.is-coupon-price-calc-new').hide();

                    // 렌탈 이동 영역
                    if ($('#rentalDirectinfoListEmployee li').length > 0) {
                        $('#rentalDirectinfoListEmployee').hide();
                        $('#rentalDirectinfoList').show();
                    }

                    // 구매혜택안내 > 결제일 할인 (일반가격탭)
                    if ($buyBenefitInfoPurchase.data("purchase_yn") == 'Y') {
                        KRP0008.displayBenefitPurchaseArea(true);
                    } else {
                        KRP0008.displayBenefitPurchaseArea(false);
                    }
                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                    KRP0008.displayBenefitPointArea('B2C');

                    //BTOCSITE-73832  제품 번들링 과제
                    KRP0008.additionModel.tabClick('b2cTab');

                    KRP0008.bottomFoldAreaControl('N');
					
					//BTOCSITE-94331 구독 다품목 적용 - 띠배너 적용
					KRP0008.cashBackBanner("B2C");
                }
            })
        });

        // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰 - 소모품
        $('#employeeDisposableTab .tabs > li').each(function(){
            /*var $this = $(this);
            $(this).find('a').click(function(){
                var selectedTab = $this.attr('id');
                var tabIdx = $this.index();

                // 임직원 or 복지몰 가격탭
                if(tabIdx == 0) {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("first").removeClass("last");
                    $('span[id^="b2cBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="b2cBadge"]'));
                    $('#badgeArea').append($('span[id^="employeeBadge"]'));
                    $('span[id^="employeeBadge"]').show();
                    $('.emp-price-info').show();

                    // 바텀시트 임직원 쿠폰할인가 노출여부
                    var employeeCouponYn = $('.emp-price-info.is-coupon-price-calc-new').data('set-coupon-discount-price');
                    if (employeeCouponYn == undefined || employeeCouponYn !== "Y") {
                        $(".emp-price-info.price-red.is-coupon-price-calc-new.is-popup-cont-member").hide();
                    }

                    $('#actionSheetDiscountType').css("display","");
                    if ($('.total-coupon-payment .payment .price').data('price') != undefined) $('.total-coupon-payment').hide();

                    // 일반 가격탭
                } else {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("last").removeClass("first");
                    $('span[id^="employeeBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="employeeBadge"]'));
                    $('#badgeArea').append($('span[id^="b2cBadge"]'));
                    $('span[id^="b2cBadge"]').show();
                    $('.emp-price-info').hide();
                    $('#actionSheetDiscountType').hide();
                    if ($('.total-coupon-payment .payment .price').data('price') != undefined) $('.total-coupon-payment').show();
                }
            })*/
            var $this = $(this);
            $(this).find('a').click(function(){
                var selectedTab = $this.attr('id');
                var tabIdx = $this.index();

                // 임직원 or 복지몰 가격탭
                if(tabIdx == 0) {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("first").removeClass("last");
                    $('span[id^="b2cBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="b2cBadge"]'));
                    $('#badgeArea').append($('span[id^="employeeBadge"]'));
                    $('span[id^="employeeBadge"]').show();
                    // $('#actionSheetDiscountType').css("display","");
                    $('.emp-price-info.is-price-calc-new').show();
                    $('.total-coupon-payment').hide();
                    if ($('.emp-price-info.is-coupon-price-calc-new').data('set-coupon-discount-price') == 'Y') $('.emp-price-info.is-coupon-price-calc-new').show();


                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                    KRP0008.displayBenefitPointArea(digitalData.userInfo.partnerType);
                    // 일반 가격탭

                    KRP0008.bottomFoldAreaControl('Y');
                } else {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("last").removeClass("first");
                    $('span[id^="employeeBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="employeeBadge"]'));
                    $('#badgeArea').append($('span[id^="b2cBadge"]'));
                    $('span[id^="b2cBadge"]').show();
                    // $('#actionSheetDiscountType').hide();
                    $('.emp-price-info.is-price-calc-new').hide();

                    if ($('.total-coupon-payment .payment .price').data('set-coupon-discount-price') == 'Y') $('.total-coupon-payment').show();
                    $('.emp-price-info.is-coupon-price-calc-new').hide();

                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                    KRP0008.displayBenefitPointArea('B2C');

                    KRP0008.bottomFoldAreaControl('N');
                }
            })
        });
        
        if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
	        //GNB로그인시 선택 옵션값 저장
	        $("a[href='/sso/member/login']").on("click",function(){
	        	let optionValArr = new Array();
	        	$("#tab2").find("input:checked:visible").each(function(){
	        		optionValArr.push($(this).val());
	        	});
	        	sessionStorage.setItem("optionValArr",JSON.stringify(optionValArr));
	        });
        }
    })


    $(window).load(function(){
        var hash = location.hash;
        if(hash) {
            var findEl = $(hash);
            if(findEl.length > 0) {
                var target_top = findEl.offset().top;
                setTimeout(function () {
                    $("html, body").animate({ scrollTop: target_top }, 0);
                }, 30);
            }
        }

        $(this).on('resize', function(){
            KRP0008.resize();
        });

        // iframe resizer lib 추가
        var script = document.createElement('script');
        script.src = "https://www.lge.co.kr/kr/brands/gram/lib/iframeResizer.contentWindow.min.js";
        document.getElementsByTagName('head')[0].appendChild(script);
    });

    /* BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다. start */
    function resizeEv1() {
        if(document.getElementById('base_detail_target')) {
            if(document.getElementById('pdp_visual_click2')) {
                var size1 = document.getElementById('base_detail_target');
                var size2 = document.getElementById('pdp_visual_click2');
                size2.style.width = size1.offsetWidth + 'px';
            }
        }
    }
    /* BTOCSITE-37933 [UI] 다품목 판매 활성화_ PDP start */
    function resizeEv2() {
        if(document.getElementById('actionSheetCart')) {
            if(window.innerWidth > 767) {
                var size0 = document.querySelector('#actionSheetCart .component-wrap');
                var size1 = document.getElementById('actionSheetCart');
                var size2 = document.querySelector('#actionSheetCart .action-sheet-inner');
                if(size0.offsetHeight > 318) {
                    size2.style.height = size1.offsetHeight - 70 + 'px';
                }
                else {
                    size2.style.removeProperty('height');
                }
            }
        }
    }

    /* BTOCSITE-85293 START */
    function resizeActionSheetConsent() {
        var isModal = $('#actionSheetConsent').closest('.ui_modal_wrap');
        var isMobile = window.outerWidth < 768 ;
        var isClass = $('#actionSheetConsent').hasClass('active');
        if(isModal.length && isMobile){ // 모달 에서 모바일 전환
            $('#actionSheetConsent').removeClass('active');
        }else if(!isModal.length && !isMobile && isClass){  //엑션시트 에서 PC 전환
            $('#actionSheetConsent').vcModal('show');
        }
    }
    /* BTOCSITE-85293 END */

    window.onresize = function(){
        resizeEv1();
        resizeEv2();
        resizeActionSheetConsent(); /* BTOCSITE-85293 */
    }
    window.onload = function(){
        resizeEv1();
        resizeEv2();
        resizeActionSheetConsent(); /* BTOCSITE-85293 */
    }
    /* BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다. end */
    
    /*BTOCSITE-85182*/
    function subMultiItemBenefit(partnerYn){
    	let tgtYn = "N";
    	let benefitAmt = 0;
    	if(partnerYn == "Y"){
    		//임직원
    		tgtYn = $("#subMultiItemBenefit").data("partner-tgt-yn");
    		benefitAmt = $("#subMultiItemBenefit").data("partner-amt")/10000;
    	}else{
    		//일반
    		tgtYn = $("#subMultiItemBenefit").data("tgt-yn");
    		benefitAmt = $("#subMultiItemBenefit").data("amt")/10000;
    	}
    	if(tgtYn == "Y"){
    		$("#subMultiItemBenefitTxt").html('당월 내, 이 다품목 제품을 구독하면<br class="mo-only"> '+benefitAmt+'만원 캐시백이 추가 적용 됩니다.');
    		$("#subMultiItemBenefit").show();
    	}else{
    		$("#subMultiItemBenefit").hide();
    	}
    }
    
    return {
		// BTOCSITE-45339, cookie name 설정 방법은 임시로 하드코딩...
		setTail: function(_value, _days) {
			var _name = "f_area";	// cookie name
			KRP0008.setCookie(_name, _value, _days);
		}
        ,
        // BTOCSITE-54289 // UP가전 2.0 PDP
        init: function(up20Flag) {
            KRP0008.init(up20Flag);
        }
        ,
        // BTOCSITE-78355 [S]
        refresh: function() {
            KRP0008.refresh();
        }
        // BTOCSITE-78355 [E]
        // BTOCSITE-89574 START
        , setValueExtraBtnByTimeDeal: function() {
            KRP0008.setValueExtraBtnByTimeDeal();
        }
        // BTOCSITE-89574 END
        ,
        addCartAjaxCall: function(ajaxUrl, param, isToast) {
            KRP0008.addCartAjaxCall(ajaxUrl, param, isToast);
        }
        // BTOCSITE-70412 START
        ,
        updatePaymentAmountPrice: function($paymentAmount, quantityChange) {
            KRP0008.updatePaymentAmountPrice($paymentAmount, quantityChange)
        },
        // BTOCSITE-70412 END
        additionInit : function(){
            KRP0008.additionModel.additionInit();
        },
        addRentalCartTag: function(modelId, price, quantity) {
            KRP0008.addRentalCartTag(modelId, price, quantity);
        },
        csSubscribeClickRecordEvent: function() {
            KRP0008.csSubscribeClickRecordEvent();
        }
	};

})();

/*
window.addEventListener("pageshow", function (event) {
    if (event.persisted || (window.performance && window.performance.navigation.type == 2 )) {
        console.log("yongho => start step 1");
        _KRP0008.additionInit();
        if($('#quantity').val() > 1){
            $('.payment-amount .quantity-payment-wrap .minus').prop('disabled',false);
        }
    }
});*/

// $(function(){
//     Promise.resolve(_KRP0008.init()).then(_KRP0008_COUPON.KRP0008_COUPON_INIT());
// });